export default {
  "审批同意成功": "審批同意成功",
  "请填写拒绝原因": "請填寫拒絕原因",
  "审批拒绝成功": "審批拒絕成功",
  "审批拒绝失败": "審批拒絕失敗",
  "审批拒绝失败:": "審批拒絕失敗:",
  "审批撤销成功": "審批撤銷成功",
  "审批撤销失败": "審批撤銷失敗",
  "审批撤销失败:": "審批撤銷失敗:",
  "重新发起操作": "重新發起操作",
  "审批单链接已复制到剪贴板": "審批單連結已複製到剪貼簿",
  "复制链接失败": "複製連結失敗",
  "复制链接失败:": "複製連結失敗:",
  "请选择新的审批人": "請選擇新的審批人",
  "审批人更新成功": "審批人更新成功",
  "审批单详情": "審批單詳情",
  "审批人无法审批？要变更审批人？可联系审批管理员": "審批人無法審批？要變更審批人？可聯絡審批管理員",
  "修改审批人": "修改審批人",
  "项目详情链接：": "專案詳情連結：",
  "查看项目详情": "檢視專案詳情",
  "复制链接": "複製連結",
  "链接已复制到剪贴板": "連結已複製到剪貼簿",
  "浏览器不支持复制功能": "瀏覽器不支援複製功能",
  "审批单号": "審批單號",
  "审批标题": "審批標題",
  "审批进度": "審批進度",
  "审批类型": "審批型別",
  "发起原因": "發起原因",
  "发起时间": "發起時間",
  "拒绝": "拒絕",
  "更多": "更多",
  "请输入审批单号/审批标题": "請輸入審批單號/審批標題",
  "发起时间:": "發起時間:",
  "查询类型:": "查詢型別:",
  "我发起的": "我發起的",
  "我审批的": "我審批的",
  "审批类型:": "審批型別:",
  "请选择审批类型": "請選擇審批型別",
  "审批进度:": "審批進度:",
  "请选择审批进度": "請選擇審批進度",
  "拒绝审批": "拒絕審批",
  "确认拒绝": "確認拒絕",
  "请填写拒绝原因：": "請填寫拒絕原因：",
  "请输入拒绝原因...": "請輸入拒絕原因...",
  "已选择": "已選擇",
  "点击进入": "點選進入",
  "暂无可用审批类型": "暫無可用審批型別",
  "审批统计": "審批統計",
  "我的审批单": "我的審批單",
  "撤销": "撤銷",
  "同意": "同意",
  "审批流程": "審批流程",
  "流程发起": "流程發起",
  "发起人：": "發起人：",
  "时间：": "時間：",
  "审批节点": "審批節點",
  "分组审批：每个小组都需通过，每个小组审批通过规则为": "分組審批：每個小組都需透過，每個小組審批透過規則為",
  "小组": "小組",
  "该分组暂无审批人信息": "該分組暫無審批人資訊",
  "暂无审批人信息": "暫無審批人資訊",
  "暂无审批流程信息": "暫無審批流程資訊",
  "审批流程已完成": "審批流程已完成",
  "编辑审批人": "編輯審批人",
  "需上一节点审批通过后开放...": "需上一節點審批透過後開放...",
  "等待审批中...": "等待審批中...",
  "不需要审批了": "不需要審批了",
  "当前状态": "當前狀態",
  "涉及系统": "涉及系統",
  "其他信息": "其他資訊",
  "获取事件详情失败:": "獲取事件詳情失敗:",
  "获取事件详情失败": "獲取事件詳情失敗",
  "Goc事件明细": "Goc事件明細",
  "确认撤销": "確認撤銷",
  "您确定要撤销此审批单吗？撤销后将无法恢复。": "您確定要撤銷此審批單嗎？撤銷後將無法恢復。",
  "将": "將",
  "替换为：": "替換為：",
  "分支名称": "分支名稱",
  "我的审批": "我的審批",
  "所有审批": "所有審批",
  "ECS筛选": "ECS篩選",
  "实例名称": "例項名稱",
  "请输入实例名称": "請輸入例項名稱",
  "实例状态": "例項狀態",
  "请选择实例状态": "請選擇例項狀態",
  "CPU核数": "CPU核數",
  "请输入CPU核数": "請輸入CPU核數",
  "内存大小(GB)": "記憶體大小(GB)",
  "请输入内存大小(GB)": "請輸入記憶體大小(GB)",
  "操作系统类型": "作業系統型別",
  "请选择操作系统类型": "請選擇作業系統型別",
  "网络类型": "網路型別",
  "请选择网络类型": "請選擇網路型別",
  "网络计费类型": "網路計費型別",
  "请选择网络计费类型": "請選擇網路計費型別",
  "实例计费类型": "例項計費型別",
  "请选择实例计费类型": "請選擇例項計費型別",
  "实例是否不可用": "例項是否不可用",
  "不可用": "不可用",
  "运行中": "執行中",
  "已停止": "已停止",
  "启动中": "啟動中",
  "停止中": "停止中",
  "等待中": "等待中",
  "经典网络": "經典網路",
  "专有网络": "專有網路",
  "按固定带宽": "按固定頻寬",
  "按使用流量": "按使用流量",
  "包年包月": "包年包月",
  "按量付费": "按量付費",
  "抢占式实例": "搶佔式例項",
  "实例ID": "例項ID",
  "可用区": "可用區",
  "实例规格": "例項規格",
  "规格族": "規格族",
  "CPU/内存": "CPU/記憶體",
  "系统类型": "系統型別",
  "镜像ID": "映象ID",
  "主机名": "主機名",
  "交换机ID": "交換機ID",
  "私网IP": "私網IP",
  "公网IP": "公網IP",
  "弹性公网IP": "彈性公網IP",
  "安全组": "安全組",
  "搜索关键词": "搜尋關鍵詞",
  "请输入搜索关键词": "請輸入搜尋關鍵詞",
  "监控项单位": "監控項單位",
  "请输入单位，多个用逗号分隔或直接选择": "請輸入單位，多個用逗號分隔或直接選擇",
  "命名空间": "名稱空間",
  "监控项描述": "監控項描述",
  "统计周期": "統計週期",
  "维度": "維度",
  "单位": "單位",
  "统计方法": "統計方法",
  "PolarDB筛选": "PolarDB篩選",
  "数据库类型": "資料庫型別",
  "请选择数据库类型": "請選擇資料庫型別",
  "数据库版本": "資料庫版本",
  "请输入数据库版本，多个用逗号分隔": "請輸入資料庫版本，多個用逗號分隔",
  "存储付费类型": "儲存付費型別",
  "请选择存储付费类型": "請選擇儲存付費型別",
  "付费类型": "付費型別",
  "请选择付费类型": "請選擇付費型別",
  "集群状态": "叢集狀態",
  "请选择集群状态": "請選擇叢集狀態",
  "集群系列": "叢集系列",
  "请选择集群系列": "請選擇叢集系列",
  "存储类型": "儲存型別",
  "请选择存储类型": "請選擇儲存型別",
  "强一致性": "強一致性",
  "请选择强一致性": "請選擇強一致性",
  "删除保护": "刪除保護",
  "锁定": "鎖定",
  "是否过期": "是否過期",
  "锁定模式": "鎖定模式",
  "请选择锁定模式": "請選擇鎖定模式",
  "热备集群": "熱備叢集",
  "请选择热备集群": "請選擇熱備叢集",
  "创建中": "建立中",
  "删除中": "刪除中",
  "重启中": "重啟中",
  "变配中": "變配中",
  "标准版": "標準版",
  "高性能": "高效能",
  "未锁定": "未鎖定",
  "手动锁定": "手動鎖定",
  "因过期而锁定": "因過期而鎖定",
  "因恢复而锁定": "因恢復而鎖定",
  "因磁盘配额超限而锁定": "因磁碟配額超限而鎖定",
  "SE标准版": "SE標準版",
  "开启": "開啟",
  "集群描述": "叢集描述",
  "数据库引擎": "資料庫引擎",
  "集群类型": "叢集型別",
  "节点规格": "節點規格",
  "节点数量": "節點數量",
  "存储空间(GB)": "儲存空間(GB)",
  "已用存储(GB)": "已用儲存(GB)",
  "计费类型": "計費型別",
  "存储计费类型": "儲存計費型別",
  "子系列": "子系列",
  "数据库节点": "資料庫節點",
  "资源组ID": "資源組ID",
  "集群创建时间": "叢集建立時間",
  "集群过期时间": "叢集過期時間",
  "云产品描述": "雲產品描述",
  "RDS筛选": "RDS篩選",
  "实例描述": "例項描述",
  "请输入实例描述": "請輸入例項描述",
  "请选择数据库引擎": "請選擇資料庫引擎",
  "实例类型": "例項型別",
  "请选择实例类型": "請選擇例項型別",
  "请选择计费类型": "請選擇計費型別",
  "迁移中": "遷移中",
  "升级中": "升級中",
  "创建只读实例中": "建立只讀例項中",
  "恢复中": "恢復中",
  "导入中": "匯入中",
  "从其他实例导入中": "從其他例項匯入中",
  "网络类型变更中": "網路型別變更中",
  "容灾切换中": "容災切換中",
  "克隆中": "克隆中",
  "克隆只读实例中": "克隆只讀例項中",
  "内核版本升级中": "核心版本升級中",
  "创建临时实例中": "建立臨時例項中",
  "SSL配置修改中": "SSL配置修改中",
  "SSL启用中": "SSL啟用中",
  "SSL禁用中": "SSL禁用中",
  "已删除": "已刪除",
  "内存(GB)": "記憶體(GB)",
  "网络连接类型": "網路連線型別",
  "连接地址": "連線地址",
  "连接模式": "連線模式",
  "VPC云实例ID": "VPC雲例項ID",
  "锁定原因": "鎖定原因",
  "只读实例ID": "只讀例項ID",
  "实例创建时间": "例項建立時間",
  "实例过期时间": "例項過期時間",
  "提示级别": "提示級別",
  "地域ID": "地域ID",
  "地域名称": "地域名稱",
  "地域端点": "地域端點",
  "添加网关域名": "新增閘道器域名",
  "域名": "域名",
  "请输入域名": "請輸入域名",
  "网关": "閘道器",
  "请选择网关": "請選擇閘道器",
  "协议": "協議",
  "请选择协议": "請選擇協議",
  "证书": "證書",
  "请选择证书": "請選擇證書",
  "证书名称": "證書名稱",
  "证书ID": "證書ID",
  "绑定域名": "繫結域名",
  "过期时间": "過期時間",
  "主机记录": "主機記錄",
  "指域名前缀，例如：www": "指域名字首，例如：www",
  "记录类型": "記錄型別",
  "指解析记录的用途，例如：网站、邮箱": "指解析記錄的用途，例如：網站、郵箱",
  "解析请求来源(isp)": "解析請求來源(isp)",
  "指解析请求的来源，例如：电信、联通": "指解析請求的來源，例如：電信、聯通",
  "记录值": "記錄值",
  "一般是填写服务器的IP地址": "一般是填寫伺服器的IP地址",
  "指解析结果在Local DNS中的缓存时间": "指解析結果在Local DNS中的快取時間",
  "解析记录在云解析DNS中的启用情况": "解析記錄在雲解析DNS中的啟用情況",
  "启用": "啟用",
  "暂停": "暫停",
  "已绑定网关": "已繫結閘道器",
  "最近同步时间": "最近同步時間",
  "请输入主机记录": "請輸入主機記錄",
  "请输入记录值": "請輸入記錄值",
  "所有状态": "所有狀態",
  "常用域名": "常用域名",
  "未标为常用域名": "未標為常用域名",
  "记录数": "記錄數",
  "DNS服务器地址": "DNS伺服器地址",
  "付费版本": "付費版本",
  "免费版": "免費版",
  "企业标准版": "企業標準版",
  "企业旗舰版": "企業旗艦版",
  "请选择行业线": "請選擇行業線",
  "未设置开始结束时间": "未設定開始結束時間",
  "实际工作时间": "實際工作時間",
  "近30天": "近30天",
  "近三月": "近三月",
  "开始结束时间": "開始結束時間",
  "任务类型": "任務型別",
  "请到开始结束时间处设置预估人天（左侧蓝色分级线可拖动）": "請到開始結束時間處設定預估人天（左側藍色分級線可拖動）",
  "需求甘特图": "需求甘特圖",
  "任务列表": "任務列表",
  "任务甘特图": "任務甘特圖",
  "需求信息": "需求資訊",
  "任务状态": "任務狀態",
  "未知用户": "未知使用者",
  "的": "的",
  "甘特图视图": "甘特圖檢視",
  "一键收起": "一鍵收起",
  "一键展开": "一鍵展開",
  "任务状态筛选：": "任務狀態篩選：",
  "请选择任务状态": "請選擇任務狀態",
  "任务时间筛选：": "任務時間篩選：",
  "新建目录": "新建目錄",
  "编辑目录": "編輯目錄",
  "目录名称": "目錄名稱",
  "请输入目录名称": "請輸入目錄名稱",
  "请至少选择一个组织、系统或其他人员": "請至少選擇一個組織、系統或其他人員",
  "组织": "組織",
  "添加该组织下的所有人员,支持多选": "新增該組織下的所有人員,支援多選",
  "请选择组织": "請選擇組織",
  "组织人员": "組織人員",
  "已添加组织人员": "已新增組織人員",
  "添加该系统下的所有人员,支持多选": "新增該系統下的所有人員,支援多選",
  "系统人员": "系統人員",
  "已添加系统人员": "已新增系統人員",
  "其他人员": "其他人員",
  "请选择其他人员": "請選擇其他人員",
  "支持多选": "支援多選",
  "创建面板": "建立面板",
  "查看目录详情": "檢視目錄詳情",
  "删除目录": "刪除目錄",
  "创建目录": "建立目錄",
  "人员名称": "人員名稱",
  "部门": "部門",
  "任务预估工时": "任務預估工時",
  "任务实际工时": "任務實際工時",
  "缺陷工时": "缺陷工時",
  "线上问题工时": "線上問題工時",
  "考勤工时": "考勤工時",
  "加班工时": "加班工時",
  "缺陷时效": "缺陷時效",
  "研发为缺陷解决时效相加（解决时效=解决时间-创建时间）": "研發為缺陷解決時效相加（解決時效=解決時間-建立時間）",
  "测试为缺陷关闭时效相加（关闭时效=关闭时间-解决时间）": "測試為缺陷關閉時效相加（關閉時效=關閉時間-解決時間）",
  "线上问题时效": "線上問題時效",
  "研发为线上问题解决时效相加（解决时效=解决时间-创建时间）": "研發為線上問題解決時效相加（解決時效=解決時間-建立時間）",
  "测试为线上问题关闭时效相加（关闭时效=关闭时间-解决时间）": "測試為線上問題關閉時效相加（關閉時效=關閉時間-解決時間）",
  "缺陷平均时效": "缺陷平均時效",
  "缺陷平均时效 = 缺陷时效 / 缺陷数量": "缺陷平均時效 = 缺陷時效 / 缺陷數量",
  "线上问题平均时效": "線上問題平均時效",
  "线上问题平均时效 = 线上问题时效 / 线上问题数量": "線上問題平均時效 = 線上問題時效 / 線上問題數量",
  "缺陷工时占比": "缺陷工時佔比",
  "缺陷工时占比 = 缺陷实际工时 / 考勤工时": "缺陷工時佔比 = 缺陷實際工時 / 考勤工時",
  "线上问题工时占比": "線上問題工時佔比",
  "线上问题工时占比 = 线上问题工时 / 考勤工时": "線上問題工時佔比 = 線上問題工時 / 考勤工時",
  "缺陷重开次数": "缺陷重開次數",
  "缺陷重开率": "缺陷重開率",
  "缺陷重开率 = 缺陷重开次数 / 缺陷数量": "缺陷重開率 = 缺陷重開次數 / 缺陷數量",
  "缺陷（平均值）": "缺陷（平均值）",
  "线上问题（平均值）": "線上問題（平均值）",
  "平均产品评审驳回率": "平均產品評審駁回率",
  "平均代码提交规范率": "平均程式碼提交規範率",
  "平均紧急发布率": "平均緊急釋出率",
  "代码与发布质量监测": "程式碼與釋出質量監測",
  "研发缺陷与线上缺陷综合指标": "研發缺陷與線上缺陷綜合指標",
  "产品需求各阶段平均耗时": "產品需求各階段平均耗時",
  "人员数据详情": "人員資料詳情",
  "姓名": "姓名",
  "员工编码": "員工編碼",
  "等待阶段平均时间": "等待階段平均時間",
  "产品方案平均时间": "產品方案平均時間",
  "研发平均开发时间": "研發平均開發時間",
  "测试平均等待时间": "測試平均等待時間",
  "缺陷平均解决耗时": "缺陷平均解決耗時",
  "缺陷平均关闭时长": "缺陷平均關閉時長",
  "缺陷平均重开率": "缺陷平均重開率",
  "线上问题需求设计缺陷率": "線上問題需求設計缺陷率",
  "线上问题平均解决耗时": "線上問題平均解決耗時",
  "线上问题平均关闭时长": "線上問題平均關閉時長",
  "线上问题平均重开率": "線上問題平均重開率",
  "任务实际工时需满足以下条件：": "任務實際工時需滿足以下條件：",
  "工时开始时间大于等于任务开始时间。": "工時開始時間大於等於任務開始時間。",
  "工时结束时间小于等于任务结束时间。": "工時結束時間小於等於任務結束時間。",
  "缺陷实际工时": "缺陷實際工時",
  "缺陷实际工时需满足以下条件：": "缺陷實際工時需滿足以下條件：",
  "工时开始时间大于等于缺陷创建时间。": "工時開始時間大於等於缺陷建立時間。",
  "工时结束时间小于等于缺陷解决时间。": "工時結束時間小於等於缺陷解決時間。",
  "线上问题实际工时": "線上問題實際工時",
  "线上问题实际工时需满足以下条件：": "線上問題實際工時需滿足以下條件：",
  "工时开始时间大于等于线上问题创建时间。": "工時開始時間大於等於線上問題建立時間。",
  "工时结束时间小于等于线上问题解决时间。": "工時結束時間小於等於線上問題解決時間。",
  "偏离值": "偏離值",
  "实际工时 = 任务实际工时 + 缺陷实际工时 + 线上问题实际工时": "實際工時 = 任務實際工時 + 缺陷實際工時 + 線上問題實際工時",
  "偏离值=考勤工时 − 实际工时": "偏離值=考勤工時 − 實際工時",
  "如果偏离值为正，表示考勤工时超过了任务工时，可能意味着员工加班或工作效率低下。 如果偏离值为负，表示考勤工时低于任务工时，可能意味着员工未能完成预定的工作量。": "如果偏離值為正，表示考勤工時超過了任務工時，可能意味著員工加班或工作效率低下。 如果偏離值為負，表示考勤工時低於任務工時，可能意味著員工未能完成預定的工作量。",
  "偏差百分比": "偏差百分比",
  "偏离率的计算公式通常为：偏离率=(考勤工时−实际工时)/实际工时*100%": "偏離率的計算公式通常為：偏離率=(考勤工時−實際工時)/實際工時*100%",
  "正偏离率：表示考勤工时高于实际工时，可能意味着员工在工作中投入了更多时间，或者任务预估时间不足。": "正偏離率：表示考勤工時高於實際工時，可能意味著員工在工作中投入了更多時間，或者任務預估時間不足。",
  "负偏离率：表示考勤工时低于实际工时，可能意味着员工未能完成预定的工作量，或者考勤记录存在问题。": "負偏離率：表示考勤工時低於實際工時，可能意味著員工未能完成預定的工作量，或者考勤記錄存在問題。",
  "查看全员甘特图": "檢視全員甘特圖",
  "单位：": "單位：",
  "名称和链接已复制到剪贴板": "名稱和連結已複製到剪貼簿",
  "点击这里展开左侧菜单": "點選這裡展開左側選單",
  "请选择左侧菜单项进行操作": "請選擇左側選單項進行操作",
  "点击这里展开左侧菜单以查看更多选项": "點選這裡展開左側選單以檢視更多選項",
  "任务责任人看板": "任務責任人看板",
  "任务状态占比": "任務狀態佔比",
  "预估工时（单位: 天）": "預估工時（單位: 天）",
  "各时间段内个人任务的预估工时总和，数据为0表示存在任务尚未排期": "各時間段內個人任務的預估工時總和，資料為0表示存在任務尚未排期",
  "研发任务与考勤数据对比": "研發任務與考勤資料對比",
  "工时、缺陷、任务数据": "工時、缺陷、任務資料",
  "查看教程": "檢視教程",
  "新建值班表": "新建值班表",
  "编辑值班表": "編輯值班表",
  "值班表名称": "值班表名稱",
  "请输入值班表名称": "請輸入值班表名稱",
  "值班时间段": "值班時間段",
  "请选择值班时间段": "請選擇值班時間段",
  "不参与组长轮转的业务领域": "不參與組長輪轉的業務領域",
  "可选，默认全部参与": "可選，預設全部參與",
  "只影响值班组长候选人，不影响业务领域自身的值班安排": "隻影響值班組長候選人，不影響業務領域自身的值班安排",
  "创建值班表": "建立值班表",
  "配置日常值班表模板": "配置日常值班表模板",
  "领域负责人": "領域負責人",
  "值班日期": "值班日期",
  "值班组长": "值班組長",
  "日常值班表模版": "日常值班表模版",
  "已选人员固定值班；业务岗位按关联部门成员轮转，组长按未排除的值班业务领域负责人轮转": "已選人員固定值班；業務崗位按關聯部門成員輪轉，組長按未排除的值班業務領域負責人輪轉",
  "按启用的业务领域重置模板岗位": "按啟用的業務領域重置模板崗位",
  "确认重置模板岗位？": "確認重置模板崗位？",
  "确认重置": "確認重置",
  "模板岗位已重置": "模板崗位已重置",
  "重置模板岗位": "重置模板崗位",
  "假": "假",
  "班": "班",
  "按最新模板重新排班": "按最新模板重新排班",
  "请先完成值班模板调整": "請先完成值班模板調整",
  "业务岗位只重排所选业务领域；值班组长按整张值班表的负责人候选范围独立重排。生效日期之前的排班不会修改。": "業務崗位只重排所選業務領域；值班組長按整張值班表的負責人候選範圍獨立重排。生效日期之前的排班不會修改。",
  "生效日期": "生效日期",
  "请选择生效日期": "請選擇生效日期",
  "重排内容": "重排內容",
  "请至少选择一项重排内容": "請至少選擇一項重排內容",
  "重排业务岗位": "重排業務崗位",
  "重排值班组长": "重排值班組長",
  "需重排的业务领域": "需重排的業務領域",
  "请选择本次需要重排的业务领域": "請選擇本次需要重排的業務領域",
  "今天": "今天",
  "可联系方式": "可聯絡方式",
  "值班表名称和链接已复制到剪贴板": "值班表名稱和連結已複製到剪貼簿",
  "从生效日期起，可选择重排业务岗位、值班组长或两者同时重排": "從生效日期起，可選擇重排業務崗位、值班組長或兩者同時重排",
  "重新排值班表": "重新排值班表",
  "自动排班": "自動排班",
  "只补全空缺岗位，不覆盖已手工填写的人员": "只補全空缺崗位，不覆蓋已手工填寫的人員",
  "按关联部门自动填充": "按關聯部門自動填充",
  "业务需求明细": "業務需求明細",
  "请至少选择一种专业线": "請至少選擇一種專業線",
  "请输入仪表盘名称": "請輸入儀表盤名稱",
  "仪表盘名称不能超过100个字符": "儀表盤名稱不能超過100個字元",
  "专业线类型": "專業線型別",
  "自定义专业线": "自定義專業線",
  "请选择自定义专业线": "請選擇自定義專業線",
  "配置专业线": "配置專業線",
  "可查看人员": "可檢視人員",
  "描述不能超过500个字符": "描述不能超過500個字元",
  "新建专业线": "新建專業線",
  "编辑专业线": "編輯專業線",
  "查看专业线": "檢視專業線",
  "专业线名称": "專業線名稱",
  "请输入专业线名称": "請輸入專業線名稱",
  "专业线名称不能超过100个字符": "專業線名稱不能超過100個字元",
  "请选择成员": "請選擇成員",
  "删除确认": "刪除確認",
  "暂停至": "暫停至",
  "产品需求明细": "產品需求明細",
  "管理自定义专业线": "管理自定義專業線",
  "折叠全部": "摺疊全部",
  "展开全部": "展開全部",
  "退出全屏": "退出全屏",
  "图表全屏": "圖表全屏",
  "整体交付周数统计（产品需求维度）": "整體交付週數統計（產品需求維度）",
  "选择专业线": "選擇專業線",
  "选择产品经理": "選擇產品經理",
  "年度交付周数（整体）": "年度交付週數（整體）",
  "专业线交付周数统计（产品需求维度）": "專業線交付週數統計（產品需求維度）",
  "整体交付周数统计（业务需求维度）": "整體交付週數統計（業務需求維度）",
  "专业线交付周数统计（业务需求维度）": "專業線交付週數統計（業務需求維度）",
  "近两周需求进展环比": "近兩週需求進展環比",
  "超期需求": "超期需求",
  "超2周": "超2周",
  "超3周": "超3周",
  "超1个月": "超1個月",
  "超期未介入产品需求": "超期未介入產品需求",
  "超期未介入业务需求": "超期未介入業務需求",
  "超期方案未完成产品需求": "超期方案未完成產品需求",
  "评审完成超期未排期产品需求": "評審完成超期未排期產品需求",
  "周新增/上线需求（数量）": "周新增/上線需求（數量）",
  "完成方案/评审-上线（周需时）": "完成方案/評審-上線（周需時）",
  "专业线需求数量": "專業線需求數量",
  "您还没有仪表盘哦，请先点击下方按钮创建一个仪表盘吧": "您還沒有儀表盤哦，請先點選下方按鈕建立一個儀表盤吧",
  "只能上传图片文件": "只能上傳圖片檔案",
  "图片大小不能超过 5MB": "圖片大小不能超過 5MB",
  "图片上传成功": "圖片上傳成功",
  "上传失败:": "上傳失敗:",
  "卡片信息缺失，无法赠送": "卡片資訊缺失，無法贈送",
  "请选择接收人": "請選擇接收人",
  "赠送成功": "贈送成功",
  "请选择卡片进行预览": "請選擇卡片進行預覽",
  "确认赠送": "確認贈送",
  "接收人": "接收人",
  "请选择需要赠送的同事": "請選擇需要贈送的同事",
  "赠送说明": "贈送說明",
  "请输入赠送说明": "請輸入贈送說明",
  "选择装饰": "選擇裝飾",
  "自定义": "自定義",
  "实时预览": "實時預覽",
  "送你": "送你",
  "选择点赞卡组：": "選擇點贊卡組：",
  "请选择组": "請選擇組",
  "研发过程缺陷质量指标": "研發過程缺陷質量指標",
  "研发过程缺陷解决时效": "研發過程缺陷解決時效",
  "质量度量指标": "質量度量指標",
  "子项目质量度量指标对比": "子專案質量度量指標對比",
  "缺陷逃逸率=线上Bug数/（线上Bug数+研发过程Bug数）×100%": "缺陷逃逸率=線上Bug數/（線上Bug數+研發過程Bug數）×100%",
  "缺陷漏检率=线上Bug数/研发过程Bug数×100%": "缺陷漏檢率=線上Bug數/研發過程Bug數×100%",
  "缺陷平均解决耗时=∑（解决时间-创建时间）/n。": "缺陷平均解決耗時=∑（解決時間-建立時間）/n。",
  "缺陷平均关闭耗时": "缺陷平均關閉耗時",
  "缺陷平均关闭耗时=∑（关闭时间-解决时间）/n。": "缺陷平均關閉耗時=∑（關閉時間-解決時間）/n。",
  "缺陷重开率=重新打开的缺陷数/已关闭的缺陷总数×100%": "缺陷重開率=重新開啟的缺陷數/已關閉的缺陷總數×100%",
  "需求设计缺陷率=需求设计缺陷数/缺陷总数×100%": "需求設計缺陷率=需求設計缺陷數/缺陷總數×100%",
  "研发过程缺陷质量指标（子项目）": "研發過程缺陷質量指標（子專案）",
  "研发过程缺陷解决时效（子项目）": "研發過程缺陷解決時效（子專案）",
  "测试阶段平均时间": "測試階段平均時間",
  "验收阶段平均时间": "驗收階段平均時間",
  "需求平均前置时间": "需求平均前置時間",
  "产品需求各阶段平均耗时横向对比": "產品需求各階段平均耗時橫向對比",
  "等待阶段": "等待階段",
  "产品方案": "產品方案",
  "研发阶段": "研發階段",
  "测试阶段": "測試階段",
  "验收阶段": "驗收階段",
  "需求前置时间": "需求前置時間",
  "从需求提出，到完成开发、测试、上线的时间周期价值，反映了业务和产研团队对客户问题或业务机会的交付（响应）速度，依赖整个组织各职能部门的协调一致和紧密协作。": "從需求提出，到完成開發、測試、上線的時間週期價值，反映了業務和產研團隊對客戶問題或業務機會的交付（響應）速度，依賴整個組織各職能部門的協調一致和緊密協作。",
  "注: 各阶段时间均已四舍五入至两位小数，总时间与各阶段直接相加可能存在微小差异。": "注: 各階段時間均已四捨五入至兩位小數，總時間與各階段直接相加可能存在微小差異。",
  "回滚率": "回滾率",
  "产品评审驳回率=评审驳回数/（评审驳回回数+评审通过数）×100%": "產品評審駁回率=評審駁回數/（評審駁回回數+評審透過數）×100%",
  "代码提交规范率=代码提交关联需求或者缺陷数/提交总数×100%": "程式碼提交規範率=程式碼提交關聯需求或者缺陷數/提交總數×100%",
  "紧急发布率=紧急发布次数/发布总次数 ×100%": "緊急釋出率=緊急釋出次數/釋出總次數 ×100%",
  "发布成功率=发布成功数/发布总数 ×100%": "釋出成功率=釋出成功數/釋出總數 ×100%",
  "发布回滚率=回滚数/发布总数 ×100%": "釋出回滾率=回滾數/釋出總數 ×100%",
  "线上缺陷质量指标": "線上缺陷質量指標",
  "线上缺陷解决时效": "線上缺陷解決時效",
  "线上缺陷质量指标（子项目）": "線上缺陷質量指標（子專案）",
  "线上缺陷解决时效（子项目）": "線上缺陷解決時效（子專案）",
  "子项目代码与发布质量监测对比": "子專案程式碼與釋出質量監測對比",
  "子系统产品需求各阶段平均耗时更新对比": "子系統產品需求各階段平均耗時更新對比",
  "需求总交付": "需求總交付",
  "需求耗时分布（均值）": "需求耗時分佈（均值）",
  "需求平均等待时间": "需求平均等待時間",
  "需求平均开发周期": "需求平均開發週期",
  "需求平均测试周期": "需求平均測試週期",
  "需求平均验收周期": "需求平均驗收週期",
  "发布回滚率": "釋出回滾率",
  "产品需求设计缺陷率": "產品需求設計缺陷率",
  "产品需求设计缺陷率=产品需求设计缺陷数/研发过程缺陷总数×100%": "產品需求設計缺陷率=產品需求設計缺陷數/研發過程缺陷總數×100%",
  "研发过程缺陷平均解决耗时（单位：天）": "研發過程缺陷平均解決耗時（單位：天）",
  "研发过程缺陷平均解决耗时": "研發過程缺陷平均解決耗時",
  "研发过程缺陷平均解决耗时=∑（解决时间-创建时间）/n。": "研發過程缺陷平均解決耗時=∑（解決時間-建立時間）/n。",
  "研发过程缺陷平均关闭耗时（单位：天）": "研發過程缺陷平均關閉耗時（單位：天）",
  "研发过程缺陷平均关闭耗时": "研發過程缺陷平均關閉耗時",
  "研发过程缺陷平均关闭耗时=∑（关闭时间-解决时间）/n。": "研發過程缺陷平均關閉耗時=∑（關閉時間-解決時間）/n。",
  "研发过程缺陷重开率": "研發過程缺陷重開率",
  "研发过程缺陷重开率=重新打开的缺陷数/已关闭的缺陷总数×100%": "研發過程缺陷重開率=重新開啟的缺陷數/已關閉的缺陷總數×100%",
  "线上缺陷产品需求设计缺陷率": "線上缺陷產品需求設計缺陷率",
  "线上缺陷产品需求设计缺陷率=线上缺陷产品需求设计缺陷数/线上缺陷总数×100%": "線上缺陷產品需求設計缺陷率=線上缺陷產品需求設計缺陷數/線上缺陷總數×100%",
  "线上缺陷平均解决耗时（单位：天）": "線上缺陷平均解決耗時（單位：天）",
  "线上缺陷平均解决耗时": "線上缺陷平均解決耗時",
  "线上缺陷平均解决耗时=∑（解决时间-创建时间）/n。": "線上缺陷平均解決耗時=∑（解決時間-建立時間）/n。",
  "线上缺陷平均关闭耗时（单位：天）": "線上缺陷平均關閉耗時（單位：天）",
  "线上缺陷平均关闭耗时": "線上缺陷平均關閉耗時",
  "线上缺陷平均关闭耗时=∑（关闭时间-解决时间）/n。": "線上缺陷平均關閉耗時=∑（關閉時間-解決時間）/n。",
  "线上缺陷重开率": "線上缺陷重開率",
  "线上缺陷重开率=重新打开的缺陷数/已关闭的缺陷总数×100%": "線上缺陷重開率=重新開啟的缺陷數/已關閉的缺陷總數×100%",
  "改进看板": "改進看板",
  "效率指标": "效率指標",
  "执行人类型": "執行人型別",
  "质量指标": "質量指標",
  "财务分析": "財務分析",
  "请选择团队": "請選擇團隊",
  "选择年份": "選擇年份",
  "排名": "排名",
  "年": "年",
  "总计:": "總計:",
  "人员/年份": "人員/年份",
  "排序方式": "排序方式",
  "按": "按",
  "计划上线时间": "計劃上線時間",
  "操作人员": "操作人員",
  "服务状态": "服務狀態",
  "其他": "其他",
  "影响周期": "影響週期",
  "有效解决时间": "有效解決時間",
  "责任组长": "責任組長",
  "直接原因": "直接原因",
  "根本原因": "根本原因",
  "关联项名称": "關聯項名稱",
  "驳回原因": "駁回原因",
  "提交不规范": "提交不規範",
  "提交人邮箱": "提交人郵箱",
  "请求次数": "請求次數",
  "平均响应时间 (ms)": "平均響應時間 (ms)",
  "错误数": "錯誤數",
  "慢查询": "慢查詢",
  "异常数": "異常數",
  "慢接口": "慢介面",
  "等待时间": "等待時間",
  "非规范提交记录": "非規範提交記錄",
  "发布失败记录": "釋出失敗記錄",
  "未覆盖需求记录": "未覆蓋需求記錄",
  "技术债务详情": "技術債務詳情",
  "总计：": "總計：",
  "执行次数": "執行次數",
  "已解决": "已解決",
  "慢SQL模版详情": "慢SQL模版詳情",
  "慢SQL日志记录": "慢SQL日誌記錄",
  "近三年": "近三年",
  "近二年": "近二年",
  "近一年": "近一年",
  "筛选指标": "篩選指標",
  "上月": "上月",
  "过往整周期": "過往整週期",
  "昨天": "昨天",
  "上周": "上週",
  "上个月": "上個月",
  "上两月": "上兩月",
  "上三月": "上三月",
  "上一自然半年": "上一自然半年",
  "去年": "去年",
  "最近": "最近",
  "近7天": "近7天",
  "近60天": "近60天",
  "近90天": "近90天",
  "近180天": "近180天",
  "近365天": "近365天",
  "近1月": "近1月",
  "近3月": "近3月",
  "近6月": "近6月",
  "近12月": "近12月",
  "当前整周期": "當前整週期",
  "当前自然半年": "當前自然半年",
  "今年": "今年",
  "至今": "至今",
  "本周至今": "本週至今",
  "本月至今": "本月至今",
  "本年至今": "本年至今",
  "我的任务": "我的任務",
  "任务负责人看板": "任務負責人看板",
  "气泡大小:": "氣泡大小:",
  "（值越大，气泡越大）；": "（值越大，氣泡越大）；",
  "气泡颜色:": "氣泡顏色:",
  "（值越大，颜色越深）": "（值越大，顏色越深）",
  "排序:": "排序:",
  "您没有权限查看该角色数据": "您沒有許可權檢視該角色資料",
  "选择角色": "選擇角色",
  "人员对比": "人員對比",
  "专业线对比": "專業線對比",
  "年度对比": "年度對比",
  "选择业务领域": "選擇業務領域",
  "选择人员(可多选)": "選擇人員(可多選)",
  "选择业务领域(可多选)": "選擇業務領域(可多選)",
  "选择年份(可多选)": "選擇年份(可多選)",
  "请选择角色": "請選擇角色",
  "角色：": "角色：",
  "您没有权限查看该用户数据": "您沒有許可權檢視該使用者資料",
  "指标": "指標",
  "(单位:": "(單位:",
  "均值/总数": "均值/總數",
  "个人对比": "個人對比",
  "全年": "全年",
  "上半年": "上半年",
  "下半年": "下半年",
  "上班": "上班",
  "打卡时间": "打卡時間",
  "下班": "下班",
  "卡片唯一标志编码，前、后端需要根据该标志编码进行功能开发": "卡片唯一標誌編碼，前、後端需要根據該標誌編碼進行功能開發",
  "（创建公共卡片需要代码开发，请确认卡片功能上线后再创建卡片）": "（建立公共卡片需要程式碼開發，請確認卡片功能上線後再建立卡片）",
  "新建卡片如需代码开发，请提前告知开发卡片编码": "新建卡片如需程式碼開發，請提前告知開發卡片編碼",
  "创建卡片": "建立卡片",
  "请输入卡片名称或描述或编码": "請輸入卡片名稱或描述或編碼",
  "确定要删除 【": "確定要刪除 【",
  "】 卡片吗？": "】 卡片嗎？",
  "我的仪表盘": "我的儀表盤",
  "】 仪表盘吗？": "】 儀表盤嗎？",
  "请选择或输入成员名称": "請選擇或輸入成員名稱",
  "（可通过拖拽调整卡片展示顺序）": "（可透過拖拽調整卡片展示順序）",
  "显示在当前仪表盘": "顯示在當前儀表盤",
  "可添加的卡片": "可新增的卡片",
  "异常事项": "異常事項",
  "点击查看详情": "點選檢視詳情",
  "我的考勤详情": "我的考勤詳情",
  "只能选择单条进行操作！": "只能選擇單條進行操作！",
  "缺陷名称和链接已剪贴板": "缺陷名稱和連結已剪貼簿",
  "催办成功": "催辦成功",
  "线上问题明细": "線上問題明細",
  "缺陷明细": "缺陷明細",
  "该任务相关联的服务的服务类型": "該任務相關聯的服務的服務型別",
  "指派给我的": "指派給我的",
  "抄送给我的": "抄送給我的",
  "我反馈的": "我反饋的",
  "需求明细": "需求明細",
  "我负责的需求": "我負責的需求",
  "我开发的需求": "我開發的需求",
  "我关注的需求": "我關注的需求",
  "我相关的需求": "我相關的需求",
  "已催促全部未确认人！": "已催促全部未確認人！",
  "该评审相关信息已复制到剪贴板": "該評審相關資訊已複製到剪貼簿",
  "评审明细": "評審明細",
  "确定要完成": "確定要完成",
  "确定要取消": "確定要取消",
  "评审的会议吗？": "評審的會議嗎？",
  "我参与的评审": "我參與的評審",
  "我发起的评审": "我發起的評審",
  "质量门禁": "質量門禁",
  "可靠性评级": "可靠性評級",
  "可维修性评级": "可維修性評級",
  "漏洞数量": "漏洞數量",
  "安全评级": "安全評級",
  "热点已审查(%)": "熱點已審查(%)",
  "审查评级": "審查評級",
  "覆盖率(%)": "覆蓋率(%)",
  "重复率(%)": "重複率(%)",
  "代码行数": "程式碼行數",
  "扫描时间": "掃描時間",
  "详细报告": "詳細報告",
  "漏洞总数": "漏洞總數",
  "严重漏洞": "嚴重漏洞",
  "高危漏洞": "高危漏洞",
  "中危漏洞": "中危漏洞",
  "低危漏洞": "低危漏洞",
  "组件总数": "元件總數",
  "严重组件": "嚴重元件",
  "高危组件": "高危元件",
  "中危组件": "中危元件",
  "低危组件": "低危元件",
  "慢SQL模板": "慢SQL模板",
  "「协同」": "「協同」",
  "我负责的迭代": "我負責的迭代",
  "预估人天（天）": "預估人天（天）",
  "实际工时（时）": "實際工時（時）",
  "任务明细": "任務明細",
  "我负责的任务": "我負責的任務",
  "我参与的任务": "我參與的任務",
  "点击维护团队成员后可查看成员工作状况": "點選維護團隊成員後可檢視成員工作狀況",
  "维护成员": "維護成員",
  "请选择或输入成员名称查询": "請選擇或輸入成員名稱查詢",
  "用例类型": "用例型別",
  "运行结果": "執行結果",
  "用例状态": "用例狀態",
  "用例内容": "用例內容",
  "我创建的测试用例": "我建立的測試用例",
  "请选择截止时间": "請選擇截止時間",
  "今天到期": "今天到期",
  "本周到期": "本週到期",
  "请先编辑并排期": "請先編輯並排期",
  "待排期任务": "待排期任務",
  "待评审测试用例": "待評審測試用例",
  "未知": "未知",
  "测试环境": "測試環境",
  "生产环境": "生產環境",
  "UAT环境": "UAT環境",
  "查看全部": "檢視全部",
  "研发缺陷": "研發缺陷",
  "线上缺陷": "線上缺陷",
  "未完成事项": "未完成事項",
  "项目数据透视": "專案資料透視",
  "考勤状态：": "考勤狀態：",
  "考勤状态：普通": "考勤狀態：普通",
  "欢迎来到研发效能工作台": "歡迎來到研發效能工作臺",
  "研发效能工作台，聚合了研发效能平台与你相关的工作内容，帮助你更轻松、高效的处理工作，": "研發效能工作臺，聚合了研發效能平臺與你相關的工作內容，幫助你更輕鬆、高效的處理工作，",
  "自定义卡片等功能帮助你高效触达工作场景。": "自定義卡片等功能幫助你高效觸達工作場景。",
  "请选择工作台角色": "請選擇工作臺角色",
  "开始工作": "開始工作",
  "请选择仪表盘": "請選擇儀表盤",
  "新的仪表盘": "新的儀表盤",
  "配置仪表盘": "配置儀表盤",
  "编辑卡片": "編輯卡片",
  "配置卡片": "配置卡片",
  "分组字段:": "分組欄位:",
  "分组层级最多支持4级，请重新选择": "分組層級最多支援4級，請重新選擇",
  "选择分组字段（最多4级）": "選擇分組欄位（最多4級）",
  "⚠️ 已达到最大分组层级限制（4级），可删除现有分组后继续选择": "⚠️ 已達到最大分組層級限制（4級），可刪除現有分組後繼續選擇",
  "📋 基础信息": "📋 基礎資訊",
  "🏢 归属信息": "🏢 歸屬資訊",
  "👥 团队人员": "👥 團隊人員",
  "⚡ 操作人员": "⚡ 操作人員",
  "当前分组 (": "當前分組 (",
  "统计图表": "統計圖表",
  "清理资源中...": "清理資源中...",
  "切换中...": "切換中...",
  "获取图表选择数据失败:": "獲取圖表選擇資料失敗:",
  "展开控制面板": "展開控制面板",
  "收起控制面板": "收起控制面板",
  "刷新数据": "重新整理資料",
  "添加图表": "新增圖表",
  "调整图表顺序": "調整圖表順序",
  "展示图表：": "展示圖表：",
  "选择图表": "選擇圖表",
  "需求创建时间:": "需求建立時間:",
  "请先选择需求池来查看数据": "請先選擇需求池來檢視資料",
  "您还没有自定义需求池哦，请先点击下方按钮创建一个需求池吧": "您還沒有自定義需求池哦，請先點選下方按鈕建立一個需求池吧",
  "创建需求池": "建立需求池",
  "请先选择左侧的需求池来查看数据": "請先選擇左側的需求池來檢視資料",
  "展开控制面板(视图切换 · Tab切换 · 操作区)": "展開控制面板(檢視切換 · Tab切換 · 操作區)",
  "收起控制面板(视图切换 · Tab切换 · 操作区)": "收起控制面板(檢視切換 · Tab切換 · 操作區)",
  "拖拽调整列宽": "拖拽調整列寬",
  "需求名称/序列号": "需求名稱/序列號",
  "请输入名称或序列号": "請輸入名稱或序列號",
  "请选择需求类型": "請選擇需求型別",
  "系统培训": "系統培訓",
  "需要": "需要",
  "不需要": "不需要",
  "影响国家": "影響國家",
  "期待完成日期": "期待完成日期",
  "发布完成日期": "釋出完成日期",
  "状态筛选": "狀態篩選",
  "人员筛选": "人員篩選",
  "筛选条件已重置": "篩選條件已重置",
  "拆分时，该角色下每个人员独立一个分组；不拆分时，该角色下所有人员合并为一个分组": "拆分時，該角色下每個人員獨立一個分組；不拆分時，該角色下所有人員合併為一個分組",
  "拆分": "拆分",
  "字段管理 (": "欄位管理 (",
  "字段管理": "欄位管理",
  "搜索字段名称...": "搜尋欄位名稱...",
  "个字段": "個欄位",
  "全选": "全選",
  "固定字段": "固定欄位",
  "已启用字段": "已啟用欄位",
  "未启用字段": "未啟用欄位",
  "没有找到匹配的字段": "沒有找到匹配的欄位",
  "新建图表": "新建圖表",
  "编辑图表": "編輯圖表",
  "查看图表": "檢視圖表",
  "请输入图表名称": "請輸入圖表名稱",
  "横轴（类别）": "橫軸（類別）",
  "请选择横轴类别": "請選擇橫軸類別",
  "过滤条件": "過濾條件",
  "设置过滤条件": "設定過濾條件",
  "未设置": "未設定",
  "请选择迭代": "請選擇迭代",
  "请选择国家线": "請選擇國家線",
  "请选择测试": "請選擇測試",
  "实际完成日期": "實際完成日期",
  "获取图表数据失败:": "獲取圖表資料失敗:",
  "图表顺序调整成功": "圖表順序調整成功",
  "拖拽卡片调整图表显示顺序，调整完成后点击确定保存": "拖拽卡片調整圖表顯示順序，調整完成後點選確定儲存",
  "拖拽调整顺序": "拖拽調整順序",
  "图表删除成功": "圖表刪除成功",
  "请先配置图表": "請先配置圖表",
  "删除图表确认": "刪除圖表確認",
  "确定要删除图表": "確定要刪除圖表",
  "需求池名称": "需求池名稱",
  "请输入需求池名称": "請輸入需求池名稱",
  "需求池名称不能超过100个字符": "需求池名稱不能超過100個字元",
  "负责人：": "負責人：",
  "确认添加人员": "確認新增人員",
  "确认添加": "確認新增",
  "选中的系统：": "選中的系統：",
  "选中的标签：": "選中的標籤：",
  "将要添加的人员": "將要新增的人員",
  "点击人员标签的 ✕ 可移除该人员": "點選人員標籤的 ✕ 可移除該人員",
  "所选系统的人员已全部存在，无需添加新人员。": "所選系統的人員已全部存在，無需新增新人員。",
  "其他可查看人员": "其他可檢視人員",
  "快速添加系统人员/标签人员": "快速新增系統人員/標籤人員",
  "选择系统来快速添加人员": "選擇系統來快速新增人員",
  "选择标签来快速添加属于该标签的需求的人员": "選擇標籤來快速新增屬於該標籤的需求的人員",
  "中文名": "中文名",
  "英文名": "英文名",
  "关闭状态创建的标签为研发效能内部标签，开启状态为研发效能内部标签+需求看板外部展示标签。": "關閉狀態建立的標籤為研發效能內部標籤，開啟狀態為研發效能內部標籤+需求看板外部展示標籤。",
  "添加标签": "新增標籤",
  "标签需求": "標籤需求",
  "请先选择系统": "請先選擇系統",
  "所选系统的人员已全部存在，无需添加": "所選系統的人員已全部存在，無需新增",
  "请先选择标签": "請先選擇標籤",
  "所选标签的人员已全部存在，无需添加": "所選標籤的人員已全部存在，無需新增",
  "人员已添加成功": "人員已新增成功",
  "添加失败": "新增失敗",
  "暂无有效的甘特图数据": "暫無有效的甘特圖資料",
  "个分组，": "個分組，",
  "条记录": "條記錄",
  "全部折叠": "全部摺疊",
  "需求:": "需求:",
  "任务名称:": "任務名稱:",
  "负责人:": "負責人:",
  "任务类型:": "任務型別:",
  "开始时间:": "開始時間:",
  "结束时间:": "結束時間:",
  "所属迭代": "所屬迭代",
  "暂停至日期": "暫停至日期",
  "提测时间": "提測時間",
  "后端任务时间": "後端任務時間",
  "前端任务时间": "前端任務時間",
  "测试任务时间": "測試任務時間",
  "UI任务时间": "UI任務時間",
  "需求标题": "需求標題",
  "UI设计师": "UI設計師",
  "筛选中...": "篩選中...",
  "数据更新中...": "資料更新中...",
  "所有需求池": "所有需求池",
  "产品需求池": "產品需求池",
  "业务方需求池": "業務方需求池",
  "开发需求池": "開發需求池",
  "测试需求池": "測試需求池",
  "前端需求池": "前端需求池",
  "后端需求池": "後端需求池",
  "UI设计需求池": "UI設計需求池",
  "技术支持需求池": "技術支援需求池",
  "已完成需求池": "已完成需求池",
  "已复制": "已複製",
  "性别:": "性別:",
  "男": "男",
  "女": "女",
  "入职时间:": "入職時間:",
  "所属国家:": "所屬國家:",
  "Base地:": "Base地:",
  "部门:": "部門:",
  "手机号:": "手機號:",
  "邮箱:": "郵箱:",
  "所属系统:": "所屬系統:",
  "备注:": "備註:",
  "参与项目数 :": "參與專案數 :",
  "总人数:": "總人數:",
  "逻辑图 (向右)": "邏輯圖 (向右)",
  "思维导图": "思維導圖",
  "性别": "性別",
  "入职时间": "入職時間",
  "所属国家": "所屬國家",
  "所在部门": "所在部門",
  "手机号": "手機號",
  "请选择所属系统": "請選擇所屬系統",
  "请输入备注": "請輸入備註",
  "点赞说明": "點贊說明",
  "缺陷的新增数量会有所波动。小幅度的波动是正常的，不必过于关注。需要关注的是大幅度的波动或连续的上升趋势会带来需求交付的延期风险。": "缺陷的新增數量會有所波動。小幅度的波動是正常的，不必過於關注。需要關注的是大幅度的波動或連續的上升趨勢會帶來需求交付的延期風險。",
  "是指单位时间内未解决的缺陷数量的趋势，反映出团队处理缺陷的能力及软件质量的状态。以下是一些查看存量缺陷趋势指标时的提示：": "是指單位時間內未解決的缺陷數量的趨勢，反映出團隊處理缺陷的能力及軟體質量的狀態。以下是一些檢視存量缺陷趨勢指標時的提示：",
  "长期趋势：如果长期存量缺陷数量持续增长，可能说明存在质量问题或团队处理缺陷的效率低下。": "長期趨勢：如果長期存量缺陷數量持續增長，可能說明存在質量問題或團隊處理缺陷的效率低下。",
  "处理速度：存量缺陷如果长期不降只升，表示团队处理缺陷的速度赶不上新增缺陷的速度，可能需要调整优先级，分配更多的资源来处理旧的缺陷。": "處理速度：存量缺陷如果長期不降只升，表示團隊處理缺陷的速度趕不上新增缺陷的速度，可能需要調整優先順序，分配更多的資源來處理舊的缺陷。",
  "缺陷趋势是一个健康的软件开发生命周期中的重要工具，除了使用它来追踪需求进度，也可以作为改进工作流程、提升产品质量的重要参考。": "缺陷趨勢是一個健康的軟體開發生命週期中的重要工具，除了使用它來追蹤需求進度，也可以作為改進工作流程、提升產品質量的重要參考。",
  "该图表会显示每天新增的缺陷数量、修复的缺陷数量以及仍然活跃的或未解决的缺陷数量（通常称为\"缺陷存量\"）。": "該圖表會顯示每天新增的缺陷數量、修復的缺陷數量以及仍然活躍的或未解決的缺陷數量（通常稱為\"缺陷存量\"）。",
  "通常指的是在一天缺陷数量的变化。包括新增的缺陷，已经关闭的缺陷，解决中的缺陷等。": "通常指的是在一天缺陷數量的變化。包括新增的缺陷，已經關閉的缺陷，解決中的缺陷等。",
  "效率衡量： 如果你的团队今天解决了很多缺陷，但同时又产生了许多新的缺陷，那缺陷数量变化（日）指标就能很好地反映出这个情况，作为衡量团队工作效率的一个指标。": "效率衡量： 如果你的團隊今天解決了很多缺陷，但同時又產生了許多新的缺陷，那缺陷數量變化（日）指標就能很好地反映出這個情況，作為衡量團隊工作效率的一個指標。",
  "进度追踪：这个指标可以帮助研发跟踪需求的进度。如果缺陷的数量持续减少，那说明正在向好的方向发展。": "進度追蹤：這個指標可以幫助研發跟蹤需求的進度。如果缺陷的數量持續減少，那說明正在向好的方向發展。",
  "所选时间段内未关闭缺陷各状态占比": "所選時間段內未關閉缺陷各狀態佔比",
  "所选时间段内未关闭缺陷各优先级占比": "所選時間段內未關閉缺陷各優先順序佔比",
  "帮助检测潜在问题： 这可以帮助我们识别出哪些人可能需要更多的支持，或者他们的工作负载是否过大。如果某位团队成员的未解决缺陷数量远高于其他人，这可能表明他们正在处理的问题区域特别复杂，或可能需要增加资源和注意力。": "幫助檢測潛在問題： 這可以幫助我們識別出哪些人可能需要更多的支援，或者他們的工作負載是否過大。如果某位團隊成員的未解決缺陷數量遠高於其他人，這可能表明他們正在處理的問題區域特別複雜，或可能需要增加資源和注意力。",
  "均衡工作负载：这个指标也可以帮助我们平衡工作负载，我们可以通过调整任务分配，使每个团队成员负责的缺陷数量大致平均。这个指标并不意味着缺陷多的团队成员工作效率低下或技术能力差，反而可能因为他们在处理更复杂的、更需要专业技术的问题。因此，必须结合实际情况进行，理解背后可能的因素，而不是简单地从数量上学判别。": "均衡工作負載：這個指標也可以幫助我們平衡工作負載，我們可以透過調整任務分配，使每個團隊成員負責的缺陷數量大致平均。這個指標並不意味著缺陷多的團隊成員工作效率低下或技術能力差，反而可能因為他們在處理更復雜的、更需要專業技術的問題。因此，必須結合實際情況進行，理解背後可能的因素，而不是簡單地從數量上學判別。",
  "是指单位时间内未解决的线上问题数量的趋势，反映出团队处理线上问题的能力及软件质量的状态。以下是一些查看存量线上问题趋势指标时的提示：": "是指單位時間內未解決的線上問題數量的趨勢，反映出團隊處理線上問題的能力及軟體質量的狀態。以下是一些檢視存量線上問題趨勢指標時的提示：",
  "长期趋势：如果长期存量线上问题数量持续增长，可能说明存在质量问题或团队处理线上问题的效率低下。": "長期趨勢：如果長期存量線上問題數量持續增長，可能說明存在質量問題或團隊處理線上問題的效率低下。",
  "处理速度：存量线上问题如果长期不降只升，表示团队处理线上问题的速度赶不上新增线上问题的速度，可能需要调整优先级，分配更多的资源来处理旧的线上问题。": "處理速度：存量線上問題如果長期不降只升，表示團隊處理線上問題的速度趕不上新增線上問題的速度，可能需要調整優先順序，分配更多的資源來處理舊的線上問題。",
  "线上问题趋势是一个健康的软件开发生命周期中的重要工具，除了使用它来追踪需求进度，也可以作为改进工作流程、提升产品质量的重要参考。": "線上問題趨勢是一個健康的軟體開發生命週期中的重要工具，除了使用它來追蹤需求進度，也可以作為改進工作流程、提升產品質量的重要參考。",
  "该图表会显示每天新增的线上问题数量、修复的线上问题数量以及仍然活跃的或未解决的线上问题数量（通常称为\"线上问题存量\"）。": "該圖表會顯示每天新增的線上問題數量、修復的線上問題數量以及仍然活躍的或未解決的線上問題數量（通常稱為\"線上問題存量\"）。",
  "通常指的是在一天线上问题数量的变化。包括新增的线上问题，已经关闭的线上问题，解决中的线上问题等。": "通常指的是在一天線上問題數量的變化。包括新增的線上問題，已經關閉的線上問題，解決中的線上問題等。",
  "效率衡量： 如果你的团队今天解决了很多线上问题，但同时又产生了许多新的线上问题，那线上问题数量变化（日）指标就能很好地反映出这个情况，作为衡量团队工作效率的一个指标。": "效率衡量： 如果你的團隊今天解決了很多線上問題，但同時又產生了許多新的線上問題，那線上問題數量變化（日）指標就能很好地反映出這個情況，作為衡量團隊工作效率的一個指標。",
  "进度追踪：这个指标可以帮助研发跟踪需求的进度。如果线上问题的数量持续减少，那说明正在向好的方向发展。": "進度追蹤：這個指標可以幫助研發跟蹤需求的進度。如果線上問題的數量持續減少，那說明正在向好的方向發展。",
  "所选时间段内未关闭线上问题各状态占比": "所選時間段內未關閉線上問題各狀態佔比",
  "所选时间段内未关闭线上问题各优先级占比": "所選時間段內未關閉線上問題各優先順序佔比",
  "帮助检测潜在问题： 这可以帮助我们识别出哪些人可能需要更多的支持，或者他们的工作负载是否过大。如果某位团队成员的未解决线上问题数量远高于其他人，这可能表明他们正在处理的问题区域特别复杂，或可能需要增加资源和注意力。": "幫助檢測潛在問題： 這可以幫助我們識別出哪些人可能需要更多的支援，或者他們的工作負載是否過大。如果某位團隊成員的未解決線上問題數量遠高於其他人，這可能表明他們正在處理的問題區域特別複雜，或可能需要增加資源和注意力。",
  "均衡工作负载：这个指标也可以帮助我们平衡工作负载，我们可以通过调整任务分配，使每个团队成员负责的线上问题数量大致平均。这个指标并不意味着线上问题多的团队成员工作效率低下或技术能力差，反而可能因为他们在处理更复杂的、更需要专业技术的问题。因此，必须结合实际情况进行，理解背后可能的因素，而不是简单地从数量上学判别。": "均衡工作負載：這個指標也可以幫助我們平衡工作負載，我們可以透過調整任務分配，使每個團隊成員負責的線上問題數量大致平均。這個指標並不意味著線上問題多的團隊成員工作效率低下或技術能力差，反而可能因為他們在處理更復雜的、更需要專業技術的問題。因此，必須結合實際情況進行，理解背後可能的因素，而不是簡單地從數量上學判別。",
  "有": "有",
  "没有": "沒有",
  "配置模板": "配置模板",
  "自动推送": "自動推送",
  "抄送人&负责人": "抄送人&負責人",
  "编辑模板": "編輯模板",
  "管理部门周报细分模板": "管理部門週報細分模板",
  "确认要删除该部门周报模板吗？": "確認要刪除該部門週報模板嗎？",
  "删除部门周报模板": "刪除部門週報模板",
  "配置部门周报": "配置部門週報",
  "部门列表": "部門列表",
  "已配置模板列表": "已配置模板列表",
  "配置部门周报模板": "配置部門週報模板",
  "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W周报】 会自动转译为 【xxx部门2034年第17周周报】；通配符说明：%N【部门名称】、%Y【当前年份】、%W【当年第几周】": "如果沒有自定義的需求，可以直接使用帶有萬用字元的預設模板，無需修改！預設利用萬用字元轉譯標題模板，eg：【%N_%Y%W週報】 會自動轉譯為 【xxx部門2034年第17週週報】；萬用字元說明：%N【部門名稱】、%Y【當前年份】、%W【當年第幾周】",
  "点击上方复制按钮获取原始模板或者自定义带有%Y与%W的模板": "點選上方複製按鈕獲取原始模板或者自定義帶有%Y與%W的模板",
  "点击获取原始标题模板": "點選獲取原始標題模板",
  "原始标题模板已复制到剪贴板": "原始標題模板已複製到剪貼簿",
  "选择你的周报收件人": "選擇你的週報收件人",
  "周报包含成员": "週報包含成員",
  "已添加周报模板项": "已新增週報模板項",
  "(可拖拽调整顺序)": "(可拖拽調整順序)",
  "未添加周报模板项": "未新增週報模板項",
  "已有模板": "已有模板",
  "确认删除该项目周报模板吗？": "確認刪除該專案週報模板嗎？",
  "未获取到模板ID，无法删除": "未獲取到模板ID，無法刪除",
  "删除模板": "刪除模板",
  "配置项目周报": "配置專案週報",
  "我负责且进行中的项目": "我負責且進行中的專案",
  "发送成功": "傳送成功",
  "汇报对象为邮件收件人，并且会自动拉取项目相关人员作为邮件抄送人": "彙報物件為郵件收件人，並且會自動拉取專案相關人員作為郵件抄送人",
  "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W周报】 会自动转译为 【xx项目_2024年第17周周报】；通配符说明：%N【项目名称】、%Y【当前年份】、%W【当年第几周】": "如果沒有自定義的需求，可以直接使用帶有萬用字元的預設模板，無需修改！預設利用萬用字元轉譯標題模板，eg：【%N_%Y%W週報】 會自動轉譯為 【xx專案_2024年第17週週報】；萬用字元說明：%N【專案名稱】、%Y【當前年份】、%W【當年第幾周】",
  "选择周报收件人": "選擇週報收件人",
  "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W周报】 会自动转译为 【产品经理_2024年第17周周报】；通配符说明：%N【角色名称】、%Y【当前年份】、%W【当年第几周】": "如果沒有自定義的需求，可以直接使用帶有萬用字元的預設模板，無需修改！預設利用萬用字元轉譯標題模板，eg：【%N_%Y%W週報】 會自動轉譯為 【產品經理_2024年第17週週報】；萬用字元說明：%N【角色名稱】、%Y【當前年份】、%W【當年第幾周】",
  "选择周报成员": "選擇週報成員",
  "请选择周报成员": "請選擇週報成員",
  "周报人员状况": "週報人員狀況",
  "模板包含成员": "模板包含成員",
  "确认要克隆该部门小组周报模板吗？": "確認要克隆該部門小組週報模板嗎？",
  "一键克隆模板": "一鍵克隆模板",
  "确认要删除该部门小组周报模板吗？": "確認要刪除該部門小組週報模板嗎？",
  "删除部门小组周报模板": "刪除部門小組週報模板",
  "创建部门小组周报模板": "建立部門小組週報模板",
  "配置个人周报模板": "配置個人週報模板",
  "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W_%B%P周报】 会自动转译为 【Luke李黎明_2024年第17周_研发效能（Development Engineer）周报】；通配符说明：%N【发送人姓名】、%Y【当前年份】、%W【当年第几周】、%B【业务领域】、%P【岗位】": "如果沒有自定義的需求，可以直接使用帶有萬用字元的預設模板，無需修改！預設利用萬用字元轉譯標題模板，eg：【%N_%Y%W_%B%P週報】 會自動轉譯為 【Luke李黎明_2024年第17周_研發效能（Development Engineer）週報】；萬用字元說明：%N【傳送人姓名】、%Y【當前年份】、%W【當年第幾周】、%B【業務領域】、%P【崗位】",
  "如果开启则在每周日15:00自动推送": "如果開啟則在每週日15:00自動推送",
  "已生成分享内容至剪切板": "已生成分享內容至剪下板",
  "删除评论": "刪除評論",
  "确认删除这条评论吗?": "確認刪除這條評論嗎?",
  "汇报给：": "彙報給：",
  "抄送：": "抄送：",
  "上一条": "上一條",
  "下一条": "下一條",
  "已读数：": "已讀數：",
  "已读人：": "已讀人：",
  "点赞人：": "點贊人：",
  "点赞": "點贊",
  "评论区：": "評論區：",
  "已保存为本周草稿内容": "已儲存為本週草稿內容",
  "保存后，本周写周报会携带上草稿内容，下周自动失效（草稿只对本周工作小结、下周工作计划、感想&问题&建议、自由内容模板有效）": "儲存後，本週寫週報會攜帶上草稿內容，下週自動失效（草稿只對本週工作小結、下週工作計劃、感想&問題&建議、自由內容模板有效）",
  "保存本周草稿": "儲存本週草稿",
  "确定现在推送工作周报吗？": "確定現在推送工作週報嗎？",
  "周报已在推送中，请勿重复提交": "週報已在推送中，請勿重複提交",
  "已创建周报推送任务，请稍等": "已建立週報推送任務，請稍等",
  "确认后将会直接生成【当周周报】！": "確認後將會直接生成【當週週報】！",
  "保存后，本周写周报会携带上草稿内容，下周自动失效": "儲存後，本週寫週報會攜帶上草稿內容，下週自動失效",
  "以下数据由系统生成：": "以下資料由系統生成：",
  "点击查看git提交详情": "點選檢視git提交詳情",
  "点击查看代码提交规范": "點選檢視程式碼提交規範",
  "确认后将会直接生成【当周周报】并通过邮件推送给汇报对象！": "確認後將會直接生成【當週週報】並透過郵件推送給彙報物件！",
  "用例类别": "用例類別",
  "标记": "標記",
  "开始日期": "開始日期",
  "风险程度": "風險程度",
  "风险应对方法": "風險應對方法",
  "已处理": "已處理",
  "未处理": "未處理",
  "总用例数量": "總用例數量",
  "新增功能用例数量": "新增功能用例數量",
  "已完成功能用例数量": "已完成功能用例數量",
  "未完成功能用例数量": "未完成功能用例數量",
  "新增自动化用例数量": "新增自動化用例數量",
  "已完成自动化用例数量": "已完成自動化用例數量",
  "未完成自动化用例数量": "未完成自動化用例數量",
  "该URL已失效，请重新复制新的分享链接在打开详情！": "該URL已失效，請重新複製新的分享連結在開啟詳情！",
  "点赞数": "點贊數",
  "确认要删除该周报吗？": "確認要刪除該週報嗎？",
  "删除周报": "刪除週報",
  "欢迎使用每周三省吾身": "歡迎使用每週三省吾身",
  "每周三省吾身，支持配置周报模板，根据您本周的工作内容一键生成周报，并且支持定时推送，": "每週三省吾身，支援配置週報模板，根據您本週的工作內容一鍵生成周報，並且支援定時推送，",
  "让您更轻松的填写周报。": "讓您更輕鬆的填寫週報。",
  "创建周报模板": "建立週報模板",
  "写部门周报": "寫部門週報",
  "配置角色模板": "配置角色模板",
  "写项目周报": "寫專案週報",
  "配置项目周报模板": "配置專案週報模板",
  "请输入标题名称": "請輸入標題名稱",
  "选择成员": "選擇成員",
  "获取该组织下的所有人员，支持多选": "獲取該組織下的所有人員，支援多選",
  "组织人员与岗位": "組織人員與崗位",
  "产品人员": "產品人員",
  "红色代表大于本周平均值，需关注。": "紅色代表大於本週平均值，需關注。",
  "平均值计算规则：总缺陷数 / 总人数": "平均值計算規則：總缺陷數 / 總人數",
  "汇总": "彙總",
  "1）淡黄色代表此产品经理评审数量在周平均值以下，如果持续较低需关注其工作内容。 平均值计算规则：总评审数 / 总人数": "1）淡黃色代表此產品經理評審數量在周平均值以下，如果持續較低需關注其工作內容。 平均值計算規則：總評審數 / 總人數",
  "2）红色代表未评审需求。": "2）紅色代表未評審需求。",
  "平均值": "平均值",
  "1）红色代表工作时长高于47.5小时(每天9.5H), 需关注。": "1）紅色代表工作時長高於47.5小時(每天9.5H), 需關注。",
  "2） 绿色代表工作时长低于42.5小时(每天8.5H)。": "2） 綠色代表工作時長低於42.5小時(每天8.5H)。",
  "周报推送时间": "週報推送時間",
  "每周日下午六点": "每週日下午六點",
  "确认要删除该周报模板吗？": "確認要刪除該週報模板嗎？",
  "删除周报模板": "刪除週報模板",
  "配置角色模块": "配置角色模組",
  "新增周报模块": "新增週報模組",
  "总工作时长": "總工作時長",
  "待介入需求平均已等待时长(天)": "待介入需求平均已等待時長(天)",
  "处理中需求": "處理中需求",
  "已暂停需求": "已暫停需求",
  "本周新增需求": "本週新增需求",
  "本周评审需求": "本週評審需求",
  "本周产品缺陷": "本週產品缺陷",
  "颜色说明": "顏色說明",
  ": 黄色代表需要关注，红色代表需要重点关注。": ": 黃色代表需要關注，紅色代表需要重點關注。",
  "数据统计时间范围": "資料統計時間範圍",
  ": 上周一 00:00 到上周日 23:59:59。": ": 上週一 00:00 到上週日 23:59:59。",
  "总工作时长参考": "總工作時長參考",
  "- 红色: 工作时长高于 47.5 小时 (每天 9.5 小时)，需关注。": "- 紅色: 工作時長高於 47.5 小時 (每天 9.5 小時)，需關注。",
  "- 绿色: 工作时长低于 42.5 小时 (每天 8.5 小时)。": "- 綠色: 工作時長低於 42.5 小時 (每天 8.5 小時)。",
  ": 待介入业务需求 + 待介入产品需求的总数。": ": 待介入業務需求 + 待介入產品需求的總數。",
  "待介入需求平均已等待时长 (天)": "待介入需求平均已等待時長 (天)",
  "计算规则为 (当前时间 - 待介入需求的创建时间) / 待介入需求数量。": "計算規則為 (當前時間 - 待介入需求的建立時間) / 待介入需求數量。",
  ": 需求状态为 “业务已确认” 或 “产品方案中” 的需求数量。": ": 需求狀態為 “業務已確認” 或 “產品方案中” 的需求數量。",
  "统计该产品经理的已暂停需求，“()”中统计的是平均暂停时长，与待介入需求平均已等待时长逻辑一致。": "統計該產品經理的已暫停需求，“()”中統計的是平均暫停時長，與待介入需求平均已等待時長邏輯一致。",
  "- 淡黄色: 此产品经理评审数量在周平均值以下，需关注其工作内容。": "- 淡黃色: 此產品經理評審數量在周平均值以下，需關注其工作內容。",
  "- 红色: 未评审需求。": "- 紅色: 未評審需求。",
  ": 测试问题中类别为 “需求缺陷” 的问题数。": ": 測試問題中類別為 “需求缺陷” 的問題數。",
  "- 红色: 大于本周平均值。": "- 紅色: 大於本週平均值。",
  "汇总/平均": "彙總/平均",
  "审核中": "稽核中",
  "工作项名称": "工作項名稱",
  "发布类型": "釋出型別",
  "关联分支": "關聯分支",
  "关联缺陷": "關聯缺陷",
  "预约日期": "預約日期",
  "预约人": "預約人",
  "预约时间": "預約時間",
  "发布状态": "釋出狀態",
  "发布描述": "釋出描述",
  "审核备注": "稽核備註",
  "确认要取消预约吗？": "確認要取消預約嗎？",
  "预约记录": "預約記錄",
  "服务分支详情": "服務分支詳情",
  "填写原因": "填寫原因",
  "原因不能为空": "原因不能為空",
  "请输入原因": "請輸入原因",
  "关联缺陷详情": "關聯缺陷詳情",
  "请选择发布分支": "請選擇釋出分支",
  "编辑预约": "編輯預約",
  "不存在预约发布服务分支": "不存在預約釋出服務分支",
  "预约发布类型": "預約釋出型別",
  "请选择预约发布类型": "請選擇預約釋出型別",
  "请选择工作项": "請選擇工作項",
  "请选择预约日期": "請選擇預約日期",
  "重新拉取服务分支": "重新拉取服務分支",
  "星期日": "星期日",
  "星期一": "星期一",
  "星期二": "星期二",
  "星期三": "星期三",
  "星期四": "星期四",
  "星期五": "星期五",
  "星期六": "星期六",
  "预约详情": "預約詳情",
  "预约状态": "預約狀態",
  "已预约": "已預約",
  "未预约": "未預約",
  "假期": "假期",
  "查看需求详情": "檢視需求詳情",
  "查看迭代详情": "檢視迭代詳情",
  "预约": "預約",
  "下个月": "下個月",
  "确认回滚": "確認回滾",
  "版本": "版本",
  "镜像": "映象",
  "处理中": "處理中",
  "历史版本": "歷史版本",
  "提交申请": "提交申請",
  "请输入回滚原因": "請輸入回滾原因",
  "申请调试": "申請除錯",
  "审批人": "審批人",
  "调试时长": "除錯時長",
  "请输入调试时长": "請輸入除錯時長",
  "请输入数字": "請輸入數字",
  "请输入1-120分钟": "請輸入1-120分鐘",
  "申请原因": "申請原因",
  "申请记录": "申請記錄",
  "审批中": "審批中",
  "已通过": "已透過",
  "已拒绝": "已拒絕",
  "申请人": "申請人",
  "申请时间": "申請時間",
  "审批成功": "審批成功",
  "审批时间": "審批時間",
  "就绪：": "就緒：",
  "个，可用：": "個，可用：",
  "个，期望：": "個，期望：",
  "滚动更新中": "滾動更新中",
  "容器名称": "容器名稱",
  "当前镜像": "當前映象",
  "启动时间": "啟動時間",
  "内存": "記憶體",
  "调试记录": "除錯記錄",
  "实时日志": "實時日誌",
  "健康检测": "健康檢測",
  "运行时长": "執行時長",
  "实例 IP": "例項 IP",
  "节点信息": "節點資訊",
  "基本操作": "基本操作",
  "查看 Yaml": "檢視 Yaml",
  "同步当前服务": "同步當前服務",
  "WebSocket 连接错误:": "WebSocket 連線錯誤:",
  "停止连接": "停止連線",
  "重新连接": "重新連線",
  "Pod 名称:": "Pod 名稱:",
  "容器名称:": "容器名稱:",
  "YAML 已复制到剪贴板！": "YAML 已複製到剪貼簿！",
  "复制失败！": "複製失敗！",
  "Yaml 配置": "Yaml 配置",
  "Pod数据同步成功": "Pod資料同步成功",
  "容器数据同步成功": "容器資料同步成功",
  "数据同步中，请耐心等待": "資料同步中，請耐心等待",
  "当前服务同步成功": "當前服務同步成功",
  "获取容器调试权限失败，请重试": "獲取容器除錯許可權失敗，請重試",
  "副本数量": "副本數量",
  "调整": "調整",
  "实例IP": "例項IP",
  "服务实例": "服務例項",
  "列表视图": "列表檢視",
  "卡片视图": "卡片檢視",
  "实例信息": "例項資訊",
  "K8s 集群": "K8s 叢集",
  "区域": "區域",
  "K8s 命名空间": "K8s 名稱空間",
  "镜像仓库": "映象倉庫",
  "加密成功": "加密成功",
  "加密生成器": "加密生成器",
  "复制生成结果": "複製生成結果",
  "加密": "加密",
  "副本数数据异常，请刷新页面后重试": "副本數資料異常，請重新整理頁面後重試",
  "伸缩": "伸縮",
  "服务：": "服務：",
  "当前期望副本数：": "當前期望副本數：",
  "目标副本数：": "目標副本數：",
  "可连续点击 +1/-1 选择最终目标值，然后一次提交。": "可連續點選 +1/-1 選擇最終目標值，然後一次提交。",
  "申请将副本数从": "申請將副本數從",
  "修改为": "修改為",
  "容器组数量": "容器組數量",
  "可用副本数/期望副本数": "可用副本數/期望副本數",
  "请输入服务名称": "請輸入服務名稱",
  "服务总数": "服務總數",
  "地域/集群/命名空间": "地域/叢集/名稱空間",
  "命名空间：": "名稱空間：",
  "请选择命名空间": "請選擇名稱空間",
  "请先选择地域": "請先選擇地域",
  "应用同步成功": "應用同步成功",
  "泳道组": "泳道組",
  "编辑泳道组": "編輯泳道組",
  "入口类型:": "入口型別:",
  "泳道组流量入口:": "泳道組流量入口:",
  "泳道组涉及的应用": "泳道組涉及的應用",
  "暂无匹配的应用": "暫無匹配的應用",
  "暂无应用数据": "暫無應用資料",
  "请不要重复提交": "請不要重複提交",
  "提交错误:": "提交錯誤:",
  "创建泳道组": "建立泳道組",
  "更新": "更新",
  "创建泳道组后：": "建立泳道組後：",
  "1.若未创建灰度泳道，网关的所有流量默认会路由至后端服务的基线节点。": "1.若未建立灰度泳道，閘道器的所有流量預設會路由至後端服務的基線節點。",
  "2.若已创建灰度泳道，网关会将不匹配灰度规则的流量路由至基线节点。": "2.若已建立灰度泳道，閘道器會將不匹配灰度規則的流量路由至基線節點。",
  "因此，需确保网关所指向的后端服务包含基线节点，否则请求会报错。": "因此，需確保閘道器所指向的後端服務包含基線節點，否則請求會報錯。",
  "基线节点指的是未接入服务治理的节点，或接入过程中未添加 alicloud.service.tag 标签的节点。": "基線節點指的是未接入服務治理的節點，或接入過程中未新增 alicloud.service.tag 標籤的節點。",
  "泳道组名称": "泳道組名稱",
  "请输入泳道组名称": "請輸入泳道組名稱",
  "泳道组名称不能超过64个字符": "泳道組名稱不能超過64個字元",
  "支持大小写字母、数字、\".\"和\"-\"、长度不超过64个字符": "支援大小寫字母、數字、\".\"和\"-\"、長度不超過64個字元",
  "入口类型": "入口型別",
  "请选择入口类型": "請選擇入口型別",
  "入口网关": "入口閘道器",
  "请选择入口网关": "請選擇入口閘道器",
  "泳道组涉及应用": "泳道組涉及應用",
  "选择泳道组涉及应用": "選擇泳道組涉及應用",
  "请选择泳道组涉及的应用": "請選擇泳道組涉及的應用",
  "应用数据同步成功": "應用資料同步成功",
  "请先选择命名空间": "請先選擇名稱空間",
  "请先选择泳道组": "請先選擇泳道組",
  "命名空间同步成功": "名稱空間同步成功",
  "刷新成功": "重新整理成功",
  "泳道组同步成功": "泳道組同步成功",
  "同步命名空间": "同步名稱空間",
  "刷新泳道组": "重新整理泳道組",
  "同步泳道组": "同步泳道組",
  "当前命名空间下暂无泳道组": "當前名稱空間下暫無泳道組",
  "请创建第一个泳道组来开始流量管理": "請建立第一個泳道組來開始流量管理",
  "按内容模式必须设置至少一条灰度条件": "按內容模式必須設定至少一條灰度條件",
  "请完善所有灰度条件的参数": "請完善所有灰度條件的引數",
  "按内容模式至少需要一条灰度条件": "按內容模式至少需要一條灰度條件",
  "参数类型": "引數型別",
  "参数": "引數",
  "条件": "條件",
  "前缀匹配": "字首匹配",
  "正则匹配": "正則匹配",
  "百分比": "百分比",
  "hash(get(key)) % 100 < value 成立时满足条件": "hash(get(key)) % 100 < value 成立時滿足條件",
  "值": "值",
  "输入值后按回车添加": "輸入值後按回車新增",
  "输入值后按回车添加多个条件": "輸入值後按回車新增多個條件",
  "hash(get(key)) % 100 &lt; value 成立时满足条件": "hash(get(key)) % 100 &lt; value 成立時滿足條件",
  "按内容模式至少需要一条条件": "按內容模式至少需要一條條件",
  "删除条件": "刪除條件",
  "编辑泳道": "編輯泳道",
  "创建泳道": "建立泳道",
  "泳道名称": "泳道名稱",
  "请输入一个便于理解和识别的泳道名称": "請輸入一個便於理解和識別的泳道名稱",
  "请输入泳道名称": "請輸入泳道名稱",
  "泳道名称不能超过64个字符": "泳道名稱不能超過64個字元",
  "泳道标签": "泳道標籤",
  "请选择泳道标签": "請選擇泳道標籤",
  "编辑模式下不能修改泳道标签": "編輯模式下不能修改泳道標籤",
  "泳道标签需要用来给应用打标，当匹配条件命中时，会将打上此处定义的标识。": "泳道標籤需要用來給應用打標，當匹配條件命中時，會將打上此處定義的標識。",
  "确认匹配关系": "確認匹配關係",
  "请确认泳道标签与打标节点之间的匹配关系。如果不合预期，请根据实际情况调整泳道或节点的标签。请注意，下列匹配关系是系统当前的实时状态，后续可能会随着系统的变更而发生改变。": "請確認泳道標籤與打標節點之間的匹配關係。如果不合預期，請根據實際情況調整泳道或節點的標籤。請注意，下列匹配關係是系統當前的實時狀態，後續可能會隨著系統的變更而發生改變。",
  "应用名称": "應用名稱",
  "匹配节点数/全部节点数": "匹配節點數/全部節點數",
  "泳道状态": "泳道狀態",
  "灰度模式": "灰度模式",
  "灰度模式在整个泳道组内需保持一致，一旦第一条泳道成功创建，后续泳道就不可以再对其进行更改": "灰度模式在整個泳道組內需保持一致，一旦第一條泳道成功建立，後續泳道就不可以再對其進行更改",
  "按内容匹配度": "按內容匹配度",
  "当请求内容可以用于灰度识别时，建议采用此种灰度模式。倘若不可以，也强烈建议您通过系统改造增加此类灰度标识，以便获得更好的灰度效果。比如，可以保持灰度请求前后的一致性。": "當請求內容可以用於灰度識別時，建議採用此種灰度模式。倘若不可以，也強烈建議您透過系統改造增加此類灰度標識，以便獲得更好的灰度效果。比如，可以保持灰度請求前後的一致性。",
  "按比例匹配度": "按比例匹配度",
  "当请求内容无法用于灰度识别且遗留系统也无法进行改造时，可以采用此种退化的灰度模式。该模式有一定弊端，可能导致同一来源的请求进入不同泳道，而造成灰度请求前后行为的不一致。": "當請求內容無法用於灰度識別且遺留系統也無法進行改造時，可以採用此種退化的灰度模式。該模式有一定弊端，可能導致同一來源的請求進入不同泳道，而造成灰度請求前後行為的不一致。",
  "流量比例": "流量比例",
  "为所选路由或Path设置流量比例，在默认情况下，泳道内的所有路由或Path都将使用统一的流量比例。": "為所選路由或Path設定流量比例，在預設情況下，泳道內的所有路由或Path都將使用統一的流量比例。",
  "• 单个泳道流量比例不能超过": "• 單個泳道流量比例不能超過",
  "• 泳道组内所有泳道流量比例之和不能超过": "• 泳道組內所有泳道流量比例之和不能超過",
  "• 当前泳道组已使用": "• 當前泳道組已使用",
  "%，最多还可分配": "%，最多還可分配",
  "请输入流量比例": "請輸入流量比例",
  "灰度条件": "灰度條件",
  "灰度条件指定了请求内容的灰度匹配方式。当请求内容满足下列条件时，会被打上前面指定的泳道标签。": "灰度條件指定了請求內容的灰度匹配方式。當請求內容滿足下列條件時，會被打上前面指定的泳道標籤。",
  "条件关系": "條件關係",
  "按内容模式必须设置至少一条灰度条件，且所有条件参数都必须填写完整。": "按內容模式必須設定至少一條灰度條件，且所有條件引數都必須填寫完整。",
  "以下条件同时满足": "以下條件同時滿足",
  "以下条件任意满足": "以下條件任意滿足",
  "请添加灰度条件": "請新增灰度條件",
  "添加灰度条件": "新增灰度條件",
  "条件:": "條件:",
  "泳道同步成功": "泳道同步成功",
  "泳道应用列表": "泳道應用列表",
  "流量分配条件规则": "流量分配條件規則",
  "灰度比例": "灰度比例",
  "已启用": "已啟用",
  "已关闭": "已關閉",
  "流量分配": "流量分配",
  "刷新泳道": "重新整理泳道",
  "同步泳道": "同步泳道",
  "搜索泳道名称": "搜尋泳道名稱",
  "发布中": "釋出中",
  "编辑中": "編輯中",
  "下线中": "下線中",
  "强制HTTPS": "強制HTTPS",
  "已开启": "已開啟",
  "来源": "來源",
  "插件名称": "外掛名稱",
  "未启用": "未啟用",
  "当前版本": "當前版本",
  "最高版本": "最高版本",
  "确认生效?": "確認生效?",
  "生效成功!": "生效成功!",
  "生效": "生效",
  "灰度配置": "灰度配置",
  "保存(无权限)": "儲存(無許可權)",
  "保存成功!": "儲存成功!",
  "灰度版本": "灰度版本",
  "请选择!": "請選擇!",
  "灰度方式": "灰度方式",
  "灰度值": "灰度值",
  "最多只能设置4000个灰度值": "最多隻能設定4000個灰度值",
  "请至少选择或输入一个灰度值": "請至少選擇或輸入一個灰度值",
  "选择国家": "選擇國家",
  "选择用户": "選擇使用者",
  "用户ID": "使用者ID",
  "每行一个用户ID，或用逗号分隔 例如: user1 user2,user3 user4": "每行一個使用者ID，或用逗號分隔 例如: user1 user2,user3 user4",
  "请输入要添加的用户ID": "請輸入要新增的使用者ID",
  "没有有效的用户ID可添加": "沒有有效的使用者ID可新增",
  "预览": "預覽",
  "生效中": "生效中",
  "服务类別": "服務類別",
  "秒": "秒",
  "责任描述": "責任描述",
  "查看错误日志": "檢視錯誤日誌",
  "请勾选要复制的数据": "請勾選要複製的資料",
  "已复制发布记录到剪贴板": "已複製釋出記錄到剪貼簿",
  "复制选中数据": "複製選中資料",
  "请选择或输入服务名称": "請選擇或輸入服務名稱",
  "关联发布单": "關聯釋出單",
  "选择系统": "選擇系統",
  "编辑回滚责任人": "編輯回滾責任人",
  "申请Hot Fix": "申請Hot Fix",
  "申请服务的服务类型": "申請服務的服務型別",
  "服务类型不能为空": "服務型別不能為空",
  "服务不能为空": "服務不能為空",
  "申请的服务": "申請的服務",
  "分支不能为空": "分支不能為空",
  "申请的分支": "申請的分支",
  "请输入发布原因，不超过30个字符": "請輸入釋出原因，不超過30個字元",
  "发布原因不能为空": "釋出原因不能為空",
  "获取服务列表失败:": "獲取服務列表失敗:",
  "获取分支列表失败:": "獲取分支列表失敗:",
  "获取服务属性失败:": "獲取服務屬性失敗:",
  "获取服务列表失败": "獲取服務列表失敗",
  "获取服务信息失败": "獲取服務資訊失敗",
  "请先选择发布单类型和对应的载体": "請先選擇釋出單型別和對應的載體",
  "获取已发布服务分支失败": "獲取已釋出服務分支失敗",
  "分支领先Master": "分支領先Master",
  "分支落后Master": "分支落後Master",
  "新加坡生产环境发布": "新加坡生產環境釋出",
  "（提交后会创建新加坡生产环境发布申请，发布需走审批流程，并会自动创建一个发布单，请先确保新加披uat已验证通过）": "（提交後會建立新加坡生產環境釋出申請，釋出需走審批流程，並會自動建立一個釋出單，請先確保新加披uat已驗證透過）",
  "（提交后会按服务顺序直接发布，并会根据发布单类型创建或关联一个发布单）": "（提交後會按服務順序直接釋出，並會根據釋出單型別建立或關聯一個釋出單）",
  "默认查60天git提交记录": "預設查60天git提交記錄",
  "分支检查失败": "分支檢查失敗",
  "分支落后检查": "分支落後檢查",
  "已关联发布单服务分支清单": "已關聯釋出單服務分支清單",
  "请选择发布单类型": "請選擇釋出單型別",
  "请选择或输入需求名称": "請選擇或輸入需求名稱",
  "本次发布关联的产品需求": "本次釋出關聯的產品需求",
  "请选择或输入迭代名称": "請選擇或輸入迭代名稱",
  "本次发布关联的Sprint": "本次釋出關聯的Sprint",
  "请选择或输入线上问题名称": "請選擇或輸入線上問題名稱",
  "本次发布关联的线上问题": "本次釋出關聯的線上問題",
  "如果拉取，则会将该载体下所有commit记录的服务分支拉取出来并填充": "如果拉取，則會將該載體下所有commit記錄的服務分支拉取出來並填充",
  "添加服务分支": "新增服務分支",
  "非常重要！！！服务将按照当前表格顺序发布，默认顺序为后端基础、后端核心、后端其他、前端基础、前端核心、前端其他，可拖动修改发布顺序。": "非常重要！！！服務將按照當前表格順序釋出，預設順序為後端基礎、後端核心、後端其他、前端基礎、前端核心、前端其他，可拖動修改釋出順序。",
  "待发布": "待發布",
  "发布检查": "釋出檢查",
  "分支检查结果": "分支檢查結果",
  "未发布发布单": "未釋出釋出單",
  "发布单": "釋出單",
  "已取消": "已取消",
  "排队中": "排隊中",
  "暂无流水线明细": "暫無流水線明細",
  "原发布流水线": "原發布流水線",
  "服务 / 分支": "服務 / 分支",
  "分支：": "分支：",
  "环境：": "環境：",
  "当前发布状态": "當前釋出狀態",
  "耗时：": "耗時：",
  "部署实际状态": "部署實際狀態",
  "前往 K8s 查看": "前往 K8s 檢視",
  "发布历史 / 日志": "釋出歷史 / 日誌",
  "保留原发布信息和流水线明细；展开服务可查看流水线。K8s 实际运行情况请点击对应入口，页面每 3 秒自动刷新。": "保留原發布資訊和流水線明細；展開服務可檢視流水線。K8s 實際執行情況請點選對應入口，頁面每 3 秒自動重新整理。",
  "查看 K8s 服务详情": "檢視 K8s 服務詳情",
  "K8s 详情": "K8s 詳情",
  "【新加坡生产环境】发布需要走审批流程。（tips：在表格中勾选的服务可被直接代入提交表单）": "【新加坡生產環境】釋出需要走審批流程。（tips：在表格中勾選的服務可被直接代入提交表單）",
  "【非生产环境】可以不走正常发布流程。（tips：在表格中勾选的服务可被直接代入提交表单）": "【非生產環境】可以不走正常釋出流程。（tips：在表格中勾選的服務可被直接代入提交表單）",
  "申请发布": "申請釋出",
  "创建发布": "建立釋出",
  "【Hot Fix】可在这提交申请。（tips：1、若【二次发布】提交的服务为首次发布，则发布单发布次数不会加1）2、在表格中勾选的服务可被直接代入提交表单": "【Hot Fix】可在這提交申請。（tips：1、若【二次釋出】提交的服務為首次釋出，則釋出單釋出次數不會加1）2、在表格中勾選的服務可被直接代入提交表單",
  "确定要回滚": "確定要回滾",
  "确定要中断部署": "確定要中斷部署",
  "点击查看服务部署流水线，（": "點選檢視服務部署流水線，（",
  "）个服务正在部署流程中": "）個服務正在部署流程中",
  "（发布成功后发布单将变为【待回归】状态，需要测试回归需求）": "（釋出成功後釋出單將變為【待迴歸】狀態，需要測試迴歸需求）",
  "服务代码分支": "服務程式碼分支",
  "存在以下SQL工单未通过，请确定是否忽略？": "存在以下SQL工單未透過，請確定是否忽略？",
  "请输入发布单名称": "請輸入釋出單名稱",
  "确定一键发布?": "確定一鍵釋出?",
  "一键发布流程创建成功": "一鍵釋出流程建立成功",
  "】 发布单吗？": "】 釋出單嗎？",
  "】 发布单是否已经完成发布？": "】 釋出單是否已經完成釋出？",
  "确定后该发布单未发布服务分支将会被删除，状态将会变为【待回归】状态！": "確定後該釋出單未釋出服務分支將會被刪除，狀態將會變為【待迴歸】狀態！",
  "确定要验收 【": "確定要驗收 【",
  "】 发布单中的所有需求吗？": "】 釋出單中的所有需求嗎？",
  "操作后发布单状态将更新为【已验收】、需求状态更新为【已关闭】且无法回退": "操作後釋出單狀態將更新為【已驗收】、需求狀態更新為【已關閉】且無法回退",
  "确定要拒绝验收 【": "確定要拒絕驗收 【",
  "】发布单中的所有需求吗？": "】釋出單中的所有需求嗎？",
  "操作后发布单状态将变为【验收失败】": "操作後釋出單狀態將變為【驗收失敗】",
  "已将发布单分享链接至剪切板": "已將釋出單分享連結至剪下板",
  "可以将发布单状态手动设置为【待回归】状态": "可以將釋出單狀態手動設定為【待迴歸】狀態",
  "手动完成发布": "手動完成釋出",
  "查看审批详情": "檢視審批詳情",
  "回归": "迴歸",
  "验收": "驗收",
  "检查项详情": "檢查項詳情",
  "操作失败": "操作失敗",
  "暂无操作日志": "暫無操作日誌",
  "（操作后发布单状态将更新为【待验收】、需求状态更新为【已发布】且无法回退）": "（操作後釋出單狀態將更新為【待驗收】、需求狀態更新為【已釋出】且無法回退）",
  "需求已经发布成功，请及时进行线上验收并进行结果确认": "需求已經發布成功，請及時進行線上驗收並進行結果確認",
  "查看所有": "檢視所有",
  "请确认检查项内容": "請確認檢查項內容",
  "暂无内容": "暫無內容",
  "更多（+": "更多（+",
  "关联发布单操作（无需操作可直接关闭）": "關聯釋出單操作（無需操作可直接關閉）",
  "发布单吗？": "釋出單嗎？",
  "确定要验收": "確定要驗收",
  "发布单中的所有需求吗？": "釋出單中的所有需求嗎？",
  "是否紧急发布": "是否緊急釋出",
  "预期发布日期": "預期釋出日期",
  "实际发布日期": "實際釋出日期",
  "点击查看任务": "點選檢視任務",
  "服务分支": "服務分支",
  "关联工作项": "關聯工作項",
  "删除发布单": "刪除釋出單",
  "已生产发布单分享链接至剪切板": "已生產釋出單分享連結至剪下板",
  "（下面为任务中未发布的服务分支，提交后将直接发起发布）": "（下面為任務中未釋出的服務分支，提交後將直接發起釋出）",
  "已指定责任人": "已指定責任人",
  "已指定": "已指定",
  "今日部署：": "今日部署：",
  "今日部署服务数量（与昨日环比情况）": "今日部署服務數量（與昨日環比情況）",
  "部署成功率：": "部署成功率：",
  "今日部署成功的服务数量 / 今日部署服务数量": "今日部署成功的服務數量 / 今日部署服務數量",
  "待部署：": "待部署：",
  "今日创建的发布单中还未部署的服务数量": "今日建立的釋出單中還未部署的服務數量",
  "紧急发布：": "緊急釋出：",
  "今日紧急发布发布单中的服务总数": "今日緊急釋出釋出單中的服務總數",
  "今日申请Hot fix的服务数量": "今日申請Hot fix的服務數量",
  "预计明日：": "預計明日：",
  "预计发布时间为明日且未发布的服务数量": "預計釋出時間為明日且未釋出的服務數量",
  "已回归": "已迴歸",
  "今日创建的发布单中已回归状态的发布单数量": "今日建立的釋出單中已迴歸狀態的釋出單數量",
  "待回归": "待迴歸",
  "今日创建的发布单中待回归状态的发布单数量": "今日建立的釋出單中待迴歸狀態的釋出單數量",
  "已验收": "已驗收",
  "今日创建的发布单中已验收状态的发布单数量": "今日建立的釋出單中已驗收狀態的釋出單數量",
  "今日创建的发布单中待发布状态的发布单数量": "今日建立的釋出單中待發布狀態的釋出單數量",
  "上线失败：": "上線失敗：",
  "今日创建的发布单中上线失败状态的发布单数量": "今日建立的釋出單中上線失敗狀態的釋出單數量",
  "发布窗口期内无需审批即可创建发布单": "釋出視窗期內無需審批即可建立釋出單",
  "今日部署": "今日部署",
  "部署成功率": "部署成功率",
  "待部署": "待部署",
  "预计明日": "預計明日",
  "待验收": "待驗收",
  "上线失败": "上線失敗",
  "已复制到剪贴板": "已複製到剪貼簿",
  "问题数": "問題數",
  "最新提交问题统计": "最新提交問題統計",
  "规则": "規則",
  "文件路径": "檔案路徑",
  "发现": "發現",
  "个问题": "個問題",
  "代码提交详情": "程式碼提交詳情",
  "文件代码详情": "檔案程式碼詳情",
  "跳转至GitLab": "跳轉至GitLab",
  "复制Commit ID": "複製Commit ID",
  "复制文件路径": "複製檔案路徑",
  "搜索服务": "搜尋服務",
  "提交人：": "提交人：",
  "提交信息：": "提交資訊：",
  "提交时间：": "提交時間：",
  "请输入...": "請輸入...",
  "严重性": "嚴重性",
  "输入文件路径": "輸入檔案路徑",
  "问题行号": "問題行號",
  "错误信息": "錯誤資訊",
  "早到之星": "早到之星",
  "披星戴月": "披星戴月",
  "迟到最多": "遲到最多",
  "迟到": "遲到",
  "各部门平均工时": "各部門平均工時",
  "最近七天": "最近七天",
  "排名Top 20": "排名Top 20",
  "各部门平均工时排名": "各部門平均工時排名",
  "各岗位平均工时": "各崗位平均工時",
  "各Base地平均工时": "各Base地平均工時",
  "各人员平均工时": "各人員平均工時",
  "人员月度排名Top 20": "人員月度排名Top 20",
  "个人加班工时": "個人加班工時",
  "部门加班工时": "部門加班工時",
  "Base地加班工时": "Base地加班工時",
  "新增/交付需求": "新增/交付需求",
  "近12月内新增需求数、已交付（取值以需求关闭时间）需求数量；": "近12月內新增需求數、已交付（取值以需求關閉時間）需求數量；",
  "线上问题解决时效与数量趋势（横向）": "線上問題解決時效與數量趨勢（橫向）",
  "线上问题修复时长指标：平均问题修复时长反映了研发过程质量，指标反映了测试缺陷修复效率。": "線上問題修復時長指標：平均問題修復時長反映了研發過程質量，指標反映了測試缺陷修復效率。",
  "1、平均响应耗时=∑（确认时间-指派时间）/n，该耗时越长研发需要改进。": "1、平均響應耗時=∑（確認時間-指派時間）/n，該耗時越長研發需要改進。",
  "2、平均修复耗时=∑（解决时间-确认时间）/n，该耗时越长研发需要改进。": "2、平均修復耗時=∑（解決時間-確認時間）/n，該耗時越長研發需要改進。",
  "3、平均关闭耗时=∑（关闭时间-解决时间）/n，该耗时越长缺陷提交人需要改进。": "3、平均關閉耗時=∑（關閉時間-解決時間）/n，該耗時越長缺陷提交人需要改進。",
  "4、平均修复总耗时=∑（关闭时间-首次指派时间）/n，该耗时越长缺陷提交人需要改进。": "4、平均修復總耗時=∑（關閉時間-首次指派時間）/n，該耗時越長缺陷提交人需要改進。",
  "5、全局平均修复耗时：∑（T1+T2+...+Tn）/ n（缺陷个数），单位时间区间内各系统，业务领域，研发整体测试缺陷解决耗时的平均基线，高于该基线的团队需要改进。": "5、全域性平均修復耗時：∑（T1+T2+...+Tn）/ n（缺陷個數），單位時間區間內各系統，業務領域，研發整體測試缺陷解決耗時的平均基線，高於該基線的團隊需要改進。",
  "缺陷解决时效与数量趋势（横向）": "缺陷解決時效與數量趨勢（橫向）",
  "测试缺陷修复时长指标：平均问题修复时长反映了研发过程质量，指标反映了测试缺陷修复效率。": "測試缺陷修復時長指標：平均問題修復時長反映了研發過程質量，指標反映了測試缺陷修復效率。",
  "线上问题解决时效与数量趋势（时间）": "線上問題解決時效與數量趨勢（時間）",
  "缺陷解决时效与数量趋势（时间）": "缺陷解決時效與數量趨勢（時間）",
  "线上问题新增趋势": "線上問題新增趨勢",
  "新增缺陷趋势": "新增缺陷趨勢",
  "趋势": "趨勢",
  "占比(状态)": "佔比(狀態)",
  "占比(优先级)": "佔比(優先順序)",
  "所选时间段内未关闭缺陷优先级占比": "所選時間段內未關閉缺陷優先順序佔比",
  "按成员排名": "按成員排名",
  "按项目/业务领域排名": "按專案/業務領域排名",
  "\"存量缺陷按系统/领域排名\"这一指标，对全局存量缺陷进行比较，并依据数量进行排名，以观测各研发团队的质量情况。": "\"存量缺陷按系統/領域排名\"這一指標，對全域性存量缺陷進行比較，並依據數量進行排名，以觀測各研發團隊的質量情況。",
  "这个指标的主要价值和意义在于：": "這個指標的主要價值和意義在於：",
  "排名靠前（即存量缺陷多）的团队可能需要进行更深入的代码审查或质量改进。": "排名靠前（即存量缺陷多）的團隊可能需要進行更深入的程式碼審查或質量改進。",
  "风险识别：如果某团队存量缺陷持续较多，那么可能代表该组织需求交付存在一定的风险，研发管理者需要引起注意，进行风险控制。": "風險識別：如果某團隊存量缺陷持續較多，那麼可能代表該組織需求交付存在一定的風險，研發管理者需要引起注意，進行風險控制。",
  "进展情况：通过查看各团队的存量缺陷排名，存量缺陷多可能说明团队进度较慢，存量缺陷少则可能说明团队进度较快。": "進展情況：透過檢視各團隊的存量缺陷排名，存量缺陷多可能說明團隊進度較慢，存量缺陷少則可能說明團隊進度較快。",
  "持续改进：此指标可以作为团队质量持续改进的一种工具，比如用来制定缺陷减少的目标，或者在各个研发组织之间推广成功的优秀实践等。": "持續改進：此指標可以作為團隊質量持續改進的一種工具，比如用來制定缺陷減少的目標，或者在各個研發組織之間推廣成功的優秀實踐等。",
  "每人创建的Bug数": "每人建立的Bug數",
  "每人解决的Bug数": "每人解決的Bug數",
  "每人关闭的Bug数": "每人關閉的Bug數",
  "按Bug严重程度统计": "按Bug嚴重程度統計",
  "按Bug解决方案统计": "按Bug解決方案統計",
  "按Bug类型统计": "按Bug型別統計",
  "缺陷关闭数": "缺陷關閉數",
  "缺陷新增数": "缺陷新增數",
  "历史缺陷存量": "歷史缺陷存量",
  "截至前一天21时未关闭的缺陷数量": "截至前一天21時未關閉的缺陷數量",
  "截至七天前21时未关闭的缺陷数量": "截至七天前21時未關閉的缺陷數量",
  "日清率(%)": "日清率(%)",
  "日清率(含存量)=（今日内缺陷关闭数/（今日新增缺陷数+至今日之前的缺陷存量））*100%": "日清率(含存量)=（今日內缺陷關閉數/（今日新增缺陷數+至今日之前的缺陷存量））*100%",
  "周清率(%)": "周清率(%)",
  "周清率(含存量)=（近7天缺陷关闭数/(近7天新增缺陷数+至7天前的缺陷存量））*100%": "周清率(含存量)=（近7天缺陷關閉數/(近7天新增缺陷數+至7天前的缺陷存量））*100%",
  "截至十四天前21时未关闭的缺陷数量": "截至十四天前21時未關閉的缺陷數量",
  "日清率(含存量)=（昨日缺陷关闭数/（昨日缺陷新增数+至昨日之前的缺陷存量））*100%": "日清率(含存量)=（昨日缺陷關閉數/（昨日缺陷新增數+至昨日之前的缺陷存量））*100%",
  "周清率(含存量)=（近7~14天内缺陷关闭数/（近7~14天内缺陷新增数+至14天前的缺陷存量））*100%": "周清率(含存量)=（近7~14天內缺陷關閉數/（近7~14天內缺陷新增數+至14天前的缺陷存量））*100%",
  "实时缺陷数据统计": "實時缺陷資料統計",
  "日清率": "日清率",
  "周清率": "周清率",
  "历史列表": "歷史列表",
  "返回实时数据": "返回實時資料",
  "总共": "總共",
  "展示条数": "展示條數",
  "代码提交规范率趋势": "程式碼提交規範率趨勢",
  "代码提交规范率排行": "程式碼提交規範率排行",
  "点击查看CR详情": "點選檢視CR詳情",
  "关闭搜索": "關閉搜尋",
  "展开搜索": "展開搜尋",
  "导出数据": "匯出資料",
  "下载文件失败：": "下載檔案失敗：",
  "总体需求数量（自然年）": "總體需求數量（自然年）",
  "年度累计交付需求总量": "年度累計交付需求總量",
  "年度累计交付需求需满足以下条件：": "年度累計交付需求需滿足以下條件：",
  "1）需求状态为：已发布、已关闭；": "1）需求狀態為：已釋出、已關閉；",
  "2）需求发布时间在本年1月1日至今天之间；": "2）需求釋出時間在本年1月1日至今天之間；",
  "3）不包括技术需求。": "3）不包括技術需求。",
  "年度累计新增需求总量": "年度累計新增需求總量",
  "年度累计新增需求需满足以下条件：": "年度累計新增需求需滿足以下條件：",
  "1）需求创建时间在本年1月1日至今天之间；": "1）需求建立時間在本年1月1日至今天之間；",
  "2）不包括技术需求。": "2）不包括技術需求。",
  "当前需求存量": "當前需求存量",
  "当前需求存量需满足以下条件：": "當前需求存量需滿足以下條件：",
  "1）需求状态不包括：已发布、已关闭；": "1）需求狀態不包括：已釋出、已關閉；",
  "当周需求数量（自然周）": "當週需求數量（自然周）",
  "当周交付需求数": "當週交付需求數",
  "当周交付需求需满足以下条件：": "當週交付需求需滿足以下條件：",
  "2）需求发布时间晚于上周日；": "2）需求釋出時間晚於上週日；",
  "当周新增需求数": "當週新增需求數",
  "当周新增需求需满足以下条件：": "當週新增需求需滿足以下條件：",
  "1）需求发布时间在本周一至今天之间；": "1）需求釋出時間在本週一至今天之間；",
  "需求准入数量": "需求准入數量",
  "超1个月未准入需求数": "超1個月未准入需求數",
  "超1个月未准入需求需满足以下条件：": "超1個月未准入需求需滿足以下條件：",
  "1）需求状态为：待介入；": "1）需求狀態為：待介入；",
  "2）需求创建时间早于近1月（相对于今天）的最后一天；": "2）需求建立時間早於近1月（相對於今天）的最後一天；",
  "近1周准入通过需求数": "近1周准入透過需求數",
  "近1周准入通过需求需满足以下条件：": "近1周准入透過需求需滿足以下條件：",
  "1）需求状态从待介入（产品需求以产品方案中等状态代替）更新为其他状态（不包含已取消）；": "1）需求狀態從待介入（產品需求以產品方案中等狀態代替）更新為其他狀態（不包含已取消）；",
  "进入研发需求数量": "進入研發需求數量",
  "超1个月待排期需求数": "超1個月待排期需求數",
  "超1个月待排期需求需满足以下条件：": "超1個月待排期需求需滿足以下條件：",
  "1）需求状态不包括已取消及已排期之前的需求状态；": "1）需求狀態不包括已取消及已排期之前的需求狀態；",
  "近1周排期需求数": "近1周排期需求數",
  "近1周排期需求需满足以下条件：": "近1周排期需求需滿足以下條件：",
  "1）已排期状态更新时间为：近1周（相对于今天的上1周时间范围）；": "1）已排期狀態更新時間為：近1周（相對於今天的上1周時間範圍）；",
  "实时需求数据统计": "實時需求資料統計",
  "如果选择了多个业务领域或系统，那预估结果为所选": "如果選擇了多個業務領域或系統，那預估結果為所選",
  "与": "與",
  "的聚合结果": "的聚合結果",
  "获取预估结果失败": "獲取預估結果失敗",
  "请至少选择一个筛选条件": "請至少選擇一個篩選條件",
  "已设为默认筛选条件": "已設為預設篩選條件",
  "操作区": "操作區",
  "新需求交付时间预估": "新需求交付時間預估",
  "产品需求概览": "產品需求概覽",
  "产品需求看板": "產品需求看板",
  "预估完成时间": "預估完成時間",
  "未来8周整体资源使用情况": "未來8周整體資源使用情況",
  "资源利用率计算说明": "資源利用率計算說明",
  "📊 计算公式": "📊 計算公式",
  "(角色人员任务排期已覆盖的工作日数 /": "(角色人員任務排期已覆蓋的工作日數 /",
  "(当周工作日数 × 角色人员数量)) × 100%": "(當週工作日數 × 角色人員數量)) × 100%",
  "💡 示例说明": "💡 示例說明",
  "• 当前系统下有": "• 當前系統下有",
  "2 个前端": "2 個前端",
  "• 本周有": "• 本週有",
  "5 个工作日": "5 個工作日",
  "，总人天为": "，總人天為",
  "• 任务排期分别覆盖了": "• 任務排期分別覆蓋了",
  "和": "和",
  "个工作日": "個工作日",
  "➜ 前端投入人天为 5，资源利用率为": "➜ 前端投入人天為 5，資源利用率為",
  "研发角色资源明细": "研發角色資源明細",
  "未来第几周忙不忙？": "未來第幾周忙不忙？",
  "📋 产品经理角色": "📋 產品經理角色",
  "1. 计算该产品经理最近 90 天的业务需求介入速率": "1. 計算該產品經理最近 90 天的業務需求介入速率",
  "例如：3 天/个": "例如：3 天/個",
  "2. 计算预估介入完成时间": "2. 計算預估介入完成時間",
  "未介入业务需求数 × 介入速率": "未介入業務需求數 × 介入速率",
  "3. 判断：当前时间 &gt; 预估完成时间 → 不忙": "3. 判斷：當前時間 &gt; 預估完成時間 → 不忙",
  "💻 研发与测试角色": "💻 研發與測試角色",
  "指定周工作日内任务排期时间未排满 → 不忙": "指定周工作日內任務排期時間未排滿 → 不忙",
  "指定周工作日内任务排期时间已排满 → 忙": "指定周工作日內任務排期時間已排滿 → 忙",
  "任务数：": "任務數：",
  "业务需求数：": "業務需求數：",
  "数量：": "數量：",
  "职位:": "職位:",
  "暂无角色资源数据": "暫無角色資源資料",
  "未来第几周:": "未來第幾周:",
  "繁忙人员": "繁忙人員",
  "空闲人员": "空閒人員",
  "繁忙率": "繁忙率",
  "繁忙人员:": "繁忙人員:",
  "空闲人员:": "空閒人員:",
  "健康度雷达图": "健康度雷達圖",
  "获取系统列表失败:": "獲取系統列表失敗:",
  "重置筛选": "重置篩選",
  "业务领域不能为空": "業務領域不能為空",
  "业务满意度(0-4)": "業務滿意度(0-4)",
  "删除原因": "刪除原因",
  "已创建": "已建立",
  "预估工时（人天）": "預估工時（人天）",
  "部分任务类型默认不展示": "部分任務型別預設不展示",
  "实际工时（人天）": "實際工時（人天）",
  "成本分析": "成本分析",
  "成本月对比": "成本月對比",
  "成本分布": "成本分佈",
  "提交失败，请检查必填项": "提交失敗，請檢查必填項",
  "请选择要添加的指标": "請選擇要新增的指標",
  "所选指标已全部存在，请选择其他指标": "所選指標已全部存在，請選擇其他指標",
  "指标描述：": "指標描述：",
  "暂无描述": "暫無描述",
  "指标极性：": "指標極性：",
  "正向指标": "正向指標",
  "负向指标": "負向指標",
  "权重值": "權重值",
  "请输入权重值": "請輸入權重值",
  "权重值不能小于0": "權重值不能小於0",
  "权重值不能大于100": "權重值不能大於100",
  "满分线": "滿分線",
  "请输入满分线": "請輸入滿分線",
  "满分线不能小于0": "滿分線不能小於0",
  "零分线": "零分線",
  "请输入零分线": "請輸入零分線",
  "零分线不能小于0": "零分線不能小於0",
  "指标顺序已更新": "指標順序已更新",
  "新建模型": "新建模型",
  "编辑模型": "編輯模型",
  "查看模型详情": "檢視模型詳情",
  "模型基础信息": "模型基礎資訊",
  "模型名称": "模型名稱",
  "请输入模型名称": "請輸入模型名稱",
  "模型名称不能超过100个字符": "模型名稱不能超過100個字元",
  "基础分": "基礎分",
  "请输入基础分": "請輸入基礎分",
  "基础分不能小于0": "基礎分不能小於0",
  "基础分不能大于100": "基礎分不能大於100",
  "请选择关联的业务领域（支持多选）": "請選擇關聯的業務領域（支援多選）",
  "请选择关联业务领域": "請選擇關聯業務領域",
  "模型指标配置": "模型指標配置",
  "请为以下指标配置权重值、满分线和零分线": "請為以下指標配置權重值、滿分線和零分線",
  "请选择要添加的指标（支持多选）": "請選擇要新增的指標（支援多選）",
  "批量添加指标 (": "批次新增指標 (",
  "个指标，点击按钮批量添加": "個指標，點選按鈕批次新增",
  "获取团队汇总数据失败": "獲取團隊彙總資料失敗",
  "获取团队汇总数据失败:": "獲取團隊彙總資料失敗:",
  "🏢 业务领域": "🏢 業務領域",
  "📅 年月": "📅 年月",
  "实际值": "實際值",
  "实际分": "實際分",
  "加权得分": "加權得分",
  "⚠️ 事故扣分": "⚠️ 事故扣分",
  "📊 总加权得分": "📊 總加權得分",
  "📈 同比变化": "📈 同比變化",
  "正在加载团队汇总数据...": "正在載入團隊彙總資料...",
  "📊 数据概览": "📊 資料概覽",
  "🎯 当前平均分": "🎯 當前平均分",
  "📈 环比变化": "📈 環比變化",
  "📊 去年同期": "📊 去年同期",
  "📊 同比变化": "📊 同比變化",
  "🏆 得分排名": "🏆 得分排名",
  "汇总平均": "彙總平均",
  "📡 效能指标雷达图": "📡 效能指標雷達圖",
  "🏢 选择业务领域:": "🏢 選擇業務領域:",
  "当前指标得分（加权得分）": "當前指標得分（加權得分）",
  "同比指标对比（加权得分）": "同比指標對比（加權得分）",
  "暂无雷达图数据，请先选择一个业务领域查看指标对比": "暫無雷達圖資料，請先選擇一個業務領域檢視指標對比",
  "创建效能评分模型": "建立效能評分模型",
  "获取团队详情数据失败": "獲取團隊詳情資料失敗",
  "获取团队详情数据失败:": "獲取團隊詳情資料失敗:",
  "正在加载团队数据...": "正在載入團隊資料...",
  "请先选择业务领域": "請先選擇業務領域",
  "在筛选条件中选择一个业务领域以查看团队详情数据": "在篩選條件中選擇一個業務領域以檢視團隊詳情資料",
  "📊 年度数据概览": "📊 年度資料概覽",
  "月": "月",
  "平均分": "平均分",
  "📈 年度提升": "📈 年度提升",
  "🏆 最高月份（": "🏆 最高月份（",
  "⚠️ 最低月份（": "⚠️ 最低月份（",
  "📈 月度得分趋势": "📈 月度得分趨勢",
  "📅 月度得分详情": "📅 月度得分詳情",
  "📅 选择月份（多选，不选则显示所有月份）:": "📅 選擇月份（多選，不選則顯示所有月份）:",
  "请选择月份，不选则显示所有月份数据": "請選擇月份，不選則顯示所有月份資料",
  "年度平均指标对比（加权得分）": "年度平均指標對比（加權得分）",
  "暂无雷达图数据": "暫無雷達圖資料",
  "暂无选中月份的雷达图数据，请选择其他月份或清空选择查看所有月份数据": "暫無選中月份的雷達圖資料，請選擇其他月份或清空選擇檢視所有月份資料",
  "您不是业务领域负责人，无法查看": "您不是業務領域負責人，無法檢視",
  "您不是业务领域负责人，无法查询团队视图": "您不是業務領域負責人，無法查詢團隊檢視",
  "查询已触发": "查詢已觸發",
  "全局视图数据已刷新": "全域性檢視資料已重新整理",
  "团队视图数据已刷新": "團隊檢視資料已重新整理",
  "请选择时间范围": "請選擇時間範圍",
  "团队视图": "團隊檢視",
  "全局视图": "全域性檢視",
  "还没有效能评分模型哦": "還沒有效能評分模型哦",
  "立即创建": "立即建立",
  "💯 满分部门（100%）": "💯 滿分部門（100%）",
  "👍 优秀部门（≥90%）": "👍 優秀部門（≥90%）",
  "💔 待改进部门（＜90%）": "💔 待改進部門（＜90%）",
  "指标/部门": "指標/部門",
  "确认关闭": "確認關閉",
  "请至少选择一个邮件接收人": "請至少選擇一個郵件接收人",
  "邮件发送成功": "郵件傳送成功",
  "提交失败，请重试": "提交失敗，請重試",
  "选择邮件收件人": "選擇郵件收件人",
  "是否发送水印图表": "是否傳送水印圖表",
  "水印图表异步发送，存在失败的情况，且发送时间较长，请谨慎发送": "水印圖表非同步傳送，存在失敗的情況，且傳送時間較長，請謹慎傳送",
  "请输入有效的邮箱地址": "請輸入有效的郵箱地址",
  "需求吞吐量趋势（业务领域）": "需求吞吐量趨勢（業務領域）",
  "统计口径：当月已发布/当月新增*100%": "統計口徑：當月已釋出/當月新增*100%",
  "交付需求数（个）": "交付需求數（個）",
  "创建需求数（个）": "建立需求數（個）",
  "未完成需求数（个）": "未完成需求數（個）",
  "吞吐率平均值（%）": "吞吐率平均值（%）",
  "高于平均吞吐率的业务领域 (共": "高於平均吞吐率的業務領域 (共",
  "个, 上期": "個, 上期",
  "个 )": "個 )",
  "连续2个月高于平均值的业务领域": "連續2個月高於平均值的業務領域",
  "技术需求占比": "技術需求佔比",
  "统计口径：当月发布技术需求/当月发布总需求*100%": "統計口徑：當月釋出技術需求/當月釋出總需求*100%",
  "技术需求交付占比平均值(%)": "技術需求交付佔比平均值(%)",
  "技术需求占比最多": "技術需求佔比最多",
  "技术需求占比最少": "技術需求佔比最少",
  "开发交付周期": "開發交付週期",
  "统计口径：已发布时间-产品阶段结束时间": "統計口徑：已釋出時間-產品階段結束時間",
  "所有类型需求平均交付周期(天)": "所有型別需求平均交付週期(天)",
  "产品需求平均交付周期(天)": "產品需求平均交付週期(天)",
  "技术需求平均交付周期(天)": "技術需求平均交付週期(天)",
  "产品需求开发交付周期最长": "產品需求開發交付週期最長",
  "技术需求开发交付周期最长": "技術需求開發交付週期最長",
  "产品需求开发交付周期最短": "產品需求開發交付週期最短",
  "技术需求开发交付周期最短": "技術需求開發交付週期最短",
  "交付需求的创建时间分布": "交付需求的建立時間分佈",
  "bug关闭与新增情况": "bug關閉與新增情況",
  "统计口径：bug关闭占比=当月bug关闭数/新增数": "統計口徑：bug關閉佔比=當月bug關閉數/新增數",
  "关闭总数(个)": "關閉總數(個)",
  "新增总数(个)": "新增總數(個)",
  "各领域关闭占比平均值(%)": "各領域關閉佔比平均值(%)",
  "关闭bug创建时间分布": "關閉bug建立時間分佈",
  "bug类型及业务领域占比": "bug型別及業務領域佔比",
  "线上bug逃逸率（按照逃逸率降序排序）": "線上bug逃逸率（按照逃逸率降序排序）",
  "统计口径：线上bug关闭数/(过程bug关闭数+线上bug关闭数)*100%": "統計口徑：線上bug關閉數/(過程bug關閉數+線上bug關閉數)*100%",
  "bug逃逸率平均值(%)": "bug逃逸率平均值(%)",
  "逃逸率最高": "逃逸率最高",
  "逃逸率最低": "逃逸率最低",
  "bug关闭时效": "bug關閉時效",
  "平均响应耗时=∑(确认时间-指派时间)/bug关闭数 该耗时越长研发需要改进": "平均響應耗時=∑(確認時間-指派時間)/bug關閉數 該耗時越長研發需要改進",
  "平均修复耗时=∑(解决时间-确认时间)/bug关闭数 该耗时越长研发需要改进": "平均修復耗時=∑(解決時間-確認時間)/bug關閉數 該耗時越長研發需要改進",
  "平均关闭耗时=∑(关闭时间-解决时间)/bug关闭数 该耗时越长缺陷提交人需要改进": "平均關閉耗時=∑(關閉時間-解決時間)/bug關閉數 該耗時越長缺陷提交人需要改進",
  "指标统计说明": "指標統計說明",
  "所有bug平均关闭时效(天)": "所有bug平均關閉時效(天)",
  "有效线上bug平均关闭时效(天)": "有效線上bug平均關閉時效(天)",
  "平均关闭时效最长": "平均關閉時效最長",
  "平均关闭时效最短": "平均關閉時效最短",
  "关闭bug总数(个)": "關閉bug總數(個)",
  "关闭量占比(%)": "關閉量佔比(%)",
  "有效bug关闭数(个)": "有效bug關閉數(個)",
  "生产事故概况": "生產事故概況",
  "事故总数(个)": "事故總數(個)",
  "事故归属业务领域": "事故歸屬業務領域",
  "事故级别分布": "事故級別分佈",
  "原因类型分布": "原因型別分佈",
  "月度事故分布": "月度事故分佈",
  "生产事故改进情况": "生產事故改進情況",
  "措施总数": "措施總數",
  "超期未完成": "超期未完成",
  "改进措施分布情况": "改進措施分佈情況",
  "事故负责人改进状态分布图": "事故負責人改進狀態分佈圖",
  "需求分析": "需求分析",
  "需求吞吐量趋势": "需求吞吐量趨勢",
  "过程缺陷分析": "過程缺陷分析",
  "线上bug分析": "線上bug分析",
  "线上bug关闭与新增情况": "線上bug關閉與新增情況",
  "线上bug创建时间分布": "線上bug建立時間分佈",
  "线上bug类型及业务领域占比": "線上bug型別及業務領域佔比",
  "线上bug关闭时效": "線上bug關閉時效",
  "线上bug逃逸率": "線上bug逃逸率",
  "生产事故落地进展": "生產事故落地進展",
  "研发数据分析": "研發資料分析",
  "需求吞吐量": "需求吞吐量",
  "交付需求的创建时间分布 (按当月发布需求总数降序排列)": "交付需求的建立時間分佈 (按當月釋出需求總數降序排列)",
  "bug关闭与新增情况（按照bug关闭占比降序排序）": "bug關閉與新增情況（按照bug關閉佔比降序排序）",
  "关闭bug创建时间分布（按照关闭bug数降序排序）": "關閉bug建立時間分佈（按照關閉bug數降序排序）",
  "bug类型占比": "bug型別佔比",
  "bug业务领域占比": "bug業務領域佔比",
  "bug关闭时效（按照总体关闭时间降序排序）": "bug關閉時效（按照總體關閉時間降序排序）",
  "线上bug关闭与新增情况（按照bug关闭占比降序排序）": "線上bug關閉與新增情況（按照bug關閉佔比降序排序）",
  "线上bug创建时间分布（按照线上bug数降序排序）": "線上bug建立時間分佈（按照線上bug數降序排序）",
  "线上bug执行方案占比": "線上bug執行方案佔比",
  "线上bug有效占比": "線上bug有效佔比",
  "线上bug类型占比": "線上bug型別佔比",
  "线上bug业务领域占比": "線上bug業務領域佔比",
  "线上bug关闭时效（按照关闭时间降序排序）": "線上bug關閉時效（按照關閉時間降序排序）",
  "研发管理荣誉榜": "研發管理榮譽榜",
  "代码提交规范率部门排行": "程式碼提交規範率部門排行",
  "上期": "上期",
  "超平均": "超平均",
  "交付需求数": "交付需求數",
  "吞吐率": "吞吐率",
  "关闭bug数": "關閉bug數",
  "关闭占比（关闭数/新增数）": "關閉佔比（關閉數/新增數）",
  "关闭量": "關閉量",
  "关闭量占比": "關閉量佔比",
  "新增bug数": "新增bug數",
  "交付需求数量TOP3": "交付需求數量TOP3",
  "关闭bug总数TOP3": "關閉bug總數TOP3",
  "占比最多TOP3": "佔比最多TOP3",
  "占比最少TOP3": "佔比最少TOP3",
  "新增bug总数TOP3": "新增bug總數TOP3",
  "正在生成邮件报告（请勿关闭页面），请稍后...": "正在生成郵件報告（請勿關閉頁面），請稍後...",
  "月报已生成,请选择发送邮件人": "月報已生成,請選擇傳送郵件人",
  "处理失败:": "處理失敗:",
  "分享链接已复制到剪贴板": "分享連結已複製到剪貼簿",
  "发送邮件": "傳送郵件",
  "业务指标看板": "業務指標看板",
  "仅主管指标": "僅主管指標",
  "业务领域（可多选）": "業務領域（可多選）",
  "系统（可多选）": "系統（可多選）",
  "指标（可多选）": "指標（可多選）",
  "刷新当前视图": "重新整理當前檢視",
  "展示业务指标当前值，并提供往年同比（%）对照（": "展示業務指標當前值，並提供往年同比（%）對照（",
  "当前范围暂无可展示指标": "當前範圍暫無可展示指標",
  "同比": "同比",
  "环比": "環比",
  "当期平均": "當期平均",
  "往年同期": "往年同期",
  "小贴士：点击卡片可查看业务指标趋势的明细数据": "小貼士：點選卡片可檢視業務指標趨勢的明細資料",
  "数据更新于": "資料更新於",
  "个人指标看板": "個人指標看板",
  "角色（可多选）": "角色（可多選）",
  "展示个人指标当前值，并提供往年同比（%）对照（": "展示個人指標當前值，並提供往年同比（%）對照（",
  "小贴士：点击卡片可查看指标趋势的明细数据": "小貼士：點選卡片可檢視指標趨勢的明細資料",
  "业务领域名称": "業務領域名稱",
  "当前范围暂无可展示数据": "當前範圍暫無可展示資料",
  "岗位名": "崗位名",
  "业务汇总": "業務彙總",
  "人员汇总": "人員彙總",
  "导出 Excel": "匯出 Excel",
  "展示汇总统计表格数据，支持业务汇总与人员汇总视图切换": "展示彙總統計表格資料，支援業務彙總與人員彙總檢視切換",
  "岗位（可多选）": "崗位（可多選）",
  "人员（可多选）": "人員（可多選）",
  "均值": "均值",
  "点击角色卡片可筛选下方表格，再次点击当前角色可恢复全部": "點選角色卡片可篩選下方表格，再次點選當前角色可恢復全部",
  "配置成员": "配置成員",
  "配置团队成员": "配置團隊成員",
  "团队名称": "團隊名稱",
  "给团队起个名字": "給團隊起個名字",
  "保存团队": "儲存團隊",
  "请先填写团队名称": "請先填寫團隊名稱",
  "团队配置已保存": "團隊配置已儲存",
  "团队配置保存失败，请稍后重试": "團隊配置儲存失敗，請稍後重試",
  "团队指标看板": "團隊指標看板",
  "暂未配置团队名称": "暫未配置團隊名稱",
  "导出所有角色人员指标明细": "匯出所有角色人員指標明細",
  "导出": "匯出",
  "团队整体视图": "團隊整體檢視",
  "人员明细视图": "人員明細檢視",
  "第一步：点击这里配置团队": "第一步：點選這裡配置團隊",
  "请先配置团队成员": "請先配置團隊成員",
  "先补齐产品、研发、测试成员，再查看团队指标。": "先補齊產品、研發、測試成員，再檢視團隊指標。",
  "配置团队": "配置團隊",
  "团队": "團隊",
  "小贴士：先配置团队角色成员，再查看团队维度指标趋势与变化": "小貼士：先配置團隊角色成員，再檢視團隊維度指標趨勢與變化",
  "里程碑记录": "里程碑記錄",
  "需求记录": "需求記錄",
  "缺陷记录": "缺陷記錄",
  "事故记录": "事故記錄",
  "技术债务记录": "技術債務記錄",
  "指标详情": "指標詳情",
  "暂无指标详情": "暫無指標詳情",
  "提示：点击柱子可查看记录明细": "提示：點選柱子可檢視記錄明細",
  "当前区间暂无趋势数据": "當前區間暫無趨勢資料",
  "选择部门": "選擇部門",
  "请选择本部门线中的部门": "請選擇本部門線中的部門",
  "单独选人": "單獨選人",
  "可单独选择人员，与部门选择取并集": "可單獨選擇人員，與部門選擇取並集",
  "选择人员": "選擇人員",
  "已自动选择人员，可继续调整": "已自動選擇人員，可繼續調整",
  "请先选择部门或单独选人": "請先選擇部門或單獨選人",
  "已选": "已選",
  "紧急发布 & HotFix趋势": "緊急釋出 & HotFix趨勢",
  "总次数": "總次數",
  "窗口期发布次数": "視窗期釋出次數",
  "成功次数": "成功次數",
  "成功率（%）": "成功率（%）",
  "研发平均交付周期（Day）": "研發平均交付週期（Day）",
  "需求在各阶段的停留时长之和的平均值，指需求交付之前，从研发开始到结束所经历的时间；（不包含技术类需求）": "需求在各階段的停留時長之和的平均值，指需求交付之前，從研發開始到結束所經歷的時間；（不包含技術類需求）",
  "需求数量排名": "需求數量排名",
  "平均交付周期（Day）": "平均交付週期（Day）",
  "需求在各阶段的停留时长之和的平均值，指需求交付之前，从开始到结束所经历的时间；（不包含技术类需求）": "需求在各階段的停留時長之和的平均值，指需求交付之前，從開始到結束所經歷的時間；（不包含技術類需求）",
  "需求分布图": "需求分佈圖",
  "按日": "按日",
  "按周": "按周",
  "按月": "按月",
  "执行人类型：": "執行人型別：",
  "选择执行人类型": "選擇執行人型別",
  "执行人：": "執行人：",
  "选择执行人": "選擇執行人",
  "复杂度：": "複雜度：",
  "选择复杂度": "選擇複雜度",
  "优先级：": "優先順序：",
  "选择优先级": "選擇優先順序",
  "需求延期交付数": "需求延期交付數",
  "需求延期交付数：": "需求延期交付數：",
  "1、需求交付月度指标，预计到期日为当月的需求（需求已发布时间-预计到期日&lt;0的数量累计，即为延期交付数量。": "1、需求交付月度指標，預計到期日為當月的需求（需求已釋出時間-預計到期日&lt;0的數量累計，即為延期交付數量。",
  "2、平均需求延期交付时间，根据系统或者领域，或者全局选择，需求延期交付时间的平均值。": "2、平均需求延期交付時間，根據系統或者領域，或者全域性選擇，需求延期交付時間的平均值。",
  "新增需求趋势": "新增需求趨勢",
  "新增需求趋势：": "新增需求趨勢：",
  "本指标反映各团队的新增需求数量的变化趋势，期待新增需求持续输入且数量相对稳定，若需求数量（story points）新增较多，需要考虑研发资源与交付时效是否可以按期完成。": "本指標反映各團隊的新增需求數量的變化趨勢，期待新增需求持續輸入且數量相對穩定，若需求數量（story points）新增較多，需要考慮研發資源與交付時效是否可以按期完成。",
  "存量需求趋势": "存量需求趨勢",
  "存量需求趋势：": "存量需求趨勢：",
  "所选时间区间项目尚未完成需求的数量和，存量需求趋势 = （当前期的存量需求 - 前一期的存量需求） / 前一期的存量需求，其列成一个时间序列。如果存量需求呈现上升趋势，需要考虑研发资源分配和交付时效，反之亦然。": "所選時間區間專案尚未完成需求的數量和，存量需求趨勢 = （當前期的存量需求 - 前一期的存量需求） / 前一期的存量需求，其列成一個時間序列。如果存量需求呈現上升趨勢，需要考慮研發資源分配和交付時效，反之亦然。",
  "存量需求占比(状态)": "存量需求佔比(狀態)",
  "所选时间段内未关闭需求各状态占比": "所選時間段內未關閉需求各狀態佔比",
  "存量需求占比(优先级)": "存量需求佔比(優先順序)",
  "所选时间段内未关闭需求优先级占比": "所選時間段內未關閉需求優先順序佔比",
  "需求交付时长分布": "需求交付時長分佈",
  "需求交付时长分布：": "需求交付時長分佈：",
  "所选时间区间内完成的需求，按完成日期排列，并分别统计每日完成需求从创建到完成的耗时时长分布。有助于团队了解需求交付的速度和效率，并从中找出可能存在的问题和瓶颈。": "所選時間區間內完成的需求，按完成日期排列，並分別統計每日完成需求從建立到完成的耗時時長分佈。有助於團隊瞭解需求交付的速度和效率，並從中找出可能存在的問題和瓶頸。",
  "需求趋势": "需求趨勢",
  "需求趋势：": "需求趨勢：",
  "需求趋势指标用于衡量在一段特定时间内需求的变化趋势。该图表会显示每天新增、发布需求数量以及仍然活跃的或未解决的需求数量（通常称为\"需求存量\"），故我们的需求颗粒度标准需要统一。": "需求趨勢指標用於衡量在一段特定時間內需求的變化趨勢。該圖表會顯示每天新增、釋出需求數量以及仍然活躍的或未解決的需求數量（通常稱為\"需求存量\"），故我們的需求顆粒度標準需要統一。",
  "需求阶段数量累积": "需求階段數量累積",
  "需求阶段累积（数量）：": "需求階段累積（數量）：",
  "截止所选时间段内各个需求阶段的数量累积": "截止所選時間段內各個需求階段的數量累積",
  "需求阶段耗时累积": "需求階段耗時累積",
  "需求阶段累积（耗时）：": "需求階段累積（耗時）：",
  "截止所选时间段内各个需求阶段的耗时累积": "截止所選時間段內各個需求階段的耗時累積",
  "选择来源": "選擇來源",
  "平均时效": "平均時效",
  "平均时效:": "平均時效:",
  "已完成处理": "已完成處理",
  "待处理": "待處理",
  "获取点赞详情数据失败": "獲取點贊詳情資料失敗",
  "获取点赞详情数据失败:": "獲取點贊詳情資料失敗:",
  "正向": "正向",
  "中性": "中性",
  "负面": "負面",
  "显示所有类型的反馈": "顯示所有型別的反饋",
  "等待处理的反馈": "等待處理的反饋",
  "已经处理完成的反馈": "已經處理完成的反饋",
  "当前用户提交的反馈": "當前使用者提交的反饋",
  "图标": "圖示",
  "Tab名称": "Tab名稱",
  "Tab代码": "Tab程式碼",
  "默认Tab": "預設Tab",
  "App Tab页配置": "App Tab頁配置",
  "管理移动端App中反馈页面的Tab标签配置": "管理移動端App中反饋頁面的Tab標籤配置",
  "搜索Tab名称或代码": "搜尋Tab名稱或程式碼",
  "新增Tab": "新增Tab",
  "配置已删除": "配置已刪除",
  "编辑功能待实现": "編輯功能待實現",
  "配置详情": "配置詳情",
  "反馈来源:": "反饋來源:",
  "反馈国家:": "反饋國家:",
  "一级类型数量:": "一級型別數量:",
  "二级类型数量:": "二級型別數量:",
  "清空筛选": "清空篩選",
  "中文内容为必填项，请填写中文内容": "中文內容為必填項，請填寫中文內容",
  "英文内容为必填项，请填写英文内容": "英文內容為必填項，請填寫英文內容",
  "规则中的反馈来源和默认负责人均为必填项": "規則中的反饋來源和預設負責人均為必填項",
  "同一类型下不能配置相同来源的规则": "同一型別下不能配置相同來源的規則",
  "编辑反馈类型成功": "編輯反饋型別成功",
  "新增反馈类型成功": "新增反饋型別成功",
  "请输入Code": "請輸入Code",
  "命名规则：全大写字母，单词之间使用下划线分隔": "命名規則：全大寫字母，單詞之間使用下劃線分隔",
  "请输入Code（例如：PRODUCT_ISSUE）": "請輸入Code（例如：PRODUCT_ISSUE）",
  "命名规则：只能包含大写字母，单词之间使用下划线分隔，例如：PRODUCT_ISSUE": "命名規則：只能包含大寫字母，單詞之間使用下劃線分隔，例如：PRODUCT_ISSUE",
  "配置级别": "配置級別",
  "请选择配置级别": "請選擇配置級別",
  "主配置": "主配置",
  "次配置": "次配置",
  "自定义规则配置": "自定義規則配置",
  "多语言内容": "多語言內容",
  "内容（必填）": "內容（必填）",
  "内容": "內容",
  "描述（选填）": "描述（選填）",
  "排序号": "排序號",
  "默认负责人": "預設負責人",
  "关注人": "關注人",
  "已配置规则的来源": "已配置規則的來源",
  "语言内容包": "語言內容包",
  "个语言": "個語言",
  "属性删除成功": "屬性刪除成功",
  "获取属性列表失败:": "獲取屬性列表失敗:",
  "获取属性列表失败": "獲取屬性列表失敗",
  "批量添加属性失败:": "批次新增屬性失敗:",
  "批量添加属性失败": "批次新增屬性失敗",
  "删除属性失败:": "刪除屬性失敗:",
  "删除属性失败": "刪除屬性失敗",
  "添加子节点": "新增子節點",
  "请选择要添加的属性": "請選擇要新增的屬性",
  "批量添加": "批次新增",
  "父节点：": "父節點：",
  "搜索属性名称...": "搜尋屬性名稱...",
  "项，已选择": "項，已選擇",
  "项": "項",
  "清除成功": "清除成功",
  "清除失败:": "清除失敗:",
  "清除失败": "清除失敗",
  "不能复制到自己": "不能複製到自己",
  "💡 提示：已配置的单元格可以拖拽复制到其他单元格，未配置的单元格可以作为拖拽目标": "💡 提示：已配置的單元格可以拖拽複製到其他單元格，未配置的單元格可以作為拖拽目標",
  "正在复制:": "正在複製:",
  "一级:": "一級:",
  "二级:": "二級:",
  "总数:": "總數:",
  "未配置": "未配置",
  "编辑配置": "編輯配置",
  "确定要一键复制该来源配置到所有空白配置的国家与来源吗？": "確定要一鍵複製該來源配置到所有空白配置的國家與來源嗎？",
  "一键复制": "一鍵複製",
  "确定要清除此配置吗？": "確定要清除此配置嗎？",
  "清除配置": "清除配置",
  "添加配置": "新增配置",
  "获取FAQ详情失败:": "獲取FAQ詳情失敗:",
  "删除FAQ配置失败:": "刪除FAQ配置失敗:",
  "该FAQ暂无语言包配置": "該FAQ暫無語言包配置",
  "问题内容": "問題內容",
  "答案内容": "答案內容",
  "语言包数量": "語言包數量",
  "确定要删除这条FAQ配置吗？": "確定要刪除這條FAQ配置嗎？",
  "FAQ管理": "FAQ管理",
  "请输入问题标题、内容或答案": "請輸入問題標題、內容或答案",
  "新增FAQ": "新增FAQ",
  "反馈来源": "反饋來源",
  "请选择反馈来源": "請選擇反饋來源",
  "请选择默认负责人": "請選擇預設負責人",
  "请选择关注人": "請選擇關注人",
  "默认无需处理": "預設無需處理",
  "是否默认无需处理": "是否預設無需處理",
  "添加规则": "新增規則",
  "语言内容详情": "語言內容詳情",
  "暂无语言内容": "暫無語言內容",
  "新增成功": "新增成功",
  "编辑功能": "編輯功能",
  "新增功能": "新增功能",
  "命名规则：只能包含大写字母，单词之间使用下划线分隔，例如：FUNCTION_SWITCH": "命名規則：只能包含大寫字母，單詞之間使用下劃線分隔，例如：FUNCTION_SWITCH",
  "请输入Code（例如：FUNCTION_SWITCH）": "請輸入Code（例如：FUNCTION_SWITCH）",
  "删除配置成功": "刪除配置成功",
  "删除配置失败": "刪除配置失敗",
  "配置类型": "配置型別",
  "消息群ID": "訊息群ID",
  "确定要删除这条配置吗？": "確定要刪除這條配置嗎？",
  "基础数据配置": "基礎資料配置",
  "如国家、来源、站点等基础配置信息": "如國家、來源、站點等基礎配置資訊",
  "请输入展示内容或配置值": "請輸入展示內容或配置值",
  "配置类型:": "配置型別:",
  "请选择配置类型": "請選擇配置型別",
  "新增配置": "新增配置",
  "编辑配置成功": "編輯配置成功",
  "新增配置成功": "新增配置成功",
  "请输入消息群ID": "請輸入訊息群ID",
  "获取FAQ详情失败": "獲取FAQ詳情失敗",
  "删除FAQ配置成功": "刪除FAQ配置成功",
  "删除FAQ配置失败": "刪除FAQ配置失敗",
  "FAQ配置": "FAQ配置",
  "管理常见问题解答，支持多语言配置": "管理常見問題解答，支援多語言配置",
  "中文问题和答案为必填项，请填写中文内容": "中文問題和答案為必填項，請填寫中文內容",
  "英文问题和答案为必填项，请填写英文内容": "英文問題和答案為必填項，請填寫英文內容",
  "编辑FAQ成功": "編輯FAQ成功",
  "新增FAQ成功": "新增FAQ成功",
  "编辑FAQ": "編輯FAQ",
  "问题内容（必填）": "問題內容（必填）",
  "答案内容（必填）": "答案內容（必填）",
  "请选择语言类型": "請選擇語言型別",
  "请输入敏感词": "請輸入敏感詞",
  "请输入有效的敏感词": "請輸入有效的敏感詞",
  "批量添加敏感词失败": "批次新增敏感詞失敗",
  "批量添加敏感词": "批次新增敏感詞",
  "语言类型": "語言型別",
  "敏感词列表": "敏感詞列表",
  "请输入敏感词，支持以下格式：&#10;1. 每行一个敏感词&#10;2. 用逗号分隔：敏感词1,敏感词2,敏感词3&#10;3. 用分号分隔：敏感词1;敏感词2;敏感词3&#10;4. 混合使用：敏感词1,敏感词2&#10;敏感词3;敏感词4": "請輸入敏感詞，支援以下格式：&#10;1. 每行一個敏感詞&#10;2. 用逗號分隔：敏感詞1,敏感詞2,敏感詞3&#10;3. 用分號分隔：敏感詞1;敏感詞2;敏感詞3&#10;4. 混合使用：敏感詞1,敏感詞2&#10;敏感詞3;敏感詞4",
  "预览敏感词 (": "預覽敏感詞 (",
  "个)：": "個)：",
  "使用说明：": "使用說明：",
  "• 支持多种分隔符：逗号(,)、分号(;)、换行符": "• 支援多種分隔符：逗號(,)、分號(;)、換行符",
  "• 系统会自动去除空白字符和重复项": "• 系統會自動去除空白字元和重複項",
  "• 建议每批添加不超过100个敏感词": "• 建議每批新增不超過100個敏感詞",
  "• 添加前请确认语言类型选择正确": "• 新增前請確認語言型別選擇正確",
  "语言名称": "語言名稱",
  "敏感词": "敏感詞",
  "敏感词配置": "敏感詞配置",
  "配置各语言的敏感词，包括政治、色情、暴力、赌博、毒品、恐怖主义、宗教、种族歧视等敏感词": "配置各語言的敏感詞，包括政治、色情、暴力、賭博、毒品、恐怖主義、宗教、種族歧視等敏感詞",
  "语言类型:": "語言型別:",
  "请选择语言": "請選擇語言",
  "新增敏感词": "新增敏感詞",
  "编辑敏感词成功": "編輯敏感詞成功",
  "新增敏感词成功": "新增敏感詞成功",
  "编辑敏感词": "編輯敏感詞",
  "反馈类型配置": "反饋型別配置",
  "功能配置": "功能配置",
  "暂无类型数据": "暫無型別資料",
  "暂无次类型数据": "暫無次型別資料",
  "反馈类型筛选": "反饋型別篩選",
  "主类型": "主型別",
  "次类型": "次型別",
  "反馈类型": "反饋型別",
  "个已选": "個已選",
  "聊天消息": "聊天訊息",
  "暂无可翻译的原文内容": "暫無可翻譯的原文內容",
  "缺少反馈ID": "缺少反饋ID",
  "翻译成功": "翻譯成功",
  "翻译失败": "翻譯失敗",
  "请输入回复内容或上传附件": "請輸入回覆內容或上傳附件",
  "回复成功": "回覆成功",
  "回复失败": "回覆失敗",
  "暂无可翻译内容": "暫無可翻譯內容",
  "反馈信息": "反饋資訊",
  "翻译后": "翻譯後",
  "手动翻译": "手動翻譯",
  "处理与回复": "處理與回覆",
  "翻译中": "翻譯中",
  "翻译": "翻譯",
  "暂无处理与回复记录": "暫無處理與回覆記錄",
  "回复后您会被添加到关注人": "回覆後您會被新增到關注人",
  "发送": "傳送",
  "反馈记录不存在了": "反饋記錄不存在了",
  "操作日志": "操作日誌",
  "评分": "評分",
  "来源渠道": "來源渠道",
  "问题解决类型": "問題解決型別",
  "是否弹幕": "是否彈幕",
  "关联标签": "關聯標籤",
  "反馈主类型": "反饋主型別",
  "反馈次类型": "反饋次型別",
  "站点": "站點",
  "用户删除": "使用者刪除",
  "聊天记录": "聊天記錄",
  "原文：": "原文：",
  "翻译：": "翻譯：",
  "反馈人ID": "反饋人ID",
  "被指派人": "被指派人",
  "关联BUG": "關聯BUG",
  "暂无状态记录": "暫無狀態記錄",
  "状态变更失败": "狀態變更失敗",
  "介入时间": "介入時間",
  "下架": "下架",
  "上架": "上架",
  "请选择反馈主类型": "請選擇反饋主型別",
  "保存失败:": "儲存失敗:",
  "请先选择主类型": "請先選擇主型別",
  "该主类型下暂无次类型": "該主型別下暫無次型別",
  "选择反馈类型": "選擇反饋型別",
  "（可选）": "（可選）",
  "关联业务需求": "關聯業務需求",
  "确定要删除这个关联需求吗？": "確定要刪除這個關聯需求嗎？",
  "请选择要添加的需求": "請選擇要新增的需求",
  "关联需求详情": "關聯需求詳情",
  "添加需求：": "新增需求：",
  "请输入备注内容": "請輸入備註內容",
  "备注添加成功": "備註新增成功",
  "备注添加失败": "備註新增失敗",
  "暂无数据可导出": "暫無資料可匯出",
  "导出成功": "匯出成功",
  "请先选择需要分享的反馈": "請先選擇需要分享的反饋",
  "批量分享内容已复制": "批次分享內容已複製",
  "批量分享失败": "批次分享失敗",
  "翻译失败:": "翻譯失敗:",
  "用户是否删除": "使用者是否刪除",
  "批量分享": "批次分享",
  "反馈类型负责人": "反饋型別負責人",
  "人员类型": "人員型別",
  "请选择人员类型（可选）": "請選擇人員型別（可選）",
  "取消关联成功": "取消關聯成功",
  "取消关联失败": "取消關聯失敗",
  "请选择要关联的线上问题": "請選擇要關聯的線上問題",
  "确定要取消关联吗？": "確定要取消關聯嗎？",
  "添加线上问题：": "新增線上問題：",
  "请选择线上问题": "請選擇線上問題",
  "关联成功": "關聯成功",
  "关联失败": "關聯失敗",
  "请选择要关联的业务需求": "請選擇要關聯的業務需求",
  "请选择业务需求": "請選擇業務需求",
  "无需处理后，反馈状态将自动更新为已关闭": "無需處理後，反饋狀態將自動更新為已關閉",
  "翻译中...": "翻譯中...",
  "反馈翻译": "反饋翻譯",
  "反馈原文": "反饋原文",
  "处理状态": "處理狀態",
  "添加关联业务需求": "新增關聯業務需求",
  "添加关联BUG": "新增關聯BUG",
  "最新回复内容": "最新回覆內容",
  "最新回复内容翻译": "最新回覆內容翻譯",
  "反馈人名称": "反饋人名稱",
  "设备型号": "裝置型號",
  "系统版本": "系統版本",
  "app版本": "app版本",
  "反馈提交时间": "反饋提交時間",
  "变更处理人": "變更處理人",
  "变更关注人": "變更關注人",
  "转业务需求": "轉業務需求",
  "转线上问题": "轉線上問題",
  "编辑关联标签": "編輯關聯標籤",
  "编辑备注": "編輯備註",
  "查看图片": "檢視圖片",
  "查看消息": "檢視訊息",
  "查看操作记录": "檢視操作記錄",
  "暂无可分享的反馈信息": "暫無可分享的反饋資訊",
  "分享内容已复制": "分享內容已複製",
  "分享失败": "分享失敗",
  "暂不转换": "暫不轉換",
  "备注保存成功": "備註儲存成功",
  "备注保存失败": "備註儲存失敗",
  "修改失败": "修改失敗",
  "业务需求创建失败": "業務需求建立失敗",
  "全部类型": "全部型別",
  "事件类型": "事件型別",
  "事件详情": "事件詳情",
  "工单ID:": "工單ID:",
  "工单名称": "工單名稱",
  "工程师": "工程師",
  "所属组": "所屬組",
  "是否备份": "是否備份",
  "已备份": "已備份",
  "未备份": "未備份",
  "完成时间": "完成時間",
  "SQL内容": "SQL內容",
  "审核结果": "稽核結果",
  "影响行数:": "影響行數:",
  "应用ID": "應用ID",
  "发布标题": "釋出標題",
  "集群": "叢集",
  "配置变更详情": "配置變更詳情",
  "原值:": "原值:",
  "新值:": "新值:",
  "运行ID:": "執行ID:",
  "发布ID:": "釋出ID:",
  "服务基本信息": "服務基本資訊",
  "服务类别": "服務類別",
  "运行信息": "執行資訊",
  "操作人信息": "操作人資訊",
  "电话": "電話",
  "错误日志对象:": "錯誤日誌物件:",
  "加载详情中...": "載入詳情中...",
  "暂无详情数据": "暫無詳情資料",
  "事件名": "事件名",
  "• 数据库变更：为数据库名": "• 資料庫變更：為資料庫名",
  "• 配置变更：为应用ID": "• 配置變更：為應用ID",
  "• 服务发布：为服务名": "• 服務釋出：為服務名",
  "个事件": "個事件",
  "暂无事件数据": "暫無事件資料",
  "时间轴视图": "時間軸檢視",
  "网格视图": "網格檢視",
  "获取事件数据失败:": "獲取事件資料失敗:",
  "获取事件数据失败": "獲取事件資料失敗",
  "获取字典数据失败:": "獲取字典資料失敗:",
  "获取事件类型数据失败": "獲取事件型別資料失敗",
  "时间范围不能超过180天": "時間範圍不能超過180天",
  "时间范围不能超过180天，请重新选择": "時間範圍不能超過180天，請重新選擇",
  "发起审计成功": "發起審計成功",
  "发起审计失败": "發起審計失敗",
  "发起审计失败:": "發起審計失敗:",
  "GOC统一事件看板": "GOC統一事件看板",
  "总事件": "總事件",
  "时间范围：": "時間範圍：",
  "业务领域：": "業務領域：",
  "请选择环境": "請選擇環境",
  "发起审计": "發起審計",
  "请输入审批标题": "請輸入審批標題",
  "指派工单": "指派工單",
  "必须选择一个工单": "必須選擇一個工單",
  "指派成功": "指派成功",
  "指派失败": "指派失敗",
  "请选择被指派人员": "請選擇被指派人員",
  "获取运维人员失败:": "獲取運維人員失敗:",
  "获取可处理人员失败，将继续提交工单": "獲取可處理人員失敗，將繼續提交工單",
  "创建工单成功！": "建立工單成功！",
  "表单验证失败:": "表單驗證失敗:",
  "创建工单": "建立工單",
  "紧急程度": "緊急程度",
  "请选择紧急程度": "請選擇緊急程度",
  "问题分类": "問題分類",
  "请选择问题分类": "請選擇問題分類",
  "问题描述": "問題描述",
  "请输入问题描述": "請輸入問題描述",
  "缺少工单ID": "缺少工單ID",
  "请选择评价分数": "請選擇評價分數",
  "评价成功": "評價成功",
  "评价失败": "評價失敗",
  "评价工单失败:": "評價工單失敗:",
  "评价工单": "評價工單",
  "评价分数：": "評價分數：",
  "评价内容：": "評價內容：",
  "请输入评价内容（可选）": "請輸入評價內容（可選）",
  "获取聊天记录失败:": "獲取聊天記錄失敗:",
  "回复失败:": "回覆失敗:",
  "工单信息": "工單資訊",
  "创建时间：": "建立時間：",
  "（可处理人：": "（可處理人：",
  "请输入回复内容": "請輸入回覆內容",
  "工单详情": "工單詳情",
  "1分": "1分",
  "2分": "2分",
  "3分": "3分",
  "4分": "4分",
  "5分": "5分",
  "工单筛选": "工單篩選",
  "指派人员": "指派人員",
  "请选择指派人员": "請選擇指派人員",
  "评价分数": "評價分數",
  "获取工单详情失败:": "獲取工單詳情失敗:",
  "工单已完成": "工單已完成",
  "完成工单失败": "完成工單失敗",
  "请至少选择一个可指派的工单": "請至少選擇一個可指派的工單",
  "工单编号": "工單編號",
  "可处理人员": "可處理人員",
  "被指派人员": "被指派人員",
  "实际处理人员": "實際處理人員",
  "分数范围为1~5分": "分數範圍為1~5分",
  "评价内容": "評價內容",
  "处理完成": "處理完成",
  "服务评价": "服務評價",
  "确定要删除此工单吗？": "確定要刪除此工單嗎？",
  "删除工单失败:": "刪除工單失敗:",
  "批量指派": "批次指派",
  "确认完成工单": "確認完成工單",
  "确定要完成此工单吗？": "確定要完成此工單嗎？",
  "请等待文件上传完成": "請等待檔案上傳完成",
  "点击或拖拽文件到此区域上传": "點選或拖拽檔案到此區域上傳",
  "支持多文件上传，单个文件不超过10MB": "支援多檔案上傳，單個檔案不超過10MB",
  "已读完成": "已讀完成",
  "去填写": "去填寫",
  "已读": "已讀",
  "未读": "未讀",
  "系统通知": "系統通知",
  "全部已读": "全部已讀",
  "全部设为已读": "全部設為已讀",
  "加载里程碑失败": "載入里程碑失敗",
  "请先选择一个里程碑": "請先選擇一個里程碑",
  "关联迭代": "關聯迭代",
  "下一步": "下一步",
  "项目：": "專案：",
  "请选择一个里程碑：": "請選擇一個里程碑：",
  "请选择里程碑": "請選擇里程碑",
  "项目ID不能为空": "專案ID不能為空",
  "预算已更新": "預算已更新",
  "编辑预算": "編輯預算",
  "预估人天不能为空": "預估人天不能為空",
  "须大于 0": "須大於 0",
  "机器预算（人民币）": "機器預算（人民幣）",
  "其他预算（人民币）": "其他預算（人民幣）",
  "预期收益（人民币）": "預期收益（人民幣）",
  "预期收益不能为空": "預期收益不能為空",
  "项目编码：": "專案編碼：",
  "空间 / 业务领域未配置": "空間 / 業務領域未配置",
  "空间": "空間",
  "年份:": "年份:",
  "周期:": "週期:",
  "规模": "規模",
  "时间进度": "時間進度",
  "进度根据时间流逝计算占比：(当前日期 - 开始日期) / (结束日期 - 开始日期) × 100%": "進度根據時間流逝計算佔比：(當前日期 - 開始日期) / (結束日期 - 開始日期) × 100%",
  "点击查看迭代明细": "點選檢視迭代明細",
  "完成数/总数": "完成數/總數",
  "点击查看需求明细": "點選檢視需求明細",
  "点击查看任务明细": "點選檢視任務明細",
  "质量评分:": "質量評分:",
  "未评分": "未評分",
  "未完成不可评分": "未完成不可評分",
  "项目团队": "專案團隊",
  "立项后技术接口人仅可变更主开发、主测试、其他干系人；如需变更其他人员，请联系Zola周华变更。": "立項後技術介面人僅可變更主開發、主測試、其他幹係人；如需變更其他人員，請聯絡 Zola 周華變更。",
  "暂无": "暫無",
  "暂无项目": "暫無專案",
  "点击\"新建项目\"开始创建": "點選\"新建專案\"開始建立",
  "项目完成": "專案完成",
  "确认完成项目": "確認完成專案",
  "实际人天": "實際人天",
  "请填写实际人天": "請填寫實際人天",
  "请输入实际人天，可保留两位小数": "請輸入實際人天，可保留兩位小數",
  "人力成本约为": "人力成本約為",
  "（实际人天 × 平均工资 ¥": "（實際人天 × 平均工資 ¥",
  "/人天）": "/人天）",
  "机器成本（元）": "機器成本（元）",
  "请填写机器成本": "請填寫機器成本",
  "请输入机器成本": "請輸入機器成本",
  "其他成本（元）": "其他成本（元）",
  "请填写其他成本": "請填寫其他成本",
  "请输入其他成本": "請輸入其他成本",
  "实际收益（元）": "實際收益（元）",
  "请填写实际收益": "請填寫實際收益",
  "请输入实际收益": "請輸入實際收益",
  "暂无验收标准": "暫無驗收標準",
  "添加验收标准": "新增驗收標準",
  "关键结果": "關鍵結果",
  "权重": "權重",
  "验收时间": "驗收時間",
  "请选择日期": "請選擇日期",
  "验收人": "驗收人",
  "验收标准": "驗收標準",
  "确定要删除此验收标准吗？": "確定要刪除此驗收標準嗎？",
  "项目不存在，无法保存里程碑": "專案不存在，無法儲存里程碑",
  "请输入里程碑名称": "請輸入里程碑名稱",
  "请输入完成目标": "請輸入完成目標",
  "请选择截止日期": "請選擇截止日期",
  "编辑里程碑": "編輯里程碑",
  "新增里程碑": "新增里程碑",
  "如：立项启动、各系统改动点确认": "如：立項啟動、各系統改動點確認",
  "开始日期 / 截止日期": "開始日期 / 截止日期",
  "请选择开始日期和截止日期": "請選擇開始日期和截止日期",
  "项目不存在，无法保存风险": "專案不存在，無法儲存風險",
  "编辑风险": "編輯風險",
  "新增风险": "新增風險",
  "请输入风险类型": "請輸入風險型別",
  "风险描述": "風險描述",
  "请输入风险描述": "請輸入風險描述",
  "请输入风险原因": "請輸入風險原因",
  "风险等级": "風險等級",
  "请选择风险等级": "請選擇風險等級",
  "应对措施": "應對措施",
  "请输入应对措施": "請輸入應對措施",
  "替换": "替換",
  "暂无人员": "暫無人員",
  "项目背景": "專案背景",
  "项目目标": "專案目標",
  "带此图标的字段可在详情中快速编辑。立项通过后需要变更项目基础与预算信息，可联系Zola周华": "帶此圖示的欄位可在詳情中快速編輯。立項透過後需要變更專案基礎與預算資訊，可聯絡Zola周華",
  "项目编码": "專案編碼",
  "所属空间": "所屬空間",
  "项目状态": "專案狀態",
  "请选择年份": "請選擇年份",
  "项目背景与目标": "專案背景與目標",
  "请编辑项目背景（支持富文本格式）": "請編輯專案背景（支援富文字格式）",
  "请编辑项目目标（支持富文本格式）": "請編輯專案目標（支援富文字格式）",
  "项目预算与资源": "專案預算與資源",
  "人力预算": "人力預算",
  "人力成本": "人力成本",
  "机器预算": "機器預算",
  "机器成本": "機器成本",
  "其他预算": "其他預算",
  "其他成本": "其他成本",
  "预期收益": "預期收益",
  "实际收益": "實際收益",
  "预期ROI": "預期ROI",
  "实际ROI": "實際ROI",
  "当前进度:": "當前進度:",
  "预算进度": "預算進度",
  "预算进度 = 当前已用预算 ÷ 总预算 × 100%": "預算進度 = 當前已用預算 ÷ 總預算 × 100%",
  "请选择时间或预估人天": "請選擇時間或預估人天",
  "编辑任务时间": "編輯任務時間",
  "开始结束:": "開始結束:",
  "预估人天:": "預估人天:",
  "请至少选择一项": "請至少選擇一項",
  "完成关联": "完成關聯",
  "多少天之内的创建的迭代": "多少天之內的建立的迭代",
  "多少天之内的创建的需求": "多少天之內的建立的需求",
  "最近7天": "最近7天",
  "最近30天": "最近30天",
  "最近180天": "最近180天",
  "最近360天": "最近360天",
  "选择要关联的迭代": "選擇要關聯的迭代",
  "选择要关联的需求": "選擇要關聯的需求",
  "没有迭代？": "沒有迭代？",
  "没有产品需求？": "沒有產品需求？",
  "去创建": "去建立",
  "仅支持删除任务类型工作项": "僅支援刪除任務型別工作項",
  "确定要删除该工作项吗？": "確定要刪除該工作項嗎？",
  "确定要将该工作项移出项目吗？": "確定要將該工作項移出專案嗎？",
  "项目或工作项信息异常": "專案或工作項資訊異常",
  "当前工作项类型不支持移出项目": "當前工作項型別不支援移出專案",
  "解绑成功": "解綁成功",
  "暂无关联链接": "暫無關聯連結",
  "创建能力待接入": "建立能力待接入",
  "知道了": "知道了",
  "添加备注成功": "新增備註成功",
  "迭代详情": "迭代詳情",
  "任务详情": "任務詳情",
  "展示内容：": "展示內容：",
  "里程碑时间轴": "里程碑時間軸",
  "工作项明细": "工作項明細",
  "已完成 / 总数": "已完成 / 總數",
  "暂无里程碑数据": "暫無里程碑資料",
  "只看未完成": "只看未完成",
  "暂无工作项数据": "暫無工作項資料",
  "暂无迭代数据": "暫無迭代資料",
  "迭代名称": "迭代名稱",
  "周期": "週期",
  "未完成": "未完成",
  "暂无明细记录": "暫無明細記錄",
  "暂无需求数据": "暫無需求資料",
  "暂无任务数据": "暫無任務資料",
  "实际工时(h)": "實際工時(h)",
  "任务不支持直接关联项目：请先在关联需求，然后在需求下创建任务，任务会通过需求自动关联到该项目": "任務不支援直接關聯專案：請先在關聯需求，然後在需求下建立任務，任務會透過需求自動關聯到該專案",
  "仅项目技术接口人可编辑周报模板并写周报": "僅專案技術介面人可編輯週報模板並寫週報",
  "编辑周报模板": "編輯週報模板",
  "新增周报模板": "新增週報模板",
  "当前无权限编辑该角色成员": "當前無許可權編輯該角色成員",
  "确定要移除此人员吗？": "確定要移除此人員嗎？",
  "暂无活动记录": "暫無活動記錄",
  "总数": "總數",
  "查看": "檢視",
  "请先完成所有内容": "請先完成所有內容",
  "验收完成": "驗收完成",
  "完成验收失败": "完成驗收失敗",
  "工作项完成情况": "工作項完成情況",
  "工作项完成情况检查": "工作項完成情況檢查",
  "暂无完成明细": "暫無完成明細",
  "存在未完成工作项，无法完成验收，请先完成所有内容。": "存在未完成工作項，無法完成驗收，請先完成所有內容。",
  "迭代明细": "迭代明細",
  "业务接口人（BPM）": "業務介面人（BPM）",
  "技术接口人（产品经理）": "技術介面人（產品經理）",
  "业务负责人": "業務負責人",
  "验收负责人": "驗收負責人",
  "主开发": "主開發",
  "主测试": "主測試",
  "系统落地负责人": "系統落地負責人",
  "系统培训负责人": "系統培訓負責人",
  "其他干系人": "其他幹係人",
  "该角色至少保留一名人员，无法全部移除": "該角色至少保留一名人員，無法全部移除",
  "已移除": "已移除",
  "项目名称不能为空": "專案名稱不能為空",
  "项目编号不能为空": "專案編號不能為空",
  "项目编号不能超过20个字符": "專案編號不能超過20個字元",
  "项目编号仅支持字母、数字、中划线、下划线": "專案編號僅支援字母、數字、中劃線、下劃線",
  "项目背景不能为空": "專案背景不能為空",
  "项目目标不能为空": "專案目標不能為空",
  "时间进度总览": "時間進度總覽",
  "周报": "週報",
  "活动时间线": "活動時間線",
  "查看审批单": "檢視審批單",
  "开始项目": "開始專案",
  "重新发起审批": "重新發起審批",
  "发起立项审批": "發起立項審批",
  "质量打分": "質量打分",
  "完整编辑": "完整編輯",
  "项目信息不存在": "專案資訊不存在",
  "未指定": "未指定",
  "验收评价": "驗收評價",
  "暂无评价": "暫無評價",
  "明细": "明細",
  "完成里程碑": "完成里程碑",
  "完成": "完成",
  "里程碑已完成": "里程碑已完成",
  "验收分数须为 1～5 分": "驗收分數須為 1～5 分",
  "验收已保存": "驗收已儲存",
  "验收保存失败": "驗收儲存失敗",
  "里程碑验收": "里程碑驗收",
  "完成评分（满分 5 分）：": "完成評分（滿分 5 分）：",
  "完成评价：": "完成評價：",
  "请填写对该里程碑完成情况的评价（选填）": "請填寫對該里程碑完成情況的評價（選填）",
  "加载项目风险失败": "載入專案風險失敗",
  "风险已标记为已处理": "風險已標記為已處理",
  "删除风险": "刪除風險",
  "解决风险": "解決風險",
  "检索值": "檢索值",
  "请输入项目名称、编码或描述": "請輸入專案名稱、編碼或描述",
  "项目类型": "專案型別",
  "请选择类型": "請選擇型別",
  "加载更多": "載入更多",
  "保存草稿": "儲存草稿",
  "起草完成": "起草完成",
  "提交并进入技术起草": "提交併進入技術起草",
  "开始日期、预计完成日期": "開始日期、預計完成日期",
  "所属年份": "所屬年份",
  "项目规模": "專案規模",
  "业务接口人": "業務介面人",
  "技术接口人": "技術介面人",
  "至少填写一条里程碑": "至少填寫一條里程碑",
  "风险为选填，若添加则每条须填写完整": "風險為選填，若新增則每條須填寫完整",
  "一、项目基本信息": "一、專案基本資訊",
  "二、项目背景与目标": "二、專案背景與目標",
  "三、项目团队": "三、專案團隊",
  "四、项目预算与资源": "四、專案預算與資源",
  "五、项目关键里程碑": "五、專案關鍵里程碑",
  "六、项目风险": "六、專案風險",
  "业务起草已提交，项目已流转至技术起草": "業務起草已提交，專案已流轉至技術起草",
  "草稿已保存": "草稿已儲存",
  "起草完成，可发起立项审批": "起草完成，可發起立項審批",
  "编写说明": "編寫說明",
  "请按顺序填写下列区域，点击区域名称可快速定位到对应表单。绿色勾表示该区域已填写完整。": "請按順序填寫下列區域，點選區域名稱可快速定位到對應表單。綠色勾表示該區域已填寫完整。",
  "仅业务接口人和技术接口人可编写项目信息。": "僅業務介面人和技術介面人可編寫專案資訊。",
  "整体预览": "整體預覽",
  "待填": "待填",
  "选填": "選填",
  "待填写": "待填寫",
  "提示：点击上方步骤标题可快速跳转到对应区域。": "提示：點選上方步驟標題可快速跳轉到對應區域。",
  "请输入项目背景": "請輸入專案背景",
  "请描述项目的背景、现状和需要解决的问题": "請描述專案的背景、現狀和需要解決的問題",
  "请输入项目目标": "請輸入專案目標",
  "请描述项目的预期目标、关键成果和成功标准": "請描述專案的預期目標、關鍵成果和成功標準",
  "请输入项目名称": "請輸入專案名稱",
  "项目名称不能超过100个字符": "專案名稱不能超過100個字元",
  "请选择所属年份": "請選擇所屬年份",
  "项目的计划开始和结束时间": "專案的計劃開始和結束時間",
  "请选择项目周期": "請選擇專案週期",
  "请选择所属空间": "請選擇所屬空間",
  "请选择项目类型": "請選擇專案型別",
  "请选择项目规模": "請選擇專案規模",
  "人力预算：--（请先填写预估人天）": "人力預算：--（請先填寫預估人天）",
  "人力预算：": "人力預算：",
  "万（人民币）": "萬（人民幣）",
  "计算方式：预估人天 ×": "計算方式：預估人天 ×",
  "元/人天（人民币）": "元/人天（人民幣）",
  "预期ROI：--": "預期ROI：--",
  "计算公式：预期ROI = （预期收益 - 总投资） ÷ 总投资 × 100%，其中总投资 = 人力预算（预估人天 × 3000） + 机器预算 + 其他预算": "計算公式：預期ROI = （預期收益 - 總投資） ÷ 總投資 × 100%，其中總投資 = 人力預算（預估人天 × 3000） + 機器預算 + 其他預算",
  "大于0，支持两位小数": "大於0，支援兩位小數",
  "请输入预估人天": "請輸入預估人天",
  "须大于0，且可保留两位小数": "須大於0，且可保留兩位小數",
  "请输入金额（元）": "請輸入金額（元）",
  "请输入预期收益": "請輸入預期收益",
  "五、项目关键里程碑（业务与技术协作编写）": "五、專案關鍵里程碑（業務與技術協作編寫）",
  "请至少填写一条里程碑，每条里程碑的「里程碑名称」「完成目标」「开始日期」「预计完成日期」「负责人」均必填。": "請至少填寫一條里程碑，每條里程碑的「里程碑名稱」「完成目標」「開始日期」「預計完成日期」「負責人」均必填。",
  "六、项目风险（选填）": "六、專案風險（選填）",
  "风险为选填，若添加则每条须填写完整（风险类型、描述、风险原因、风险程度、风险应对方法）。": "風險為選填，若新增則每條須填寫完整（風險型別、描述、風險原因、風險程度、風險應對方法）。",
  "请选择业务接口人（可多选）": "請選擇業務介面人（可多選）",
  "请选择业务接口人": "請選擇業務介面人",
  "请选择技术接口人（可多选）": "請選擇技術介面人（可多選）",
  "请选择技术接口人": "請選擇技術介面人",
  "请选择业务负责人（可多选）": "請選擇業務負責人（可多選）",
  "请选择业务负责人": "請選擇業務負責人",
  "请选择验收负责人（可多选）": "請選擇驗收負責人（可多選）",
  "请选择验收负责人": "請選擇驗收負責人",
  "请选择主开发（可多选）": "請選擇主開發（可多選）",
  "请选择主测试（可多选）": "請選擇主測試（可多選）",
  "请选择系统落地负责人（可多选）": "請選擇系統落地負責人（可多選）",
  "请选择系统落地负责人": "請選擇系統落地負責人",
  "请选择系统培训负责人（可多选）": "請選擇系統培訓負責人（可多選）",
  "请选择系统培训负责人": "請選擇系統培訓負責人",
  "请选择其他干系人（可多选）": "請選擇其他幹係人（可多選）",
  "请选择开始日期和预计完成时间": "請選擇開始日期和預計完成時間",
  "添加里程碑": "新增里程碑",
  "低": "低",
  "高": "高",
  "请选择风险程度": "請選擇風險程度",
  "请输入风险应对方法": "請輸入風險應對方法",
  "添加风险": "新增風險",
  "结项": "結項",
  "确定要删除这个项目吗？": "確定要刪除這個專案嗎？",
  "质量评分": "質量評分",
  "待评分": "待評分",
  "完成数/总数，点击查看迭代明细": "完成數/總數，點選檢視迭代明細",
  "完成数/总数，点击查看需求明细": "完成數/總數，點選檢視需求明細",
  "完成数/总数，点击查看任务明细": "完成數/總數，點選檢視任務明細",
  "发起审批": "發起審批",
  "重发审批": "重發審批",
  "打分": "打分",
  "个项目": "個專案",
  "新建项目": "新建專案",
  "隐藏筛选": "隱藏篩選",
  "显示筛选": "顯示篩選",
  "卡片": "卡片",
  "表格": "表格",
  "看板": "看板",
  "点击选择 1-5 星": "點選選擇 1-5 星",
  "所有的": "所有的",
  "获取项目详情失败": "獲取專案詳情失敗",
  "加载项目详情...": "載入專案詳情...",
  "项目ID为空，无法写周报": "專案ID為空，無法寫週報",
  "正在提交评分...": "正在提交評分...",
  "评分成功": "評分成功",
  "正在删除项目...": "正在刪除專案...",
  "项目已删除": "專案已刪除",
  "正在开始项目...": "正在開始專案...",
  "项目已开始": "專案已開始",
  "正在发起立项审批...": "正在發起立項審批...",
  "已发起立项审批": "已發起立項審批",
  "暂无审批单信息": "暫無審批單資訊",
  "正在完成项目...": "正在完成專案...",
  "项目已完成": "專案已完成",
  "没有找到符合条件的项目": "沒有找到符合條件的專案",
  "暂无项目数据": "暫無專案資料",
  "清除筛选条件": "清除篩選條件",
  "创建项目": "建立專案",
  "项目需求明细": "專案需求明細",
  "项目任务明细": "專案任務明細",
  "项目迭代明细": "專案迭代明細",
  "编辑空间": "編輯空間",
  "确定要删除这个空间吗？": "確定要刪除這個空間嗎？",
  "删除后空间下的所有项目将无法访问": "刪除後空間下的所有專案將無法訪問",
  "删除空间": "刪除空間",
  "成员（": "成員（",
  "暂无成员": "暫無成員",
  "创建于": "建立於",
  "暂无空间": "暫無空間",
  "点击\"新建空间\"开始创建": "點選\"新建空間\"開始建立",
  "空间名称": "空間名稱",
  "项目数": "專案數",
  "最后更新人": "最後更新人",
  "最后更新时间": "最後更新時間",
  "成员管理": "成員管理",
  "其他成员": "其他成員",
  "暂无其他成员": "暫無其他成員",
  "空间详情": "空間詳情",
  "在此空间下创建项目": "在此空間下建立專案",
  "空间信息不存在": "空間資訊不存在",
  "活跃空间": "活躍空間",
  "新建空间": "新建空間",
  "请输入空间名称": "請輸入空間名稱",
  "空间名称不能超过50个字符": "空間名稱不能超過50個字元",
  "空间负责人": "空間負責人",
  "请选择空间负责人": "請選擇空間負責人",
  "空间描述": "空間描述",
  "请输入空间描述（可选）": "請輸入空間描述（可選）",
  "空间成员": "空間成員",
  "请选择成员（可多选）": "請選擇成員（可多選）",
  "个空间": "個空間",
  "空间名称或描述": "空間名稱或描述",
  "没有找到符合条件的空间": "沒有找到符合條件的空間",
  "暂无空间数据": "暫無空間資料",
  "创建空间": "建立空間",
  "产品需求原型或需求文档": "產品需求原型或需求文件",
  "产品经理响应速度": "產品經理響應速度",
  "产品经理对业务方需求的理解度": "產品經理對業務方需求的理解度",
  "与产品经理沟通过程": "與產品經理溝透過程",
  "研发开发和交付效率": "研發開發和交付效率",
  "产品功能交付质量": "產品功能交付質量",
  "提交成功": "提交成功",
  "产品需求交付验收单": "產品需求交付驗收單",
  "尊敬的业务方：": "尊敬的業務方：",
  "您好！": "您好！",
  "非常感谢您对我们工作的支持！为了不断改进我们的服务质量，我们诚邀您填写此份简短的问卷，以便我们了解您对我们产品需求交付的满意度以及任何改进建议。您的反馈对我们非常重要！": "非常感謝您對我們工作的支援！為了不斷改進我們的服務質量，我們誠邀您填寫此份簡短的問卷，以便我們瞭解您對我們產品需求交付的滿意度以及任何改進建議。您的反饋對我們非常重要！",
  "产品需求基本信息": "產品需求基本資訊",
  "需求相关时间和时长": "需求相關時間和時長",
  "需求创建时间": "需求建立時間",
  "需求交付时间": "需求交付時間",
  "研发投入时间": "研發投入時間",
  "前端：": "前端：",
  "(小时)": "(小時)",
  "后端：": "後端：",
  "测试：": "測試：",
  "产品阶段耗时": "產品階段耗時",
  "研发阶段耗时": "研發階段耗時",
  "测试阶段耗时": "測試階段耗時",
  "是否与您确认期待完成时间": "是否與您確認期待完成時間",
  "需求验收意见": "需求驗收意見",
  "请选择验收结果": "請選擇驗收結果",
  "请填写不通过原因": "請填寫不透過原因",
  "改进建议或意见": "改進建議或意見",
  "请填写改进建议或意见": "請填寫改進建議或意見",
  "满意度评价": "滿意度評價",
  "请您对以下方面进行满意度评价,并在相应选项后打分。": "請您對以下方面進行滿意度評價,並在相應選項後打分。",
  "请根据实际情况进行评价，评价结果将作为需求交付质量的重要参考。": "請根據實際情況進行評價，評價結果將作為需求交付質量的重要參考。",
  "总体评价": "總體評價",
  "对本次需求交付的整体满意度": "對本次需求交付的整體滿意度",
  "提交问卷": "提交問卷",
  "需求背景描述": "需求背景描述",
  "问题清晰度": "問題清晰度",
  "原型或者需求设计": "原型或者需求設計",
  "产品需求评审质量评价": "產品需求評審質量評價",
  "尊敬的需求评审参与人员：": "尊敬的需求評審參與人員：",
  "非常感谢您参与此次产品需求评审，为了了解此次需求评审质量情况，我们诚邀您匿名填写此份简短的问卷，感谢您的支持！": "非常感謝您參與此次產品需求評審，為了瞭解此次需求評審質量情況，我們誠邀您匿名填寫此份簡短的問卷，感謝您的支援！",
  "需求评审后是否有修改？": "需求評審後是否有修改？",
  "亲, 您已填写过该问卷哦, 感谢您的参与!": "親, 您已填寫過該問卷哦, 感謝您的參與!",
  "感谢您的反馈, 我们将努力做得更好!": "感謝您的反饋, 我們將努力做得更好!",
  "(未填写详细内容)": "(未填寫詳細內容)",
  "导出失败": "匯出失敗",
  "导出Word": "匯出Word",
  "变更记录": "變更記錄",
  "事故名称和链接已剪贴板": "事故名稱和連結已剪貼簿",
  "事故名称": "事故名稱",
  "影响范围": "影響範圍",
  "分类": "分類",
  "影响值": "影響值",
  "暂无影响范围数据": "暫無影響範圍資料",
  "备注说明": "備註說明",
  "时间节点": "時間節點",
  "恢复时间": "恢復時間",
  "影响开始时间": "影響開始時間",
  "影响结束时间": "影響結束時間",
  "定级依据": "定級依據",
  "暂无定级依据": "暫無定級依據",
  "责任人与团队": "責任人與團隊",
  "事故处理责任组长": "事故處理責任組長",
  "暂无服务数据": "暫無服務資料",
  "事件时间线": "事件時間線",
  "暂无时间线数据": "暫無時間線資料",
  "事故原因": "事故原因",
  "改进措施和计划": "改進措施和計劃",
  "措施内容": "措施內容",
  "计划完成时间": "計劃完成時間",
  "永久": "永久",
  "跟踪备注": "跟蹤備註",
  "查看添加": "檢視新增",
  "暂无改进措施": "暫無改進措施",
  "暂无附件": "暫無附件",
  "选择责任人": "選擇責任人",
  "事故序列号": "事故序列號",
  "请输入事故名称或序列号": "請輸入事故名稱或序列號",
  "进行中并且截止日期在3天内的措施发企微消息提醒": "進行中並且截止日期在3天內的措施發企微訊息提醒",
  "发送失败": "傳送失敗",
  "进行中临期提醒": "進行中臨期提醒",
  "到达开始时间但未开始和超过完成时间的措施给责任人发送企微消息提醒": "到達開始時間但未開始和超過完成時間的措施給責任人傳送企微訊息提醒",
  "未开始逾期提醒": "未開始逾期提醒",
  "热力图": "熱力圖",
  "事故等级分布": "事故等級分佈",
  "事故序列分布": "事故序列分佈",
  "月度事故趋势": "月度事故趨勢",
  "改进措施状态概览": "改進措施狀態概覽",
  "改进措施改进状态分布图": "改進措施改進狀態分佈圖",
  "改进措施负责人超期未完成": "改進措施負責人超期未完成",
  "前置过程（背景）": "前置過程（背景）",
  "事故发生": "事故發生",
  "事件发现/处置": "事件發現/處置",
  "善后处理": "善後處理",
  "暂存报告时，事故名称不能为空": "暫存報告時，事故名稱不能為空",
  "有附件正在上传中，请稍后再试！": "有附件正在上傳中，請稍後再試！",
  "操作失败：": "操作失敗：",
  "文件上传失败:": "檔案上傳失敗:",
  "暂存": "暫存",
  "1. 事故概况": "1. 事故概況",
  "请输入事故名称": "請輸入事故名稱",
  "2. 影响范围": "2. 影響範圍",
  "数值": "數值",
  "请输入有效数字": "請輸入有效數字",
  "3. 责任分析": "3. 責任分析",
  "已存在群": "已存在群",
  "拉群人数小于3人": "拉群人數小於3人",
  "是否拉群": "是否拉群",
  "4. 关联服务": "4. 關聯服務",
  "请选择服务类型": "請選擇服務型別",
  "请选择服务": "請選擇服務",
  "选择服务": "選擇服務",
  "添加服务": "新增服務",
  "5. 事件时间线": "5. 事件時間線",
  "添加时间节点": "新增時間節點",
  "请选择时间": "請選擇時間",
  "文字颜色": "文字顏色",
  "字体加粗": "字型加粗",
  "加粗": "加粗",
  "6. 原因分析": "6. 原因分析",
  "7. 改进措施和计划": "7. 改進措施和計劃",
  "改进措施": "改進措施",
  "设为永久": "設為永久",
  "8. 附件": "8. 附件",
  "未暂存的更改将在关闭后清空，是否继续？": "未暫存的更改將在關閉後清空，是否繼續？",
  "推送邮件": "推送郵件",
  "确定删除吗？": "確定刪除嗎？",
  "新建事故报告": "新建事故報告",
  "配置影响范围": "配置影響範圍",
  "选择影响指标": "選擇影響指標",
  "请选择影响范围": "請選擇影響範圍",
  "指标名称(单位)": "指標名稱(單位)",
  "是否加粗": "是否加粗",
  "组名": "組名",
  "项)": "項)",
  "显示顺序": "顯示順序",
  "新建指标": "新建指標",
  "批量编辑": "批次編輯",
  "批量删除": "批次刪除",
  "批量操作": "批次操作",
  "必选": "必選",
  "选择分类": "選擇分類",
  "最长20字": "最長20字",
  "例如：包裹量": "例如：包裹量",
  "最长50字": "最長50字",
  "例如：件": "例如：件",
  "添加指标": "新增指標",
  "确定要删除这些指标吗？此操作不可逆！": "確定要刪除這些指標嗎？此操作不可逆！",
  "刷新措施详情失败:": "重新整理措施詳情失敗:",
  "添加备注失败": "新增備註失敗",
  "添加备注错误:": "新增備註錯誤:",
  "备注删除成功": "備註刪除成功",
  "删除备注失败": "刪除備註失敗",
  "删除备注错误:": "刪除備註錯誤:",
  "确认删除这条备注？": "確認刪除這條備註？",
  "措施跟踪备注": "措施跟蹤備註",
  "措施信息": "措施資訊",
  "备注记录": "備註記錄",
  "暂无备注": "暫無備註",
  "不能超过1000字符": "不能超過1000字元",
  "请输入备注内容...": "請輸入備註內容...",
  "下载失败，请手动右键另存为": "下載失敗，請手動右鍵另存為",
  "该格式文件不支持预览，已自动触发下载": "該格式檔案不支援預覽，已自動觸發下載",
  "若未下载成功，请": "若未下載成功，請",
  "点击此处": "點選此處",
  "文件预览": "檔案預覽",
  "推送有点慢，但我没放弃——": "推送有點慢，但我沒放棄——",
  "用户列表加载失败": "使用者列表載入失敗",
  "必须选择一个收件人": "必須選擇一個收件人",
  "发射成功～邮件正在路上！": "發射成功～郵件正在路上！",
  "发射失败…请稍后再试": "發射失敗…請稍後再試",
  "确认发送事故邮件？": "確認傳送事故郵件？",
  "收件人：": "收件人：",
  "标题：": "標題：",
  "标题：默认标题": "標題：預設標題",
  "确认发送": "確認傳送",
  "再检查一下": "再檢查一下",
  "发送事故邮件": "傳送事故郵件",
  "默认已填充事故相关人员邮箱，可自行删减/追加；支持按姓名或邮箱搜索。": "預設已填充事故相關人員郵箱，可自行刪減/追加；支援按姓名或郵箱搜尋。",
  "邮件标题": "郵件標題",
  "留空将使用默认标题（事故名称-事故报告）": "留空將使用預設標題（事故名稱-事故報告）",
  "收件人": "收件人",
  "按姓名/邮箱搜索，支持多选": "按姓名/郵箱搜尋，支援多選",
  "抄送人员": "抄送人員",
  "可选：按姓名/邮箱搜索抄送人员": "可選：按姓名/郵箱搜尋抄送人員",
  "抄送组织": "抄送組織",
  "团队邮箱": "團隊郵箱",
  "可选：选择团队邮箱": "可選：選擇團隊郵箱",
  "事故报告": "事故報告",
  "草稿箱": "草稿箱",
  "数据看板": "資料看板",
  "需求编号": "需求編號",
  "需求文档": "需求文件",
  "是否与您沟通确认": "是否與您溝通確認",
  "请选择是否与您沟通确认": "請選擇是否與您溝通確認",
  "(对本次需求交付的整体满意度)": "(對本次需求交付的整體滿意度)",
  "请对总体情况进行评分": "請對總體情況進行評分",
  "需求业务方": "需求業務方",
  "评价状态": "評價狀態",
  "已评价": "已評價",
  "未评价": "未評價",
  "验收意见": "驗收意見",
  "不通过验收的原因": "不透過驗收的原因",
  "评价状态：": "評價狀態：",
  "请选择评价情况": "請選擇評價情況",
  "所有": "所有",
  "COE 等级分布": "COE 等級分佈",
  "根因类型分布": "根因型別分佈",
  "责任人 COE 分布": "責任人 COE 分佈",
  "COE编号": "COE編號",
  "等级": "等級",
  "发生时间": "發生時間",
  "发现耗时": "發現耗時",
  "恢复耗时": "恢復耗時",
  "故障责任人": "故障責任人",
  "直接资损": "直接資損",
  "间接资损": "間接資損",
  "Todo 内容": "Todo 內容",
  "交付时间": "交付時間",
  "延期情况": "延期情況",
  "延期": "延期",
  "COE 明细": "COE 明細",
  "COE Todo 明细": "COE Todo 明細",
  "月度 COE 趋势": "月度 COE 趨勢",
  "COE 总数": "COE 總數",
  "高等级 COE": "高等級 COE",
  "故障等级为 P0 或 P1 的 COE 数量": "故障等級為 P0 或 P1 的 COE 數量",
  "平均发现时长": "平均發現時長",
  "当前筛选范围内，从故障发生到发现的平均耗时；缺少有效时间对时不参与计算": "當前篩選範圍內，從故障發生到發現的平均耗時；缺少有效時間對時不參與計算",
  "平均恢复时长": "平均恢復時長",
  "当前筛选范围内，从故障发现到恢复的平均耗时；缺少有效时间对时不参与计算": "當前篩選範圍內，從故障發現到恢復的平均耗時；缺少有效時間對時不參與計算",
  "累计资损": "累計資損",
  "直接损失 + 间接损失": "直接損失 + 間接損失",
  "延期 Todo": "延期 Todo",
  "Todo 完成率": "Todo 完成率",
  "已完成 Todo ÷ Todo 总数 × 100%": "已完成 Todo ÷ Todo 總數 × 100%",
  "COE Todo 状态概览": "COE Todo 狀態概覽",
  "Todo 总数": "Todo 總數",
  "逾期未完成": "逾期未完成",
  "COE Todo 状态分布": "COE Todo 狀態分佈",
  "完成率": "完成率",
  "负责人 COE Todo 状态分布": "負責人 COE Todo 狀態分佈",
  "负责人逾期 COE Todo": "負責人逾期 COE Todo",
  "COE 全局数据看板": "COE 全域性資料看板",
  "全部打开": "全部開啟",
  "部分看板数据加载失败，请点击刷新重试": "部分看板資料載入失敗，請點選重新整理重試",
  "加载 COE 评论失败": "載入 COE 評論失敗",
  "评论已删除": "評論已刪除",
  "删除 COE 评论失败": "刪除 COE 評論失敗",
  "保存 COE 评论失败": "儲存 COE 評論失敗",
  "评论已更新": "評論已更新",
  "输入评论，使用 @ 提醒相关人员": "輸入評論，使用 @ 提醒相關人員",
  "添加图片": "新增圖片",
  "Enter 发送，Shift + Enter 换行": "Enter 傳送，Shift + Enter 換行",
  "修改评论，使用 @ 提醒相关人员": "修改評論，使用 @ 提醒相關人員",
  "回复当前讨论，使用 @ 提醒相关人员": "回覆當前討論，使用 @ 提醒相關人員",
  "Enter 保存，Shift + Enter 换行": "Enter 儲存，Shift + Enter 換行",
  "收起评论": "收起評論",
  "展开评论": "展開評論",
  "原文位置已变更，暂无法定位": "原文位置已變更，暫無法定位",
  "编辑评论": "編輯評論",
  "删除这条评论？": "刪除這條評論？",
  "编辑回复": "編輯回覆",
  "删除这条回复？": "刪除這條回覆？",
  "暂无评论": "暫無評論",
  "原文已修改，评论仅作备案，无法定位": "原文已修改，評論僅作備案，無法定位",
  "暂无原文已修改评论": "暫無原文已修改評論",
  "变更记录加载失败": "變更記錄載入失敗",
  "重新加载": "重新載入",
  "暂无变更记录": "暫無變更記錄",
  "图片": "圖片",
  "详情加载失败": "詳情載入失敗",
  "故障级别": "故障級別",
  "持续时长": "持續時長",
  "归属系统": "歸屬系統",
  "1-故障基础信息": "1-故障基礎資訊",
  "故障责任组长": "故障責任組長",
  "内外因素": "內外因素",
  "归属部门": "歸屬部門",
  "复盘组织者": "覆盤組織者",
  "复盘参与人": "覆盤參與人",
  "2-故障现象": "2-故障現象",
  "3-故障影响": "3-故障影響",
  "关联系统影响": "關聯絡統影響",
  "异常数据量": "異常資料量",
  "资损能否追回": "資損能否追回",
  "客户投诉量": "客戶投訴量",
  "故障发现人": "故障發現人",
  "影响时长": "影響時長",
  "客诉渠道": "客訴渠道",
  "故障上报人": "故障上報人",
  "用户/客户通知人": "使用者/客戶通知人",
  "4-故障处理时间线": "4-故障處理時間線",
  "操作人员：": "操作人員：",
  "暂无处理时间线": "暫無處理時間線",
  "5-5 Why 根因分析": "5-5 Why 根因分析",
  "暂无该阶段分析": "暫無該階段分析",
  "问题": "問題",
  "答案": "答案",
  "6-综合根因总结": "6-綜合根因總結",
  "暂无根因总结": "暫無根因總結",
  "根因类型": "根因型別",
  "7-改进措施": "7-改進措施",
  "暂无该类改进措施": "暫無該類改進措施",
  "措施": "措施",
  "关联5Why": "關聯5Why",
  "8-Todo 列表": "8-Todo 列表",
  "暂无Todo": "暫無Todo",
  "任务内容": "任務內容",
  "故障现象": "故障現象",
  "故障影响": "故障影響",
  "处理时间线": "處理時間線",
  "根因总结": "根因總結",
  "请先填写发生时间和恢复时间": "請先填寫發生時間和恢復時間",
  "当前持续时长已是计算结果": "當前持續時長已是計算結果",
  "覆盖持续时长？": "覆蓋持續時長？",
  "确认覆盖": "確認覆蓋",
  "请填写问题": "請填寫問題",
  "请填写措施": "請填寫措施",
  "发现本机未同步的编辑内容": "發現本機未同步的編輯內容",
  "恢复内容": "恢復內容",
  "放弃缓存": "放棄快取",
  "最新内容尚未保存，且本机缓存失败，请先点击暂存后再关闭": "最新內容尚未儲存，且本機快取失敗，請先點選暫存後再關閉",
  "内容已更新，请确认后重新保存": "內容已更新，請確認後重新儲存",
  "请先填写故障名称后再暂存": "請先填寫故障名稱後再暫存",
  "保存成功，但本机备份清理失败，已保留当前页面内容，请稍后重试": "儲存成功，但本機備份清理失敗，已保留當前頁面內容，請稍後重試",
  "动作": "動作",
  "图片/附件": "圖片/附件",
  "请填写根因总结": "請填寫根因總結",
  "如：5.1-Why1": "如：5.1-Why1",
  "搜索并选择需求（可多选）": "搜尋並選擇需求（可多選）",
  "暂无需求": "暫無需求",
  "请选择故障级别": "請選擇故障級別",
  "请输入持续时长": "請輸入持續時長",
  "恢复时间减去发生时间，不足 1 分钟向下取整；点击后回填到持续时长": "恢復時間減去發生時間，不足 1 分鐘向下取整；點選後回填到持續時長",
  "计算": "計算",
  "请选择归属系统": "請選擇歸屬系統",
  "请选择内外因素": "請選擇內外因素",
  "外部原因无需选择归属部门": "外部原因無需選擇歸屬部門",
  "请选择归属部门（可多选）": "請選擇歸屬部門（可多選）",
  "搜索并选择迭代（可多选）": "搜尋並選擇迭代（可多選）",
  "暂无迭代": "暫無迭代",
  "请输入故障现象": "請輸入故障現象",
  "请输入直接资损金额": "請輸入直接資損金額",
  "请输入间接资损金额": "請輸入間接資損金額",
  "8-Todo列表": "8-Todo列表",
  "编辑COE复盘记录": "編輯COE覆盤記錄",
  "新建COE复盘记录": "新建COE覆盤記錄",
  "复盘目录": "覆盤目錄",
  "时间线": "時間線",
  "根因": "根因",
  "COE复盘名称和链接已复制到剪贴板": "COE覆盤名稱和連結已複製到剪貼簿",
  "刷新详情和评论": "重新整理詳情和評論",
  "Todo 状态更新失败": "Todo 狀態更新失敗",
  "Todo 状态已更新": "Todo 狀態已更新",
  "Todo 至少需要保留一名执行人": "Todo 至少需要保留一名執行人",
  "Todo 更新失败": "Todo 更新失敗",
  "Todo 已更新": "Todo 已更新",
  "请选择执行人": "請選擇執行人",
  "搜索关联需求": "搜尋關聯需求",
  "延期提醒发送成功": "延期提醒傳送成功",
  "延期提醒发送失败": "延期提醒傳送失敗",
  "COE编号、故障名称或任务内容": "COE編號、故障名稱或任務內容",
  "确认发送延期提醒？": "確認傳送延期提醒？",
  "将向已延期且未完成 Todo 的执行人发送飞书汇总提醒。": "將向已延期且未完成 Todo 的執行人傳送飛書彙總提醒。",
  "延期提醒": "延期提醒",
  "已复制COE编号": "已複製COE編號",
  "Todo列表": "Todo列表",
  "请输入故障名称": "請輸入故障名稱",
  "5.1-5Why根因分析-1故障原因（为什么会发生）": "5.1-5Why根因分析-1故障原因（為什麼會發生）",
  "5.2-5Why根因分析-2故障感知（为什么没有及时发现）": "5.2-5Why根因分析-2故障感知（為什麼沒有及時發現）",
  "5.3-5Why根因分析-3故障止损（为什么没快速阻止损失扩大）": "5.3-5Why根因分析-3故障止損（為什麼沒快速阻止損失擴大）",
  "5.4-5Why根因分析-4故障定位（为什么排查耗时长）": "5.4-5Why根因分析-4故障定位（為什麼排查耗時長）",
  "技术架构根因": "技術架構根因",
  "研发质量根因": "研發質量根因",
  "监控观测根因": "監控觀測根因",
  "应急处置根因": "應急處置根因",
  "流程制度根因": "流程制度根因",
  "7.1-改进措施-故障预防": "7.1-改進措施-故障預防",
  "7.2-改进措施-故障感知": "7.2-改進措施-故障感知",
  "7.3-改进措施-故障止损": "7.3-改進措施-故障止損",
  "7.4-改进措施-故障定位": "7.4-改進措施-故障定位",
  "告警类型": "告警型別",
  "值班人员": "值班人員",
  "告警详情": "告警詳情",
  "该群已被解散": "該群已被解散",
  "进群成功": "進群成功",
  "确认要解散该群吗？": "確認要解散該群嗎？",
  "解散后，该群将无法使用。": "解散後，該群將無法使用。",
  "解散成功": "解散成功",
  "仅该群创建者可以解散": "僅該群建立者可以解散",
  "解散": "解散",
  "今日告警记录": "今日告警記錄",
  "系统崩溃": "系統崩潰",
  "数据错误": "資料錯誤",
  "运营受阻": "運營受阻",
  "确认覆盖内容": "確認覆蓋內容",
  "确认清空": "確認清空",
  "拨打告警电话": "撥打告警電話",
  "告警记录": "告警記錄",
  "该业务领域今日没有值班人员": "該業務領域今日沒有值班人員",
  "一键告警": "一鍵告警",
  "新增自定义告警电话": "新增自定義告警電話",
  "（非必须，默认拨打值班人员电话）": "（非必須，預設撥打值班人員電話）",
  "将相关值班人员加入应急响应群。": "將相關值班人員加入應急響應群。",
  "仅拉群": "僅拉群",
  "拉群成功": "拉群成功",
  "拉群人数不足": "拉群人數不足",
  "给相关值班人员以及自定义电话拨打告警电话。": "給相關值班人員以及自定義電話撥打告警電話。",
  "仅拨打告警电话": "僅撥打告警電話",
  "将相关值班人员加入应急响应群，并给相关值班人员以及自定义电话拨打告警电话。": "將相關值班人員加入應急響應群，並給相關值班人員以及自定義電話撥打告警電話。",
  "拉群+拨打告警电话": "拉群+撥打告警電話",
  "请输入有效的中国手机号码": "請輸入有效的中國手機號碼",
  "请输入电话": "請輸入電話",
  "输入或选择电话号码": "輸入或選擇電話號碼",
  "添加电话": "新增電話",
  "报警详情": "報警詳情",
  "选择模板可快速填充内容": "選擇模板可快速填充內容",
  "选择模板": "選擇模板",
  "专属号码模式：": "專屬號碼模式：",
  "使用专属号码(0571-23677999)呼叫": "使用專屬號碼(0571-23677999)呼叫",
  "公共模式：": "公共模式：",
  "使用系统分配的公共号码呼叫": "使用系統分配的公共號碼呼叫",
  "（推荐优先使用专属号码保证通话质量）": "（推薦優先使用專屬號碼保證通話質量）",
  "是否使用专属号码呼叫": "是否使用專屬號碼呼叫",
  "请输入报警详情": "請輸入報警詳情",
  "报警详情不能超过200个字": "報警詳情不能超過200個字",
  "请输入或选择模板编辑...": "請輸入或選擇模板編輯...",
  "呼叫成功": "呼叫成功",
  "_验收报告": "_驗收報告",
  "开发人员": "開發人員",
  "发送人员": "傳送人員",
  "需求匹配度": "需求匹配度",
  "功能完备性": "功能完備性",
  "功能流畅性": "功能流暢性",
  "设计满意度": "設計滿意度",
  "总体意见": "總體意見",
  "需求细项": "需求細項",
  "验收人员": "驗收人員",
  "验收结果": "驗收結果",
  "补充意见": "補充意見",
  "备注不能为空": "備註不能為空",
  "备注成功": "備註成功",
  "提交备注": "提交備註",
  "流转": "流轉",
  "发布列表": "釋出列表",
  "仅被指派人可操作": "僅被指派人可操作",
  "实际任务不能超过120个小时": "實際任務不能超過120個小時",
  "最多保留两位小数，总位数不超过四位": "最多保留兩位小數，總位數不超過四位",
  "单个任务不能超过3天，请拆解任务": "單個任務不能超過3天，請拆解任務",
  "文件或视频上传失败，请重试！": "檔案或影片上傳失敗，請重試！",
  "上传文件不能超过500MB": "上傳檔案不能超過500MB",
  "重现步骤(双击开始编辑)": "重現步驟(雙擊開始編輯)",
  "视频 & 附件": "影片 & 附件",
  "点击或者将\"视频\"拖动到区域上传": "點選或者將\"影片\"拖動到區域上傳",
  "点击或者将\"文件\"拖动到区域上传": "點選或者將\"檔案\"拖動到區域上傳",
  "名称和链接已剪贴板": "名稱和連結已剪貼簿",
  "进群失败": "進群失敗",
  "指派给产品经理": "指派給產品經理",
  "已读取暂存需求": "已讀取暫存需求",
  "简要说明": "簡要說明",
  "具体举例说明": "具體舉例說明",
  "系统、服务、重要组件、停止或者无法正常运行，严重影响或阻碍测试执行": "系統、服務、重要元件、停止或者無法正常執行，嚴重影響或阻礙測試執行",
  "1、系统崩渍或者挂起": "1、系統崩漬或者掛起",
  "2、服务挂掉": "2、服務掛掉",
  "3、中间件等重要组件无法正常使用": "3、中介軟體等重要元件無法正常使用",
  "4、核心功能的严重错误": "4、核心功能的嚴重錯誤",
  "1、程序无法执行、应用模块无法启动或异常退出": "1、程式無法執行、應用模組無法啟動或異常退出",
  "2、系统崩渍、死锁、内存泄露、导致严重问题或致命错误": "2、系統崩漬、死鎖、記憶體洩露、導致嚴重問題或致命錯誤",
  "3、存在主流程核心功能的严重功能错误、逻辑错误、严重影响或阻碍测试执行": "3、存在主流程核心功能的嚴重功能錯誤、邏輯錯誤、嚴重影響或阻礙測試執行",
  "4、 APP 闪退": "4、 APP 閃退",
  "主流程严重的功能性缺陷,影响测试执行": "主流程嚴重的功能性缺陷,影響測試執行",
  "1、影响主流程的严重错误": "1、影響主流程的嚴重錯誤",
  "2、主流程功能不符合要求或未完成": "2、主流程功能不符合要求或未完成",
  "1、存在影响结果和使用的主流程功能的重大功能错误、逻辑错误、影响测试执行": "1、存在影響結果和使用的主流程功能的重大功能錯誤、邏輯錯誤、影響測試執行",
  "2、不符合或未完成的主流程器求和交互": "2、不符合或未完成的主流程器求和互動",
  "3、内存泄露": "3、記憶體洩露",
  "4、严重的数值计算错误": "4、嚴重的數值計算錯誤",
  "主流程功能性缺陷,不影响测试执行": "主流程功能性缺陷,不影響測試執行",
  "1、影响主流程的错误": "1、影響主流程的錯誤",
  "2、严重影响用户体验和使用的缺陷": "2、嚴重影響使用者體驗和使用的缺陷",
  "1、存在影响结果和使用的主流程功能的较大功能错误、逻辑错误、不影响测试执行": "1、存在影響結果和使用的主流程功能的較大功能錯誤、邏輯錯誤、不影響測試執行",
  "2、严重影响用户体验和使用的 UI 问题，如严重兼容性适配问题": "2、嚴重影響使用者體驗和使用的 UI 問題，如嚴重相容性適配問題",
  "3、影咱系统性能的问题": "3、影咱系統效能的問題",
  "4、不符合大部分用户操作习惯": "4、不符合大部分使用者操作習慣",
  "一般功能性缺陷，主流程功能无异常": "一般功能性缺陷，主流程功能無異常",
  "1、不影响主流程的错误": "1、不影響主流程的錯誤",
  "2、直接影响用户体验和使用的缺陷": "2、直接影響使用者體驗和使用的缺陷",
  "3、主流程功能不符合需求或未完成": "3、主流程功能不符合需求或未完成",
  "1、存在不影响结果和使用的非主流程小的功能错误，逻辑错误": "1、存在不影響結果和使用的非主流程小的功能錯誤，邏輯錯誤",
  "2、不符合或未完成的非主流程需求和交互": "2、不符合或未完成的非主流程需求和互動",
  "3、直接影响用户体验和使用的 UI 问题，如兼容性适配问题，界面截断、折行、溢出等": "3、直接影響使用者體驗和使用的 UI 問題，如相容性適配問題，介面截斷、折行、溢位等",
  "4、提示信息错误，有歧义，或者未给出提示信息而直接影响用户体验": "4、提示資訊錯誤，有歧義，或者未給出提示資訊而直接影響使用者體驗",
  "5、操作界面不友好，不符合部分用户习惯": "5、操作介面不友好，不符合部分使用者習慣",
  "保存中...": "儲存中...",
  "已保存到云端": "已儲存到雲端",
  "重现步骤（粘贴链接后输入空格变为超链接）": "重現步驟（貼上連結後輸入空格變為超連結）",
  "上传视频": "上傳影片",
  "视频文件不能超过50MB,仅支持.mp4,.avi,.mov,.flv.mp4,.avi,.mov,.wmv,.mkv,.flv,.webm,.3gp,.mpeg,.asf格式": "影片檔案不能超過50MB,僅支援.mp4,.avi,.mov,.flv.mp4,.avi,.mov,.wmv,.mkv,.flv,.webm,.3gp,.mpeg,.asf格式",
  "附件不能超过10MB": "附件不能超過10MB",
  "请选择严重程度": "請選擇嚴重程度",
  "研发": "研發",
  "请输入指派给": "請輸入指派給",
  "Bug页面地址(一个地址一行)": "Bug頁面地址(一個地址一行)",
  "不支持在ALL系统下拖动，请切换具体系统后操作！": "不支援在ALL系統下拖動，請切換具體系統後操作！",
  "添加子模块": "新增子模組",
  "重命名": "重新命名",
  "取消编辑": "取消編輯",
  "新建模块": "新建模組",
  "不支持在ALL系统下创建模块，请切换具体系统后操作！": "不支援在ALL系統下建立模組，請切換具體系統後操作！",
  "一次仅支持创建一个模块，请保存后在新建！": "一次僅支援建立一個模組，請儲存後在新建！",
  "所有模块": "所有模組",
  "出现bug的页面": "出現bug的頁面",
  "添加链接：": "新增連結：",
  "链接不能为空": "連結不能為空",
  "按创建时间最早": "按建立時間最早",
  "按创建时间最晚": "按建立時間最晚",
  "按更新时间最早": "按更新時間最早",
  "按更新时间最晚": "按更新時間最晚",
  "按截止时间最早": "按截止時間最早",
  "按截止时间最晚": "按截止時間最晚",
  "保存为默认排序": "儲存為預設排序",
  "在\"只看我\"下，不能选择人物相关": "在\"只看我\"下，不能選擇人物相關",
  "请选择反馈人": "請選擇反饋人",
  "请选择责任人": "請選擇責任人",
  "请选择被指派人": "請選擇被指派人",
  "解决人": "解決人",
  "已复制全页内容到剪贴板": "已複製全頁內容到剪貼簿",
  "全页复制": "全頁複製",
  "展示与自己相关的": "展示與自己相關的",
  "缺陷确认时间": "缺陷確認時間",
  "缺陷解决时间": "缺陷解決時間",
  "缺陷关闭时间": "缺陷關閉時間",
  "记录不存在了": "記錄不存在了",
  "进行中": "進行中",
  "概览": "概覽",
  "在途需求": "在途需求",
  "在途异常需求": "在途異常需求",
  "我提的业务需求": "我提的業務需求",
  "关联我的产品需求": "關聯我的產品需求",
  "在\"只看我\"下，不能选择产品对接人": "在\"只看我\"下，不能選擇產品對接人",
  "请选择产品对接人": "請選擇產品對接人",
  "请选择提出人": "請選擇提出人",
  "在\"只看我\"下，不能选择创建人": "在\"只看我\"下，不能選擇建立人",
  "我提出": "我提出",
  "交接成功": "交接成功",
  "当前产品对接": "當前產品對接",
  "交接产品": "交接產品",
  "请选择交接产品": "請選擇交接產品",
  "请先选择交接产品": "請先選擇交接產品",
  "已批量填充空白交接产品": "已批次填充空白交接產品",
  "请先选择需要清空的业务需求": "請先選擇需要清空的業務需求",
  "已清空所选业务需求的交接产品": "已清空所選業務需求的交接產品",
  "请先选择需要交接的业务需求": "請先選擇需要交接的業務需求",
  "业务需求交接": "業務需求交接",
  "交接的业务需求（": "交接的業務需求（",
  "，可操作": "，可操作",
  "交接产品：": "交接產品：",
  "统一选择交接产品": "統一選擇交接產品",
  "批量填充空值": "批次填充空值",
  "清空交接": "清空交接",
  "隐藏无法操作的需求": "隱藏無法操作的需求",
  "驳回时间": "駁回時間",
  "驳回人": "駁回人",
  "交付时长分布": "交付時長分佈",
  "4周内交付率：": "4周內交付率：",
  "认领": "認領",
  "驳回": "駁回",
  "拒绝验收": "拒絕驗收",
  "是否删除需求": "是否刪除需求",
  "确认要删除需求吗？": "確認要刪除需求嗎？",
  "添加产品对接人": "新增產品對接人",
  "驳回业务需求": "駁回業務需求",
  "请输入任务名称": "請輸入任務名稱",
  "在“只看我”下，不能选择产品对接人": "在“只看我”下，不能選擇產品對接人",
  "期待开始": "期待開始",
  "期待结束": "期待結束",
  "在“只看我”下，不能选择创建人": "在“只看我”下，不能選擇建立人",
  "展示产品经理、业务方、创建人为自己的记录": "展示產品經理、業務方、建立人為自己的記錄",
  "产品需求名称": "產品需求名稱",
  "产品需求创建时间": "產品需求建立時間",
  "产品介入时间": "產品介入時間",
  "产品评审完成时间": "產品評審完成時間",
  "预计开发投入时间": "預計開發投入時間",
  "预计开发完成时间": "預計開發完成時間",
  "实际开发完成时间": "實際開發完成時間",
  "预计测试投入时间": "預計測試投入時間",
  "预计测试完成时间": "預計測試完成時間",
  "实际测试完成时间": "實際測試完成時間",
  "实际验收完成时间": "實際驗收完成時間",
  "期望上线时间": "期望上線時間",
  "实际上线时间": "實際上線時間",
  "请勾选要复制的需求": "請勾選要複製的需求",
  "已复制需求内容到剪贴板": "已複製需求內容到剪貼簿",
  "业务需求，记录的业务需求描述，产品经理可以认领**需求并创建产品需求进入研发任务。": "業務需求，記錄的業務需求描述，產品經理可以認領**需求並建立產品需求進入研發任務。",
  "导出Excel": "匯出Excel",
  "请先勾选需要交接的业务需求": "請先勾選需要交接的業務需求",
  "业务交接": "業務交接",
  "使用人": "使用人",
  "介入人": "介入人",
  "发布人": "釋出人",
  "需求描述(双击开始编辑)": "需求描述(雙擊開始編輯)",
  "点击或者将文件拖动到区域上传": "點選或者將檔案拖動到區域上傳",
  "变更需求描述模版": "變更需求描述模版",
  "当前产品经理设置了专属需求模板，切换会覆盖现有内容(当前需求描述内容将被复制到剪贴板)。": "當前產品經理設定了專屬需求模板，切換會覆蓋現有內容(當前需求描述內容將被複制到剪貼簿)。",
  "确定要执行此操作吗？": "確定要執行此操作嗎？",
  "原先需求描述内容已复制到剪贴板": "原先需求描述內容已複製到剪貼簿",
  "该需求功能提出的具体人，或者具体使用用户": "該需求功能提出的具體人，或者具體使用使用者",
  "系统使用人": "系統使用人",
  "简单 - 小于5个工作日": "簡單 - 小於5個工作日",
  "中等 - 5~10个工作日": "中等 - 5~10個工作日",
  "复杂 - 大于10个工作日": "複雜 - 大於10個工作日",
  "业务方提出的需求功能或者目标为了服务该国家，不适用于全球通用业务场景": "業務方提出的需求功能或者目標為了服務該國家，不適用於全球通用業務場景",
  "业务方提出的需求功能或者目标为了服务该垂直行业线，适用于全球通用业务场景": "業務方提出的需求功能或者目標為了服務該垂直行業線，適用於全球通用業務場景",
  "需求描述": "需求描述",
  "编辑需求主要归属": "編輯需求主要歸屬",
  "业务需求名称": "業務需求名稱",
  "业务需求创建时间": "業務需求建立時間",
  "业务需求期望上线时间": "業務需求期望上線時間",
  "业务需求实际上线时间": "業務需求實際上線時間",
  "请选择待关联需求": "請選擇待關聯需求",
  "综合数据看板🔥": "綜合資料看板🔥",
  "预测数据看板🔥": "預測資料看板🔥",
  "我的数据看板📊": "我的資料看板📊",
  "只能上传.xmind文件!": "只能上傳.xmind檔案!",
  "上传测试用例": "上傳測試用例",
  "参与总人数 * 工时（天）": "參與總人數 * 工時（天）",
  "成本预估=人/天*3000，可直观告知业务方预估花费成本，需对方考虑ROI是否合理。": "成本預估=人/天*3000，可直觀告知業務方預估花費成本，需對方考慮ROI是否合理。",
  "以及后期如果成本过高，需要上升到不同维度进行决策。": "以及後期如果成本過高，需要上升到不同維度進行決策。",
  "任务参与相关人员": "任務參與相關人員",
  "展开更多录入项": "展開更多錄入項",
  "该任务相关联的服务": "該任務相關聯的服務",
  "服务相关联的分支": "服務相關聯的分支",
  "已经是用例了": "已經是用例了",
  "导入用例": "匯入用例",
  "模块": "模組",
  "请选择模块": "請選擇模組",
  "请切换到具体项目在创建": "請切換到具體專案在建立",
  "暂时还不支持保存": "暫時還不支援儲存",
  "脑图渲染慢，请耐心等待": "腦圖渲染慢，請耐心等待",
  "暂无数据，请点击左侧模块": "暫無資料，請點選左側模組",
  "模块视图需要切换到具体项目下查看": "模組檢視需要切換到具體專案下檢視",
  "模块视图": "模組檢視",
  "提测记录": "提測記錄",
  "请输入规划名称": "請輸入規劃名稱",
  "绑定成功": "繫結成功",
  "业务需求名称已复制到剪贴板": "業務需求名稱已複製到剪貼簿",
  "业务需求描述": "業務需求描述",
  "暂无关联业务需求": "暫無關聯業務需求",
  "暂无业务需求": "暫無業務需求",
  "请填写所有验收人员": "請填寫所有驗收人員",
  "请填写所有验收结果": "請填寫所有驗收結果",
  "提交过程中出错:": "提交過程中出錯:",
  "人员信息": "人員資訊",
  "验收结论": "驗收結論",
  "：通过": "：透過",
  "：不通过": "：不透過",
  "必填项：1-5分制，满分20分。原则上，总分12分以下不通过。": "必填項：1-5分制，滿分20分。原則上，總分12分以下不透過。",
  "应用": "應用",
  "操作类型": "操作型別",
  "旧值": "舊值",
  "新值": "新值",
  "变更类型": "變更型別",
  "配置Key": "配置Key",
  "变更Key": "變更Key",
  "无变更": "無變更",
  "变更数量": "變更數量",
  "发布备注": "釋出備註",
  "操作者": "操作者",
  "Apollo配置工单列表": "Apollo配置工單列表",
  "确定（已选": "確定（已選",
  "项）": "項）",
  "选择环境": "選擇環境",
  "应用ID：": "應用ID：",
  "选择应用ID": "選擇應用ID",
  "收起变更明细": "收起變更明細",
  "展开查看变更明细": "展開檢視變更明細",
  "工单状态": "工單狀態",
  "备份": "備份",
  "组": "組",
  "SQL工单列表": "SQL工單列表",
  "隐藏": "隱藏",
  "待办需求池": "待辦需求池",
  "只有方案中需求才可以在发起业务评审！": "只有方案中需求才可以在發起業務評審！",
  "发起业务评审": "發起業務評審",
  "请输入删除原因": "請輸入刪除原因",
  "是否解绑Sprint": "是否解綁Sprint",
  "确认要解绑Sprint吗？": "確認要解綁Sprint嗎？",
  "解绑Sprint": "解綁Sprint",
  "绑定Sprint": "繫結Sprint",
  "添加任务": "新增任務",
  "草稿不支持查看详情，请保存为正常需求后操作！": "草稿不支援檢視詳情，請儲存為正常需求後操作！",
  "计划需求评审日期": "計劃需求評審日期",
  "计划技术方案评审日期": "計劃技術方案評審日期",
  "计划测试用例评审日期": "計劃測試用例評審日期",
  "计划提测日期": "計劃提測日期",
  "计划业务验收日期": "計劃業務驗收日期",
  "点击查看后端任务详情": "點選檢視後端任務詳情",
  "点击查看前端任务详情": "點選檢視前端任務詳情",
  "点击查看测试任务详情": "點選檢視測試任務詳情",
  "点击查看UI任务详情": "點選檢視UI任務詳情",
  "产品阶段截止时间": "產品階段截止時間",
  "研发阶段截止时间": "研發階段截止時間",
  "测试阶段截止时间": "測試階段截止時間",
  "阶段耗时明细": "階段耗時明細",
  "确定取消暂停吗？": "確定取消暫停嗎？",
  "取消暂停后状态将会恢复到": "取消暫停後狀態將會恢復到",
  "最后一次": "最後一次",
  "操作状态": "操作狀態",
  "取消暂停成功": "取消暫停成功",
  "取消暂停": "取消暫停",
  "克隆成功": "克隆成功",
  "复制名称和链接": "複製名稱和連結",
  "仅复制链接": "僅複製連結",
  "请先勾选需要复制的行": "請先勾選需要複製的行",
  "已复制选中行的内容到剪贴板": "已複製選中行的內容到剪貼簿",
  "创建Sprint": "建立Sprint",
  "所勾选需求中存在不可验收需求": "所勾選需求中存在不可驗收需求",
  "批量验收": "批次驗收",
  "所选需求必须都有发布权限且属于同一业务领域": "所選需求必須都有釋出許可權且屬於同一業務領域",
  "批量发布": "批次釋出",
  "产品交接": "產品交接",
  "查看需求阶段耗时": "檢視需求階段耗時",
  "查看需求状态数量统计": "檢視需求狀態數量統計",
  "在研发过程中，增量代码缺陷率的高低直接影响软件质量和团队效率。这个数值越高，说明研发质量越低。": "在研發過程中，增量程式碼缺陷率的高低直接影響軟體質量和團隊效率。這個數值越高，說明研發質量越低。",
  "增量代码缺陷率:": "增量程式碼缺陷率:",
  "通常指在特定代码变更中发现的缺陷数量与该变更所涉及的代码行数的比率。较低的缺陷率通常意味着代码质量较高，反之则可能表明存在较多问题。": "通常指在特定程式碼變更中發現的缺陷數量與該變更所涉及的程式碼行數的比率。較低的缺陷率通常意味著程式碼質量較高，反之則可能表明存在較多問題。",
  "高质量代码:": "高質量程式碼:",
  "低的增量代码缺陷率通常表明代码质量较高，开发团队在编码时遵循了良好的实践和标准。": "低的增量程式碼缺陷率通常表明程式碼質量較高，開發團隊在編碼時遵循了良好的實踐和標準。",
  "高缺陷率的潜在问题:": "高缺陷率的潛在問題:",
  "质量控制不足: 高的增量代码缺陷率可能表明在开发过程中存在质量控制不足的问题，可能是测试覆盖率不够或开发人员对需求理解不清。": "質量控制不足: 高的增量程式碼缺陷率可能表明在開發過程中存在質量控制不足的問題，可能是測試覆蓋率不夠或開發人員對需求理解不清。",
  "千行代码缺陷率（Bug Rate）": "千行程式碼缺陷率（Bug Rate）",
  "是软件开发中常用的质量指标，用于衡量每千行代码中存在的缺陷数量。这个指标在评估软件质量和开发团队绩效时具有重要意义。以下是关于千行代码缺陷率考核指标的详细说明：": "是軟體開發中常用的質量指標，用於衡量每千行程式碼中存在的缺陷數量。這個指標在評估軟體質量和開發團隊績效時具有重要意義。以下是關於千行程式碼缺陷率考核指標的詳細說明：",
  "千行代码bug率=bug数/ (代码行数/1000)": "千行程式碼bug率=bug數/ (程式碼行數/1000)",
  "例如，如果一个项目有 2000 行代码，发现了 4 个缺陷，则千行代码缺陷率为： 千行代码bug率=4/（2000/1000）=2‰": "例如，如果一個專案有 2000 行程式碼，發現了 4 個缺陷，則千行程式碼缺陷率為： 千行程式碼bug率=4/（2000/1000）=2‰",
  "CMMI 级别与千行代码缺陷率": "CMMI 級別與千行程式碼缺陷率",
  "CMMI（能力成熟度模型集成）为不同成熟度级别的组织设定了千行代码缺陷率的标准：": "CMMI（能力成熟度模型整合）為不同成熟度級別的組織設定了千行程式碼缺陷率的標準：",
  "CMMI 1 级:": "CMMI 1 級:",
  "CMMI 2 级:": "CMMI 2 級:",
  "CMMI 3 级:": "CMMI 3 級:",
  "CMMI 4 级:": "CMMI 4 級:",
  "CMMI 5 级:": "CMMI 5 級:",
  "缺少需求名称！": "缺少需求名稱！",
  "确认提交": "確認提交",
  "已存在相同类型和名称的任务，如下：": "已存在相同型別和名稱的任務，如下：",
  "请选择操作：": "請選擇操作：",
  "仍要全部创建": "仍要全部建立",
  "仅创建不存在的": "僅建立不存在的",
  "（注：任务时间不能超过需求起始至交付时间段）": "（注：任務時間不能超過需求起始至交付時間段）",
  "时间跨度不能超过3天，请拆解": "時間跨度不能超過3天，請拆解",
  "单个任务不能超过3天，请拆解": "單個任務不能超過3天，請拆解",
  "请填入必填字段后在创建": "請填入必填欄位後在建立",
  "提测检查不通过，请确认itp平台用例冒烟是否通过~": "提測檢查不透過，請確認itp平臺用例冒煙是否透過~",
  "提测检查通过，可以申请提测": "提測檢查透過，可以申請提測",
  "填写提测申请": "填寫提測申請",
  "提测检查": "提測檢查",
  "CR报告：": "CR報告：",
  "服务名：": "服務名：",
  "分支名：": "分支名：",
  "点击复制CommitId": "點選複製CommitId",
  "CommitId已复制至剪贴板": "CommitId已複製至剪貼簿",
  "必填项 (": "必填項 (",
  "此项为必填项": "此項為必填項",
  "确定清空该选项及内容吗？": "確定清空該選項及內容嗎？",
  "选择/重新选择配置": "選擇/重新選擇配置",
  "请输入数据库相关内容": "請輸入資料庫相關內容",
  "请输入配置相关内容": "請輸入配置相關內容",
  "请输入相关内容": "請輸入相關內容",
  "重新选择配置": "重新選擇配置",
  "最近由": "最近由",
  "于": "於",
  "非必填项 (": "非必填項 (",
  "需求上线检查项": "需求上線檢查項",
  "若检查项已被确认，请再次认真核对！": "若檢查項已被確認，請再次認真核對！",
  "4周内达成率": "4周內達成率",
  "需求评审": "需求評審",
  "技术评审": "技術評審",
  "用例评审": "用例評審",
  "联调": "聯調",
  "提测": "提測",
  "计划上线": "計劃上線",
  "产品截止": "產品截止",
  "研发截止": "研發截止",
  "测试截止": "測試截止",
  "技术方案": "技術方案",
  "注意：研发排队后不支持更改需求类型": "注意：研發排隊後不支援更改需求型別",
  "迭代周期": "迭代週期",
  "查看业务需求描述": "檢視業務需求描述",
  "只读权限！": "只讀許可權！",
  "计划时间": "計劃時間",
  "交付物": "交付物",
  "提测详情": "提測詳情",
  "是否创建任务(后端、前端、测试、UI)": "是否建立任務(後端、前端、測試、UI)",
  "不创建": "不建立",
  "点击创建将会给后端、前端、测试、UI创建对应的测试任务，如果已存在任务则不创建！": "點選建立將會給後端、前端、測試、UI建立對應的測試任務，如果已存在任務則不建立！",
  "提测申请正在提交中，稍后会自动退出~": "提測申請正在提交中，稍後會自動退出~",
  "提测申请提交成功，已通知相关人员": "提測申請提交成功，已通知相關人員",
  "请输入需求名称": "請輸入需求名稱",
  "存为草稿": "存為草稿",
  "请输入需求描述": "請輸入需求描述",
  "粘贴链接后输入空格变为超链接": "貼上連結後輸入空格變為超連結",
  "业务需求接口人": "業務需求介面人",
  "如果经由技术支持或产品中转的需求，务必填写正确的需求提出人。": "如果經由技術支援或產品中轉的需求，務必填寫正確的需求提出人。",
  "需求状态变更时会自动通知到关注人。以便关注人知晓此需求进展情况": "需求狀態變更時會自動通知到關注人。以便關注人知曉此需求進展情況",
  "如果业务有明确期望上线日期，则填写此数据即可。": "如果業務有明確期望上線日期，則填寫此資料即可。",
  "期待时间": "期待時間",
  "需求状态变更时会自动通知到对应国家的技术支持。以便技术支持知晓此需求进展情况。": "需求狀態變更時會自動通知到對應國家的技術支援。以便技術支援知曉此需求進展情況。",
  "产品需求可以归属于国家线或行业线，或同时具备两者的特性，但必须以其中一方为主。具体定义如下：": "產品需求可以歸屬於國家線或行業線，或同時具備兩者的特性，但必須以其中一方為主。具體定義如下：",
  "国家线：业务方提出的需求功能或目标主要服务于特定国家的业务场景，不适用于全球通用业务场景。": "國家線：業務方提出的需求功能或目標主要服務於特定國家的業務場景，不適用於全球通用業務場景。",
  "行业线：业务方提出的需求功能或目标主要服务于特定垂直行业的业务场景，适用于全球通用业务场景。": "行業線：業務方提出的需求功能或目標主要服務於特定垂直行業的業務場景，適用於全球通用業務場景。",
  "默认选择当前需求影响国家下的技术支持。": "預設選擇當前需求影響國家下的技術支援。",
  "是否给前端、后端、测试、UI创建对应的任务，一端已存在任务的负责人将不在创建": "是否給前端、後端、測試、UI建立對應的任務，一端已存在任務的負責人將不在建立",
  "自动创建任务": "自動建立任務",
  "不创建任务": "不建立任務",
  "请选择是否自动创建任务": "請選擇是否自動建立任務",
  "如果已明确后端开发人员，可预选对应人员。相应人员将会提前收到需求进行预览。": "如果已明確後端開發人員，可預選對應人員。相應人員將會提前收到需求進行預覽。",
  "如果已明确前端开发人员，可预选对应人员。相应人员将会提前收到需求进行预览。": "如果已明確前端開發人員，可預選對應人員。相應人員將會提前收到需求進行預覽。",
  "如果已明确测试人员，可预选对应人员。相应人员将会提前收到需求进行预览。": "如果已明確測試人員，可預選對應人員。相應人員將會提前收到需求進行預覽。",
  "如果已明确UI设计人员，可预选对应人员。相应人员将会提前收到需求进行预览。": "如果已明確UI設計人員，可預選對應人員。相應人員將會提前收到需求進行預覽。",
  "该下拉列表展示的是研发效能内部标签。": "該下拉選單展示的是研發效能內部標籤。",
  "添加标��": "新增標��",
  "UI设计交付物": "UI設計交付物",
  "技术方案交付物": "技術方案交付物",
  "技术需求": "技術需求",
  "如果需要使用系统培训，将会给系统培训师发消息": "如果需要使用系統培訓，將會給系統培訓師發訊息",
  "未保存的更改": "未儲存的更改",
  "离开": "離開",
  "请选择要编辑的需求": "請選擇要編輯的需求",
  "编辑现有需求": "編輯現有需求",
  "是否是技术需求": "是否是技術需求",
  "需求描述（粘贴链接后输入空格变为超链接）": "需求描述（貼上連結後輸入空格變為超連結）",
  "按期待完成时间最早": "按期待完成時間最早",
  "按期待完成时间最晚": "按期待完成時間最晚",
  "按实际完成时间最早": "按實際完成時間最早",
  "按实际完成时间最晚": "按實際完成時間最晚",
  "按优先级最高": "按優先順序最高",
  "按优先级最低": "按優先順序最低",
  "在“只看我”下，不能选择需求执行人": "在“只看我”下，不能選擇需求執行人",
  "请选择需求执行人类型": "請選擇需求執行人型別",
  "请选择需求执行人": "請選擇需求執行人",
  "请选择Sprint": "請選擇Sprint",
  "业务满意度": "業務滿意度",
  "0~1 代表 大于等于0 ，小于1": "0~1 代表 大於等於0 ，小於1",
  "1~2 代表 大于等于1 ，小于2": "1~2 代表 大於等於1 ，小於2",
  "2~3 代表 大于等于2 ，小于3": "2~3 代表 大於等於2 ，小於3",
  "3~4 代表 大于等于3 ，小于4": "3~4 代表 大於等於3 ，小於4",
  "4 代表 等于4": "4 代表 等於4",
  "请选择业务满意度": "請選擇業務滿意度",
  "创建开始结束": "建立開始結束",
  "默认展示所有开发角色为自己的需求，并可与其他筛选条件“与”查询": "預設展示所有開發角色為自己的需求，並可與其他篩選條件“與”查詢",
  "合并请求": "合併請求",
  "开发分支：": "開發分支：",
  "目标分支：": "目標分支：",
  "失败原因：": "失敗原因：",
  "请输入删除原因：": "請輸入刪除原因：",
  "请先选择需要清空的需求": "請先選擇需要清空的需求",
  "已清空所选需求的交接产品": "已清空所選需求的交接產品",
  "请先选择需要交接的需求": "請先選擇需要交接的需求",
  "要交接的需求（": "要交接的需求（",
  "关联Bug数": "關聯Bug數",
  "关联需求详情列表": "關聯需求詳情列表",
  "创建人名称": "建立人名稱",
  "关联测试用例（冒烟通过率：": "關聯測試用例（冒煙透過率：",
  "智能会议纪要数量": "智慧會議紀要數量",
  "需求关联评审": "需求關聯評審",
  "会议时间": "會議時間",
  "30分钟": "30分鐘",
  "1小时": "1小時",
  "1.5小时": "1.5小時",
  "2小时": "2小時",
  "会议开始时提醒": "會議開始時提醒",
  "5分钟前提醒": "5分鐘前提醒",
  "15分钟前提醒": "15分鐘前提醒",
  "一小时前提醒": "一小時前提醒",
  "一天前提醒": "一天前提醒",
  "会议室": "會議室",
  "请先选择会议时间！": "請先選擇會議時間！",
  "请选择发布环境": "請選擇釋出環境",
  "请输入预计发布时间": "請輸入預計釋出時間",
  "和这次发布相关的人": "和這次釋出相關的人",
  "请输入协同人": "請輸入協同人",
  "紧急发布原因": "緊急釋出原因",
  "请输入紧急发布原因": "請輸入緊急釋出原因",
  "请详细说明紧急发布的原因...": "請詳細說明緊急釋出的原因...",
  "请输入发布描述信息...": "請輸入釋出描述資訊...",
  "是否拉取": "是否拉取",
  "人员列表": "人員列表",
  "拉群人员列表": "拉群人員列表",
  "取消全选": "取消全選",
  "💡 勾选的人员将在创建发布单时自动加入发布群": "💡 勾選的人員將在建立釋出單時自動加入釋出群",
  "发布检查项": "釋出檢查項",
  "已显示所有关联服务（包括同仓库服务）": "已顯示所有關聯服務（包括同倉庫服務）",
  "已隐藏同仓库的服务": "已隱藏同倉庫的服務",
  "选择分支": "選擇分支",
  "最新 Merged By": "最新 Merged By",
  "请先选择服务": "請先選擇服務",
  "加载全部分支失败": "載入全部分支失敗",
  "选": "選",
  "非常重要！": "非常重要！",
  "服务将按照当前表格顺序发布，默认顺序为后端基础、后端核心、后端其他、前端基础、前端核心、前端其他，可拖动修改发布顺序。": "服務將按照當前表格順序釋出，預設順序為後端基礎、後端核心、後端其他、前端基礎、前端核心、前端其他，可拖動修改釋出順序。",
  "请按commit规范提交代码，规范为\"[需求或线上问题的序列号]你的提交描述\"，我们会直接从commit提交记录中拉取当前需求、迭代、回归缺陷、线上问题的服务分支。": "請按commit規範提交程式碼，規範為\"[需求或線上問題的序列號]你的提交描述\"，我們會直接從commit提交記錄中拉取當前需求、迭代、迴歸缺陷、線上問題的服務分支。",
  "默认不带出同仓库的服务分支，如果需要带出，请点击“显示所有关联服务”": "預設不帶出同倉庫的服務分支，如果需要帶出，請點選“顯示所有關聯服務”",
  "点击隐藏同仓库的服务": "點選隱藏同倉庫的服務",
  "点击显示所有关联服务": "點選顯示所有關聯服務",
  "（服务：": "（服務：",
  "请选择一个分支": "請選擇一個分支",
  "从全部分支中选择": "從全部分支中選擇",
  "发布项名称": "釋出項名稱",
  "关联发布单数量": "關聯釋出單數量",
  "是否能创建发布单": "是否能建立釋出單",
  "发布项明细": "釋出項明細",
  "请至少添加一个服务分支": "請至少新增一個服務分支",
  "请完善所有服务分支的服务名称和分支信息": "請完善所有服務分支的服務名稱和分支資訊",
  "确认提交?": "確認提交?",
  "限制：": "限制：",
  "个/工作项": "個/工作項",
  "⚠️ 已达创建上限": "⚠️ 已達建立上限",
  "需要先预约发布才能创建发布单，": "需要先預約釋出才能建立釋出單，",
  "去预约": "去預約",
  "平均耗时(天)": "平均耗時(天)",
  "需求状态": "需求狀態",
  "产品阶段耗时(天)": "產品階段耗時(天)",
  "大于3天显示红色，小于等于3天显示绿色": "大於3天顯示紅色，小於等於3天顯示綠色",
  "研发阶段耗时(天)": "研發階段耗時(天)",
  "测试阶段耗时(天)": "測試階段耗時(天)",
  "验收阶段耗时(天)": "驗收階段耗時(天)",
  "总耗时(天)": "總耗時(天)",
  "小于等于15天显示绿色，15-30天显示橙色，大于30天显示红色": "小於等於15天顯示綠色，15-30天顯示橙色，大於30天顯示紅色",
  "产品等待阶段开始": "產品等待階段開始",
  "产品等待阶段结束": "產品等待階段結束",
  "产品方案阶段开始": "產品方案階段開始",
  "产品方案阶段结束": "產品方案階段結束",
  "产品评审阶段开始": "產品評審階段開始",
  "产品评审阶段结束": "產品評審階段結束",
  "需求阶段耗时": "需求階段耗時",
  "基础模式": "基礎模式",
  "详细模式": "詳細模式",
  "数据加载中...": "資料載入中...",
  "正在加载更多数据 (": "正在載入更多資料 (",
  "请填写检查项，红色为必填项": "請填寫檢查項，紅色為必填項",
  "当前需求类型为【": "當前需求型別為【",
  "当前状态流转之后就无法更改需求类型了，请确认是否继续？如果不确定，请与需求相关人员确认后再做决定！": "當前狀態流轉之後就無法更改需求型別了，請確認是否繼續？如果不確定，請與需求相關人員確認後再做決定！",
  "提测申请正在暂存中！": "提測申請正在暫存中！",
  "提测申请已暂存！": "提測申請已暫存！",
  "不是": "不是",
  "提测主题": "提測主題",
  "请输入提测主题": "請輸入提測主題",
  "研发人员": "研發人員",
  "请选择研发人员": "請選擇研發人員",
  "请选择测试人员": "請選擇測試人員",
  "提测环境": "提測環境",
  "请选择提测环境": "請選擇提測環境",
  "预计上线日期": "預計上線日期",
  "本地测试结果": "本地測試結果",
  "请选择本地测试结果": "請選擇本地測試結果",
  "是否有P0测试用例": "是否有P0測試用例",
  "请选择是否有测试用例": "請選擇是否有測試用例",
  "是否新增模块": "是否新增模組",
  "请选择是否新增模块": "請選擇是否新增模組",
  "没有P0测试用例的原因": "沒有P0測試用例的原因",
  "请填写没有测试用例的原因": "請填寫沒有測試用例的原因",
  "新增模块说明": "新增模組說明",
  "请填写新增模块说明": "請填寫新增模組說明",
  "提测内容": "提測內容",
  "重点测试点": "重點測試點",
  "联调结果": "聯調結果",
  "检查项加载中...": "檢查項載入中...",
  "检查项信息": "檢查項資訊",
  "全部选择\"是\"": "全部選擇\"是\"",
  "全部选择\"否\"": "全部選擇\"否\"",
  "一键选择": "一鍵選擇",
  "请选择是否": "請選擇是否",
  "确定要清空该选项及内容吗？": "確定要清空該選項及內容嗎？",
  "请输入分支名称": "請輸入分支名稱",
  "分支名只能包含数字、字母、小数点、短横线和下划线和斜杠分隔符": "分支名只能包含數字、字母、小數點、短橫線和下劃線和斜槓分隔符",
  "创建分支失败:": "建立分支失敗:",
  "创建分支": "建立分支",
  "服务名称：": "服務名稱：",
  "分支名称：": "分支名稱：",
  "* 分支名只能包含数字、字母、小数点、短横线和下划线和斜杠分隔符": "* 分支名只能包含數字、字母、小數點、短橫線和下劃線和斜槓分隔符",
  "加载分支列表失败": "載入分支列表失敗",
  "加载分支列表失败:": "載入分支列表失敗:",
  "请选择开发分支！": "請選擇開發分支！",
  "代码合并成功": "程式碼合併成功",
  "代码合并失败": "程式碼合併失敗",
  "合并分支": "合併分支",
  "请选择开发分支": "請選擇開發分支",
  "选择要合并到提测分支的开发分支": "選擇要合併到提測分支的開發分支",
  "由": "由",
  "提测分支（目标分支）": "提測分支（目標分支）",
  "开发分支将合并到此分支": "開發分支將合併到此分支",
  "请先选择服务名称！": "請先選擇服務名稱！",
  "请先创建提测分支！": "請先建立提測分支！",
  "分支创建成功": "分支建立成功",
  "提测分支": "提測分支",
  "请&nbsp;": "請&nbsp;",
  "&nbsp;或&nbsp;": "&nbsp;或&nbsp;",
  "建": "建",
  "&nbsp;一个提测分支": "&nbsp;一個提測分支",
  "删除行": "刪除行",
  "删": "刪",
  "是否被驳回": "是否被駁回",
  "获取数据失败": "獲取資料失敗",
  "需求任务甘特图": "需求任務甘特圖",
  "任务状况：": "任務狀況：",
  "逾期": "逾期",
  "未逾期": "未逾期",
  "需求未设置任务或未设置任务时间": "需求未設定任務或未設定任務時間",
  "人员昵称": "人員暱稱",
  "人员岗位": "人員崗位",
  "负责人名称": "負責人名稱",
  "负责人岗位": "負責人崗位",
  "需求状态数量统计": "需求狀態數量統計",
  "按系统分组": "按系統分組",
  "按人员分组": "按人員分組",
  "需求状态数量明细": "需求狀態數量明細",
  "需求自定义阶段数量明细": "需求自定義階段數量明細",
  "确认要删除任务吗？": "確認要刪除任務嗎？",
  "甘特图": "甘特圖",
  "开始人": "開始人",
  "结束人": "結束人",
  "需求角色阶段耗时明细": "需求角色階段耗時明細",
  "0.0天": "0.0天",
  "方案阶段": "方案階段",
  "评审阶段": "評審階段",
  "研发等待": "研發等待",
  "提测等待": "提測等待",
  "验收等待": "驗收等待",
  "暂无信息": "暫無資訊",
  "测试用例缺失的原因：": "測試用例缺失的原因：",
  "新增模块说明：": "新增模組說明：",
  "提测内容：": "提測內容：",
  "影响范围：": "影響範圍：",
  "重点测试点：": "重點測試點：",
  "联调结果：": "聯調結果：",
  "环境配置：": "環境配置：",
  "相关Sql：": "相關Sql：",
  "其他信息：": "其他資訊：",
  "数据看板🔥": "資料看板🔥",
  "是否删除规划": "是否刪除規劃",
  "确认要删除该规划吗？": "確認要刪除該規劃嗎？",
  "删除成功！": "刪除成功！",
  "请选择视图": "請選擇檢視",
  "状态看板": "狀態看板",
  "规划看板": "規劃看板",
  "新建规划": "新建規劃",
  "正在创建中，请勿重复提交": "正在建立中，請勿重複提交",
  "会议开始时间必须在当前时间之后": "會議開始時間必須在當前時間之後",
  "正在创建中，请稍等": "正在建立中，請稍等",
  "创建成功！": "建立成功！",
  "会议周期": "會議週期",
  "不重复": "不重複",
  "每天重复": "每天重複",
  "每个工作日重复": "每個工作日重複",
  "每周重复": "每週重複",
  "每月重复": "每月重複",
  "请选择周期": "請選擇週期",
  "会议创建人将自动成为参与人，无需额外选择": "會議建立人將自動成為參與人，無需額外選擇",
  "请选择会议参与人": "請選擇會議參與人",
  "请输入内容": "請輸入內容",
  "当前会议时间段空闲的会议室列表": "當前會議時間段空閒的會議室列表",
  "添加参与人": "新增參與人",
  "克隆评审（会议）": "克隆評審（會議）",
  "该会议相关信息已复制到剪贴板": "該會議相關資訊已複製到剪貼簿",
  "新建评审（会议）": "新建評審（會議）",
  "展示创建人为自己的记录": "展示建立人為自己的記錄",
  "评审": "評審",
  "的会议吗？": "的會議嗎？",
  "克隆评审会议": "克隆評審會議",
  "创建评审会议": "建立評審會議",
  "编辑评审会议": "編輯評審會議",
  "评审需求只能未关闭的需求": "評審需求只能未關閉的需求",
  "评审Sprint只能是进行中的Sprint": "評審Sprint只能是進行中的Sprint",
  "评审测试用例只能是未完成评审的用例": "評審測試用例只能是未完成評審的用例",
  "评审（会议）周期": "評審（會議）週期",
  "评审（会议）创建人将自动成为参与人，无需额外选择": "評審（會議）建立人將自動成為參與人，無需額外選擇",
  "请选择评审（会议）参与人": "請選擇評審（會議）參與人",
  "如果选择预约，在提交表单时会直接预约一个会议": "如果選擇預約，在提交表單時會直接預約一個會議",
  "当前评审时间段空闲的会议室列表": "當前評審時間段空閒的會議室列表",
  "评审确认情况": "評審確認情況",
  "AI智能会议纪要": "AI智慧會議紀要",
  "按章节": "按章節",
  "按主题": "按主題",
  "按发言人": "按發言人",
  "请选择当前评审时间段空闲的会议室": "請選擇當前評審時間段空閒的會議室",
  "空闲": "空閒",
  "最多只能选6个会议室": "最多隻能選6個會議室",
  "评审时间": "評審時間",
  "您不是会议参与人，没有权限查看该智能会议纪要": "您不是會議參與人，沒有許可權檢視該智慧會議紀要",
  "会议纪要(双击填写)": "會議紀要(雙擊填寫)",
  "双击填写": "雙擊填寫",
  "会议纪要附件": "會議紀要附件",
  "会议录制文件标题": "會議錄製檔案標題",
  "开始录制时间": "開始錄製時間",
  "结束录制时间": "結束錄製時間",
  "参会人": "參會人",
  "查看AI智能会议纪要": "檢視AI智慧會議紀要",
  "评审关联会议详情": "評審關聯會議詳情",
  "会议室（时间不得超过14天）": "會議室（時間不得超過14天）",
  "周期性会议不支持选择会议室": "週期性會議不支援選擇會議室",
  "请先选择时间！": "請先選擇時間！",
  "请先选择评审时间！": "請先選擇評審時間！",
  "评审关联详情": "評審關聯詳情",
  "会议纪要": "會議紀要",
  "规划添加需求（默认展示自己创建的需求）": "規劃新增需求（預設展示自己建立的需求）",
  "正在导出，请稍后...": "正在匯出，請稍後...",
  "下载图片": "下載圖片",
  "下载": "下載",
  "链接已失效": "連結已失效",
  "需求详情列表": "需求詳情列表",
  "任务负责人": "任務負責人",
  "只允许任务负责人删除": "只允許任務負責人刪除",
  "迭代开始后移入": "迭代開始後移入",
  "迭代开始后移出": "迭代開始後移出",
  "个工作项尚未完成，请处理后再完成迭代": "個工作項尚未完成，請處理後再完成迭代",
  "确认起始时间完成迭代": "確認起始時間完成迭代",
  "确认起始时间": "確認起始時間",
  "把它们移除本迭代，移至未规划": "把它們移除本迭代，移至未規劃",
  "把它们移至其他迭代": "把它們移至其他迭代",
  "度量指标": "度量指標",
  "标准值": "標準值",
  "千行代码缺陷率": "千行程式碼缺陷率",
  "（缺陷总数/代码行数）* 1000": "（缺陷總數/程式碼行數）* 1000",
  "移动端：&lt;": "移動端：&lt;",
  "前端：&lt;": "前端：&lt;",
  "后端：&lt;": "後端：&lt;",
  "查看任务详情": "檢視任務詳情",
  "查看缺陷详情": "檢視缺陷詳情",
  "计划暂停至日期": "計劃暫停至日期",
  "更换Sprint": "更換Sprint",
  "取消批量": "取消批次",
  "批量选择": "批次選擇",
  "数据明细": "資料明細",
  "迭代已完成归档，如需查看请切换到「已归档」下查看": "迭代已完成歸檔，如需檢視請切換到「已歸檔」下檢視",
  "编辑迭代": "編輯迭代",
  "解锁": "解鎖",
  "是否删除迭代吗": "是否刪除迭代嗎",
  "确认要删除迭代吗？": "確認要刪除迭代嗎？",
  "删除迭代": "刪除迭代",
  "树形": "樹形",
  "阶段看板": "階段看板",
  "缺陷列表": "缺陷列表",
  "产品经理：": "產品經理：",
  "后端开发：": "後端開發：",
  "前端开发：": "前端開發：",
  "测试开发：": "測試開發：",
  "UI设计：": "UI設計：",
  "技术支持：": "技術支援：",
  "业务对接：": "業務對接：",
  "关注人：": "關注人：",
  "相关人：": "相關人：",
  "功能使用：": "功能使用：",
  "Sprint迭代": "Sprint迭代",
  "未规划工作项（产品需求）": "未規劃工作項（產品需求）",
  "工作项": "工作項",
  "迭代名称和链接已复制到剪贴板": "迭代名稱和連結已複製到剪貼簿",
  "提醒成功": "提醒成功",
  "催开始": "催開始",
  "催结束": "催結束",
  "规划迭代": "規劃迭代",
  "开始迭代": "開始迭代",
  "完成迭代": "完成迭代",
  "发布迭代": "釋出迭代",
  "创建人：": "建立人：",
  "迭代周期：": "迭代週期：",
  "迭代进度：": "迭代進度：",
  "目标进度：": "目標進度：",
  "开始迭代：": "開始迭代：",
  "完成迭代：": "完成迭代：",
  "后端研发：": "後端研發：",
  "前端研发：": "前端研發：",
  "当前状态：": "當前狀態：",
  "迭代目标：": "迭代目標：",
  "未规划项（拖动需要展开Sprint）": "未規劃項（拖動需要展開Sprint）",
  "锁定已锁定，不能规划迭代，请联系负责人解锁后再操作": "鎖定已鎖定，不能規劃迭代，請聯絡負責人解鎖後再操作",
  "确认后，当前状态将被标记为该需求的迭代目标，操作完成！": "確認後，當前狀態將被標記為該需求的迭代目標，操作完成！",
  "迭代目标状态：": "迭代目標狀態：",
  "暂无迭代目标": "暫無迭代目標",
  "迭代尚未开始": "迭代尚未開始",
  "返回旧版": "返回舊版",
  "新建Sprint": "新建Sprint",
  "交接迭代": "交接迭代",
  "当前没有可交接的迭代": "當前沒有可交接的迭代",
  "人天": "人天",
  "迭代工时概览": "迭代工時概覽",
  "（1人天 = 8小时）": "（1人天 = 8小時）",
  "开始": "開始",
  "请到Sprint（新版）右上角完成迭代": "請到Sprint（新版）右上角完成迭代",
  "工作项变更": "工作項變更",
  "工作项概览": "工作項概覽",
  "查看任务列表": "檢視任務列表",
  "添加需求任务": "新增需求任務",
  "目标(双击开始编辑)": "目標(雙擊開始編輯)",
  "Sprint名称和链接已剪贴板": "Sprint名稱和連結已剪貼簿",
  "请先选择交接负责人": "請先選擇交接負責人",
  "已批量填充空白交接负责人": "已批次填充空白交接負責人",
  "请先勾选需要清空的迭代": "請先勾選需要清空的迭代",
  "已清空选中迭代的交接负责人": "已清空選中迭代的交接負責人",
  "请先选择需要交接的迭代": "請先選擇需要交接的迭代",
  "请选择交接负责人": "請選擇交接負責人",
  "迭代目标": "迭代目標",
  "时间周期": "時間週期",
  "当前负责人": "當前負責人",
  "交接负责人": "交接負責人",
  "迭代交接": "迭代交接",
  "要交接的迭代（": "要交接的迭代（",
  "交接负责人：": "交接負責人：",
  "统一选择交接负责人": "統一選擇交接負責人",
  "隐藏无法操作的迭代": "隱藏無法操作的迭代",
  "请输入Sprint名称": "請輸入Sprint名稱",
  "Sprint名称不能包含中文字符": "Sprint名稱不能包含中文字元",
  "该Sprint包含的需求，一个需求只能属于一个Sprint": "該Sprint包含的需求，一個需求只能屬於一個Sprint",
  "版本号只能以数字开头结尾并且用小数点连接（如 1.0.0），创建迭代会自动版本+1": "版本號只能以數字開頭結尾並且用小數點連線（如 1.0.0），建立迭代會自動版本+1",
  "格式不正确，(如 1.0.0)": "格式不正確，(如 1.0.0)",
  "邮件抄送人": "郵件抄送人",
  "请输入迭代目标": "請輸入迭代目標",
  "在“只看我”下，不能选择负责人": "在“只看我”下，不能選擇負責人",
  "请至少选择一个状态": "請至少選擇一個狀態",
  "周期开始": "週期開始",
  "周期结束": "週期結束",
  "正在添加": "正在新增",
  "添加失败，请重试！": "新增失敗，請重試！",
  "更新中": "更新中",
  "更新成功！": "更新成功！",
  "更新失败，请重试！": "更新失敗，請重試！",
  "是否删除Sprint": "是否刪除Sprint",
  "确认要删除Sprint吗？": "確認要刪除Sprint嗎？",
  "Sprint（新版）": "Sprint（新版）",
  "大类筛选（可选，不选则显示全部）": "大類篩選（可選，不選則顯示全部）",
  "选择大类以缩小范围": "選擇大類以縮小範圍",
  "输入要创建的分支名称或选择分支": "輸入要建立的分支名稱或選擇分支",
  "存在未创建的分支，请点击分支后的“ + ”创建后再保存任务": "存在未建立的分支，請點選分支後的“ + ”建立後再儲存任務",
  "所属需求：": "所屬需求：",
  "服务类型、服务、分支不能为空！": "服務型別、服務、分支不能為空！",
  "需求 & 服务分支(双击开始编辑)": "需求 & 服務分支(雙擊開始編輯)",
  "任务描述(双击开始编辑)": "任務描述(雙擊開始編輯)",
  "任务名称和链接已剪贴板": "任務名稱和連結已剪貼簿",
  "系统与Sprint、需求下拉框会有联动效果": "系統與Sprint、需求下拉框會有聯動效果",
  "筛选大类": "篩選大類",
  "Sprint下拉选择只有筛选需求的作用，任务只会与需求直接关联": "Sprint下拉選擇只有篩選需求的作用，任務只會與需求直接關聯",
  "该下拉列表展示的是“任务中心”标签。": "該下拉選單展示的是“任務中心”標籤。",
  "该任务相关联的服务(注:服务类型选择后，服务名称下拉框会自动加载服务名称)": "該任務相關聯的服務(注:服務型別選擇後，服務名稱下拉框會自動載入服務名稱)",
  "输入分支“+”创建或选择分支": "輸入分支“+”建立或選擇分支",
  "数字、字母、小数点、短横线、下划线": "數字、字母、小數點、短橫線、下劃線",
  "创建远程分支": "建立遠端分支",
  "删除当前行": "刪除當前行",
  "在“只看我”下，不能选择参与人": "在“只看我”下，不能選擇參與人",
  "请选择参与人": "請選擇參與人",
  "默认展示负责人、参与人、创建人为自己的记录，并可与其他筛选条件“与”查询": "預設展示負責人、參與人、建立人為自己的記錄，並可與其他篩選條件“與”查詢",
  "相关任务": "相關任務",
  "取消排序": "取消排序",
  "新建状态流转规则": "新建狀態流轉規則",
  "编辑状态流转规则": "編輯狀態流轉規則",
  "当工作项从": "當工作項從",
  "进入": "進入",
  "时，需要满足：": "時，需要滿足：",
  "字段": "欄位",
  "必填，": "必填，",
  "部分人": "部分人",
  "操作，": "操作，",
  "且": "且",
  "添加其它字段条件": "新增其它欄位條件",
  "字段条件": "欄位條件",
  "添加必填字段": "新增必填欄位",
  "添加操作人员": "新增操作人員",
  "执行人角色": "執行人角色",
  "具体人员": "具體人員",
  "添加状态": "新增狀態",
  "状态阶段列表": "狀態階段列表",
  "新增阶段": "新增階段",
  "请输入阶段名称或描述或编码": "請輸入階段名稱或描述或編碼",
  "】 状态阶段吗？": "】 狀態階段嗎？",
  "状态名称（中文）": "狀態名稱（中文）",
  "状态名称（英文）": "狀態名稱（英文）",
  "状态描述": "狀態描述",
  "状态阶段名称": "狀態階段名稱",
  "状态阶段回显颜色": "狀態階段回顯顏色",
  "状态列表": "狀態列表",
  "新增状态": "新增狀態",
  "请输入状态名称或描述或编码": "請輸入狀態名稱或描述或編碼",
  "】 状态吗？": "】 狀態嗎？",
  "配置状态": "配置狀態",
  "配置状态阶段": "配置狀態階段",
  "创建一个工作流": "建立一個工作流",
  "排序号：": "排序號：",
  "编辑工作所属状态": "編輯工作所屬狀態",
  "编辑工作流基础信息": "編輯工作流基礎資訊",
  "克隆工作流": "克隆工作流",
  "删除工作流": "刪除工作流",
  "点击转正草稿": "點選轉正草稿",
  "点击关闭对外展示": "點選關閉對外展示",
  "对外展示": "對外展示",
  "点击开启对外展示": "點選開啟對外展示",
  "对外隐藏": "對外隱藏",
  "确定删除 【": "確定刪除 【",
  "】 工作流吗": "】 工作流嗎",
  "确定克隆 【": "確定克隆 【",
  "确定转正 【": "確定轉正 【",
  "工作流草稿已成功转正": "工作流草稿已成功轉正",
  "】 工作流对外展示吗": "】 工作流對外展示嗎",
  "配置 【": "配置 【",
  "】 工作流状态": "】 工作流狀態",
  "配置工作流所属状态及状态流转": "配置工作流所屬狀態及狀態流轉",
  "创建完成": "建立完成",
  "工作流已成功创建，请点击完成按钮完成创建并退出！": "工作流已成功建立，請點選完成按鈕完成建立並退出！",
  "创建 【": "建立 【",
  "】 工作流": "】 工作流",
  "上一步": "上一步",
  "请先点击保存按钮保存工作流基础信息": "請先點選儲存按鈕儲存工作流基礎資訊",
  "工作流已成功创建": "工作流已成功建立",
  "工作流名称": "工作流名稱",
  "工作流描述": "工作流描述",
  "请输入排序号": "請輸入排序號",
  "工作流Logo": "工作流Logo",
  "状态名称(中文)": "狀態名稱(中文)",
  "状态名称(英文)": "狀態名稱(英文)",
  "状态所属阶段": "狀態所屬階段",
  "阶段名称(中文)": "階段名稱(中文)",
  "阶段名称(英文)": "階段名稱(英文)",
  "阶段描述": "階段描述",
  "】 工作流基础信息": "】 工作流基礎資訊",
  "鼠标左键按住拖动调整顺序": "滑鼠左鍵按住拖動調整順序",
  "移除状态": "移除狀態",
  "确定移除": "確定移除",
  "吗": "嗎",
  "移除成功": "移除成功",
  "的流转规则吗": "的流轉規則嗎",
  "审批流程配置 -": "審批流程配置 -",
  "添加审批节点": "新增審批節點",
  "编辑审批类型": "編輯審批型別",
  "添加审批类型": "新增審批型別",
  "请输入审批类型名称，如：请假审批、报销审批等": "請輸入審批型別名稱，如：請假審批、報銷審批等",
  "请输入审批类型名称": "請輸入審批型別名稱",
  "Code是审批类型的唯一标识，用于在审批流程中引用，命名规则：全大写字母，用_分割，如：PROJECT_APPLY等": "Code是審批型別的唯一標識，用於在審批流程中引用，命名規則：全大寫字母，用_分割，如：PROJECT_APPLY等",
  "请输入审批类型Code，全大写字母，用_分割": "請輸入審批型別Code，全大寫字母，用_分割",
  "请输入审批类型Code": "請輸入審批型別Code",
  "请详细描述这个审批类型的用途和流程，帮助用户更好地理解": "請詳細描述這個審批型別的用途和流程，幫助使用者更好地理解",
  "管理人员": "管理人員",
  "请选择审批类型管理人员": "請選擇審批型別管理人員",
  "管理人员可修改已发起审批单的审批人": "管理人員可修改已發起審批單的審批人",
  "解析审批者类别 ruleScope 失败:": "解析審批者類別 ruleScope 失敗:",
  "节点配置 -": "節點配置 -",
  "基础配置": "基礎配置",
  "是否合并审批": "是否合併審批",
  "合并审批说明：": "合併審批說明：",
  "合并": "合併",
  "：将该规则节点的所有审批人员视为一个整体发起审批": "：將該規則節點的所有審批人員視為一個整體發起審批",
  "独立": "獨立",
  "：按照业务领域或系统或服务作为审批小组独立发起审批": "：按照業務領域或系統或服務作為審批小組獨立發起審批",
  "注意：合并模式适用于需要统一审批的场景，独立模式适用于按业务分组审批的场景": "注意：合併模式適用於需要統一審批的場景，獨立模式適用於按業務分組審批的場景",
  "审批者类别": "審批者類別",
  "通过规则": "透過規則",
  "审批人员": "審批人員",
  "追加固定审批人": "追加固定審批人",
  "请选择审批人员": "請選擇審批人員",
  "可选：追加固定审批人": "可選：追加固定審批人",
  "作用域配置": "作用域配置",
  "域范围": "域範圍",
  "只用于": "只用於",
  "不用于": "不用於",
  "域类型": "域型別",
  "域值": "域值",
  "删除节点": "刪除節點",
  "上移": "上移",
  "下移": "下移",
  "克隆节点": "克隆節點",
  "在此节点后添加": "在此節點後新增",
  "没有配置人员": "沒有配置人員",
  "自动获取 +": "自動獲取 +",
  "系统自动获取": "系統自動獲取",
  "业务": "業務",
  "放大": "放大",
  "重置聚焦": "重置聚焦",
  "重置视图": "重置檢視",
  "重置缩放": "重置縮放",
  "暂无审批节点，点击\"添加审批节点\"开始设计流程": "暫無審批節點，點選\"新增審批節點\"開始設計流程",
  "结束": "結束",
  "加载审批规则失败": "載入審批規則失敗",
  "节点克隆成功": "節點克隆成功",
  "保存失败": "儲存失敗",
  "禁用": "禁用",
  "编辑类型": "編輯型別",
  "删除类型": "刪除型別",
  "确定要删除这个审批类型吗？": "確定要刪除這個審批型別嗎？",
  "规则配置": "規則配置",
  "搜索审批类型名称、Code或描述": "搜尋審批型別名稱、Code或描述",
  "状态更新失败，请重试！": "狀態更新失敗，請重試！",
  "确认关闭该业务领域？": "確認關閉該業務領域？",
  "关联部门": "關聯部門",
  "企微群ID": "企微群ID",
  "飞书群ID": "飛書群ID",
  "飞书BUG群ID": "飛書BUG群ID",
  "业务群机器人url": "業務群機器人url",
  "新增业务领域": "新增業務領域",
  "请输入业务领域名称": "請輸入業務領域名稱",
  "保存中": "儲存中",
  "保存失败，请重试": "儲存失敗，請重試",
  "研发接口人": "研發介面人",
  "飞书需求群聊ID": "飛書需求群聊ID",
  "新增系统": "新增系統",
  "请输入系统名称或系统key": "請輸入系統名稱或系統key",
  "关联数据库": "關聯資料庫",
  "机器人url": "機器人url",
  "创建该系统的线上问题时，研发接口人将会被拉到线上问题群": "建立該系統的線上問題時，研發介面人將會被拉到線上問題群",
  "行业线编码(唯一且不能修改)": "行業線編碼(唯一且不能修改)",
  "行业线编码只能包含字母、数字、横划线和下划线": "行業線編碼只能包含字母、數字、橫劃線和下劃線",
  "行业线名称": "行業線名稱",
  "父级行业线": "父級行業線",
  "激活": "啟用",
  "行业线编码": "行業線編碼",
  "请输入行业线名称或编码": "請輸入行業線名稱或編碼",
  "新增行业线": "新增行業線",
  "打标明细": "打標明細",
  "确认要删除标签吗？": "確認要刪除標籤嗎？",
  "请输入标签名称": "請輸入標籤名稱",
  "新增标签": "新增標籤",
  "属性信息配置（待实现）": "屬性資訊配置（待實現）",
  "缺少组ID，无法保存": "缺少組ID，無法儲存",
  "基础信息保存成功": "基礎資訊儲存成功",
  "基础信息编辑": "基礎資訊編輯",
  "组名称": "組名稱",
  "请输入组名称": "請輸入組名稱",
  "组名称不能超过50个字符": "組名稱不能超過50個字元",
  "负责人可以管理该卡片组，并进行卡片分发与编辑(不包含删除权限,只有创建人才能删除卡片组) ps:卡片赠送消息会抄送负责人": "負責人可以管理該卡片組，並進行卡片分發與編輯(不包含刪除許可權,只有建立人才能刪除卡片組) ps:卡片贈送訊息會抄送負責人",
  "关联TOP部门": "關聯TOP部門",
  "卡片将在这些top部门内部流转": "卡片將在這些top部門內部流轉",
  "请选择关联TOP部门": "請選擇關聯TOP部門",
  "请选择TOP部门": "請選擇TOP部門",
  "组描述": "組描述",
  "请输入组描述（选填）": "請輸入組描述（選填）",
  "组描述不能超过200个字符": "組描述不能超過200個字元",
  "活动名称": "活動名稱",
  "同人同卡最大赠送数": "同人同卡最大贈送數",
  "提醒周期": "提醒週期",
  "第几小时提醒": "第幾小時提醒",
  "确认手动触发未使用卡片提醒吗？": "確認手動觸發未使用卡片提醒嗎？",
  "提醒": "提醒",
  "确认删除该活动吗？": "確認刪除該活動嗎？",
  "请选择卡片组": "請選擇卡片組",
  "请选择活动时间": "請選擇活動時間",
  "活动更新成功": "活動更新成功",
  "活动创建成功": "活動建立成功",
  "活动列表": "活動列表",
  "新建活动": "新建活動",
  "暂无活动": "暫無活動",
  "编辑活动": "編輯活動",
  "请输入活动名称": "請輸入活動名稱",
  "活动时间": "活動時間",
  "同人同卡最大赠送数量": "同人同卡最大贈送數量",
  "可选，默认不限": "可選，預設不限",
  "设置后会给未使用卡片人员发送提醒通知": "設定後會給未使用卡片人員傳送提醒通知",
  "可选，选择后需配置提醒小时": "可選，選擇後需配置提醒小時",
  "可选，范围 0~23": "可選，範圍 0~23",
  "分发原因": "分發原因",
  "单人发放数量": "單人發放數量",
  "发放人数": "發放人數",
  "总发放数": "總髮放數",
  "确认撤回该分发批次吗？": "確認撤回該分發批次嗎？",
  "撤回成功": "撤回成功",
  "撤回": "撤回",
  "分发批次记录": "分發批次記錄",
  "请选择卡片组后查看分发批次记录": "請選擇卡片組後檢視分發批次記錄",
  "卡片名称": "卡片名稱",
  "持有人": "持有人",
  "生效时间": "生效時間",
  "失效时间": "失效時間",
  "发放人": "發放人",
  "发放时间": "發放時間",
  "持有人:": "持有人:",
  "请选择持有人": "請選擇持有人",
  "卡片:": "卡片:",
  "请选择卡片": "請選擇卡片",
  "发放时间:": "發放時間:",
  "分发记录": "分發記錄",
  "请选择卡片组后查看分发记录": "請選擇卡片組後檢視分發記錄",
  "赠送人": "贈送人",
  "接收人所属部门": "接收人所屬部門",
  "赠送装饰": "贈送裝飾",
  "赠送时间": "贈送時間",
  "导出失败:": "匯出失敗:",
  "赠送人:": "贈送人:",
  "请选择赠送人": "請選擇贈送人",
  "接收人:": "接收人:",
  "赠送时间:": "贈送時間:",
  "赠送记录": "贈送記錄",
  "请选择卡片组后查看赠送记录": "請選擇卡片組後檢視贈送記錄",
  "请选择卡片组后再分发": "請選擇卡片組後再分發",
  "模板信息异常，无法分发": "模板資訊異常，無法分發",
  "请至少选择一个部门": "請至少選擇一個部門",
  "所选部门暂无人员": "所選部門暫無人員",
  "请至少选择一位人员": "請至少選擇一位人員",
  "分发成功": "分發成功",
  "有效期": "有效期",
  "请选择有效期": "請選擇有效期",
  "分发数量": "分發數量",
  "请输入分发数量": "請輸入分發數量",
  "分发数量需大于0": "分發數量需大於0",
  "请输入数量": "請輸入數量",
  "请填写分发原因": "請填寫分發原因",
  "选人模式": "選人模式",
  "按部门": "按部門",
  "按人员": "按人員",
  "指定部门": "指定部門",
  "指定人员": "指定人員",
  "请选择分发人员": "請選擇分發人員",
  "卡片赠送情况占比": "卡片贈送情況佔比",
  "请选择卡片类型": "請選擇卡片型別",
  "卡片净收到数量排行": "卡片淨收到數量排行",
  "暂无卡片净收到数量排行数据": "暫無卡片淨收到數量排行資料",
  "赠送": "贈送",
  "分发卡片": "分發卡片",
  "确定要删除这个卡片吗？": "確定要刪除這個卡片嗎？",
  "请输入卡片名称": "請輸入卡片名稱",
  "请选择卡片适用范围": "請選擇卡片適用範圍",
  "卡片模板更新成功": "卡片模板更新成功",
  "卡片模板创建成功": "卡片模板建立成功",
  "暂无素材": "暫無素材",
  "无背景": "無背景",
  "卡片适用范围": "卡片適用範圍",
  "卡片使用规则": "卡片使用規則",
  "请输入卡片使用规则": "請輸入卡片使用規則",
  "背景素材库": "背景素材庫",
  "新增卡片": "新增卡片",
  "模板信息异常，无法删除": "模板資訊異常，無法刪除",
  "分发批次": "分發批次",
  "活动配置": "活動配置",
  "请先新建一个活动哦": "請先新建一個活動哦",
  "创建活动后即可配置卡片。": "建立活動後即可配置卡片。",
  "快速创建活动": "快速建立活動",
  "卡片类型配置保存成功": "卡片型別配置儲存成功",
  "卡片类型配置": "卡片型別配置",
  "卡片类型名称": "卡片型別名稱",
  "请输入卡片类型名称": "請輸入卡片型別名稱",
  "卡片类型编码": "卡片型別編碼",
  "只能包含大写字母和下划线": "只能包含大寫字母和下劃線",
  "请输入卡片类型编码": "請輸入卡片型別編碼",
  "卡片类型编码只能包含大写字母和下划线": "卡片型別編碼只能包含大寫字母和下劃線",
  "请输入卡片类型编码（大写字母和下划线）": "請輸入卡片型別編碼（大寫字母和下劃線）",
  "适用范围": "適用範圍",
  "请选择适用范围": "請選擇適用範圍",
  "确定要删除这条记录吗？": "確定要刪除這條記錄嗎？",
  "添加卡片类型": "新增卡片型別",
  "表单未初始化": "表單未初始化",
  "请完善卡片类型信息": "請完善卡片型別資訊",
  "请完善表单信息": "請完善表單資訊",
  "创建失败": "建立失敗",
  "创建卡片组": "建立卡片組",
  "完成创建": "完成建立",
  "卡片素材": "卡片素材",
  "组素材保存成功": "組素材儲存成功",
  "组素材配置": "組素材配置",
  "仅支持上传 PNG/JPG/SVG 图片": "僅支援上傳 PNG/JPG/SVG 圖片",
  "背景素材": "背景素材",
  "点击批量上传": "點選批次上傳",
  "装饰素材": "裝飾素材",
  "素材配置": "素材配置",
  "删除组": "刪除組",
  "确定要删除这个组吗？": "確定要刪除這個組嗎？",
  "月份": "月份",
  "指标类型": "指標型別",
  "指标单位": "指標單位",
  "考核角色": "考核角色",
  "基线值": "基線值",
  "确定删除该基线吗？": "確定刪除該基線嗎？",
  "新增基线": "新增基線",
  "编辑基线": "編輯基線",
  "请选择关联类型": "請選擇關聯型別",
  "年-月": "年-月",
  "请选择年月": "請選擇年月",
  "（单位：": "（單位：",
  "批量新增基线": "批次新增基線",
  "请至少选择一个年月": "請至少選擇一個年月",
  "选择图标": "選擇圖示",
  "请选择指标图标": "請選擇指標圖示",
  "提交失败，请检查表单": "提交失敗，請檢查表單",
  "新增指标": "新增指標",
  "编辑指标": "編輯指標",
  "更换图标": "更換圖示",
  "请输入指标名称": "請輸入指標名稱",
  "指标编码": "指標編碼",
  "请输入指标编码": "請輸入指標編碼",
  "请选择指标类型": "請選擇指標型別",
  "能否算分": "能否算分",
  "请选择能否算分": "請選擇能否算分",
  "请选择考核角色": "請選擇考核角色",
  "指标极性": "指標極性",
  "请选择指标极性": "請選擇指標極性",
  "请选择指标单位": "請選擇指標單位",
  "指标级别": "指標級別",
  "指标归属": "指標歸屬",
  "指标描述": "指標描述",
  "请输入指标描述": "請輸入指標描述",
  "状态切换成功": "狀態切換成功",
  "查看基线详情": "檢視基線詳情",
  "确定删除该指标吗？": "確定刪除該指標嗎？",
  "请输入指标名称/编码/描述": "請輸入指標名稱/編碼/描述",
  "单个新增": "單個新增",
  "批量新增": "批次新增",
  "配置指标": "配置指標",
  "交付": "交付",
  "效率": "效率",
  "代码": "程式碼",
  "协作": "協作",
  "工时": "工時",
  "质量": "質量",
  "增长": "增長",
  "下降": "下降",
  "进展": "進展",
  "分析": "分析",
  "报表": "報表",
  "总览": "總覽",
  "数据": "資料",
  "安全": "安全",
  "监控": "監控",
  "性能": "效能",
  "热点": "熱點",
  "雷达": "雷達",
  "漏斗": "漏斗",
  "节点类型": "節點型別",
  "节点": "節點",
  "节点描述不能为空": "節點描述不能為空",
  "节点驳回描述（中文）": "節點駁回描述（中文）",
  "节点驳回描述（英文）": "節點駁回描述（英文）",
  "回退节点；可不设置，不设置默认按操作记录回退为上一操作节点": "回退節點；可不設定，不設定預設按操作記錄回退為上一操作節點",
  "节点描述": "節點描述",
  "回退节点": "回退節點",
  "确认要删除驳回节点吗？": "確認要刪除駁回節點嗎？",
  "新增驳回节点": "新增駁回節點",
  "请输入查询条件": "請輸入查詢條件",
  "无操作权限": "無操作許可權",
  "服务组": "服務組",
  "git组": "git組",
  "git名称": "git名稱",
  "请输入git名称": "請輸入git名稱",
  "请输入有效的git名称，例如：https://git.imile.com/tech/athena.git": "請輸入有效的git名稱，例如：https://git.imile.com/tech/athena.git",
  "服务描述": "服務描述",
  "已部署环境": "已部署環境",
  "环境数量": "環境數量",
  "开发": "開發",
  "添加环境": "新增環境",
  "克隆后，请及时修改服务名": "克隆後，請及時修改服務名",
  "克隆服务基础信息": "克隆服務基礎資訊",
  "删除后，【服务环境记录】与【服务jenkins配置】也会一并删除，确认要删除吗？": "刪除後，【服務環境記錄】與【服務jenkins配置】也會一併刪除，確認要刪除嗎？",
  "服务基础信息列表": "服務基礎資訊列表",
  "新增服务": "新增服務",
  "请输入服务名或服务描述": "請輸入服務名或服務描述",
  "日志url": "日誌url",
  "副本数": "副本數",
  "镜像列表": "映象列表",
  "是否灰度发布": "是否灰度釋出",
  "域名配置": "域名配置",
  "发布窗口开始时间": "釋出視窗開始時間",
  "发布窗口截止时间": "釋出視窗截止時間",
  "克隆环境": "克隆環境",
  "服务关联环境列表": "服務關聯環境列表",
  "新增环境": "新增環境",
  "克隆环境配置": "克隆環境配置",
  "请选择目标环境": "請選擇目標環境",
  "目标环境": "目標環境",
  "新增环境配置": "新增環境配置",
  "编辑环境配置": "編輯環境配置",
  "发布窗口时间": "釋出視窗時間",
  "Apollo环境": "Apollo環境",
  "数据库名": "資料庫名",
  "域名对象": "域名物件",
  "应用说明": "應用說明",
  "订阅后会在配置和数据库变更后推送企微消息，前端不支持订阅": "訂閱後會在配置和資料庫變更後推送企微訊息，前端不支援訂閱",
  "配置服务": "配置服務",
  "订阅人更新成功": "訂閱人更新成功",
  "更新失败": "更新失敗",
  "编辑订阅人失败:": "編輯訂閱人失敗:",
  "选择订阅人：": "選擇訂閱人：",
  "请选择订阅人": "請選擇訂閱人",
  "新的状态组": "新的狀態組",
  "状态中文名": "狀態中文名",
  "状态英文名": "狀態英文名",
  "类型编码": "型別編碼",
  "类型名称": "型別名稱",
  "正常": "正常",
  "新增类型": "新增型別",
  "请输入编码或名称或描述": "請輸入編碼或名稱或描述",
  "请输入编码或中英文名称": "請輸入編碼或中英文名稱",
  "保存草稿失败:": "儲存草稿失敗:",
  "表单提交失败:": "表單提交失敗:",
  "新增版本": "新增版本",
  "如：v2.1.0": "如：v2.1.0",
  "请输入版本号": "請輸入版本號",
  "版本号格式不正确，请输入如：v2.1.0 ，v1.0.0-beta格式（必须以v开头）": "版本號格式不正確，請輸入如：v2.1.0 ，v1.0.0-beta格式（必須以v開頭）",
  "请选择发布时间": "請選擇釋出時間",
  "选择发布时间": "選擇釋出時間",
  "一句话描述本次发布内容（可选）": "一句話描述本次釋出內容（可選）",
  "版本摘要": "版本摘要",
  "请输入版本摘要（可选）": "請輸入版本摘要（可選）",
  "更新明细": "更新明細",
  "更新类型": "更新型別",
  "选择类型": "選擇型別",
  "请选择更新类型": "請選擇更新型別",
  "更新内容": "更新內容",
  "请输入更新内容": "請輸入更新內容",
  "最新版本": "最新版本",
  "📝 版本摘要": "📝 版本摘要",
  "📋 更新内容": "📋 更新內容",
  "项更新": "項更新",
  "目录": "目錄",
  "查看所有功能更新和版本历史，了解最新系统改进": "檢視所有功能更新和版本歷史，瞭解最新系統改進",
  "暂无草稿版本": "暫無草稿版本",
  "暂无发布版本": "暫無釋出版本",
  "创建第一个版本": "建立第一個版本",
  "请填写完整的中文模板内容": "請填寫完整的中文模板內容",
  "中文模板": "中文模板",
  "请输入中文模板内容": "請輸入中文模板內容",
  "英文模板": "英文模板",
  "是否启用": "是否啟用",
  "模版所有者": "模版所有者",
  "确认要删除模版吗？": "確認要刪除模版嗎？",
  "新增模版": "新增模版",
  "搜索类型（名称）": "搜尋型別（名稱）",
  "暂无订阅类型": "暫無訂閱型別",
  "确认删除该订阅类型？": "確認刪除該訂閱型別？",
  "删除类型后将无法在页面选择该类型。": "刪除型別後將無法在頁面選擇該型別。",
  "新增订阅类型": "新增訂閱型別",
  "编辑订阅类型": "編輯訂閱型別",
  "请输入类型名称": "請輸入型別名稱",
  "例如：需求池订阅": "例如：需求池訂閱",
  "类型 CODE": "型別 CODE",
  "请输入类型 CODE": "請輸入型別 CODE",
  "仅支持字母/数字/_/-": "僅支援字母/數字/_/-",
  "例如：POOL_SUBSCRIBE": "例如：POOL_SUBSCRIBE",
  "关联值类型": "關聯值型別",
  "请选择关联值类型": "請選擇關聯值型別",
  "订阅值": "訂閱值",
  "请选择一个订阅类型": "請選擇一個訂閱型別",
  "搜索订阅值（名称）": "搜尋訂閱值（名稱）",
  "产品需求状态": "產品需求狀態",
  "订阅类型编码缺失，无法保存": "訂閱型別編碼缺失，無法儲存",
  "请至少选择一个订阅值": "請至少選擇一個訂閱值",
  "订阅已保存": "訂閱已儲存",
  "保存订阅失败，请重试": "儲存訂閱失敗，請重試",
  "无权限：仅 CTO 可新增订阅类型": "無許可權：僅 CTO 可新增訂閱型別",
  "无权限：仅创建人可编辑该类型": "無許可權：僅建立人可編輯該型別",
  "已新增订阅类型": "已新增訂閱型別",
  "已更新订阅类型": "已更新訂閱型別",
  "无权限：仅创建人可删除该类型": "無許可權：僅建立人可刪除該型別",
  "已删除订阅类型": "已刪除訂閱型別",
  "订阅类型": "訂閱型別",
  "已订阅": "已訂閱",
  "未保存": "未儲存",
  "保存订阅": "儲存訂閱",
  "确认全部订阅？": "確認全部訂閱？",
  "全部订阅": "全部訂閱",
  "确认全部取消订阅？": "確認全部取消訂閱？",
  "全部取消": "全部取消",
  "已刷新": "已重新整理",
  "正在删除": "正在刪除",
  "请输入模板id": "請輸入模板id",
  "请输入模板关键字": "請輸入模板關鍵字",
  "已选择:": "已選擇:",
  "确认绑定": "確認繫結",
  "请从下方表格中选择要绑定的SQL模板": "請從下方表格中選擇要繫結的SQL模板",
  "债务总数": "債務總數",
  "新增债务": "新增債務",
  "高优先级": "高優先順序",
  "降序 ↓": "降序 ↓",
  "升序 ↑": "升序 ↑",
  "事故详情": "事故詳情",
  "业务需求详情": "業務需求詳情",
  "仅指派人可以操作": "僅指派人可以操作",
  "新建成功": "新建成功",
  "编辑成功": "編輯成功",
  "表单校验或提交失败:": "表單校驗或提交失敗:",
  "新建技术债务": "新建技術債務",
  "编辑技术债务": "編輯技術債務",
  "请选择关联系统": "請選擇關聯絡統",
  "请选择债务类型": "請選擇債務型別",
  "绑定债务": "繫結債務",
  "未绑定任何债务": "未繫結任何債務",
  "重新选择": "重新選擇",
  "选择绑定": "選擇繫結",
  "请选择指派人": "請選擇指派人",
  "债务描述": "債務描述",
  "重开次数": "重開次數",
  "关联债务": "關聯債務",
  "暂无关联债务": "暫無關聯債務",
  "(双击开始编辑)": "(雙擊開始編輯)",
  "债务名称和链接已剪贴板": "債務名稱和連結已剪貼簿",
  "切换到系统 All 下才能筛选业务领域": "切換到系統 All 下才能篩選業務領域",
  "优先级分布": "優先順序分佈",
  "严重程度分布": "嚴重程度分佈",
  "月度债务趋势": "月度債務趨勢",
  "债务重开": "債務重開",
  "暂无文档内容": "暫無文件內容",
  "点击\"编辑文档\"开始创建": "點選\"編輯文件\"開始建立",
  "请联系管理员创建文档": "請聯絡管理員建立文件",
  "编辑文档": "編輯文件",
  "获取应用配额记录失败:": "獲取應用配額記錄失敗:",
  "获取应用配额记录失败": "獲取應用配額記錄失敗",
  "可调用模型": "可呼叫模型",
  "无": "無",
  "应用配额使用情况": "應用配額使用情況",
  "用户配额使用情况": "使用者配額使用情況",
  "创建密钥明细": "建立金鑰明細",
  "加载应用中...": "載入應用中...",
  "应用视图": "應用檢視",
  "选择您要使用的AI应用，点击卡片进入对应的应用页面": "選擇您要使用的AI應用，點選卡片進入對應的應用頁面",
  "暂无可用应用": "暫無可用應用",
  "审批申请已提交，请等待审批结果": "審批申請已提交，請等待審批結果",
  "审批申请提交失败": "審批申請提交失敗",
  "申请密钥": "申請金鑰",
  "重置密钥": "重置金鑰",
  "请填写申请原因": "請填寫申請原因",
  "请详细说明申请密钥的原因和用途": "請詳細說明申請金鑰的原因和用途",
  "• 申请后需要经过审批流程": "• 申請後需要經過審批流程",
  "• 审批通过后将自动生成API密钥": "• 審批透過後將自動生成API金鑰",
  "• 您可以在审批进度中查看申请状态": "• 您可以在審批進度中檢視申請狀態",
  "获取聊天记录失败": "獲取聊天記錄失敗",
  "已复制完整内容到剪贴板": "已複製完整內容到剪貼簿",
  "复制完整内容": "複製完整內容",
  "请求模型": "請求模型",
  "请求内容": "請求內容",
  "响应内容": "響應內容",
  "请求参数": "請求引數",
  "响应参数": "響應引數",
  "输入Token": "輸入Token",
  "输出Token": "輸出Token",
  "总Token": "總Token",
  "请求IP": "請求IP",
  "请求人": "請求人",
  "请求时间": "請求時間",
  "请求记录详情": "請求記錄詳情",
  "API Key已复制到剪贴板": "API Key已複製到剪貼簿",
  "您还没有": "您還沒有",
  "应用密钥": "應用金鑰",
  "申请一个": "申請一個",
  "应用密钥开始使用": "應用金鑰開始使用",
  "查看审批进度": "檢視審批進度",
  "隐藏密钥": "隱藏金鑰",
  "显示密钥": "顯示金鑰",
  "复制完整密钥": "複製完整金鑰",
  "Base Url已复制到剪贴板": "Base Url已複製到剪貼簿",
  "应用日配额": "應用日配額",
  "个人日配额": "個人日配額",
  "可用模型": "可用模型",
  "配额使用趋势": "配額使用趨勢",
  "在指定时间范围内的配额使用量趋势，点击图表可查看详情": "在指定時間範圍內的配額使用量趨勢，點選圖表可檢視詳情",
  "所选条件范围内暂无配额使用趋势数据": "所選條件範圍內暫無配額使用趨勢資料",
  "查看接入文档": "檢視接入文件",
  "接入文档": "接入文件",
  "刷新页面": "重新整理頁面",
  "应用配额": "應用配額",
  "使用趋势": "使用趨勢",
  "请求记录": "請求記錄",
  "配额日使用情况（已用/总量）": "配額日使用情況（已用/總量）",
  "暂无应用密钥统计数据": "暫無應用金鑰統計資料",
  "应用类型": "應用型別",
  "请选择应用类型": "請選擇應用型別",
  "加载应用类型中...": "載入應用型別中...",
  "请先确保有应用密钥统计数据": "請先確保有應用金鑰統計資料",
  "加载趋势数据中...": "載入趨勢資料中...",
  "密钥申请趋势": "金鑰申請趨勢",
  "所选时间范围内暂无应用密钥创建趋势数据": "所選時間範圍內暫無應用金鑰建立趨勢資料",
  "用户": "使用者",
  "请选择用户": "請選擇使用者",
  "加载数据中...": "載入資料中...",
  "应用密钥统计": "應用金鑰統計",
  "应用明细": "應用明細",
  "OpenApi业务日志": "OpenApi業務日誌",
  "Java服务日志(here-info)": "Java服務日誌(here-info)",
  "Java服务日志(error-logs)": "Java服務日誌(error-logs)",
  "请输入节点ID": "請輸入節點ID",
  "请输入客户端地址": "請輸入客戶端地址",
  "数据库订阅": "資料庫訂閱",
  "执行成功": "執行成功",
  "请先选择需要审批的工单": "請先選擇需要審批的工單",
  "只有待人工审核状态的工单可以审批": "只有待人工稽核狀態的工單可以審批",
  "未找到有效的工单ID，无法审批": "未找到有效的工單ID，無法審批",
  "请填写审批备注": "請填寫審批備註",
  "名称:": "名稱:",
  "请输入工单名称": "請輸入工單名稱",
  "状态:": "狀態:",
  "批量审批": "批次審批",
  "SQL详情": "SQL詳情",
  "审批备注": "審批備註",
  "终止流程": "終止流程",
  "审核通过": "稽核透過",
  "请输入审批备注": "請輸入審批備註",
  "了解更多": "瞭解更多",
  "欢迎使用 Ant Design Pro": "歡迎使用 Ant Design Pro",
  "Ant Design Pro 是一个整合了 umi，Ant Design 和 ProComponents 的脚手架方案。致力于在设计规范和基础组件的基础上，继续向上构建，提炼出典型模板/业务组件/配套设计资源，进一步提升企业级中后台产品设计研发过程中的『用户』和『设计者』的体验。": "Ant Design Pro 是一個整合了 umi，Ant Design 和 ProComponents 的腳手架方案。致力於在設計規範和基礎元件的基礎上，繼續向上構建，提煉出典型模板/業務元件/配套設計資源，進一步提升企業級中後臺產品設計研發過程中的『使用者』和『設計者』的體驗。",
  "了解 umi": "瞭解 umi",
  "了解 ant design": "瞭解 ant design",
  "了解 Pro Components": "瞭解 Pro Components",
  "创建业务需求": "建立業務需求",
  "创建任务": "建立任務",
  "创建评审": "建立評審",
  "创建回归缺陷": "建立迴歸缺陷",
  "创建线上问题": "建立線上問題",
  "按类型新建": "按型別新建",
  "转换操作失败:": "轉換操作失敗:",
  "研发任务明细": "研發任務明細",
  "差": "差",
  "较差": "較差",
  "一般": "一般",
  "良好": "良好",
  "优秀": "優秀",
  "较上周：": "較上週：",
  "视频无法播放，已在新窗口打开": "影片無法播放，已在新視窗開啟",
  "视频": "影片",
  "在新窗口播放": "在新視窗播放",
  "点击下载": "點選下載",
  "附件列表": "附件列表",
  "有问题请请点击此处,开权限等": "有問題請請點選此處,開許可權等",
  "全局搜索": "全域性搜尋",
  "点击设置计划联调日期": "點選設定計劃聯調日期",
  "点击设置计划上线日期": "點選設定計劃上線日期",
  "点击设置暂停日期": "點選設定暫停日期",
  "联调日期反馈": "聯調日期反饋",
  "填写后将会自动通知至需求业务方及产品经理！": "填寫後將會自動通知至需求業務方及產品經理！",
  "计划上线日期反馈": "計劃上線日期反饋",
  "预估人天（研发、测试总人天）": "預估人天（研發、測試總人天）",
  "变更原因": "變更原因",
  "暂停反馈": "暫停反饋",
  "计划暂停至": "計劃暫停至",
  "提测申请记录已暂存！": "提測申請記錄已暫存！",
  "标签设置成功": "標籤設定成功",
  "请输入标签中文名称": "請輸入標籤中文名稱",
  "请输入标签英文名称": "請輸入標籤英文名稱",
  "标签创建成功": "標籤建立成功",
  "暂无标签": "暫無標籤",
  "选择标签": "選擇標籤",
  "没有想要的？": "沒有想要的？",
  "手动添加": "手動新增",
  "暂无操作记录": "暫無操作記錄",
  "操作记录": "操作記錄",
  "产品验收通知": "產品驗收通知",
  "您有": "您有",
  "个需求待验收": "個需求待驗收",
  "关闭此通知后，您可以在通知中心查看": "關閉此通知後，您可以在通知中心檢視",
  "研发效能平台版本更新": "研發效能平臺版本更新",
  "发布版本号：": "釋出版本號：",
  "去查看": "去檢視",
  "每一起严重事故的背后，必然有": "每一起嚴重事故的背後，必然有",
  "29次轻微事故": "29次輕微事故",
  "300起未遂先兆": "300起未遂先兆",
  "以及": "以及",
  "1000起事故隐患": "1000起事故隱患",
  "📞 联系值班人员": "📞 聯絡值班人員",
  "很不满意": "很不滿意",
  "不满意": "不滿意",
  "满意": "滿意",
  "很满意": "很滿意",
  "添加备注失败:": "新增備註失敗:",
  "添加备注失败，请重试": "新增備註失敗，請重試",
  "查看当前工作项备注记录": "檢視當前工作項備註記錄",
  "隐藏当前工作项备注记录": "隱藏當前工作項備註記錄",
  "备注类型": "備註型別",
  "备注内容": "備註內容",
  "点击隐藏当前工作项备注记录": "點選隱藏當前工作項備註記錄",
  "点击查看当前工作项备注记录": "點選檢視當前工作項備註記錄",
  "将按当前筛选条件导出，最多支持 5000 条。": "將按當前篩選條件匯出，最多支援 5000 條。",
  "导出已勾选数据（": "匯出已勾選資料（",
  "条）": "條）",
  "导出当前筛选结果（": "匯出當前篩選結果（",
  "数据超过 5000 条，请缩小筛选范围后再导出。": "資料超過 5000 條，請縮小篩選範圍後再匯出。",
  "获取责任人详情失败:": "獲取責任人詳情失敗:",
  "获取责任人详情失败，将使用默认值": "獲取責任人詳情失敗，將使用預設值",
  "请至少选择一个责任人": "請至少選擇一個責任人",
  "更新责任人成功": "更新責任人成功",
  "更新责任人失败": "更新責任人失敗",
  "编辑责任人失败:": "編輯責任人失敗:",
  "编辑责任人失败": "編輯責任人失敗",
  "责任人员": "責任人員",
  "责任原因": "責任原因",
  "请输入责任原因": "請輸入責任原因",
  "调用 logout 接口失败:": "呼叫 logout 介面失敗:",
  "请选择或搜索系统": "請選擇或搜尋系統",
  "至少选择一个相关人": "至少選擇一個相關人",
  "图表初始化失败:": "圖表初始化失敗:",
  "手动添加事件监听器失败:": "手動新增事件監聽器失敗:",
  "已同意": "已同意",
  "未开放": "未開放",
  "审批撤销": "審批撤銷",
  "待审批": "待審批",
  "后付费": "後付費",
  "预付费": "預付費",
  "通用型": "通用型",
  "独享型": "獨享型",
  "「技术类」": "「技術類」",
  "不能为空": "不能為空",
  "实际工时不能超过120h": "實際工時不能超過120h",
  "将按全部启用的业务领域重建模板，业务岗位和值班组长都会清除固定人员并恢复自动轮转；需要固定的人员请在重置后重新选择。已生成的值班数据不会立即改变。": "將按全部啟用的業務領域重建模板，業務崗位和值班組長都會清除固定人員並恢復自動輪轉；需要固定的人員請在重置後重新選擇。已生成的值班資料不會立即改變。",
  "确认重排": "確認重排",
  "我创建的仪表盘": "我建立的儀表盤",
  "共享我的仪表盘": "共享我的儀表盤",
  "-需求交付时长": "-需求交付時長",
  "当前装饰": "當前裝飾",
  "自定义装饰": "自定義裝飾",
  "装饰": "裝飾",
  "研发bug数": "研發bug數",
  "生产bug数": "生產bug數",
  "发布总次数": "釋出總次數",
  "次": "次",
  "发布回滚次数": "釋出回滾次數",
  "研发需求设计缺陷数": "研發需求設計缺陷數",
  "产品评审驳回数": "產品評審駁回數",
  "代码规范提交数": "程式碼規範提交數",
  "研发bug重开数": "研發bug重開數",
  "生产bug重开数": "生產bug重開數",
  "紧急发布数": "緊急釋出數",
  "需求测试覆盖数": "需求測試覆蓋數",
  "缺陷数": "缺陷數",
  "万次": "萬次",
  "技术债务个数": "技術債務個數",
  "模版数量": "模版數量",
  "致命事故": "致命事故",
  "生产事故出现次数和严重程度：无P1级及以上生产事故，P2级及以下生产事故<=2": "生產事故出現次數和嚴重程度：無P1級及以上生產事故，P2級及以下生產事故<=2",
  "严重事故": "嚴重事故",
  "一般事故": "一般事故",
  "轻微事故": "輕微事故",
  "需求前置平均等待时间": "需求前置平均等待時間",
  "提出需求到产品介入需求等待时长平均值": "提出需求到產品介入需求等待時長平均值",
  "所有已介入需求到需求评审完成的累计时长平均值": "所有已介入需求到需求評審完成的累計時長平均值",
  "开始开发到转提测的累计时长平均值": "開始開發到轉提測的累計時長平均值",
  "需求转提测至产品验收通过的累计时长平均值": "需求轉提測至產品驗收透過的累計時長平均值",
  "需求开始验收到已发布的累计时长平均值": "需求開始驗收到已釋出的累計時長平均值",
  "卡片名称(中文)": "卡片名稱(中文)",
  "卡片名称(英文)": "卡片名稱(英文)",
  "只能上传jpg/png文件,且不大于10MB": "只能上傳jpg/png檔案,且不大於10MB",
  "填写评审纪要": "填寫評審紀要",
  "警告": "警告",
  "错误": "錯誤",
  "扫描中": "掃描中",
  "确定要删除任务「{name}」吗？": "確定要刪除任務「{name}」嗎？",
  "驳回项": "駁回項",
  "提交不规范项": "提交不規範項",
  "紧急发布项": "緊急釋出項",
  "发布失败项": "釋出失敗項",
  "回滚项": "回滾項",
  "我创建的需求池": "我建立的需求池",
  "共享我的需求池": "共享我的需求池",
  "后端任务": "後端任務",
  "前端任务": "前端任務",
  "测试任务": "測試任務",
  "UI任务": "UI任務",
  "产品任务": "產品任務",
  "运维任务": "運維任務",
  "其他类任务": "其他類任務",
  "其他任务": "其他任務",
  "已完成或未逾期": "已完成或未逾期",
  "进行中且已逾期": "進行中且已逾期",
  "未开始且已逾期": "未開始且已逾期",
  "配置【": "配置【",
  "】模板": "】模板",
  "拆分【": "拆分【",
  "】部门周报": "】部門週報",
  "本周新增": "本週新增",
  "本周完成": "本週完成",
  "模板": "模板",
  "分钟": "分鐘",
  "已撤销": "已撤銷",
  "重新申请": "重新申請",
  "支持大小写字母、数字、'.'和'-'、长度不超过64个字符": "支援大小寫字母、數字、'.'和'-'、長度不超過64個字元",
  "请输入有效的用户ID": "請輸入有效的使用者ID",
  "添加一行服务分支": "新增一行服務分支",
  "拉取": "拉取",
  "不拉取": "不拉取",
  "拉取载体分支": "拉取載體分支",
  "发布成功后发布单将变为【待回归】状态，需要测试回归需求": "釋出成功後釋出單將變為【待迴歸】狀態，需要測試迴歸需求",
  "确定【": "確定【",
  "】吗？": "】嗎？",
  "全局平均值": "全域性平均值",
  "平均工时": "平均工時",
  "{value} 小时": "{value} 小時",
  "基础柱状图-图形标签位置": "基礎柱狀圖-圖形標籤位置",
  "基础柱状图的图形标签位置可以指定为top-柱形上部，middle-柱形中心，bottom-柱形底部。": "基礎柱狀圖的圖形標籤位置可以指定為top-柱形上部，middle-柱形中心，bottom-柱形底部。",
  "时长": "時長",
  "{value} 天": "{value} 天",
  "{value} 个": "{value} 個",
  "平均响应耗时": "平均響應耗時",
  "平均解决耗时": "平均解決耗時",
  "平均关闭耗时": "平均關閉耗時",
  "平均修复总耗时": "平均修復總耗時",
  "全局平均修复耗时": "全域性平均修復耗時",
  "未关闭缺陷数量": "未關閉缺陷數量",
  "已关闭缺陷数量": "已關閉缺陷數量",
  "每天新增Bug数": "每天新增Bug數",
  "每天解决Bug数": "每天解決Bug數",
  "每天关闭Bug数": "每天關閉Bug數",
  "预计一个月内完成，进度良好": "預計一個月內完成，進度良好",
  "预计3个月内完成，需要关注进度": "預計3個月內完成，需要關注進度",
  "预计超过3个月完成，风险较高": "預計超過3個月完成，風險較高",
  "展示各项健康度指标的分布情况": "展示各項健康度指標的分佈情況",
  "工时（人天）": "工時（人天）",
  "占比": "佔比",
  "成本": "成本",
  "您确定要关闭吗？": "您確定要關閉嗎？",
  "添加邮箱": "新增郵箱",
  "数量（个）": "數量（個）",
  "事故总数": "事故總數",
  "bug总数": "bug總數",
  "关闭时效": "關閉時效",
  "bug数": "bug數",
  "效能度量总分": "效能度量總分",
  "各指标分数": "各指標分數",
  "{value} 分": "{value} 分",
  "总分": "總分",
  "产品": "產品",
  "{value} 次": "{value} 次",
  "每月平均发布次数": "每月平均釋出次數",
  "每月平均发布成功率": "每月平均釋出成功率",
  "成功率": "成功率",
  "耗时1周内": "耗時1周內",
  "耗时1-2周": "耗時1-2周",
  "耗时2-4周": "耗時2-4周",
  "耗时4周以上": "耗時4周以上",
  "延期交付数量": "延期交付數量",
  "平均延期交付时间": "平均延期交付時間",
  "天数": "天數",
  "累积次数（个）": "累積次數（個）",
  "累积耗时（天）": "累積耗時（天）",
  "全部反馈": "全部反饋",
  "我的反馈": "我的反饋",
  "手打标签": "手打標籤",
  "请输入搜索反馈名称": "請輸入搜尋反饋名稱",
  "确定要将此反馈转为业务需求吗？": "確定要將此反饋轉為業務需求嗎？",
  "执行完成": "執行完成",
  "待人工审核": "待人工稽核",
  "定时任务": "定時任務",
  "执行中": "執行中",
  "自动审核失败": "自動稽核失敗",
  "执行异常": "執行異常",
  "数据库变更详情": "資料庫變更詳情",
  "系统发布详情": "系統釋出詳情",
  "待审核": "待稽核",
  "数据库变更": "資料庫變更",
  "配置变更": "配置變更",
  "系统发布": "系統釋出",
  "故障/事件": "故障/事件",
  "权限变更": "許可權變更",
  "流量变更": "流量變更",
  "系统优化": "系統最佳化",
  "德国生产环境": "德國生產環境",
  "新加坡生产环境": "新加坡生產環境",
  "新加坡预发环境": "新加坡預發環境",
  "德国预发环境": "德國預發環境",
  "本地测试环境": "本地測試環境",
  "杭州测试环境": "杭州測試環境",
  "德国灰度环境": "德國灰度環境",
  "香港测试环境": "香港測試環境",
  "开发环境": "開發環境",
  "消息列表": "訊息列表",
  "验收报告": "驗收報告",
  "问卷": "問卷",
  "元": "元",
  "删除后无法恢复，请谨慎操作。": "刪除後無法恢復，請謹慎操作。",
  "移出后该工作项将不再属于当前项目，可从项目外重新关联。": "移出後該工作項將不再屬於當前專案，可從專案外重新關聯。",
  "当前为演示效果，后续会接入真实的需求 / 迭代 / 任务新增能力。": "當前為演示效果，後續會接入真實的需求 / 迭代 / 任務新增能力。",
  "项目里程碑明细": "專案里程碑明細",
  "是否需要关联遗漏需求与迭代？": "是否需要關聯遺漏需求與迭代？",
  "确定要删除该条风险吗？": "確定要刪除該條風險嗎？",
  "确认将该风险标记为已处理？": "確認將該風險標記為已處理？",
  "删除后项目数据将无法恢复": "刪除後專案資料將無法恢復",
  "张三": "張三",
  "李四": "李四",
  "王五": "王五",
  "赵六": "趙六",
  "孙七": "孫七",
  "周八": "周八",
  "吴九": "吳九",
  "郑十": "鄭十",
  "王潇武": "王瀟武",
  "常峻": "常峻",
  "古静杨": "古靜楊",
  "陈晓": "陳曉",
  "林薇": "林薇",
  "黄杨": "黃楊",
  "刘言": "劉言",
  "徐鑫": "徐鑫",
  "毛俊": "毛俊",
  "高玲": "高玲",
  "路通": "路通",
  "产品需求原型或需求文档是否准确，是否符合业务预期": "產品需求原型或需求文件是否準確，是否符合業務預期",
  "产品经理响应是否及时，是否及时解决问题": "產品經理響應是否及時，是否及時解決問題",
  "产品经理是否准确理解业务诉求，并能转化为合适的产品方案": "產品經理是否準確理解業務訴求，並能轉化為合適的產品方案",
  "与产品经理沟通过程是否顺畅，是否及时解决问题": "與產品經理溝透過程是否順暢，是否及時解決問題",
  "研发开发和交付效率是否满足业务预期": "研發開發和交付效率是否滿足業務預期",
  "产品功能交付质量是否满足业务预期": "產品功能交付質量是否滿足業務預期",
  "需求背景描述是否清晰": "需求背景描述是否清晰",
  "问题描述是否清晰": "問題描述是否清晰",
  "产品方案是否合理": "產品方案是否合理",
  "原型或者需求设计是否清晰": "原型或者需求設計是否清晰",
  "事故数量": "事故數量",
  "请选择有效日期": "請選擇有效日期",
  "事故明细": "事故明細",
  "责任人排名": "責任人排名",
  "COE 详情": "COE 詳情",
  "平均恢复时长(天)": "平均恢復時長(天)",
  "恢复时长(天)": "恢復時長(天)",
  "Todo 数量": "Todo 數量",
  "COE评论": "COE評論",
  "查看原文已修改评论": "檢視原文已修改評論",
  "删除回复": "刪除回覆",
  "综合根因内容": "綜合根因內容",
  "由表及里，导致故障现象的直接原因是什么？": "由表及裡，導致故障現象的直接原因是什麼？",
  "如：MQ推送了旧脏数据": "如：MQ推送了舊髒資料",
  "为什么会推送旧数据？": "為什麼會推送舊資料？",
  "如：未复用内存数据，查询了从库": "如：未複用記憶體資料，查詢了從庫",
  "为什么从库有旧数据？": "為什麼從庫有舊資料？",
  "如：主从同步延迟": "如：主從同步延遲",
  "为什么会读从库？": "為什麼會讀從庫？",
  "如：上传与推送拆分两个方法": "如：上傳與推送拆分兩個方法",
  "为什么拆分方法未合并？": "為什麼拆分方法未合併？",
  "如：过渡期双链路遗留": "如：過渡期雙鏈路遺留",
  "为什么没有自动告警？": "為什麼沒有自動告警？",
  "如：仅监控通道可用性": "如：僅監控通道可用性",
  "为什么缺数据一致性监控？": "為什麼缺資料一致性監控？",
  "如：未列入监控需求": "如：未列入監控需求",
  "为什么没有自动熔断？": "為什麼沒有自動熔斷？",
  "如：消息均发送成功，无异常触发": "如：訊息均傳送成功，無異常觸發",
  "为什么定位困难？": "為什麼定位困難？",
  "如：日志无异常、无数据对比": "如：日誌無異常、無資料對比",
  "是否恢复上次未成功保存的内容？选择放弃将清除这份本机缓存。": "是否恢復上次未成功儲存的內容？選擇放棄將清除這份本機快取。",
  "COE新建表单章节": "COE新建表單章節",
  "COE复盘章节": "COE覆盤章節",
  "只看延期": "只看延期",
  "系统出现崩溃情况，现象：影响范围：": "系統出現崩潰情況，現象：影響範圍：",
  "数据导出失败，错误信息：影响业务：": "資料匯出失敗，錯誤資訊：影響業務：",
  "发现数据异常，问题描述：错误数据示例：": "發現資料異常，問題描述：錯誤資料示例：",
  "运营流程受阻，受阻环节：影响程度：": "運營流程受阻，受阻環節：影響程度：",
  "当前输入框已有内容，确定要用模板覆盖吗？": "當前輸入框已有內容，確定要用模板覆蓋嗎？",
  "当前输入框已有内容，确定要清空吗？": "當前輸入框已有內容，確定要清空嗎？",
  "响应时间": "響應時間",
  "处理时间": "處理時間",
  "bug类型": "bug型別",
  "bug页面URL数": "bug頁面URL數",
  "请勿重复点击": "請勿重複點選",
  "飞书": "飛書",
  "反馈者": "反饋者",
  "抄送": "抄送",
  "时间不能小于今天": "時間不能小於今天",
  "再建一行": "再建一行",
  "期待日期": "期待日期",
  "请选择期待完成时间": "請選擇期待完成時間",
  "用例等级": "用例等級",
  "主负责人": "主負責人",
  "过程": "過程",
  "判断": "判斷",
  "观点一": "觀點一",
  "观点二": "觀點二",
  "观点三": "觀點三",
  "观点四": "觀點四",
  "需求ID": "需求ID",
  "需求是否符合业务预期，是否符合产品规划": "需求是否符合業務預期，是否符合產品規劃",
  "功能是否完备，是否满足业务预期": "功能是否完備，是否滿足業務預期",
  "功能是否流畅，是否满足业务预期": "功能是否流暢，是否滿足業務預期",
  "设计是否符合业务预期，是否符合产品规划": "設計是否符合業務預期，是否符合產品規劃",
  "时间不能小于当前时间": "時間不能小於當前時間",
  "分享链接": "分享連結",
  "一键创建": "一鍵建立",
  "添加一行": "新增一行",
  "不能超过3天": "不能超過3天",
  "内容不能超过15000个字符": "內容不能超過15000個字元",
  "需要培训师": "需要培訓師",
  "评审参与人": "評審參與人",
  "请确认要申请发布吗？": "請確認要申請釋出嗎？",
  "数据加载失败": "資料載入失敗",
  "请选择预计上线日期": "請選擇預計上線日期",
  "评审名称": "評審名稱",
  "评审类型": "評審型別",
  "评审需求": "評審需求",
  "评审Sprint": "評審Sprint",
  "评审测试用例": "評審測試用例",
  "不预约": "不預約",
  "评审描述": "評審描述",
  "12人以下": "12人以下",
  "13~20人": "13~20人",
  "20人以上": "20人以上",
  "电视": "電視",
  "投影": "投影",
  "白板": "白板",
  "（点击催读）": "（點選催讀）",
  "研发工时": "研發工時",
  "期望": "期望",
  "迭代例会": "迭代例會",
  "{b} : {c} 人天 ({d}%)": "{b} : {c} 人天 ({d}%)",
  "{b}: {c} 人天": "{b}: {c} 人天",
  "工作项总数": "工作項總數",
  "工作项完成数": "工作項完成數",
  "工作项未完成数": "工作項未完成數",
  "关联产品数": "關聯產品數",
  "上传失败！": "上傳失敗！",
  "预估时间范围": "預估時間範圍",
  "删除Sprint": "刪除Sprint",
  "（选择服务分支必须选择需求）": "（選擇服務分支必須選擇需求）",
  "时间不能为空": "時間不能為空",
  "预估人天不能小于0": "預估人天不能小於0",
  "预估人天不能超过3天，请拆解": "預估人天不能超過3天，請拆解",
  "数字越小越靠前；排序号相同时，最新创建的工作流靠前": "數字越小越靠前；排序號相同時，最新建立的工作流靠前",
  "不可编辑（": "不可編輯（",
  "移除流转": "移除流轉",
  "添加流转": "新增流轉",
  "新增流转规则（": "新增流轉規則（",
  "编辑流转规则（": "編輯流轉規則（",
  "移除流转规则（": "移除流轉規則（",
  "系统会自动获取": "系統會自動獲取",
  "，并与下方固定人员合并": "，並與下方固定人員合併",
  "一人同意": "一人同意",
  "关闭后，该业务领域下的所有系统也会全部关闭，是否继续？": "關閉後，該業務領域下的所有系統也會全部關閉，是否繼續？",
  "业务领域名称(中)": "業務領域名稱(中)",
  "业务领域名称(英)": "業務領域名稱(英)",
  "创建系统": "建立系統",
  "编辑系统": "編輯系統",
  "系统唯一Key（全大写字母，中划线拼接）": "系統唯一Key（全大寫字母，中劃線拼接）",
  "删除标签": "刪除標籤",
  "正在导出数据...": "正在匯出資料...",
  "导出失败，请稍后重试": "匯出失敗，請稍後重試",
  "只能上传jpg/png文件,且单个文件不超过10MB": "只能上傳jpg/png檔案,且單個檔案不超過10MB",
  "是否克隆服务基础信息": "是否克隆服務基礎資訊",
  "是否删除服务基础信息": "是否刪除服務基礎資訊",
  "停用": "停用",
  "添加更新明细": "新增更新明細",
  "规则名称": "規則名稱",
  "规则描述": "規則描述",
  "请输入至少五个字符": "請輸入至少五個字元",
  "配置规则属性": "配置規則屬性",
  "监控对象": "監控物件",
  "规则模板": "規則模板",
  "规则类型": "規則型別",
  "设定调度周期": "設定排程週期",
  "周": "周",
  "万": "萬",
  "债务数量": "債務數量",
  "您有未保存的更改，确定要关闭吗？": "您有未儲存的更改，確定要關閉嗎？",
  "技术债务明细": "技術債務明細",
  "显示选定应用类型在指定时间范围内的密钥创建数量趋势": "顯示選定應用型別在指定時間範圍內的金鑰建立數量趨勢",
  "umi 是一个可扩展的企业级前端应用框架,umi 以路由为基础的，同时支持配置式路由和约定式路由，保证路由的功能完备，并以此进行功能扩展。": "umi 是一個可擴充套件的企業級前端應用框架,umi 以路由為基礎的，同時支援配置式路由和約定式路由，保證路由的功能完備，並以此進行功能擴充套件。",
  "antd 是基于 Ant Design 设计体系的 React UI 组件库，主要用于研发企业级中后台产品。": "antd 是基於 Ant Design 設計體系的 React UI 元件庫，主要用於研發企業級中後臺產品。",
  "ProComponents 是一个基于 Ant Design 做了更高抽象的模板组件，以 一个组件就是一个页面为开发理念，为中后台开发带来更好的体验。": "ProComponents 是一個基於 Ant Design 做了更高抽象的模板元件，以 一個元件就是一個頁面為開發理念，為中後臺開發帶來更好的體驗。",
  "加载失败": "載入失敗",
  "点击预览": "點選預覽",
  "{value0}核/{value1}GB": "{value0}核/{value1}GB",
  "{value0} 小时": "{value0} 小時",
  "{value0} 分钟": "{value0} 分鐘",
  "{value0} 秒": "{value0} 秒",
  "第{value0}-{value1} 条共 {value2} 条": "第{value0}-{value1} 條共 {value2} 條",
  "{value0}任务甘特图": "{value0}任務甘特圖",
  "确定要删除 {value0} 目录吗？": "確定要刪除 {value0} 目錄嗎？",
  "确定要删除 {value0} 吗？": "確定要刪除 {value0} 嗎？",
  "第{value0}-{value1}条/总共 {value2} 条": "第{value0}-{value1}條/總共 {value2} 條",
  "共 {value0} 条": "共 {value0} 條",
  "重新排班成功，共更新 {value0} 条排班记录": "重新排班成功，共更新 {value0} 條排班記錄",
  "补齐今日到截止日期（{value0} ~ {value1}）缺失的排班，已有排班不会覆盖": "補齊今日到截止日期（{value0} ~ {value1}）缺失的排班，已有排班不會覆蓋",
  "已自动填充 {value0} 个空缺岗位": "已自動填充 {value0} 個空缺崗位",
  "{value0} 值班表": "{value0} 值班表",
  "4周内交付率：{value0}": "4周內交付率：{value0}",
  "年度交付周数（{value0}）": "年度交付週數（{value0}）",
  "4周内：{value0}": "4周內：{value0}",
  "赠送卡片{value0}": "贈送卡片{value0}",
  "{value0} 送你了 {value1}": "{value0} 送你了 {value1}",
  "{value0} 天": "{value0} 天",
  "<div style=\"padding: 8px; background: #fff; border-radius: 4px; \">\n              <div style=\"font-weight: bold; margin-bottom: 4px;\">{value0}</div>\n              <div>{value1}: {value2} 天</div>\n            </div>": "<div style=\"padding: 8px; background: #fff; border-radius: 4px; \">\n              <div style=\"font-weight: bold; margin-bottom: 4px;\">{value0}</div>\n              <div>{value1}: {value2} 天</div>\n            </div>",
  "{value0}年-{value1}": "{value0}年-{value1}",
  "\n            <div style=\"margin-bottom:8px;font-weight:bold\">\n              {value0} ({value1}年)\n            </div>\n            <div style=\"display:flex;align-items:center\">\n              <span style=\"\n                display:inline-block;\n                width:10px;\n                height:10px;\n                background:{value2};\n                margin-right:5px;\n                border-radius:2px\n              \"></span>\n              {value3}: {value4} {value5}\n              <span style=\"color:#666;margin-left:8px\">\n                ({value6}%)\n              </span>\n            </div>\n          ": "\n            <div style=\"margin-bottom:8px;font-weight:bold\">\n              {value0} ({value1}年)\n            </div>\n            <div style=\"display:flex;align-items:center\">\n              <span style=\"\n                display:inline-block;\n                width:10px;\n                height:10px;\n                background:{value2};\n                margin-right:5px;\n                border-radius:2px\n              \"></span>\n              {value3}: {value4} {value5}\n              <span style=\"color:#666;margin-left:8px\">\n                ({value6}%)\n              </span>\n            </div>\n          ",
  "\n                <div style=\"font-weight:bold\">{value0} - {value1}</div>\n                <div style=\"display:flex;align-items:center;margin:3px 0\">\n                  <span style=\"display:inline-block;width:10px;height:10px;background:{value2};margin-right:5px;\"></span>\n                  <strong>{value3}</strong>: {value4} {value5} ({value6}%)\n                </div>\n                <div style=\"margin-top:5px;font-weight:bold\">\n                  总计: {value7} {value8}\n                </div>\n              ": "\n                <div style=\"font-weight:bold\">{value0} - {value1}</div>\n                <div style=\"display:flex;align-items:center;margin:3px 0\">\n                  <span style=\"display:inline-block;width:10px;height:10px;background:{value2};margin-right:5px;\"></span>\n                  <strong>{value3}</strong>: {value4} {value5} ({value6}%)\n                </div>\n                <div style=\"margin-top:5px;font-weight:bold\">\n                  總計: {value7} {value8}\n                </div>\n              ",
  "模板{value0}": "模板{value0}",
  "最新{value0}: {value1}{value2}": "最新{value0}: {value1}{value2}",
  "累计{value0}: {value1}{value2}": "累計{value0}: {value1}{value2}",
  "{value0} 万次": "{value0} 萬次",
  "{value0} 次": "{value0} 次",
  "{value0}年": "{value0}年",
  "{value0}指标": "{value0}指標",
  "{value0} 月": "{value0} 月",
  "{value0} 文件上传失败": "{value0} 檔案上傳失敗",
  "仅查看{value0}": "僅檢視{value0}",
  "请选择{value0}": "請選擇{value0}",
  " • 搜索到 {value0} 个结果": " • 搜尋到 {value0} 個結果",
  "点击查看{value0}任务详情": "點選檢視{value0}任務詳情",
  "正在渲染... ({value0}/{value1})": "正在渲染... ({value0}/{value1})",
  "配置项目周报模板{value0}": "配置專案週報模板{value0}",
  "共{value0}条 ": "共{value0}條 ",
  "{value0}预约详情": "{value0}預約詳情",
  "已提交回滚到版本 {value0}": "已提交回滾到版本 {value0}",
  "确认回滚到版本 {value0}？": "確認回滾到版本 {value0}？",
  "申请回滚到版本 {value0}": "申請回滾到版本 {value0}",
  "申请调试 (Pod: {value0} 容器: {value1})": "申請除錯 (Pod: {value0} 容器: {value1})",
  "容器信息 ({value0})": "容器資訊 ({value0})",
  "{value0}重启请求已提交": "{value0}重啟請求已提交",
  "是否重启该{value0}": "是否重啟該{value0}",
  "确认要重启该{value0}吗？": "確認要重啟該{value0}嗎？",
  "{value0}重启申请已提交": "{value0}重啟申請已提交",
  "重启{value0}": "重啟{value0}",
  "申请重启{value0}": "申請重啟{value0}",
  "副本数已修改为 {value0}": "副本數已修改為 {value0}",
  "执行{value0}": "執行{value0}",
  "申请{value0}": "申請{value0}",
  "确定要删除泳道组 \"{value0}\" 吗？此操作不可恢复。": "確定要刪除泳道組 \"{value0}\" 嗎？此操作不可恢復。",
  "流量比例不能超过 {value0}%": "流量比例不能超過 {value0}%",
  "流量比例必须在0-{value0}%之间": "流量比例必須在0-{value0}%之間",
  "确定要删除泳道 \"{value0}\" 吗？此操作不可恢复。": "確定要刪除泳道 \"{value0}\" 嗎？此操作不可恢復。",
  "[{value0}] 前缀匹配 [{value1}]": "[{value0}] 字首匹配 [{value1}]",
  "[{value0}] 正则匹配 [{value1}]": "[{value0}] 正則匹配 [{value1}]",
  "[{value0}] 百分比 [{value1}]": "[{value0}] 百分比 [{value1}]",
  "第 {value0}-{value1} 条/总共 {value2} 条": "第 {value0}-{value1} 條/總共 {value2} 條",
  "{value0} 灰度配置": "{value0} 灰度配置",
  "最多还能添加 {value0} 个用户ID，当前待添加{value1}个": "最多還能新增 {value0} 個使用者ID，當前待新增{value1}個",
  "成功添加 {value0} 个用户ID": "成功新增 {value0} 個使用者ID",
  "{value0}秒": "{value0}秒",
  "共 {value0} 条记录": "共 {value0} 條記錄",
  "服务发布流水线（{value0}）": "服務釋出流水線（{value0}）",
  "复制{value0}": "複製{value0}",
  "查看问题 \n              {value0}": "檢視問題 \n              {value0}",
  "{value0}万": "{value0}萬",
  "{value0}年{value1}月{value2}日": "{value0}年{value1}月{value2}日",
  "{value0} - {value1}详情": "{value0} - {value1}詳情",
  "未来第{value0}周": "未來第{value0}周",
  "查看更多 (+{value0})": "檢視更多 (+{value0})",
  "{value0} 人天": "{value0} 人天",
  "{value0}人天": "{value0}人天",
  "{value0}<br/>\n                  实际工时: {value1} 人天<br/>\n                  占比（实际工时/总工时）: {value2}%": "{value0}<br/>\n                  實際工時: {value1} 人天<br/>\n                  佔比（實際工時/總工時）: {value2}%",
  "部分指标已存在，已跳过：{value0}": "部分指標已存在，已跳過：{value0}",
  "成功添加 {value0} 个指标": "成功新增 {value0} 個指標",
  "{value0}全年平均分": "{value0}全年平均分",
  "{value0}下半年平均分": "{value0}下半年平均分",
  "{value0}上半年平均分": "{value0}上半年平均分",
  "{value0}年12月平均分": "{value0}年12月平均分",
  "{value0}年{value1}月平均分": "{value0}年{value1}月平均分",
  "{value0}月": "{value0}月",
  "{value0}月指标对比（加权得分）": "{value0}月指標對比（加權得分）",
  "\n            <div>超期未完成</div>\n            <div>{value0}: {value1}个</div>\n          ": "\n            <div>超期未完成</div>\n            <div>{value0}: {value1}個</div>\n          ",
  "\n            <div style=\"font-weight:bold\">{value0}</div>\n            <div style=\"display:flex;align-items:center;margin:5px 0\">\n              <span style=\"\n                display:inline-block;\n                width:10px;\n                height:10px;\n                background:{value1};\n                margin-right:5px;\n                border-radius:2px\n              \"></span>\n              {value2}: {value3} 个\n              <span style=\"color:#666;margin-left:8px\">\n                ({value4}%)\n              </span>\n            </div>\n          ": "\n            <div style=\"font-weight:bold\">{value0}</div>\n            <div style=\"display:flex;align-items:center;margin:5px 0\">\n              <span style=\"\n                display:inline-block;\n                width:10px;\n                height:10px;\n                background:{value1};\n                margin-right:5px;\n                border-radius:2px\n              \"></span>\n              {value2}: {value3} 個\n              <span style=\"color:#666;margin-left:8px\">\n                ({value4}%)\n              </span>\n            </div>\n          ",
  "{value0}(天)": "{value0}(天)",
  "操作失败: {value0}": "操作失敗: {value0}",
  "总分: {value0}": "總分: {value0}",
  "统计区间：{value0}    数据量：{value1} 条": "統計區間：{value0}    資料量：{value1} 條",
  "{value0} - {value1}指标明细": "{value0} - {value1}指標明細",
  "统计区间：{value0}    成员数：{value1} 人": "統計區間：{value0}    成員數：{value1} 人",
  "{value0}-{value1}指标明细-{value2}.xls": "{value0}-{value1}指標明細-{value2}.xls",
  "{value0}-全角色指标明细-{value1}.xls": "{value0}-全形色指標明細-{value1}.xls",
  "暂未配置{value0}成员": "暫未配置{value0}成員",
  "当前筛选未命中{value0}指标": "當前篩選未命中{value0}指標",
  "展开剩余 {value0} 人": "展開剩餘 {value0} 人",
  "展示团队指标当前值，并提供往年同比（%）对照（{value0} ~ {value1}）": "展示團隊指標當前值，並提供往年同比（%）對照（{value0} ~ {value1}）",
  "按角色展示成员指标明细表格，不同角色展示各自独立指标（{value0} ~ {value1}）": "按角色展示成員指標明細表格，不同角色展示各自獨立指標（{value0} ~ {value1}）",
  "选择{value0}成员": "選擇{value0}成員",
  "已选择 {value0} 人，可在下方微调": "已選擇 {value0} 人，可在下方微調",
  "工专路 {value0} 号店": "工專路 {value0} 號店",
  "正向反馈: {value0}个 ({value1}%)": "正向反饋: {value0}個 ({value1}%)",
  "中性反馈: {value0}个 ({value1}%)": "中性反饋: {value0}個 ({value1}%)",
  "负面反馈: {value0}个 ({value1}%)": "負面反饋: {value0}個 ({value1}%)",
  "平均时效: {value0}": "平均時效: {value0}",
  "待处理 {value0} 个反馈": "待處理 {value0} 個反饋",
  "第 {value0}-{value1} 条/共 {value2} 条": "第 {value0}-{value1} 條/共 {value2} 條",
  "{value0} - 反馈详情": "{value0} - 反饋詳情",
  "{value0} - {value1}反馈详情": "{value0} - {value1}反饋詳情",
  "点赞排行 - {value0}": "點贊排行 - {value0}",
  "{value0}情绪反馈详情": "{value0}情緒反饋詳情",
  "编辑{value0}": "編輯{value0}",
  "新增{value0}": "新增{value0}",
  "成功添加 {value0} 个属性": "成功新增 {value0} 個屬性",
  "确定要删除 \"{value0}\" 吗？": "確定要刪除 \"{value0}\" 嗎？",
  "确定要删除 \"{value0}\" 及其所有子节点吗？": "確定要刪除 \"{value0}\" 及其所有子節點嗎？",
  "编辑配置 - {value0} × {value1}": "編輯配置 - {value0} × {value1}",
  "正在复制 {value0} × {value1} 的配置...": "正在複製 {value0} × {value1} 的配置...",
  "拖拽复制: {value0} × {value1}": "拖拽複製: {value0} × {value1}",
  "成功添加 {value0} 个敏感词": "成功新增 {value0} 個敏感詞",
  "确定要变更为\"{value0}\"状态吗？": "確定要變更為\"{value0}\"狀態嗎？",
  "变更{value0}": "變更{value0}",
  "当前{value0}": "當前{value0}",
  "选择{value0}": "選擇{value0}",
  "{value0}变更成功": "{value0}變更成功",
  "{value0}变更失败": "{value0}變更失敗",
  "反馈原文：{value0}\n反馈翻译：{value1}\n详情链接：{value2}": "反饋原文：{value0}\n反饋翻譯：{value1}\n詳情連結：{value2}",
  "{value0} 至 {value1}": "{value0} 至 {value1}",
  "草稿 · {value0}": "草稿 · {value0}",
  "所属空间: {value0}": "所屬空間: {value0}",
  "业务领域: {value0}": "業務領域: {value0}",
  "类型: {value0}": "型別: {value0}",
  "规模: {value0}": "規模: {value0}",
  "风险: {value0}": "風險: {value0}",
  "替换 - {value0}": "替換 - {value0}",
  "添加 - {value0}": "新增 - {value0}",
  "请选择要关联的{value0}": "請選擇要關聯的{value0}",
  "确定要删除里程碑「{value0}」吗？": "確定要刪除里程碑「{value0}」嗎？",
  "第{value0}条：{value1}未填": "第{value0}條：{value1}未填",
  "{value0} 万": "{value0} 萬",
  "预期ROI：{value0}%": "預期ROI：{value0}%",
  "已选择 {value0} 星": "已選擇 {value0} 星",
  "项目数: {value0}": "專案數: {value0}",
  "成员数: {value0}": "成員數: {value0}",
  "\n              <div style=\"font-weight:bold\">{value0}</div>\n              <div>{value1}: {value2} 天</div>\n            ": "\n              <div style=\"font-weight:bold\">{value0}</div>\n              <div>{value1}: {value2} 天</div>\n            ",
  "\n              <div style=\"margin-bottom:8px;font-weight:bold\">\n                {value0} ({value1}年)\n              </div>\n              <div style=\"display:flex;align-items:center\">\n                <span style=\"\n                  display:inline-block;\n                  width:10px;\n                  height:10px;\n                  background:{value2};\n                  margin-right:5px;\n                  border-radius:2px\n                \"></span>\n                {value3}: {value4} \n                <span style=\"color:#666;margin-left:8px\">\n                  ({value5}%)\n                </span>\n              </div>\n            ": "\n              <div style=\"margin-bottom:8px;font-weight:bold\">\n                {value0} ({value1}年)\n              </div>\n              <div style=\"display:flex;align-items:center\">\n                <span style=\"\n                  display:inline-block;\n                  width:10px;\n                  height:10px;\n                  background:{value2};\n                  margin-right:5px;\n                  border-radius:2px\n                \"></span>\n                {value3}: {value4} \n                <span style=\"color:#666;margin-left:8px\">\n                  ({value5}%)\n                </span>\n              </div>\n            ",
  "{value0}-事故报告": "{value0}-事故報告",
  "{value0}({value1}项)": "{value0}({value1}項)",
  "添加备注失败: {value0}": "新增備註失敗: {value0}",
  "删除备注失败: {value0}": "刪除備註失敗: {value0}",
  "请对{value0}进行评分": "請對{value0}進行評分",
  "{value0} 小时 {value1} 分钟": "{value0} 小時 {value1} 分鐘",
  "{value0} COE 看板": "{value0} COE 看板",
  " · {value0} 行": " · {value0} 行",
  "移除图片 {value0}": "移除圖片 {value0}",
  "展开 {value0} 条评论": "展開 {value0} 條評論",
  "查看 {value0} 条原文已修改评论": "檢視 {value0} 條原文已修改評論",
  "原文已修改评论 ({value0})": "原文已修改評論 ({value0})",
  "时间线第 {value0} 行": "時間線第 {value0} 行",
  "节点 {value0}": "節點 {value0}",
  "Todo 第 {value0} 行{value1}": "Todo 第 {value0} 行{value1}",
  "当前为 {value0} 分钟，按发生时间和恢复时间计算为 {value1} 分钟。": "當前為 {value0} 分鐘，按發生時間和恢復時間計算為 {value1} 分鐘。",
  "删除 {value0}？": "刪除 {value0}？",
  "有 {value0} 条改进措施关联了该 Why，确认后将同时清空这些关联。": "有 {value0} 條改進措施關聯了該 Why，確認後將同時清空這些關聯。",
  "已自动暂存 {value0}": "已自動暫存 {value0}",
  "提交数据缺少：{value0}，已定位到第一处": "提交資料缺少：{value0}，已定位到第一處",
  "{value0}成功，保存期间还有新的修改，已保留在当前页面和本机备份中": "{value0}成功，儲存期間還有新的修改，已保留在當前頁面和本機備份中",
  "请完善必填项：{value0}，已为你定位": "請完善必填項：{value0}，已為你定位",
  "还有 {value0} 处必填或格式校验未通过，已定位到第一处：{value1}": "還有 {value0} 處必填或格式校驗未透過，已定位到第一處：{value1}",
  "已延期 {value0} 天": "已延期 {value0} 天",
  "{value0}分钟": "{value0}分鐘",
  "{value0}小时": "{value0}小時",
  "{value0}小时{value1}分钟": "{value0}小時{value1}分鐘",
  "COE复盘名称：{value0}\n详情链接：{value1}": "COE覆盤名稱：{value0}\n詳情連結：{value1}",
  "{value0}_告警记录": "{value0}_告警記錄",
  "{value0}，拉群成功": "{value0}，拉群成功",
  "{value0}，拉群人数不足": "{value0}，拉群人數不足",
  "{value0}等": "{value0}等",
  "{value0} 不是一个视频文件": "{value0} 不是一個影片檔案",
  "业务需求{value0}": "業務需求{value0}",
  "{value0}_验收报告": "{value0}_驗收報告",
  "「{value0} 」已绑定Sprint，请解绑后后绑定新的Sprint": "「{value0} 」已繫結Sprint，請解綁後後繫結新的Sprint",
  "{value0} - {value1} (负责人: {value2})": "{value0} - {value1} (負責人: {value2})",
  "请输入{value0}相关内容": "請輸入{value0}相關內容",
  "你有未保存的更改，确定要{value0}吗？": "你有未儲存的更改，確定要{value0}嗎？",
  "{value0}关联Bug记录": "{value0}關聯Bug記錄",
  "已加载 {value0} 条数据": "已載入 {value0} 條資料",
  "已加载 {value0}/{value1} 条数据": "已載入 {value0}/{value1} 條資料",
  "已加载全部 {value0} 条数据": "已載入全部 {value0} 條資料",
  "（{value0}结束）": "（{value0}結束）",
  "已选择{value0}个会议室：{value1}": "已選擇{value0}個會議室：{value1}",
  "  \n            日期: {value0}<br/>  \n            存量: {value1}<br/>  \n            操作: {value2}<br/>  \n            期望: {value3}  \n          ": "  \n            日期: {value0}<br/>  \n            存量: {value1}<br/>  \n            操作: {value2}<br/>  \n            期望: {value3}  \n          ",
  "  \n            日期: {value0}<br/>  \n            期望: {value1}  \n          ": "  \n            日期: {value0}<br/>  \n            期望: {value1}  \n          ",
  " 共{value0}人": " 共{value0}人",
  "选择需求（{value0}）的目标状态": "選擇需求（{value0}）的目標狀態",
  "已经超期{value0}天": "已經超期{value0}天",
  "还有{value0}天到期": "還有{value0}天到期",
  "规划工时 {value0} 天": "規劃工時 {value0} 天",
  "审批节点{value0}": "審批節點{value0}",
  "{value0} 时": "{value0} 時",
  "赠送记录_{value0}.csv": "贈送記錄_{value0}.csv",
  "分发卡片-{value0}": "分發卡片-{value0}",
  "前{value0}": "前{value0}",
  "卡片配置-{value0}": "卡片配置-{value0}",
  "{value0} 年": "{value0} 年",
  "编辑版本 - {value0}{value1}": "編輯版本 - {value0}{value1}",
  "更新明细 {value0}": "更新明細 {value0}",
  "编辑{value0}的模版": "編輯{value0}的模版",
  "查看{value0}的模版": "檢視{value0}的模版",
  "\n              <div style=\"font-weight:bold\">{value0}</div>\n              <div style=\"display:flex;align-items:center;margin:3px 0\">\n                <span style=\"display:inline-block;width:10px;height:10px;background:{value1};margin-right:5px;\"></span>\n                <strong>{value2}</strong>: {value3} 个 ({value4}%)\n              </div>\n              {value5}\n            ": "\n              <div style=\"font-weight:bold\">{value0}</div>\n              <div style=\"display:flex;align-items:center;margin:3px 0\">\n                <span style=\"display:inline-block;width:10px;height:10px;background:{value1};margin-right:5px;\"></span>\n                <strong>{value2}</strong>: {value3} 個 ({value4}%)\n              </div>\n              {value5}\n            ",
  "\n              <div style=\"margin-top:5px;font-weight:bold\">\n                总计: {value0} 个\n              </div>\n              ": "\n              <div style=\"margin-top:5px;font-weight:bold\">\n                總計: {value0} 個\n              </div>\n              ",
  "\n            <div style=\"font-weight:bold\">{value0} - {value1}</div>\n            <div>数量: {value2} 个</div>\n          ": "\n            <div style=\"font-weight:bold\">{value0} - {value1}</div>\n            <div>數量: {value2} 個</div>\n          ",
  "{value0}天": "{value0}天",
  "模型名称 {value0} 已复制到剪贴板": "模型名稱 {value0} 已複製到剪貼簿",
  "显示选定应用类型{value0}在指定时间范围内的配额使用量趋势，点击图表可查看详情": "顯示選定應用型別{value0}在指定時間範圍內的配額使用量趨勢，點選圖表可檢視詳情",
  "操作人：{value0}": "操作人：{value0}",
  "已催办当前审批节点未审批人：": "已催辦當前審批節點未審批人：",
  "催办失败": "催辦失敗",
  "同意中...": "同意中...",
  "待我审批": "待我審批",
  "我发起且审批中": "我發起且審批中",
  "我发起且今日通过": "我發起且今日透過",
  "我发起且今日驳回": "我發起且今日駁回",
  "我发起且今日撤销": "我發起且今日撤銷",
  "未知岗位": "未知崗位",
  "自动轮转（业务领域负责人）": "自動輪轉（業務領域負責人）",
  "自动轮转": "自動輪轉",
  "获取可赠送人员失败": "獲取可贈送人員失敗",
  "图片上传失败，请稍后重试": "圖片上傳失敗，請稍後重試",
  "赠送失败，请稍后重试": "贈送失敗，請稍後重試",
  "请点击选择会议室": "請點選選擇會議室",
  "我是研发": "我是研發",
  "获取标签人员失败": "獲取標籤人員失敗",
  "未命名需求": "未命名需求",
  "周报标题预览效果：": "週報標題預覽效果：",
  "DevOps可直接执行，每次回滚都会记录操作日志。": "DevOps可直接執行，每次回滾都會記錄操作日誌。",
  "该审批在通过后24小时内可重复用于此版本，每次执行都会记录操作日志。": "該審批在透過後24小時內可重複用於此版本，每次執行都會記錄操作日誌。",
  "回滚申请已提交，审批通过后请再次点击该版本执行回滚": "回滾申請已提交，審批透過後請再次點選該版本執行回滾",
  "调试申请已提交": "除錯申請已提交",
  "调试": "除錯",
  "副本数变更申请已提交": "副本數變更申請已提交",
  "开始调试": "開始除錯",
  "禁用成功": "禁用成功",
  "启用成功": "啟用成功",
  "暂无匹配的泳道": "暫無匹配的泳道",
  "暂无泳道数据": "暫無泳道資料",
  "是否申请新加坡生产环境发布?": "是否申請新加坡生產環境釋出?",
  "是否创建非生产环境发布?": "是否建立非生產環境釋出?",
  "确定后会创建新加坡生产环境发布申请，发布需走审批流程，并会自动创建一个发布单（请先确保新加披uat已验证通过）": "確定後會建立新加坡生產環境釋出申請，釋出需走審批流程，並會自動建立一個釋出單（請先確保新加披uat已驗證透過）",
  "确定后会按服务顺序直接发布，并会根据发布载体类型创建或关联一个发布单": "確定後會按服務順序直接釋出，並會根據釋出載體型別建立或關聯一個釋出單",
  "昨日": "昨日",
  "近7~14天": "近7~14天",
  "总反馈详情": "總反饋詳情",
  "编辑反馈类型失败": "編輯反饋型別失敗",
  "新增反馈类型失败": "新增反饋型別失敗",
  "根节点": "根節點",
  "编辑失败": "編輯失敗",
  "新增失败": "新增失敗",
  "编辑配置失败": "編輯配置失敗",
  "新增配置失败": "新增配置失敗",
  "编辑FAQ失败": "編輯FAQ失敗",
  "新增FAQ失败": "新增FAQ失敗",
  "编辑敏感词失败": "編輯敏感詞失敗",
  "新增敏感词失败": "新增敏感詞失敗",
  "上架成功": "上架成功",
  "下架成功": "下架成功",
  "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 反馈详情链接：</span></strong></p><p></p>": "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 反饋詳情連結：</span></strong></p><p></p>",
  "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 反馈内容：</span></strong></p><p></p>": "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 反饋內容：</span></strong></p><p></p>",
  "创建工单失败": "建立工單失敗",
  "该工单不支持指派": "該工單不支援指派",
  "预算更新失败": "預算更新失敗",
  "获取项目实际人天失败": "獲取專案實際人天失敗",
  "里程碑已更新": "里程碑已更新",
  "里程碑已新增": "里程碑已新增",
  "更新里程碑失败": "更新里程碑失敗",
  "新增里程碑失败": "新增里程碑失敗",
  "风险已更新": "風險已更新",
  "风险已新增": "風險已新增",
  "更新风险失败": "更新風險失敗",
  "新增风险失败": "新增風險失敗",
  "管理需求": "管理需求",
  "移出项目": "移出專案",
  "编辑时间": "編輯時間",
  "未命名里程碑": "未命名里程碑",
  "加载项目里程碑失败": "載入專案里程碑失敗",
  "解决风险失败": "解決風險失敗",
  "请完善项目基本信息、项目背景和项目团队信息": "請完善專案基本資訊、專案背景和專案團隊資訊",
  "草稿保存失败": "草稿儲存失敗",
  "请完善必填信息": "請完善必填資訊",
  "基础": "基礎",
  "研发/周报": "研發/週報",
  "流程/其他": "流程/其他",
  "加载看板数据失败": "載入看板資料失敗",
  "评分失败": "評分失敗",
  "删除项目失败": "刪除專案失敗",
  "开始项目失败": "開始專案失敗",
  "发起立项审批失败": "發起立項審批失敗",
  "完成项目失败": "完成專案失敗",
  "已收藏": "已收藏",
  "已取消收藏": "已取消收藏",
  "收藏操作失败": "收藏操作失敗",
  "请选择是否与您沟通确认期待完成时间": "請選擇是否與您溝通確認期待完成時間",
  "暂存成功": "暫存成功",
  "暂存失败": "暫存失敗",
  "COE 复盘": "COE 覆盤",
  "更新 COE 评论失败": "更新 COE 評論失敗",
  "保存 COE 回复失败": "儲存 COE 回覆失敗",
  "持续时长计算失败": "持續時長計算失敗",
  "未填写故障名称，内容仅保存在本机": "未填寫故障名稱，內容僅儲存在本機",
  "正在自动暂存…": "正在自動暫存…",
  "自动暂存失败，已保存在本机，联网后重试": "自動暫存失敗，已儲存在本機，聯網後重試",
  "自动暂存失败，本机缓存空间不足，请手动暂存": "自動暫存失敗，本機快取空間不足，請手動暫存",
  "等待自动暂存…": "等待自動暫存…",
  "未保存修改已备份到本机": "未儲存修改已備份到本機",
  "本机缓存空间不足，请尽快保存": "本機快取空間不足，請儘快儲存",
  "附件仍在上传，请等待上传完成后再关闭": "附件仍在上傳，請等待上傳完成後再關閉",
  "存在上传失败的附件，请删除或重新上传后再关闭": "存在上傳失敗的附件，請刪除或重新上傳後再關閉",
  "附件仍在上传，请等待上传完成后再保存": "附件仍在上傳，請等待上傳完成後再儲存",
  "存在上传失败的附件，请删除或重新上传后再保存": "存在上傳失敗的附件，請刪除或重新上傳後再儲存",
  "保存失败，内容仍保留在当前页面和本机缓存中": "儲存失敗，內容仍保留在當前頁面和本機快取中",
  "如：迭代上线": "如：迭代上線",
  "选择操作人员": "選擇操作人員",
  "请输入备注，支持换行": "請輸入備註，支援換行",
  "请输入根因总结，支持换行": "請輸入根因總結，支援換行",
  "请输入说明，支持换行": "請輸入說明，支援換行",
  "请填写任务内容": "請填寫任務內容",
  "请输入任务内容，支持换行": "請輸入任務內容，支援換行",
  "请选择交付时间": "請選擇交付時間",
  "如：履约轨迹缺失": "如：履約軌跡缺失",
  "请选择故障责任组长": "請選擇故障責任組長",
  "请选择故障责任人": "請選擇故障責任人",
  "请选择复盘组织者": "請選擇覆盤組織者",
  "请选择复盘参与人": "請選擇覆盤參與人",
  "如：影响XX国家/XX业务线": "如：影響XX國家/XX業務線",
  "如：12单 / 3个客户": "如：12單 / 3個客戶",
  "如：约2小时 / 10:00-12:00": "如：約2小時 / 10:00-12:00",
  "如：工单/群反馈/客服": "如：工單/群反饋/客服",
  "如：异常订单1200单，说明统计口径": "如：異常訂單1200單，說明統計口徑",
  "如：可追回，预计7月15日前完成": "如：可追回，預計7月15日前完成",
  "如：下游账务系统对账延迟": "如：下游賬務系統對賬延遲",
  "请选择用户/客户通知人": "請選擇使用者/客戶通知人",
  "主值班": "主值班",
  "备值班": "備值班",
  "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 以下为线上问题引用内容：</span></strong></p><p></p>": "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 以下為線上問題引用內容：</span></strong></p><p></p>",
  "交接失败": "交接失敗",
  "非需求对接人与已完成状态无法操作变更": "非需求對接人與已完成狀態無法操作變更",
  "业务需求.xlsx": "業務需求.xlsx",
  "产品需求.xlsx": "產品需求.xlsx",
  "后端任务-": "後端任務-",
  "前端任务-": "前端任務-",
  "测试任务-": "測試任務-",
  "设计任务-": "設計任務-",
  "（提测申请）": "（提測申請）",
  "你有未保存的更改，确定要离开吗？": "你有未儲存的更改，確定要離開嗎？",
  "非需求产品经理无法操作变更": "非需求產品經理無法操作變更",
  "存在相同的服务，请自行Merge到一个分支后保存，服务分别是": "存在相同的服務，請自行Merge到一個分支後儲存，服務分別是",
  "申请创建紧急发布单": "申請建立緊急釋出單",
  "申请创建发布单": "申請建立釋出單",
  "产品阶段": "產品階段",
  "请选择评审类型": "請選擇評審型別",
  "需求按缺陷数量排名（单位：个)": "需求按缺陷數量排名（單位：個)",
  "迭代需求燃尽图": "迭代需求燃盡圖",
  "tips：需求状态流转维度": "tips：需求狀態流轉維度",
  "代码缺陷率（增量）排名（单位：％)": "程式碼缺陷率（增量）排名（單位：％)",
  "千行代码缺陷率（全量）排名（单位：‰)": "千行程式碼缺陷率（全量）排名（單位：‰)",
  "工时容量": "工時容量",
  "预估工时": "預估工時",
  "预估工时排名（单位：人天)": "預估工時排名（單位：人天)",
  "实际工时排名（单位：人天）": "實際工時排名（單位：人天）",
  "停用成功": "停用成功",
  "操作失败，请稍后重试": "操作失敗，請稍後重試",
  "活动列表加载失败": "活動列表載入失敗",
  "元数据加载失败，请稍后重试": "後設資料載入失敗，請稍後重試",
  "更新并发布成功": "更新併發布成功",
  "创建并发布成功": "建立併發布成功",
  "草稿保存成功": "草稿儲存成功",
  "创建草稿成功": "建立草稿成功",
  "API Key总数": "API Key總數",
  "日新增": "日新增",
  "日请求数量": "日請求數量",
  "标签设置失败": "標籤設定失敗",
  "标签创建失败": "標籤建立失敗",
  "阶段": "階段",
  "实时日志已连接...": "實時日誌已連線...",
  "欢迎使用 Pod 调试功能，通过模拟终端的方式，方便快速进入容器进行调试。(注意：默认连接的 Shell 为 Bash)": "歡迎使用 Pod 除錯功能，透過模擬終端的方式，方便快速進入容器進行除錯。(注意：預設連線的 Shell 為 Bash)",
  "控制台": "控制檯",
  "平均工时(小时)": "平均工時(小時)",
  "销售量": "銷售量",
  "不满": "不滿",
  "开始日期不能早于项目开始日期": "開始日期不能早於專案開始日期",
  "截止日期不能晚于项目截止日期": "截止日期不能晚於專案截止日期",
  "结束日期": "結束日期",
  "请选择开始日期": "請選擇開始日期",
  "请选择预计完成时间": "請選擇預計完成時間",
  "如：合并双链路代码": "如：合併雙鏈路程式碼",
  "如：强制架构评审": "如：強制架構評審",
  "如：完善测试场景": "如：完善測試場景",
  "如：新增数据一致性校验告警": "如：新增資料一致性校驗告警",
  "如：新增计税金额波动监控": "如：新增計稅金額波動監控",
  "如：建立客户侧数据日报": "如：建立客戶側資料日報",
  "如：消息推送异常自动熔断": "如：訊息推送異常自動熔斷",
  "如：批量订正工具": "如：批次訂正工具",
  "如：一键回滚机制": "如：一鍵回滾機制",
  "如：请求链路全量日志": "如：請求鏈路全量日誌",
  "如：数据对比工具": "如：資料對比工具",
  "请等待附件上传完成": "請等待附件上傳完成",
  "请删除上传失败的附件后重试": "請刪除上傳失敗的附件後重試",
  "发现时间不能早于发生时间": "發現時間不能早於發生時間",
  "恢复时间不能早于发现时间": "恢復時間不能早於發現時間",
  "内部原因必须选择归属部门": "內部原因必須選擇歸屬部門",
  "交付开始时间": "交付開始時間",
  "交付结束时间": "交付結束時間",
  "极差": "極差",
  "失望": "失望",
  "惊喜": "驚喜",
  "无标题": "無標題",
  "不限": "不限",
  "请选择提醒周期": "請選擇提醒週期",
  "请选择提醒小时": "請選擇提醒小時",
  "催办失败，请稍后重试": "催辦失敗，請稍後重試",
  "任务信息": "任務資訊",
  "名称：": "名稱：",
  "链接：": "連結：",
  "人员已失效（自动轮转）": "人員已失效（自動輪轉）",
  "值班表名称：": "值班表名稱：",
  "值班表链接：": "值班錶連結：",
  "上传失败，未返回文件URL": "上傳失敗，未返回檔案URL",
  "主播粉丝": "主播粉絲",
  "超跑礼物": "超跑禮物",
  "模板存量": "模板存量",
  "模板已解决": "模板已解決",
  "无数据": "無資料",
  "01月": "01月",
  "02月": "02月",
  "03月": "03月",
  "04月": "04月",
  "05月": "05月",
  "06月": "06月",
  "07月": "07月",
  "08月": "08月",
  "09月": "09月",
  "10月": "10月",
  "11月": "11月",
  "12月": "12月",
  "缺陷名称：": "缺陷名稱：",
  "问题反馈人：": "問題反饋人：",
  "详情链接：": "詳情連結：",
  "需求名称：": "需求名稱：",
  "需求链接：": "需求連結：",
  "暂无会议": "暫無會議",
  "邀请你参加评审": "邀請你參加評審",
  "评审主题：": "評審主題：",
  "评审详情链接：": "評審詳情連結：",
  "评审类型：": "評審型別：",
  "评审时间：": "評審時間：",
  "评审地点：": "評審地點：",
  "会议链接：": "會議連結：",
  "评审资料：": "評審資料：",
  "点击升序排列": "點選升序排列",
  "点击降序排列": "點選降序排列",
  "点击取消排序": "點選取消排序",
  "未分组": "未分組",
  "当前：按开始时间排序": "當前：按開始時間排序",
  "当前：按结束时间排序": "當前：按結束時間排序",
  "始": "始",
  "终": "終",
  "需求创建时间：": "需求建立時間：",
  "_%Y%W周报": "_%Y%W週報",
  "%N_%Y%W周报": "%N_%Y%W週報",
  "已配置项目周报模板": "已配置專案週報模板",
  "%N_%Y%W_%B%P周报": "%N_%Y%W_%B%P週報",
  "周报标题：": "週報標題：",
  "未知职位": "未知職位",
  "刚刚": "剛剛",
  "申请人同时为本节点审批人，系统已跳过": "申請人同時為本節點審批人，系統已跳過",
  "当前操作无需审批，可以立即执行": "當前操作無需審批，可以立即執行",
  "你同时是审批人，命中的审批节点已自动跳过，可以立即执行操作": "你同時是審批人，命中的審批節點已自動跳過，可以立即執行操作",
  "你同时是审批人，命中的审批节点已自动跳过，其余节点继续审批": "你同時是審批人，命中的審批節點已自動跳過，其餘節點繼續審批",
  "审批已通过，可以立即执行操作": "審批已透過，可以立即執行操作",
  "重复提交": "重複提交",
  "发布单名称：": "釋出單名稱：",
  "发布单类型：": "釋出單型別：",
  "漏洞数": "漏洞數",
  "Bug数": "Bug數",
  "在职": "在職",
  "离职": "離職",
  "当前值": "當前值",
  "Canvas转换失败": "Canvas轉換失敗",
  "获取图片URL失败": "獲取圖片URL失敗",
  "<Cell ss:StyleID=\"descLabel\"> <Data ss:Type=\"String\">指标释义</Data> </Cell>": "<Cell ss:StyleID=\"descLabel\"> <Data ss:Type=\"String\">指標釋義</Data> </Cell>",
  "<Cell ss:StyleID=\"avgLabel\"> <Data ss:Type=\"String\">团队均值</Data> </Cell>": "<Cell ss:StyleID=\"avgLabel\"> <Data ss:Type=\"String\">團隊均值</Data> </Cell>",
  "样本个数": "樣本個數",
  "里程碑个数": "里程碑個數",
  "需求个数": "需求個數",
  "缺陷个数": "缺陷個數",
  "事故个数": "事故個數",
  "债务个数": "債務個數",
  "指标值": "指標值",
  "指标达成率": "指標達成率",
  "总计需求数": "總計需求數",
  "可以配置各国、各反馈来源中的App Tab页，如：首页、产品页、用户页、设置页等": "可以配置各國、各反饋來源中的App Tab頁，如：首頁、產品頁、使用者頁、設定頁等",
  "可以配置各国、各反馈来源中的常见问题解答，支持多语言配置": "可以配置各國、各反饋來源中的常見問題解答，支援多語言配置",
  "可可以配置各国、各反馈来源中的功能，如：是否支持上传视频等": "可可以配置各國、各反饋來源中的功能，如：是否支援上傳影片等",
  "可以配置各国、各反馈来源中的反馈主次类型，如：产品问题、功能问题、性能问题、体验问题、其他问题等": "可以配置各國、各反饋來源中的反饋主次型別，如：產品問題、功能問題、效能問題、體驗問題、其他問題等",
  "App Tab页管理": "App Tab頁管理",
  "功能管理": "功能管理",
  "反馈类型管理": "反饋型別管理",
  "App Tab页": "App Tab頁",
  "新增Tab页": "新增Tab頁",
  "批量添加FAQ": "批次新增FAQ",
  "批量添加反馈类型": "批次新增反饋型別",
  "批量添加App Tab页": "批次新增App Tab頁",
  "批量添加属性": "批次新增屬性",
  "（已完成）": "（已完成）",
  "关键结果不能为空": "關鍵結果不能為空",
  "权重不能为空": "權重不能為空",
  "验收时间不能为空": "驗收時間不能為空",
  "验收人不能为空": "驗收人不能為空",
  "验收标准不能为空": "驗收標準不能為空",
  "关联需求/迭代": "關聯需求/迭代",
  "继续完成项目": "繼續完成專案",
  "完成验收": "完成驗收",
  "如果里程碑已经开始，需要变更里程碑信息，可联系 Zola 周华": "如果里程碑已經開始，需要變更里程碑資訊，可聯絡 Zola 周華",
  "请至少添加一条项目关键里程碑": "請至少新增一條專案關鍵里程碑",
  "业务起草": "業務起草",
  "创建项目 - 业务起草": "建立專案 - 業務起草",
  "技术起草": "技術起草",
  "编辑项目": "編輯專案",
  "平均解决时长(天)": "平均解決時長(天)",
  "处理时长(天)": "處理時長(天)",
  "事故名称：": "事故名稱：",
  "新增事故报告": "新增事故報告",
  "编辑事故报告": "編輯事故報告",
  "哪怕把CPU干冒烟、把内存条烧成灰、把我自己加载成地中海，也保证给您推送完！🚬🔥": "哪怕把CPU乾冒煙、把記憶體條燒成灰、把我自己載入成地中海，也保證給您推送完！🚬🔥",
  "别急，页面正在和网速搏斗中🤼": "別急，頁面正在和網速搏鬥中🤼",
  "哪怕把服务器薅秃、把网线搓出火花、把我自己加载到发际线后移三厘米，也一定把您的邮箱页面完整送到！💻🦲": "哪怕把伺服器薅禿、把網線搓出火花、把我自己載入到髮際線後移三釐米，也一定把您的郵箱頁面完整送到！💻🦲",
  "您放心，今天哪怕加班到头发掉光、咖啡喝到洗胃、服务器被我哄到崩溃重启，我也一定把您的邮件页面怼出来！☕🦲": "您放心，今天哪怕加班到頭髮掉光、咖啡喝到洗胃、伺服器被我哄到崩潰重啟，我也一定把您的郵件頁面懟出來！☕🦲",
  "未定级": "未定級",
  "请选择统计时间范围": "請選擇統計時間範圍",
  "当前用户": "當前使用者",
  "未命名附件": "未命名附件",
  "表单字段": "表單欄位",
  "自动暂存失败": "自動暫存失敗",
  "编辑执行人": "編輯執行人",
  "编辑关联需求": "編輯關聯需求",
  "未延期": "未延期",
  "恢复时间不能早于发生时间": "恢復時間不能早於發生時間",
  "反馈人：": "反饋人：",
  "指派给：": "指派給：",
  "需求提出人：": "需求提出人：",
  "必填项未填写": "必填項未填寫",
  "切换": "切換",
  "邀请你参加例会/评审": "邀請你參加例會/評審",
  "例会/评审主题：": "例會/評審主題：",
  "例会/评审详情链接：": "例會/評審詳情連結：",
  "例会/评审类型：": "例會/評審型別：",
  "例会/评审时间：": "例會/評審時間：",
  "例会/评审地点：": "例會/評審地點：",
  "例会/会议链接：": "例會/會議連結：",
  "例会/评审资料：": "例會/評審資料：",
  "迭代名称：": "迭代名稱：",
  "迭代负责人：": "迭代負責人：",
  "Sprint名称：": "Sprint名稱：",
  "迭代数据不存在": "迭代資料不存在",
  "只有状态为\"未开始\"或\"进行中\"的迭代才能操作": "只有狀態為\"未開始\"或\"進行中\"的迭代才能操作",
  "无法获取当前用户信息": "無法獲取當前使用者資訊",
  "非迭代负责人无法操作": "非迭代負責人無法操作",
  "任务名称：": "任務名稱：",
  "无作用域": "無作用域",
  "接收人ID": "接收人ID",
  "部门ID": "部門ID",
  "时间未知": "時間未知",
  "新建卡片": "新建卡片",
  "表一": "表一",
  "表二": "表二",
  "规则模板一": "規則模板一",
  "规则模板二": "規則模板二",
  "人员排名": "人員排名",
  "债务名称：": "債務名稱：",
  "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif": "微軟雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif",
  "苹果苹方=PingFang SC,Microsoft YaHei,sans-serif": "蘋果蘋方=PingFang SC,Microsoft YaHei,sans-serif",
  "宋体=simsun,serif": "宋體=simsun,serif",
  "仿宋体=FangSong,serif": "仿宋體=FangSong,serif",
  "黑体=SimHei,sans-serif": "黑體=SimHei,sans-serif",
  "指标释义": "指標釋義",
  "团队均值": "團隊平均值",
  "重开项": "重開項",
  "需求设计缺陷项": "需求設計缺陷項",
  "按系统审批流配置": "按系統審批流程配置",
  "需求统计.xlsx": "需求統計.xlsx",
  "未设置时间": "未設定時間",
  "项目创建": "專案建立",
  "添加成员：李四": "新增成員：李四",
  "开始第一个Sprint": "開始第一個 Sprint",
  "系统研发接口人": "系統研發聯絡人",
  "发布协同组": "發布協同組",
  "确认人": "確認人",
  "关闭人": "關閉人",
  "慢SQL模板记录.xlsx": "慢 SQL 範本記錄.xlsx",
  "正在连接中": "正在連線",
  "已经连接并且可以通讯": "已連線",
  "连接正在关闭": "連線正在關閉",
  "连接已关闭或者没有连接成功": "連線已關閉或連線失敗",
  "role.badge.product": "產",
  "role.badge.developer": "開",
  "role.badge.tester": "測",
  " ": " ",
  "pages.common.deleteConfirm": "確認刪除",
  "pages.common.deleteConfirmDesc": "確定要刪除任務「{name}」嗎？",
  "pages.common.ok": "確定",
  "pages.common.cancel": "取消",
  "pages.common.deleteSuccess": "刪除成功",
  "please.select.release.order": "請選擇釋出單",
  "pages.bug.responsiblePerson": "責任人",
  "pages.bug.joining": "請勿重複點選",
  "任务数": "任務數",
  "前端预计完成时间": "前端預計完成時間",
  "后端预计完成时间": "後端預計完成時間",
  "测试预计完成时间": "測試預計完成時間",
  "pages.system.form.selectUiDesign": "請選擇 UI 設計",
  "pages.system.form.systemName": "請輸入名稱！",
  "pages.searchTable.updateForm.ruleConfig": "規則配置",
  "pages.searchTable.updateForm.basicConfig": "基本配置",
  "pages.searchTable.updateForm.ruleName.nameLabel": "規則名稱",
  "pages.searchTable.updateForm.ruleName.nameRules": "請輸入規則名稱！",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "規則描述",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder": "請輸入至少五個字元",
  "pages.searchTable.updateForm.ruleDesc.descRules": "請輸入至少五個字元的規則描述！",
  "pages.searchTable.updateForm.ruleProps.title": "配置規則屬性",
  "pages.searchTable.updateForm.object": "監控物件",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "規則模板",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "規則型別",
  "pages.searchTable.updateForm.schedulingPeriod.title": "設定排程週期",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "開始時間",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules": "請選擇開始時間！",
  "pages.searchTable.titleDesc": "描述",
  "pages.searchTable.titleCallNo": "服務呼叫次數",
  "pages.searchTable.tenThousand": "萬",
  "pages.searchTable.titleStatus": "狀態",
  "pages.searchTable.nameStatus.default": "關閉",
  "pages.searchTable.nameStatus.running": "執行中",
  "pages.searchTable.nameStatus.online": "已上線",
  "pages.searchTable.nameStatus.abnormal": "異常",
  "pages.searchTable.titleUpdatedAt": "上次排程時間",
  "pages.searchTable.exception": "請輸入異常原因！",
  "pages.searchTable.titleOption": "操作",
  "pages.searchTable.config": "配置",
  "pages.searchTable.subscribeAlert": "訂閱告警",
  "pages.searchTable.title": "查詢表格",
  "pages.searchTable.new": "新建",
  "pages.searchTable.chosen": "已選擇",
  "pages.searchTable.item": "項",
  "pages.searchTable.totalServiceCalls": "服務呼叫總數",
  "pages.searchTable.batchDeletion": "批次刪除",
  "pages.searchTable.batchApproval": "批次審批",
  "pages.searchTable.createForm.newRule": "新建規則",
  "pages.searchTable.ruleName": "規則名稱為必填項",
  "pages.bug.feedbackUserCode": "反饋人",
  "pages.layouts.userLayout.title": "Ant Design 是西湖區最具影響力的 Web 設計規範",
  "pages.welcome.link": "歡迎使用",
  "pages.welcome.alertMessage": "更快更強的重型元件，已經發布。",
  "pages.admin.subPage.title": " 這個頁面只有 admin 許可權才能檢視",
  "pages.admin.subPage.alertMessage": "umi ui 現已釋出，歡迎使用 npm run ui 啟動體驗。",
  "pages.common.createDate": "建立時間",
  "pages.common.id": "序號",
  "pages.common.createUserName": "建立人",
  "pages.common.lastUpdDate": "更新時間",
  "pages.common.lastUpdUserName": "更新人",
  "pages.common.option": "操作",
  "pages.common.create": "新建",
  "pages.common.apply": "申請",
  "pages.common.edit": "編輯",
  "pages.common.delete": "刪除",
  "pages.common.restore": "恢復",
  "pages.common.copy": "克隆",
  "pages.common.status": "狀態",
  "pages.common.share": "分享",
  "pages.common.tag": "標籤",
  "pages.common.productManagerName": "產品經理",
  "pages.common.uiDesignName": "UI設計",
  "pages.common.developName": "後端開發",
  "pages.common.frontWebName": "前端開發",
  "pages.common.testEngineerName": "測試開發",
  "pages.common.testName": "測試",
  "pages.common.itSupportName": "技術支援",
  "pages.common.businessCounterpartName": "業務方",
  "pages.common.form.selectProduct": "請選擇產品經理",
  "pages.common.form.selectBusinessCounterpartName": "請選擇業務方",
  "pages.common.form.selectUdDesign": "請選擇UI設計",
  "pages.common.form.selectDev": "請選擇後端開發",
  "pages.common.form.selectFont": "請選擇前端開發",
  "pages.common.form.selectTest": "請選擇測試開發",
  "pages.common.form.selectSupport": "請選擇技術支援",
  "pages.common.startTime": "開始時間",
  "pages.common.endTime": "結束時間",
  "pages.common.colSetting": "列設定",
  "pages.common.closed": "歸檔",
  "pages.common.filter": "篩選",
  "pages.common.clear": "清除",
  "pages.common.notarize": "確認",
  "pages.common.addRemark": "新增備註",
  "pages.common.assign": "指派處理人",
  "pages.common.cardUnit": "張",
  "pages.business.businessNameCn": "業務領域(中)",
  "pages.business.businessNameEn": "業務領域(英)",
  "pages.business.systemId": "關聯絡統",
  "pages.business.title": "業務領域",
  "pages.system.updateForm.schedulingPeriod.timeLabel": "開始時間",
  "pages.system.updateForm.schedulingPeriod.timeRules": "請選擇開始時間！",
  "pages.system.status": "啟用狀態",
  "pages.system.title": "系統",
  "pages.system.name": "系統名稱",
  "pages.system.systemId": "系統ID（關聯Jira的SystemId）",
  "pages.system.systemKey": "系統Key",
  "pages.system.ruleName": "系統名稱為必填項",
  "pages.system.businessName": "業務領域",
  "pages.system.businessNameEn": "業務領域-英",
  "pages.system.leaderUserName": "系統負責人",
  "pages.system.businessLeaderUserName": "業務領域負責人",
  "pages.system.businessUserCount": "業務參與人數",
  "pages.system.systemDesc": "系統描述",
  "pages.system.exception": "請輸入異常原因！",
  "pages.system.form.businessName": "所屬業務領域",
  "pages.system.form.systemKey": "系統Key（唯一）",
  "pages.system.form.selectBusiness": "請選擇業務領域",
  "pages.system.form.selectSystemLeader": "請選擇系統負責人",
  "pages.system.form.inputSystemName": "請輸入系統名稱",
  "pages.system.form.inputSystemId": "請輸入關聯Jira系統ID",
  "pages.system.form.inputSystemKey": "請輸入系統Key",
  "pages.system.form.robotId": "機器人ID",
  "pages.businessIssue.productManagerName": "產品對接人",
  "pages.businessIssue.productManagerName2": "對接人",
  "pages.businessIssue.businessSideInfo": "提出人",
  "pages.businessIssue.businessRelatedInfo": "相關人",
  "pages.businessIssue.pengingTime": "等待時長(天)",
  "pages.businessIssue.pengingTime2": "等待時長",
  "pages.businessIssue.expectDate": "期待完成時間",
  "pages.businessIssue.relatedIssues": "關聯產品需求",
  "pages.businessIssue.relatedIssuesCount": "關聯產品需求數量",
  "pages.businessIssue.createProductIssue": "建立產品需求",
  "pages.issuePool.issueId": "序列號",
  "pages.issuePool.issueName": "需求名稱",
  "pages.issuePool.system": "所屬系統",
  "pages.issuePool.relatedUser": "相關人(抄送人)",
  "pages.issuePool.complexRate": "複雜度",
  "pages.issuePool.sourceDesc": "需求來源",
  "pages.issuePool.country": "國家",
  "pages.issuePool.label": "標籤",
  "pages.issuePool.priorityLevel": "優先順序",
  "pages.issuePool.sprint": "所屬Sprint",
  "pages.issuePool.expectDate": "期待完成時間",
  "pages.issuePool.completeDate": "實際完成時間",
  "pages.issuePool.expectDate2": "期待完成",
  "pages.issuePool.completeDate2": "實際完成",
  "pages.issuePool.reviewDate": "評審（會議）時間",
  "pages.issuePool.allReviewDate": "時間",
  "pages.issuePool.relatedIssues": "關聯需求",
  "pages.issuePool.follower": "關注",
  "pages.issuePool.cancelFollower": "取消關注",
  "pages.issuePool.transfer": "轉移系統",
  "pages.issuePool.planName": "規劃名稱",
  "pages.issuePool.allIssues": "全部需求",
  "pages.issuePool.currentSprint": "檢視當前Sprint",
  "pages.issuePool.taskCnt": "任務數量",
  "pages.issuePool.release": "建立釋出單",
  "pages.issuePool.isTechnical": "技術類需求",
  "pages.issuePool.isRequireTrainer": "需要系統培訓",
  "pages.issuePool.addPlan": "需求繫結Sprint(預設展示需求所屬系統的Sprint)",
  "pages.issuePool.follewUsers": "關注者",
  "pages.issuePool.taskTotalTime": "任務總耗時",
  "pages.issuePool.taskTime": "任務耗時",
  "pages.issuePool.form.selectIssueName": "請輸入標題",
  "pages.issuePool.form.selectExpectDate": "請選擇期待日期",
  "pages.issuePool.form.selectComplexRate": "請選擇複雜度",
  "pages.issuePool.form.selectPriorityLevel": "請選擇優先順序",
  "pages.issuePool.form.estimatedPersonDay": "預估人天",
  "pages.issuePool.form.businessReviewName": "業務評審名稱",
  "pages.issuePool.form.collaborativeIssue": "協同需求",
  "pages.issuePool.form.relatedSprint": "關聯Sprint",
  "pages.issuePool.form.country": "需求影響國家",
  "pages.issuePool.form.isRequireTrainer": "是否需要系統培訓",
  "pages.release.collaboratorList": "協同人",
  "pages.release.Date": "釋出日期",
  "pages.issueReview.name": "評審（會議）名稱",
  "pages.issueReview.allName": "名稱",
  "pages.issueReview.createUserName": "發起人",
  "pages.issueReview.reviewUsers": "評審（會議）參與人",
  "pages.issueReview.status": "評審（會議）狀態",
  "pages.issueReview.reviewType": "評審（會議）型別",
  "pages.issueReview.reviewReadCount": "確認情況",
  "pages.issueReview.reviewTime": "預估評審時間",
  "pages.issueReview.relatedIssueCount": "關聯需求數",
  "pages.issueReview.meetingCount": "會議數",
  "pages.issueReview.meetingCode": "點選複製會議號",
  "pages.issueReview.createMeeting": "發起會議",
  "pages.issueReview.editMeeting": "編輯會議",
  "pages.issueReview.cancelMeeting": "取消會議",
  "pages.issueReview.cancelReview": "刪除評審",
  "pages.issueReview.ReviewAgain": "重新評審",
  "pages.issueReview.reviewDesc": "評審（會議）描述",
  "pages.issueReview.form.meetingName": "評審會議名稱",
  "pages.issueReview.form.allMeetingName": "會議名稱",
  "pages.issueReview.form.meetingTime": "會議時長",
  "pages.issueReview.form.reviewMeetingDesc": "評審會議描述",
  "pages.issueReview.form.allReviewMeetingDesc": "會議描述",
  "pages.issueReview.form.plan": "規劃",
  "pages.issueReview.form.issues": "需求",
  "pages.issueReview.form.reviewMeetingContent": "評審會議紀要",
  "pages.issueReview.issuePool.unReadCount": "未讀人數",
  "pages.issueReview.issuePool.unReadUser": "未讀人",
  "pages.issueReview.issuePool.readCount": "已讀人數",
  "pages.issueReview.issuePool.readUser": "已讀人",
  "pages.issueReview.meetingRemindBefores": "開始前提醒",
  "pages.sprint.name": "Sprint名稱",
  "pages.sprint.owner": "負責人",
  "pages.sprint.goal": "Sprint(迭代)目標",
  "pages.sprint.issueCnt": "需求數量",
  "pages.sprint.cycle": "週期(GMT+8)",
  "pages.sprint.budget": "人天預算(Day)",
  "pages.sprint.isSynergy": "協同規劃",
  "pages.sprint.plan": "Sprint規劃",
  "pages.sprint.version": "版本號",
  "pages.sprint.createVersion": "建立迭代",
  "pages.sprint.form.time": "開始-結束",
  "pages.sprint.form.issues": "需求",
  "pages.sprint.add.issue": "新增需求",
  "pages.sprint.systemNames": "所屬系統",
  "pages.task.id": "任務ID",
  "pages.task.name": "任務名稱",
  "pages.task.type": "型別",
  "pages.task.complexRate": "複雜度",
  "pages.task.priorityLevel": "優先順序",
  "pages.task.status": "狀態",
  "pages.task.owner": "負責人",
  "pages.task.taskParticipants": "參與人",
  "pages.task.task": "任務詳情列表",
  "pages.task.estimatedPersonDay": "預估人天",
  "pages.task.issues": "需求",
  "pages.task.serviceType": "服務型別",
  "pages.task.service": "服務",
  "pages.task.branch": "分支",
  "pages.task.overtime": "已逾期",
  "pages.task.form.time": "開始-結束",
  "pages.task.sprint": "迭代",
  "pages.test.caseName": "用例名稱",
  "pages.test.systemName": "所屬系統",
  "pages.test.issueName": "所屬需求",
  "pages.test.moduleName": "所屬模組",
  "pages.test.caseLevel": "用例級別",
  "pages.test.reviewStatusDesc": "評審狀態",
  "pages.test.fileName": "檔名稱",
  "pages.bug.title": "標題",
  "pages.bug.system": "所屬系統",
  "pages.bug.issue": "所屬需求",
  "pages.bug.severityLevel": "嚴重級別",
  "pages.bug.priorityLevel": "優先順序",
  "pages.bug.implementationPlan": "執行方案",
  "pages.bug.bugType": "Bug型別",
  "pages.bug.proposer": "反饋人",
  "pages.bug.assignedUser": "指派給",
  "pages.bug.assignedDate": "指派時間",
  "pages.bug.relatedIssueInfos": "關聯需求",
  "pages.bug.deadline": "截止時間",
  "pages.bug.relatedIssuesCount": "關聯產品需求數量",
  "pages.bug.bugPageUrlsCnt": "Bug頁面URL數\t",
  "pages.bug.responseTime": "響應耗時",
  "pages.bug.processingTime": "處理耗時",
  "pages.bug.waitingCloseTime": "等待關閉",
  "pages.bug.waitingTime": "總耗時",
  "pages.bug.carbonCopyUser": "抄送人",
  "pages.bug.operatingSystem": "作業系統",
  "pages.bug.resolvedUser": "解決者",
  "pages.bug.confirmedDate": "確認時間",
  "pages.bug.resolvedDate": "解決時間",
  "pages.bug.closedUser": "關閉者",
  "pages.bug.closedDate": "關閉時間",
  "pages.bug.confirm": "確認",
  "pages.bug.resolve": "解決",
  "pages.bug.reopen": "重開",
  "pages.bug.closed": "關閉",
  "pages.bug.reminder": "催辦",
  "pages.bug.clone": "克隆",
  "pages.bug.join": "進群",
  "pages.codeQuality.title": "專案/服務",
  "pages.codeQuality.type": "類別",
  "pages.codeQuality.lines": "程式碼總行數",
  "pages.codeQuality.changeLines": "程式碼行數變化",
  "pages.codeQuality.addLines": "增量程式碼行數",
  "pages.codeQuality.allLines": "程式碼總行數",
  "pages.codeQuality.bugs": "缺陷數量",
  "pages.codeQuality.bugDensity": "千行程式碼缺陷率（‰）",
  "pages.codeQuality.addBugDensity": "增量程式碼缺陷率（％）",
  "pages.codeQuality.allBugDensity": "全量千行程式碼缺陷率（‰）",
  "pages.efficiencyDashboard.title": "需求交付概覽",
  "pages.efficiencyDashboard.issueStatistics": "需求存量統計",
  "pages.efficiencyDashboard.stockCount": "總存量",
  "pages.efficiencyDashboard.pendingInterventionsCount": "待介入",
  "pages.efficiencyDashboard.suspendedCount": "已暫停",
  "pages.efficiencyDashboard.underSolutionCount": "方案中",
  "pages.efficiencyDashboard.toBeDevelopedCount": "待開發",
  "pages.efficiencyDashboard.underDevelopmentCount": "開發中",
  "pages.efficiencyDashboard.recentSevenDayDasboard": "近7天需求概覽",
  "pages.efficiencyDashboard.newCount": "新增",
  "pages.efficiencyDashboard.closeCount": "關閉",
  "pages.efficiencyDashboard.totalReleaseCount": "總髮布",
  "pages.efficiencyDashboard.normalReleaseCount": "正常釋出",
  "pages.efficiencyDashboard.emergencyReleaseCount": "緊急釋出",
  "pages.efficiencyDashboard.delayedUnpublishedCount": "延遲未釋出",
  "pages.efficiencyDashboard.recentSevenDayQuality": "近7天需求質效",
  "pages.efficiencyDashboard.handledWaitTime": "需求等待時長（已處理） 單位: 小時",
  "pages.efficiencyDashboard.designTime": "需求設計時長（已處理） 單位: 小時",
  "pages.efficiencyDashboard.recentSevenDayOption": "近7天操作",
  "pages.efficiencyDashboard.changeCount": "狀態變更次數",
  "pages.polarDB.log.id": "ID",
  "pages.polarDB.log.environment": "環境",
  "pages.polarDB.log.dbClusterId": "叢集ID",
  "pages.polarDB.log.dbName": "資料庫",
  "pages.polarDB.log.dbNodeId": "節點ID",
  "pages.polarDB.log.executionStartTime": "SQL執行時間（UTC）",
  "pages.polarDB.log.hostAddress": "客戶端地址",
  "pages.polarDB.log.lockTimes": "SQL鎖定時長（秒）",
  "pages.polarDB.log.queryTimes": "SQL執行時長（秒）",
  "pages.polarDB.log.parseRowCounts": "解析行數",
  "pages.polarDB.log.returnRowCounts": "返回行數",
  "pages.polarDB.log.sqlText": "查詢語句",
  "pages.polarDB.log.dataTimestamp": "SQL執行時間戳",
  "pages.polarDB.log.sqlTemplateId": "SQL模板id",
  "pages.polarDB.tempalte.id": "模板id",
  "pages.polarDB.tempalte.environment": "環境",
  "pages.polarDB.tempalte.dbClusterId": "叢集ID",
  "pages.polarDB.tempalte.dbName": "資料庫",
  "pages.polarDB.tempalte.dbNodeId": "節點ID",
  "pages.polarDB.tempalte.hostAddress": "客戶端地址",
  "pages.polarDB.tempalte.sqlText": "SQL模板",
  "pages.polarDB.tempalte.createDate": "拉取時間",
  "pages.polarDB.tempalte.lastUpdDate": "更新時間",
  "pages.polarDB.tempalte.lastUpdUserName": "更新人",
  "pages.polarDB.tempalte.overdueDays": "逾期天數",
  "pages.polarDB.tempalte.handlerInfo": "處理人",
  "pages.polarDB.tempalte.status": "是否處理",
  "pages.polarDB.tempalte.remark": "備註",
  "pages.db.subscribe.dbId": "資料庫id",
  "pages.db.subscribe.dbName": "資料庫",
  "pages.db.subscribe.dbLeader": "負責人",
  "is.subscribe": "是否訂閱",
  "subscribers": "訂閱人",
  "pages.db.subscribe.explain": "須知：訂閱資料庫後，第二天開始會透過應用推送訂閱資料庫昨日的慢sql模板資料！（無慢SQL,則不推送）",
  "edit.subscribers": "編輯訂閱人",
  "pages.label.status": "啟用狀態",
  "pages.label.type": "標籤型別",
  "pages.label.nameCn": "標籤名稱(中文)",
  "pages.label.nameEn": "標籤名稱(英文)",
  "pages.label.markingCnt": "打標數量",
  "pages.label.lastUpdDate": "更新時間",
  "pages.label.lastUpdUserName": "更新人",
  "pages.label.relationTypeName": "打標型別",
  "pages.label.relationName": "打標名稱",
  "pages.label.createDate": "打標時間",
  "pages.label.createUserName": "打標人",
  "pages.delivery.id": "ID",
  "pages.delivery.releaseCarrierId": "釋出單ID",
  "pages.delivery.releaseCarrierName": "釋出單名稱",
  "pages.delivery.releaseCarrierType": "釋出單型別",
  "pages.delivery.collaboratorInfos": "協同人",
  "pages.delivery.otherInfo": "其它資訊",
  "pages.delivery.isEmergency": "緊急釋出",
  "pages.delivery.progress": "狀態",
  "pages.delivery.progressDesc": "狀態",
  "pages.delivery.appointmentDate": "預計釋出時間",
  "pages.delivery.releaseDate": "實際釋出時間",
  "pages.delivery.checkTermList": "檢查項",
  "pages.delivery.issueSn": "需求序列號",
  "pages.delivery.taskCnt": "任務數量",
  "pages.delivery.issueUrl": "需求詳情",
  "pages.delivery.serviceName": "服務名",
  "pages.delivery.serviceType": "服務型別",
  "pages.delivery.serviceStatus": "流水線狀態",
  "pages.delivery.devOwnerNames": "開發Owner",
  "pages.delivery.developerNames": "開發者",
  "pages.delivery.businessName": "業務領域",
  "pages.delivery.serviceLevel": "服務級別",
  "pages.delivery.serviceNature": "服務屬性",
  "pages.delivery.replicas": "容器副本",
  "pages.delivery.branch": "開發分支",
  "pages.delivery.releaseNum": "釋出次數",
  "pages.delivery.emergencyReleaseNum": "緊急次數",
  "pages.delivery.updateBy": "最新操作人",
  "pages.delivery.updateTime": "最新操作時間",
  "start.up.today": "今日生產投產",
  "delivery.today": "今日交付",
  "publish.window": "釋出視窗期",
  "service.publishing": "服務釋出",
  "release.reason": "釋出原因",
  "code.branch": "程式碼分支",
  "oneClick.publishing": "一鍵釋出",
  "secondary.release": "二次釋出",
  "noLpt.publishing": "非生產環境釋出",
  "regression.completion": "迴歸完成",
  "acceptance.pass": "驗收透過",
  "release.note": "釋出說明",
  "requirement.acceptance.link": "需求驗收連結",
  "release.history": "釋出歷史",
  "release.log": "釋出日誌",
  "service.log": "服務日誌",
  "vulnerability.scanning": "漏洞掃描",
  "publish": "釋出",
  "rollback": "回滾",
  "run.id": "執行ID",
  "branch": "分支",
  "commit.id": "提交ID",
  "run.time": "執行時間",
  "opt.time": "操作時間",
  "end.time": "結束時間",
  "op.user": "操作人",
  "finish.desc": "部署描述",
  "please.select.a.branch": "請選擇分支",
  "commit.publish": "提交發布",
  "commit.scanner": "提交掃描",
  "error.log": "錯誤日誌",
  "release.env": "釋出環境",
  "product.requirements": "產品需求",
  "pull.carrier.branch": "拉取釋出單分支",
  "refresh.branch": "重新整理分支",
  "related.items": "關聯項",
  "whether.to.schedule.a.meeting": "是否預約會議",
  "review.issue": "評審（會議）需求",
  "review.sprint": "評審（會議）Sprint",
  "review.test.case": "評審（會議）測試用例",
  "meeting.code": "會議號",
  "edit.review": "編輯評審",
  "edit.allReview": "編輯",
  "complete.review": "完成評審",
  "initiate.a.review.meeting": "預約評審會議",
  "initiate.a.allReview.meeting": "預約會議",
  "update.review.meeting": "變更評審會議",
  "update.review.allMeeting": "變更會議",
  "fill.in.the.review.minutes": "填寫會議紀要",
  "cancel.review.meeting": "取消評審會議",
  "delete.review": "刪除評審",
  "unconfirmed.person": "未確認人",
  "confirmed.person": "已確認人",
  "review.detail": "評審詳情",
  "relation.name": "關聯名稱",
  "relation.type": "關聯型別",
  "create.dashboard": "建立儀表盤",
  "pages.dashboard.kudoCard.description": "點亮星光，即刻讚美",
  "pages.dashboard.kudoCard.summary": "{nickname}，你收到了同事的星贊卡",
  "pages.dashboard.kudoCard.empty": "目前還沒有同事贈送您星贊卡哦~",
  "pages.dashboard.kudoRank.rankingRule": "排名按累計星贊卡數量計算。",
  "pages.dashboard.kudoRank.title": "星贊卡排行榜 Top 20",
  "pages.dashboard.kudoRank.yourRank": "你的排名",
  "pages.dashboard.kudoRank.rankTime": "排行時間：",
  "pages.dashboard.kudoRank.noData": "暫無排行資料",
  "pages.dashboard.kudoRank.selectGroup": "請選擇卡組",
  "pages.dashboard.receivedCards.title": "我收到的星贊卡",
  "pages.dashboard.receivedCards.description": "當期活動時間內你收到的卡片",
  "pages.dashboard.receivedCards.colleague": "同事",
  "pages.dashboard.receivedCards.cardName": "星贊卡",
  "pages.dashboard.receivedCards.filter": "篩選：",
  "pages.dashboard.receivedCards.noCards": "暫無星贊卡",
  "pages.dashboard.myCards.title": "我持有的星贊卡",
  "pages.dashboard.myCards.description": "當前活動時間內你擁有的卡片",
  "pages.dashboard.myCards.available": "可用",
  "pages.dashboard.myCards.status.pending": "待使用",
  "pages.dashboard.myCards.status.used": "已使用",
  "pages.dashboard.myCards.filter": "篩選：",
  "pages.dashboard.myCards.noCards": "暫無卡片",
  "instrument.name": "儀表盤名稱",
  "card.logo": "卡片Logo",
  "card.name.cn": "卡片名稱（中文）",
  "card.name.en": "卡片名稱（英文）",
  "card.code": "卡片編碼",
  "card.desc.cn": "卡片描述（中文）",
  "card.desc.en": "卡片描述（英文）",
  "card.type": "卡片型別",
  "edit.personal.instrument.card": "編輯個人儀表卡片",
  "card.list": "卡片列表",
  "to.do.name": "待辦名稱",
  "to.do.type": "待辦型別",
  "to.do.status": "待辦狀態",
  "expected.end": "預計完成時間",
  "member.name": "成員名稱",
  "edit.members": "編輯成員",
  "report.date": "彙報（年-周）",
  "weekly.report.title": "週報標題",
  "weekly.report.type": "週報型別",
  "weekly.report.title.template": "週報標題模板",
  "weekly.report.content.template": "週報內容模板",
  "report.to": "彙報物件",
  "report.by": "彙報人",
  "report.cc": "抄送人",
  "role": "角色",
  "push.time": "傳送時間",
  "is.automatic.sending.enabled": "是否啟用自動傳送",
  "stage.name": "階段名稱",
  "quantity": "數量",
  "week.on.month.ratio": "與上週環比",
  "special.remark": "備註(回車儲存)",
  "read.count": "閱讀數",
  "add.comment": "發表評論",
  "comment.content": "評論內容",
  "chinese.name": "中文名稱",
  "code": "編碼",
  "status.type": "狀態型別",
  "status.code": "狀態編碼",
  "english.name": "英文名稱",
  "status.group": "狀態組",
  "echo.color": "回顯顏色",
  "transferable.status": "可流轉狀態",
  "sort": "排序",
  "clone.to.other.status.group": "克隆到其他狀態組",
  "meeting.room.id": "會議室id",
  "meeting.room.name": "會議室名稱",
  "meeting.room.capacity": "會議室容量",
  "city": "城市",
  "building": "建築",
  "floor": "樓層",
  "meeting.room.equipment": "會議室裝置",
  "sn": "序列號",
  "标题": "標題",
  "状态": "狀態",
  "负责人": "負責人",
  "起始时间": "起始時間",
  "截止时间": "截止時間",
  "创建时间": "建立時間",
  "创建人": "建立人",
  "工作项类型": "工作項型別",
  "更新时间": "更新時間",
  "更新人名称": "更新人名稱",
  "操作": "操作",
  "优先级": "優先順序",
  "截止日期": "截止日期",
  "所属项目": "所屬專案",
  "任务名称": "任務名稱",
  "项目名称": "專案名稱",
  "团队空间": "團隊空間",
  "项目负责人": "專案負責人",
  "项目干系人": "專案幹係人",
  "项目周期": "專案週期",
  "默认视图": "預設檢視",
  "团队空间名称": "團隊空間名稱",
  "团队空间成员": "團隊空間成員",
  "团队空间描述": "團隊空間描述",
  "里程碑周期": "里程碑週期",
  "删除项目": "刪除專案",
  "项目是否公开": "專案是否公開",
  "编辑": "編輯",
  "新建需求": "新建需求",
  "转产品需求": "轉產品需求",
  "新建任务": "新建任務",
  "删除任务": "刪除任務",
  "里程碑负责人": "里程碑負責人",
  "需求名称": "需求名稱",
  "所属系统": "所屬系統",
  "干系人": "幹係人",
  "描述": "描述",
  "需求周期": "需求週期",
  "项目参与人": "專案參與人",
  "项目创建人": "專案建立人",
  "项目创建时间": "專案建立時間",
  "里程碑名称": "里程碑名稱",
  "里程碑": "里程碑",
  "系统": "系統",
  "开始时间": "開始時間",
  "实际完成时间": "實際完成時間",
  "项目": "專案",
  "主产品经理": "主產品經理",
  "公开状态": "公開狀態",
  "删除需求": "刪除需求",
  "删除里程碑": "刪除里程碑",
  "规划周期": "規劃週期",
  "人天预算": "人天預算",
  "版本号": "版本號",
  "关联需求任务数": "關聯需求任務數",
  "类型": "型別",
  "参与人": "參與人",
  "预估人天": "預估人天",
  "开始结束": "開始結束",
  "commit.cnt": "提交次數",
  "merge.cnt": "Merge次數",
  "push.cnt": "Push次數",
  "tag.cnt": "Tag次數",
  "merge.subscribe": "訂閱Merge",
  "push.subscribe": "訂閱Push",
  "merge.subscribers": "Merge訂閱者",
  "push.subscribers": "Push訂閱者",
  "warehouse.name": "倉庫名",
  "related.sn": "關聯序列號",
  "commit.email": "提交郵箱",
  "commit.url": "提交url",
  "commit.message": "提交描述",
  "commit.date": "提交時間",
  "commit.branch": "提交分支",
  "git.http.url": "Git倉庫地址",
  "nick.name": "暱稱",
  "attendance.date": "考勤日期",
  "attendance.type": "考勤型別",
  "attendance.start.address": "考勤開始地點",
  "attendance.end.address": "考勤結束地點",
  "attendance.start.source": "考勤開始來源",
  "attendance.end.source": "考勤結束來源",
  "attendance.start.result": "考勤開始結果",
  "attendance.end.result": "考勤結束結果",
  "department.name": "部門名稱",
  "department.members": "部門成員",
  "location.city": "Base地",
  "personal.attendance.days": "個人出勤天數",
  "personal.total.working.hours": "個人總工時",
  "personal.average.working.hours": "個人平均工時",
  "department.attendance.person.day": "部門出勤人天",
  "department.total.working.hours": "部門總工時",
  "department.average.working.hours": "部門平均工時",
  "location.city.attendance.person.day": "Base地出勤人天",
  "location.city.total.working.hours": "Base地總工時",
  "location.city.average.working.hours": "Base地平均工時",
  "review.location": "評審（會議）地點",
  "review.allLocation": "地點",
  "review.count": "評審數量",
  "bug.count": "缺陷數量",
  "online.bug.count": "線上問題數量",
  "is.have.template": "週報模板",
  "dept.status": "部門狀況",
  "total.commit.cnt": "提交總數",
  "requirment.commit.cnt": "需求提交數",
  "bug.commit.cnt": "缺陷提交數",
  "online.bug.commit.cnt": "線上問題提交數",
  "other.commit.cnt": "其他提交數",
  "standard.commit.rate": "規範提交率",
  "related.business": "關聯業務領域",
  "related.system": "關聯絡統",
  "position": "崗位",
  "production.Defects.score": "生產缺陷分",
  "develop.defects.score": "研發缺陷分",
  "working.hours.score": "工時分",
  "average.score.of.production.and.research": "產研平均分",
  "individual.total.score": "個人總分",
  "technical.debt.score": "技術債務分",
  "delivery.efficiency.score": "交付效率分",
  "code.review.report": "CR報告",
  "status.stage.nameCn": "階段名稱（中文）",
  "status.stage.nameEn": "階段名稱（英文）",
  "status.stage.code": "階段編碼",
  "status.stage.echoColor": "回顯顏色",
  "status.stage.sortNum": "排序編號",
  "description": "描述",
  "workflow": "工作流",
  "issue.type": "需求型別",
  "common.cancel": "取消",
  "common.ok": "確定",
  "common.confirm": "確認",
  "common.save": "儲存",
  "common.submit": "提交",
  "common.back": "返回",
  "common.close": "關閉",
  "common.reset": "重置",
  "common.refresh": "重新整理",
  "common.search": "搜尋",
  "common.clear": "清空",
  "common.copy": "複製",
  "common.add": "新增",
  "common.viewDetails": "檢視詳情",
  "common.moreActions": "更多操作",
  "common.noData": "暫無資料",
  "common.loading": "載入中...",
  "common.pleaseSelect": "請選擇",
  "common.pleaseEnter": "請輸入",
  "common.yes": "是",
  "common.no": "否",
  "common.required": "必填",
  "common.success": "成功",
  "common.failed": "失敗",
  "common.passed": "透過",
  "common.rejected": "不透過",
  "common.today": "今日",
  "common.thisWeek": "本週",
  "common.thisMonth": "本月",
  "common.thisYear": "本年",
  "common.all": "全部",
  "common.details": "詳情",
  "common.reason": "原因",
  "common.remark": "備註",
  "common.label": "標籤",
  "common.name": "名稱",
  "common.type": "型別",
  "common.count": "數量",
  "common.time": "時間",
  "common.endTime": "結束時間",
  "common.owner": "責任人",
  "common.assignee": "處理人",
  "common.members": "成員",
  "common.people": "人員",
  "common.country": "國家",
  "common.countryTeam": "國家線",
  "common.industryTeam": "行業線",
  "common.serviceName": "服務名稱",
  "common.serviceType": "服務型別",
  "common.branch": "分支",
  "common.task": "任務",
  "common.defect": "缺陷",
  "common.comments": "評論",
  "common.basicInfo": "基本資訊",
  "common.fullScreen": "全屏",
  "common.exitFullScreen": "縮小",
  "common.expandAll": "全部展開",
  "common.collapseAll": "全部收起",
  "common.clickToCopy": "點選複製",
  "common.confirmDelete": "確認刪除",
  "common.createdSuccessfully": "建立成功",
  "common.updatedSuccessfully": "更新成功",
  "common.modifiedSuccessfully": "修改成功",
  "common.savedSuccessfully": "儲存成功",
  "common.addedSuccessfully": "新增成功",
  "common.deletedSuccessfully": "刪除成功",
  "common.deleteFailed": "刪除失敗",
  "common.copyFailed": "複製失敗",
  "common.uploadAttachment": "上傳附件",
  "common.uploadFailed": "上傳失敗",
  "common.imageUploadFailed": "圖片上傳失敗",
  "common.draft": "草稿",
  "common.completed": "已完成",
  "common.released": "已釋出",
  "common.overdue": "已逾期",
  "common.hour": "小時",
  "common.day": "天",
  "common.item": "個",
  "common.total": "共",
  "0 天": "0 天",
  "请选择系统": "請選擇系統",
  "指标名称": "指標名稱",
  "指标说明": "指標說明",
  "需求主要归属": "需求主要歸屬",
  "关闭详情": "關閉詳情",
  "支持小数": "支援小數",
  "缺陷类型": "缺陷型別",
  "图": "圖",
  "表": "表",
  "请选择创建人": "請選擇建立人",
  "是否删除": "是否刪除",
  "请选择状态": "請選擇狀態",
  "实际工时（小时）": "實際工時（小時）",
  "图片上传错误，请重试！": "圖片上傳錯誤，請重試！",
  "请先设置开始结束时间和预估人天": "請先設定開始結束時間和預估人天",
  "请输入名称": "請輸入名稱",
  "计划上线日期": "計劃上線日期",
  "时间范围": "時間範圍",
  "请选择负责人": "請選擇負責人",
  "链接内容": "連結內容",
  "回收站不可以进行该操作，请恢复后在操作！": "回收站不可以進行該操作，請恢復後在操作！",
  "实际工时": "實際工時",
  "确定要删除": "確定要刪除",
  "吗？": "嗎？",
  "测试人员": "測試人員",
  "上传文件不能超过5MB": "上傳檔案不能超過5MB",
  "需求名称和链接已剪贴板": "需求名稱和連結已剪貼簿",
  "填写实际工时": "填寫實際工時",
  "请输入描述": "請輸入描述",
  "发现时间": "發現時間",
  "上传文件不能超过10MB": "上傳檔案不能超過10MB",
  "上传文件不能超过20MB": "上傳檔案不能超過20MB",
  "已经是第一条了": "已經是第一條了",
  "已经是最后一条了": "已經是最後一條了",
  "条": "條",
  "查看明细": "檢視明細",
  "请选择需求": "請選擇需求",
  "请选择查询类型": "請選擇查詢型別",
  "查询": "查詢",
  "表格视图": "表格檢視",
  "需求设计缺陷率": "需求設計缺陷率",
  "产品评审驳回率": "產品評審駁回率",
  "代码提交规范率": "程式碼提交規範率",
  "紧急发布率": "緊急釋出率",
  "未发布": "未釋出",
  "确认要删除吗？": "確認要刪除嗎？",
  "部署环境": "部署環境",
  "操作成功": "操作成功",
  "写周报": "寫週報",
  "点击添加评论": "點選新增評論",
  "取消点赞": "取消點贊",
  "添加点赞": "新增點贊",
  "点击分享周报": "點選分享週報",
  "年份": "年份",
  "至": "至",
  "回收站": "回收站",
  "审批单ID不能为空": "審批單ID不能為空",
  "基础信息": "基礎資訊",
  "服务分支信息": "服務分支資訊",
  "同步数据": "同步資料",
  "关联需求名称": "關聯需求名稱",
  "总计": "總計",
  "缺陷逃逸率": "缺陷逃逸率",
  "缺陷漏检率": "缺陷漏檢率",
  "发布成功率": "釋出成功率",
  "执行人": "執行人",
  "复制失败:": "複製失敗:",
  "事故序列": "事故序列",
  "严重程度": "嚴重程度",
  "指派人": "指派人",
  "存量": "存量",
  "说明": "說明",
  "数量变化（日）": "數量變化（日）",
  "这个指标的主要意义在于：": "這個指標的主要意義在於：",
  "质量控制：可以作为衡量软件质量变化的指标之一，帮助发现质量问题、进行质量改进。": "質量控制：可以作為衡量軟體質量變化的指標之一，幫助發現質量問題、進行質量改進。",
  "上传附件：": "上傳附件：",
  "复制成功": "複製成功",
  "提交失败:": "提交失敗:",
  "配置": "配置",
  "编辑责任人": "編輯責任人",
  "请选择人员": "請選擇人員",
  "设为默认": "設為預設",
  "发布时间": "釋出時間",
  "状态变更": "狀態變更",
  "只看我": "只看我",
  "已归档": "已歸檔",
  "全部记录": "全部記錄",
  "双击开始编辑": "雙擊開始編輯",
  "请切换到ALL系统下进行筛选": "請切換到ALL系統下進行篩選",
  "请选择地域": "請選擇地域",
  "最近更新时间": "最近更新時間",
  "同步结果": "同步結果",
  "请选择国家": "請選擇國家",
  "解决耗时": "解決耗時",
  "关闭时长": "關閉時長",
  "重开率": "重開率",
  "降序": "降序",
  "升序": "升序",
  "分支名": "分支名",
  "点击复制序列号": "點選複製序列號",
  "已复制序列号": "已複製序列號",
  "事故等级": "事故等級",
  "债务类型": "債務型別",
  "关联服务": "關聯服務",
  "指派": "指派",
  "存在未确认": "存在未確認",
  "全部已确认": "全部已確認",
  "评审吗？": "評審嗎？",
  "请选择标签": "請選擇標籤",
  "计划联调日期": "計劃聯調日期",
  "回复": "回覆",
  "完成目标": "完成目標",
  "风险类型": "風險型別",
  "风险原因": "風險原因",
  "预约发布": "預約釋出",
  "请输入申请原因": "請輸入申請原因",
  "创建时间:": "建立時間:",
  "请选择部门": "請選擇部門",
  "分": "分",
  "人": "人",
  "风险": "風險",
  "附件": "附件",
  "请输入内容（拖动右下角可调整高度）": "請輸入內容（拖動右下角可調整高度）",
  "无权限": "無許可權",
  "故障名称": "故障名稱",
  "评论不能为空": "評論不能為空",
  "评论成功": "評論成功",
  "请输入评论内容": "請輸入評論內容",
  "活动日志": "活動日誌",
  "只能在系统ALL下进行此条件筛选": "只能在系統ALL下進行此條件篩選",
  "设为默认后表格查询默认按该筛选条件查询": "設為預設後表格查詢預設按該篩選條件查詢",
  "只读权限": "只讀許可權",
  "一键创建任务": "一鍵建立任務",
  "请先勾选需求": "請先勾選需求",
  "目标值": "目標值",
  "pages.gray.userIdPlaceholder": "每行一個使用者 ID，或以逗號分隔\n例如：\nuser1\nuser2,user3\nuser4",
  "{count} 个团队": "{count} 個團隊",
  "{count} 人": "{count} 人",
  "{count} 人 · {names}{ellipsis}": "{count} 人 · {names}{ellipsis}",
  "{count} 名成员": "{count} 名成員",
  "{count} 天": "{count} 天",
  "{metric} · 需求明细": "{metric} · 需求明細",
  "、": "、",
  "个": "個",
  "天": "天",
  "序列号": "序號",
  "多团队研发效能对比": "多團隊研發效能對比",
  "并列比较团队需求负载、未开始与进行中需求、阶段耗时和大需求风险": "並列比較團隊需求負載、未開始與進行中需求、階段耗時和大型需求風險",
  "选择 1–5 个团队": "選擇 1–5 個團隊",
  "管理团队": "管理團隊",
  "刷新": "重新整理",
  "所选团队总览": "所選團隊總覽",
  "快速查看整体规模、流转效率与风险": "快速檢視整體規模、流轉效率與風險",
  "需求并集去重": "需求聯集去重",
  "团队指标矩阵": "團隊指標矩陣",
  "所有数值均可点击查看需求明细，点击列头可排序": "所有數值均可點選檢視需求明細，點選欄位標題可排序",
  "同一需求可能由多个团队共同参与，总览按需求去重，避免重复计数": "同一需求可能由多個團隊共同參與，總覽按需求去重，避免重複計數",
  "跨团队总览按需求去重": "跨團隊總覽按需求去重",
  "请选择团队查看数据": "請選擇團隊檢視資料",
  "请先配置团队": "請先設定團隊",
  "需求负载对比": "需求負載對比",
  "按团队查看总量与当前积压情况": "按團隊檢視總量與當前積壓情況",
  "研发与测试耗时对比": "研發與測試耗時對比",
  "按对应阶段完成时间进入所选区间": "按對應階段完成時間進入所選區間",
  "总数、构成、超10PD按需求创建时间；未完成/进行中为区间创建需求的当前状态；开发、测试、交付耗时分别按阶段完成时间进入区间。": "總數、構成、超10PD按需求建立時間；未完成/進行中為區間建立需求的當前狀態；開發、測試、交付耗時分別按階段完成時間進入區間。",
  "指标口径说明": "指標口徑說明",
  "除“超 10PD 需求”外，团队范围均通过需求执行人关系判断；“超 10PD 需求”通过需求绑定任务和任务负责人判断。两种关联口径不能混用。": "除「超 10PD 需求」外，團隊範圍均透過需求執行人關係判斷；「超 10PD 需求」透過需求綁定任務和任務負責人判斷。兩種關聯口徑不能混用。",
  "查看完整指标说明": "檢視完整指標說明",
  "时间口径": "時間口徑",
  "团队关联": "團隊關聯",
  "指标定义": "指標定義",
  "计算方式": "計算方式",
  "需求规模": "需求規模",
  "当前流转": "當前流轉",
  "需求构成": "需求構成",
  "阶段效率": "階段效率",
  "流转效率": "流轉效率",
  "风险关注": "風險關注",
  "总需求数": "總需求數",
  "未完成需求": "未完成需求",
  "进行中需求": "進行中需求",
  "非技术需求": "非技術需求",
  "开发阶段平均耗时": "開發階段平均耗時",
  "测试阶段平均耗时": "測試階段平均耗時",
  "总交付平均耗时": "總交付平均耗時",
  "超 10PD 需求": "超 10PD 需求",
  "需求创建时间进入所选区间": "需求建立時間進入所選區間",
  "需求创建时间进入所选区间，状态取查询时的当前状态": "需求建立時間進入所選區間，狀態取查詢時的當前狀態",
  "研发阶段完成时间进入所选区间": "研發階段完成時間進入所選區間",
  "测试阶段完成时间进入所选区间": "測試階段完成時間進入所選區間",
  "需求完成时间进入所选区间": "需求完成時間進入所選區間",
  "需求执行人关系中，执行人角色为研发、前端或测试，且执行人属于所选团队。": "需求執行人關係中，執行人角色為研發、前端或測試，且執行人屬於所選團隊。",
  "与总需求相同：通过需求执行人关系关联研发、前端或测试团队成员。": "與總需求相同：透過需求執行人關係關聯研發、前端或測試團隊成員。",
  "需求执行人关系中，研发、前端或测试执行人属于所选团队。": "需求執行人關係中，研發、前端或測試執行人屬於所選團隊。",
  "需求通过 ISSUE 类型任务绑定关系关联任务；只要任一有效绑定任务的负责人属于所选团队，该需求即进入团队范围。": "需求透過 ISSUE 類型任務綁定關係關聯任務；只要任一有效綁定任務的負責人屬於所選團隊，該需求即進入團隊範圍。",
  "满足团队关联条件的产品需求总量。": "滿足團隊關聯條件的產品需求總量。",
  "当前处于待介入、方案中、业务确认、已评审、需求排队或待开发的需求。": "當前處於待介入、方案中、業務確認、已評審、需求排隊或待開發的需求。",
  "当前处于开发中、前端开发中、联调中、已提测或测试中的需求。": "當前處於開發中、前端開發中、聯調中、已提測或測試中的需求。",
  "在产品需求中明确标记为技术需求的需求。": "在產品需求中明確標記為技術需求的需求。",
  "未标记为技术需求的其他产品需求。": "未標記為技術需求的其他產品需求。",
  "从产品阶段结束到研发阶段结束所经历的自然天数。": "從產品階段結束到研發階段結束所經歷的自然天數。",
  "从研发阶段结束到测试阶段结束所经历的自然天数。": "從研發階段結束到測試階段結束所經歷的自然天數。",
  "从产品阶段结束到需求完成所经历的自然天数。": "從產品階段結束到需求完成所經歷的自然天數。",
  "需求绑定的研发相关任务预估工时合计大于 10PD。": "需求綁定的研發相關任務預估工時合計大於 10PD。",
  "按需求 ID 去重计数；排除已删除、暂存和项目型需求。": "按需求 ID 去重計數；排除已刪除、暫存和專案型需求。",
  "从总需求中按未完成状态集合筛选，并按需求 ID 去重计数。": "從總需求中按未完成狀態集合篩選，並按需求 ID 去重計數。",
  "从总需求中按进行中状态集合筛选，并按需求 ID 去重计数。": "從總需求中按進行中狀態集合篩選，並按需求 ID 去重計數。",
  "从总需求中筛选技术需求，并按需求 ID 去重计数。": "從總需求中篩選技術需求，並按需求 ID 去重計數。",
  "从总需求中筛选非技术需求，并按需求 ID 去重计数。": "從總需求中篩選非技術需求，並按需求 ID 去重計數。",
  "仅统计两个时间字段完整的需求，逐条计算天数后取算术平均值。": "僅統計兩個時間欄位完整的需求，逐筆計算天數後取算術平均值。",
  "仅统计两个时间字段完整的已完成需求，逐条计算天数后取算术平均值。": "僅統計兩個時間欄位完整的已完成需求，逐筆計算天數後取算術平均值。",
  "对进入团队范围的需求，汇总其全部有效后端、前端、无线开发及对应技术方案、需求调研任务的预估 PD；只累加大于0的工时，按需求分组后筛选合计值 > 10。": "對進入團隊範圍的需求，彙總其全部有效後端、前端、無線開發及對應技術方案、需求調研任務的預估 PD；只累加大於0的工時，按需求分組後篩選合計值 > 10。",
  "按需求 ID 去重 · 点击查看明细": "按需求 ID 去重 · 點選檢視明細",
  "总需求": "總需求",
  "开发阶段": "開發階段",
  "交付耗时": "交付耗時",
  "开发耗时": "開發耗時",
  "测试耗时": "測試耗時",
  "预估PD": "預估PD",
  "待介入": "待介入",
  "方案中": "方案中",
  "业务确认": "業務確認",
  "已评审": "已評審",
  "需求排队": "需求排隊",
  "待开发": "待開發",
  "开发中": "開發中",
  "前端开发中": "前端開發中",
  "联调中": "聯調中",
  "已提测": "已提測",
  "测试中": "測試中",
  "团队已保存": "團隊已儲存",
  "团队已删除": "團隊已刪除",
  "管理对比团队": "管理對比團隊",
  "团队用于并列比较，同一成员可属于多个团队。": "團隊用於並列比較，同一成員可屬於多個團隊。",
  "新增团队": "新增團隊",
  "编辑团队": "編輯團隊",
  "确认删除该团队？": "確認刪除該團隊？",
  "暂未配置团队": "尚未設定團隊",
  "请输入团队名称": "請輸入團隊名稱",
  "保存": "儲存",
  "删除": "刪除",
  "团队成员": "團隊成員",
  "选择成员": "選擇成員",
  "暂未选择成员，允许保存空团队": "尚未選擇成員，允許儲存空團隊",
  "选择团队成员": "選擇團隊成員",
  "通过需求执行人关系关联团队；执行人角色限定为研发、前端或测试，执行人编码属于团队成员。": "透過需求執行人關係關聯團隊；執行人角色限定為研發、前端或測試，且執行人編碼屬於團隊成員。",
  "需求创建时间进入所选区间，并且产品、研发、测试阶段结束时间至少一项不为空": "需求建立時間進入所選區間，且產品、研發、測試階段結束時間至少一項不為空",
  "需求创建时间进入所选区间，并且需求完成时间、产品阶段结束时间均不为空": "需求建立時間進入所選區間，且需求完成時間、產品階段結束時間均不為空",
  "通过 ISSUE 类型任务绑定关系关联任务；至少一条预估工时大于0的有效绑定任务负责人属于团队成员。": "透過 ISSUE 類型任務綁定關係關聯任務；至少一筆預估工時大於0的有效綁定任務負責人屬於團隊成員。",
  "需求总量": "需求總量",
  "需求创建时间进入所选区间，并且业务编号不为空": "需求建立時間進入所選區間，且業務編號不為空",
  "排除已删除、暂存和项目型需求后，按需求 ID 去重计数。": "排除已刪除、暫存和專案型需求後，按需求 ID 去重計數。",
  "当前处于待介入、方案中、业务确认、已评审、需求排队或待开发状态的{type}需求。": "目前處於待介入、方案中、業務確認、已評審、需求排隊或待開發狀態的{type}需求。",
  "技术": "技術",
  "非技术": "非技術",
  "当前处于开发中、前端开发中、联调中、已提测或测试中状态的{type}需求。": "目前處於開發中、前端開發中、聯調中、已提測或測試中狀態的{type}需求。",
  "要求业务编号不为空，按状态集合和技术标记筛选后按需求 ID 去重计数。": "要求業務編號不為空，按狀態集合和技術標記篩選後按需求 ID 去重計數。",
  "未完成技术需求数": "未完成技術需求數",
  "进行中技术需求数": "進行中技術需求數",
  "未完成非技术需求数": "未完成非技術需求數",
  "进行中非技术需求数": "進行中非技術需求數",
  "技术需求数": "技術需求數",
  "开发测试阶段": "開發測試階段",
  "进入开发测试阶段样本的技术需求数量。": "進入開發測試階段樣本的技術需求數量。",
  "筛选 is_technical = 1 后按需求 ID 去重计数。": "篩選 is_technical = 1 後按需求 ID 去重計數。",
  "技术需求开发阶段平均耗时": "技術需求開發階段平均耗時",
  "技术需求从产品阶段结束到研发阶段结束所经历的自然天数。": "技術需求從產品階段結束到研發階段結束所經歷的自然天數。",
  "仅对两个时间字段完整的技术需求计算逐条耗时，再取算术平均值。": "僅對兩個時間欄位完整的技術需求逐筆計算耗時，再取算術平均值。",
  "技术需求测试阶段平均耗时": "技術需求測試階段平均耗時",
  "技术需求从研发阶段结束到测试阶段结束所经历的自然天数。": "技術需求從研發階段結束到測試階段結束所經歷的自然天數。",
  "非技术需求数": "非技術需求數",
  "进入开发测试阶段样本的非技术需求数量。": "進入開發測試階段樣本的非技術需求數量。",
  "筛选 is_technical 不等于 1（含空值）后按需求 ID 去重计数。": "篩選 is_technical 不等於 1（含空值）後按需求 ID 去重計數。",
  "非技术需求开发阶段平均耗时": "非技術需求開發階段平均耗時",
  "非技术需求从产品阶段结束到研发阶段结束所经历的自然天数。": "非技術需求從產品階段結束到研發階段結束所經歷的自然天數。",
  "仅对两个时间字段完整的非技术需求计算逐条耗时，再取算术平均值。": "僅對兩個時間欄位完整的非技術需求逐筆計算耗時，再取算術平均值。",
  "非技术需求测试阶段平均耗时": "非技術需求測試階段平均耗時",
  "非技术需求从研发阶段结束到测试阶段结束所经历的自然天数。": "非技術需求從研發階段結束到測試階段結束所經歷的自然天數。",
  "产品阶段结束到需求完成": "產品階段結束到需求完成",
  "研发阶段结束到测试阶段结束": "研發階段結束到測試階段結束",
  "产品阶段结束到研发阶段结束": "產品階段結束到研發階段結束",
  "已交付需求": "已交付需求",
  "已交付技术需求数": "已交付技術需求數",
  "技术需求平均交付时长": "技術需求平均交付時長",
  "技术需求研发平均交付时长": "技術需求研發平均交付時長",
  "技术需求测试平均交付时长": "技術需求測試平均交付時長",
  "已交付非技术需求数": "已交付非技術需求數",
  "非技术需求平均交付时长": "非技術需求平均交付時長",
  "非技术需求研发平均交付时长": "非技術需求研發平均交付時長",
  "非技术需求测试平均交付时长": "非技術需求測試平均交付時長",
  "总研发需求平均交付时长": "總研發需求平均交付時長",
  "进入已交付样本的{type}需求数量。": "進入已交付樣本的{type}需求數量。",
  "全部已交付需求从产品阶段结束到研发阶段结束所经历的自然天数。": "全部已交付需求從產品階段結束到研發階段結束所經歷的自然天數。",
  "{type}需求从{interval}所经历的自然天数。": "{type}需求從{interval}所經歷的自然天數。",
  "按技术标记筛选后按需求 ID 去重计数。": "按技術標記篩選後按需求 ID 去重計數。",
  "仅对计算区间两端时间完整的需求计算逐条耗时，再取算术平均值。": "僅對計算區間兩端時間完整的需求逐筆計算耗時，再取算術平均值。",
  "超 10PD 技术需求数": "超 10PD 技術需求數",
  "大需求风险": "大型需求風險",
  "绑定的研发相关任务预估工时合计大于 10PD 的技术需求。": "綁定的研發相關任務預估工時合計大於 10PD 的技術需求。",
  "汇总全部有效后端、前端、无线开发及对应技术方案、需求调研任务中大于0的预估 PD，按需求分组筛选合计值 > 10。": "彙總全部有效後端、前端、無線開發及對應技術方案、需求調研任務中大於0的預估 PD，按需求分組篩選合計值 > 10。",
  "超 10PD 非技术需求数": "超 10PD 非技術需求數",
  "绑定的研发相关任务预估工时合计大于 10PD 的非技术需求。": "綁定的研發相關任務預估工時合計大於 10PD 的非技術需求。",
  "未完成技术": "未完成技術",
  "进行中技术": "進行中技術",
  "未完成非技术": "未完成非技術",
  "进行中非技术": "進行中非技術",
  "技术开发": "技術開發",
  "技术测试": "技術測試",
  "非技术开发": "非技術開發",
  "非技术测试": "非技術測試",
  "未开始与进行中需求对比": "未開始與進行中需求對比",
  "未开始与进行中需求": "未開始與進行中需求",
  "按技术、非技术需求拆分当前状态": "按技術、非技術需求拆分目前狀態",
  "按需求创建时间进入区间，并按技术类型拆分": "按需求建立時間進入區間，並按技術類型拆分",
  "全部指标均按需求创建时间进入区间；状态指标另要求业务编号，阶段指标要求至少一个阶段时间，交付指标要求完成时间和产品阶段结束时间完整。": "全部指標均按需求建立時間進入區間；狀態指標另要求業務編號，階段指標要求至少一個階段時間，交付指標要求完成時間和產品階段結束時間完整。",
  "不限制需求创建时间，状态取查询时的当前状态": "不限制需求建立時間，狀態取查詢時的目前狀態",
  "未开始技术需求数": "未開始技術需求數",
  "未开始业务需求数": "未開始業務需求數",
  "进行中业务需求数": "進行中業務需求數",
  "业务（需求类型）": "業務",
  "排除已删除、暂存和项目型需求，要求业务编号不为空；按状态集合和技术标记筛选后按需求 ID 去重计数。": "排除已刪除、暫存和專案型需求，要求業務編號不為空；按狀態集合和技術標記篩選後按需求 ID 去重計數。",
  "业务需求数": "業務需求數",
  "进入开发测试阶段样本的业务需求（非技术产品需求）数量。": "進入開發測試階段樣本的業務需求（非技術產品需求）數量。",
  "筛选 is_technical 不等于 1（含空值），作为业务需求并按需求 ID 去重计数。": "篩選 is_technical 不等於 1（含空值），作為業務需求並按需求 ID 去重計數。",
  "技术需求从产品阶段结束到研发阶段结束的耗时，按秒折算，24小时计1天。": "技術需求從產品階段結束到研發階段結束的耗時，按秒折算，24小時計1天。",
  "技术需求从研发阶段结束到测试阶段结束的耗时，按秒折算，24小时计1天。": "技術需求從研發階段結束到測試階段結束的耗時，按秒折算，24小時計1天。",
  "仅对两个时间字段完整的技术需求逐条计算耗时，每个需求只计一次，再取算术平均值。": "僅對兩個時間欄位完整的技術需求逐筆計算耗時，每個需求只計一次，再取算術平均值。",
  "业务需求开发阶段平均耗时": "業務需求開發階段平均耗時",
  "业务需求从产品阶段结束到研发阶段结束的耗时，按秒折算，24小时计1天。": "業務需求從產品階段結束到研發階段結束的耗時，按秒折算，24小時計1天。",
  "业务需求测试阶段平均耗时": "業務需求測試階段平均耗時",
  "业务需求从研发阶段结束到测试阶段结束的耗时，按秒折算，24小时计1天。": "業務需求從研發階段結束到測試階段結束的耗時，按秒折算，24小時計1天。",
  "仅对两个时间字段完整的业务需求逐条计算耗时，每个需求只计一次，再取算术平均值。": "僅對兩個時間欄位完整的業務需求逐筆計算耗時，每個需求只計一次，再取算術平均值。",
  "需求创建时间进入所选区间，并且需求完成时间（已发布时间）、产品阶段结束时间均不为空": "需求建立時間進入所選區間，且需求完成時間（已釋出時間）、產品階段結束時間均不為空",
  "已交付业务需求数": "已交付業務需求數",
  "业务需求平均交付时长": "業務需求平均交付時長",
  "业务需求研发平均交付时长": "業務需求研發平均交付時長",
  "业务需求测试平均交付时长": "業務需求測試平均交付時長",
  "全部已交付需求从产品阶段结束到研发阶段结束的耗时，按秒折算，24小时计1天。": "全部已交付需求從產品階段結束到研發階段結束的耗時，按秒折算，24小時計1天。",
  "{type}需求从{interval}的耗时，按秒折算，24小时计1天。": "{type}需求從{interval}的耗時，按秒折算，24小時計1天。",
  "按技术标记筛选后按需求 ID 去重计数；is_technical 不等于 1 的产品需求作为业务需求。": "按技術標記篩選後按需求 ID 去重計數；is_technical 不等於 1 的產品需求作為業務需求。",
  "仅对计算区间两端时间完整的需求逐条计算耗时，每个需求只计一次，再取算术平均值。": "僅對計算區間兩端時間完整的需求逐筆計算耗時，每個需求只計一次，再取算術平均值。",
  "超 10PD 业务需求数": "超 10PD 業務需求數",
  "绑定的研发相关任务预估工时合计大于 10PD 的业务需求（非技术产品需求）。": "綁定的研發相關任務預估工時合計大於 10PD 的業務需求（非技術產品需求）。",
  "未开始技术": "未開始技術",
  "未开始业务": "未開始業務",
  "进行中业务": "進行中業務",
  "业务开发": "業務開發",
  "业务测试": "業務測試",
  "按技术、业务需求拆分未开始与进行中需求，不受日期范围影响": "按技術、業務需求拆分未開始與進行中需求，不受日期範圍影響",
  "未开始和进行中指标不受日期范围影响，统计全量需求的当前状态；总量、阶段、交付和超10PD指标按所选日期内创建的需求统计。": "未開始和進行中指標不受日期範圍影響，統計全量需求的目前狀態；總量、階段、交付和超10PD指標按所選日期內建立的需求統計。",
  "通过需求执行人关系关联团队；执行人角色限定为研发、前端或测试，执行人编码属于团队成员。同一需求有多名团队成员参与时仍只计一次。": "透過需求執行人關係關聯團隊；執行人角色限定為研發、前端或測試，執行人編碼屬於團隊成員。同一需求有多名團隊成員參與時仍只計一次。",
  "需求创建时间进入所选日期区间（含开始日和结束日）": "需求建立時間進入所選日期區間（含開始日和結束日）",
  "不限制需求创建时间，读取查询时的当前状态，并且业务编号不为空": "不限制需求建立時間，讀取查詢時的目前狀態，且業務編號不為空",
  "需求创建时间进入所选日期区间，并且产品、研发、测试阶段结束时间至少一项不为空": "需求建立時間進入所選日期區間，且產品、研發、測試階段結束時間至少一項不為空",
  "需求创建时间进入所选日期区间，并且产品阶段结束时间、研发阶段结束时间均不为空": "需求建立時間進入所選日期區間，且產品階段結束時間、研發階段結束時間均不為空",
  "需求创建时间进入所选日期区间，并且研发阶段结束时间、测试阶段结束时间均不为空": "需求建立時間進入所選日期區間，且研發階段結束時間、測試階段結束時間均不為空",
  "需求创建时间进入所选日期区间，并且需求完成时间（已发布时间）、产品阶段结束时间均不为空": "需求建立時間進入所選日期區間，且需求完成時間（已釋出時間）、產品階段結束時間均不為空",
  "需求创建时间进入所选日期区间，并且需求完成时间（已发布时间）、产品阶段结束时间、研发阶段结束时间均不为空": "需求建立時間進入所選日期區間，且需求完成時間（已釋出時間）、產品階段結束時間、研發階段結束時間均不為空",
  "需求创建时间进入所选日期区间，并且需求完成时间（已发布时间）、产品阶段结束时间、研发阶段结束时间、测试阶段结束时间均不为空": "需求建立時間進入所選日期區間，且需求完成時間（已釋出時間）、產品階段結束時間、研發階段結束時間、測試階段結束時間均不為空",
  "需求创建时间进入所选日期区间（含开始日和结束日），并且业务编号不为空": "需求建立時間進入所選日期區間（含開始日和結束日），且業務編號不為空",
  "排除已删除、暂存和项目型需求，筛选 is_technical = 1 后按需求 ID 去重计数。该数量是任一阶段时间存在的需求数，不是开发和测试平均耗时的共同样本数。": "排除已刪除、暫存和專案型需求，篩選 is_technical = 1 後按需求 ID 去重計數。該數量是任一階段時間存在的需求數，不是開發和測試平均耗時的共同樣本數。",
  "排除已删除、暂存和项目型需求，筛选 is_technical 不等于 1（含空值）作为业务需求，并按需求 ID 去重计数。该数量是任一阶段时间存在的需求数，不是开发和测试平均耗时的共同样本数。": "排除已刪除、暫存和專案型需求，篩選 is_technical 不等於 1（含空值）作為業務需求，並按需求 ID 去重計數。該數量是任一階段時間存在的需求數，不是開發和測試平均耗時的共同樣本數。",
  "排除已删除、暂存和项目型需求，筛选 is_technical = 1 并按需求 ID 去重；逐条计算耗时并保留两位小数，再取算术平均值并保留两位小数。": "排除已刪除、暫存和專案型需求，篩選 is_technical = 1 並按需求 ID 去重；逐筆計算耗時並保留兩位小數，再取算術平均值並保留兩位小數。",
  "排除已删除、暂存和项目型需求，筛选 is_technical 不等于 1（含空值）并按需求 ID 去重；逐条计算耗时并保留两位小数，再取算术平均值并保留两位小数。": "排除已刪除、暫存和專案型需求，篩選 is_technical 不等於 1（含空值）並按需求 ID 去重；逐筆計算耗時並保留兩位小數，再取算術平均值並保留兩位小數。",
  "is_technical = 1": "is_technical = 1",
  "is_technical 不等于 1（含空值）": "is_technical 不等於 1（含空值）",
  "排除已删除、暂存和项目型需求，按{typeFilter}筛选后按需求 ID 去重计数。": "排除已刪除、暫存和專案型需求，按{typeFilter}篩選後按需求 ID 去重計數。",
  "排除已删除、暂存和项目型需求，按{typeFilter}和上述状态集合筛选后按需求 ID 去重计数。": "排除已刪除、暫存和專案型需求，按{typeFilter}和上述狀態集合篩選後按需求 ID 去重計數。",
  "排除已删除、暂存和项目型需求，按{typeFilter}筛选并按需求 ID 去重；逐条计算耗时并保留两位小数，再取算术平均值并保留两位小数。": "排除已刪除、暫存和專案型需求，按{typeFilter}篩選並按需求 ID 去重；逐筆計算耗時並保留兩位小數，再取算術平均值並保留兩位小數。",
  "排除已删除、暂存和项目型需求并按需求 ID 去重；逐条计算耗时并保留两位小数，再取算术平均值并保留两位小数，不区分需求类型。": "排除已刪除、暫存和專案型需求並按需求 ID 去重；逐筆計算耗時並保留兩位小數，再取算術平均值並保留兩位小數，不區分需求型別。",
  "排除已删除、暂存和项目型需求，筛选 is_technical = 1；汇总需求绑定的全部有效后端、数据仓库、前端、移动端及对应技术方案、需求调研任务中大于 0 的预估 PD，按需求分组并筛选原始合计值 > 10，结果按需求计数。": "排除已刪除、暫存和專案型需求，篩選 is_technical = 1；彙總需求綁定的全部有效後端、資料倉儲、前端、行動端及對應技術方案、需求調研任務中大於 0 的預估 PD，按需求分組並篩選原始合計值 > 10，結果按需求計數。",
  "排除已删除、暂存和项目型需求，筛选 is_technical 不等于 1（含空值）；汇总需求绑定的全部有效后端、数据仓库、前端、移动端及对应技术方案、需求调研任务中大于 0 的预估 PD，按需求分组并筛选原始合计值 > 10，结果按需求计数。": "排除已刪除、暫存和專案型需求，篩選 is_technical 不等於 1（含空值）；彙總需求綁定的全部有效後端、資料倉儲、前端、行動端及對應技術方案、需求調研任務中大於 0 的預估 PD，按需求分組並篩選原始合計值 > 10，結果按需求計數。",
  "按需求创建时间进入区间；开发、测试分别只统计对应起止时间完整的需求": "按需求建立時間進入區間；開發、測試分別只統計對應起止時間完整的需求",
  "未开始和进行中指标不受日期范围影响；其余指标按所选日期内创建的需求统计。阶段需求数只要求任一阶段时间存在，开发、测试及交付平均耗时各自只使用所需时间字段完整的需求。": "未開始和進行中指標不受日期範圍影響；其餘指標按所選日期內建立的需求統計。階段需求數只要求任一階段時間存在，開發、測試及交付平均耗時各自只使用所需時間欄位完整的需求。",
  "所有指标均排除已删除、暂存和项目型需求。除“超 10PD 需求”外，团队范围通过需求执行人关系判断并按需求去重；“超 10PD 需求”通过需求绑定任务和任务负责人判断。需求数与各平均耗时可能使用不同的有效样本，请以每项时间口径为准。": "所有指標均排除已刪除、暫存和專案型需求。除「超 10PD 需求」外，團隊範圍透過需求執行人關係判斷並按需求去重；「超 10PD 需求」透過需求綁定任務和任務負責人判斷。需求數與各平均耗時可能使用不同的有效樣本，請以每項時間口徑為準。",
};
